// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/aed-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/fonts/aed-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2725%27 height=%2724%27 viewBox=%270 0 25 24%27 fill=%27none%27%3E%3Cpath d=%27M5.62615 9.29289C6.01667 8.90237 6.64983 8.90237 7.04036 9.29289L12.3333 14.5858L17.6261 9.29289C18.0167 8.90237 18.6498 8.90237 19.0404 9.29289C19.4309 9.68342 19.4309 10.3166 19.0404 10.7071L13.0404 16.7071C12.6498 17.0976 12.0167 17.0976 11.6261 16.7071L5.62615 10.7071C5.23562 10.3166 5.23562 9.68342 5.62615 9.29289Z%27 fill=%27%23555555%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M17.5019 2.13509C17.8102 2.31401 18 2.64353 18 3V7C19.1848 7 20.2502 7.51635 20.9812 8.33309C21.614 9.0401 22 9.97617 22 11C22 12.0238 21.614 12.9599 20.9812 13.6669C20.2502 14.4836 19.1848 15 18 15V19C18 19.3565 17.8102 19.686 17.5019 19.8649C17.1936 20.0438 16.8134 20.0451 16.5039 19.8682L10 16.1518V21C10 21.5523 9.55228 22 9 22H5C4.44772 22 4 21.5523 4 21V16C2.89543 16 2 15.1046 2 14V8C2 6.89543 2.89543 6 4 6H9.73444L16.5039 2.13176C16.8134 1.9549 17.1936 1.95617 17.5019 2.13509ZM10 14C10.174 14 10.345 14.0454 10.4961 14.1318L16 17.2768V4.72318L10.4961 7.86824C10.345 7.95458 10.174 8 10 8H4V14H10ZM6 16V20H8V16H6ZM18 13C18.5922 13 19.1233 12.7438 19.491 12.3331C19.8083 11.9786 20 11.5129 20 11C20 10.4871 19.8083 10.0214 19.491 9.66691C19.1233 9.25615 18.5922 9 18 9V13Z%27 fill=%27%233264FF%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23clip0_1252_2042%29%27%3E%3Cpath d=%27M14.639 10.258L19.469 8.96401C19.7245 8.89023 19.9921 8.86813 20.2562 8.89901C20.5203 8.92989 20.7756 9.01312 21.0071 9.14384C21.2387 9.27456 21.4419 9.45014 21.6047 9.66032C21.7676 9.87049 21.887 10.111 21.9558 10.3679C22.0246 10.6247 22.0415 10.8927 22.0055 11.1562C21.9695 11.4196 21.8814 11.6733 21.7462 11.9022C21.611 12.1312 21.4315 12.3309 21.2182 12.4897C21.0049 12.6485 20.7621 12.7632 20.504 12.827L6.015 16.71L1.565 11.69L4.462 10.914L6.912 12.328L9.809 11.552L6.066 5.30801L8.964 4.53101L14.639 10.258Z%27 stroke=%27%230F294D%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M3 21H21%27 stroke=%27%230F294D%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27clip0_1252_2042%27%3E%3Crect width=%2724%27 height=%2724%27 fill=%27white%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272.8%27 fill=%27%233264FF%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2718%27 height=%2719%27 viewBox=%270 0 18 19%27 fill=%27none%27%3E%3Cpath d=%27M15.4983 4.18945C15.8079 4.46464 15.8358 4.93869 15.5606 5.24828L7.56056 14.2483C7.41824 14.4084 7.21424 14.5 7.00001 14.5C6.78578 14.5 6.58178 14.4084 6.43945 14.2483L2.43945 9.74828C2.16426 9.43869 2.19215 8.96464 2.50174 8.68945C2.81132 8.41426 3.28538 8.44215 3.56056 8.75173L7.00001 12.6211L14.4395 4.25174C14.7146 3.94215 15.1887 3.91426 15.4983 4.18945Z%27 fill=%27%23ffffff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%278%27 viewBox=%270 0 14 8%27 fill=%27none%27%3E%3Cpath d=%27M1 1L7 7L13 1%27 stroke=%27%23555555%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2718%27 height=%2718%27 viewBox=%270 0 18 18%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23clip0_2109_14175%29%27%3E%3Cpath d=%27M14.25 9H3.75%27 stroke=%27%233264FF%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M14.25 9L9.75 13.5%27 stroke=%27%233264FF%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M14.25 9L9.75 4.5%27 stroke=%27%233264FF%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27clip0_2109_14175%27%3E%3Crect width=%2718%27 height=%2718%27 fill=%27white%27 transform=%27matrix%28-1 0 0 1 18 0%29%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23clip0_1252_2048%29%27%3E%3Cpath d=%27M14.429 11.7527L19.247 13.0907C19.5045 13.1569 19.7463 13.2738 19.9581 13.4345C20.17 13.5952 20.3476 13.7965 20.4807 14.0267C20.6138 14.2569 20.6997 14.5114 20.7333 14.7751C20.7669 15.0389 20.7475 15.3067 20.6764 15.5629C20.6052 15.8192 20.4837 16.0586 20.3189 16.2673C20.1541 16.476 19.9494 16.6497 19.7166 16.7783C19.4839 16.9069 19.2279 16.9878 18.9635 17.0163C18.6991 17.0448 18.4317 17.0203 18.1769 16.9442L3.72331 12.9315L2.43901 6.34717L5.32874 7.14981L6.72129 9.61207L9.61102 10.4147L9.55734 3.13496L12.4484 3.93725L14.429 11.7527Z%27 stroke=%27%230F294D%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M3 21H21%27 stroke=%27%230F294D%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27clip0_1252_2048%27%3E%3Crect width=%2724%27 height=%2724%27 fill=%27white%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --hw-red: #DA102A;
  --hw-yellow: #ffc107;
  --hw-green: #0A7519;
  --hw-black: #000;
  --hw-black-500: #434444;
  --hw-black-900: #121826;
  --hw-gray-100: #F2F2F2;
  --hw-gray-200: #DFDFDF;
  --hw-gray-300: #F9F9F9;
  --hw-gray-400: #CCCCCC;
  --hw-gray-500: #8B8B8B;
  --hw-gray-600: #D7D7D7;
  --hw-gray-650: #626262;
  --hw-gray-700: #656565;
  --hw-gray-800: #555555;
  --hw-gray-900: #151515;
  --hw-white: #fff;
  --hw-brand-orange: #3264FF;
  --hw-brand-orange-hover: #1D4EE5;
  /* --hw-brand-blue: #283D6B;  */
  --hw-brand-blue: #0F294D;

  --hw-brand-brown: #823719;
  /* --hw-brand-orange-light: #EEF5FF; */
  --hw-brand-orange-light: #EBEFFF;
  --hw-brand-blue-light: #EBEFFF;
  --hw-bg-light1: #FBF0EB;
  --hw-bg-light2: #F3EBE8;
  --hw-bg-light3: #F0E7E8;
  --hw-brand-orange-rgb: 50, 100, 255;
  --hw-brand-blue-rgb: 40, 61, 107;

  --hw-brand-brown-rgb: 130, 55, 25;
  --hw-black-rgb: 0, 0, 0;
  --hw-white-rgb: 255, 255, 255;
  --hw-font-sans-serif: system-ui, -apple-system, "Segoe UI", Poppins, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --hw-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --hw-body-font-family: 'DM Sans', sans-serif;
  --hw-head-font-family: 'Poppins', sans-serif;
  --hw-body-font-size: 1.4rem;
  --hw-body-font-weight: 400;
  --hw-body-line-height: 1.75;
  --hw-body-color: #555555;
  --hw-body-color2: #5E5E5E;
  --hw-body-color-rgb: 21, 21, 21;
  --hw-body-bg: #fff;
  --hw-body-bg-rgb: 255, 255, 255;
  --hw-heading-color: #000
}

@font-face {
  font-family: 'aedregular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.hw-blackout-date {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #dc3545;
  font-size: 14px;
  font-weight: bold;
  cursor: not-allowed;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

html {
  box-sizing: border-box;
  font-size: calc(1.0 * 62.5%);
}

body {
  margin: 0;
  font-family: var(--hw-body-font-family);
  font-size: var(--hw-body-font-size);
  font-weight: var(--hw-body-font-weight);
  line-height: var(--hw-body-line-height);
  color: var(--hw-body-color);
  text-align: left;
  background-color: var(--hw-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

button,
table td,
table th,
a,
input {
  font-family: var(--hw-body-font-family);
}

h6,
.h6,
h5,
.h5,
h4,
.h4,
h3,
.h3,
h2,
.h2,
h1,
.h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--hw-heading-color);
  font-family: var(--hw-head-font-family);
}

h1,
.h1 {
  font-size: calc(1.375rem + 1.5vw);
}

.h2 {
  font-size: 2.5rem;
  line-height: 1.52;
}

h3,
.h3 {
  font-size: 2.5rem;
  line-height: 1.52;
}

h4,
.h4 {
  font-size: 1.8rem;
  line-height: 1.556;
}

h6,
.h6 {
  font-size: 1.6rem;
  line-height: 1.75;
}

@media (min-width: 768px) {

  h4,
  .h4 {
    font-size: 2.2rem;
    line-height: 1.5;
  }

  .h2 {
    font-size: 3rem;
    line-height: normal;
  }
}

@media (min-width: 1200px) {

  h1,
  .h1 {
    font-size: 5rem;
  }

  .hw-h2 {
    font-size: 3.5rem;
  }
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

a {
  color: var(--hw-black-900);
  font-weight: normal;
  text-decoration: none;
  transition: color .3s ease;
}

a:hover {
  color: var(--hw-brand-orange);
}

.hw-success {
  color: var(--hw-green) !important;
}

.hw-primary {
  color: var(--hw-brand-orange) !important;
}

.hw-black {
  color: var(--hw-black) !important;
}

.hw-white {
  color: var(--hw-white) !important;
}

.hw-body-alt {
  color: var(--hw-body-color2) !important;
}

.hw-red {
  color: var(--hw-red) !important;
}

.hw-blue {
  color: var(--hw-brand-blue) !important;
}

.hw-grayk500 {
  color: var(--hw-gray-500) !important;
}

.hw-gray650 {
  color: var(--hw-gray-650) !important;
}

.hw-black800 {
  color: var(--hw-gray-800) !important;
}

.hw-black500 {
  color: var(--hw-black-500) !important;
}

.hw-black900 {
  color: var(--hw-black-900) !important;
}

.hw-gray-900 {
  color: var(--hw-gray-900) !important;
}

.hw-fontNormal {
  font-weight: normal !important;
}

.hw-fontWeight--500 {
  font-weight: 500 !important;
}

.hw-fontBold {
  font-weight: bold !important;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
  margin: 0;
}

.hw-text12 {
  font-size: 1.2rem !important;
}

.hw-text14 {
  font-size: 1.4rem !important;
  line-height: 1.71429
}

.hw-text16 {
  font-size: 1.6rem;
  line-height: 1.75;
}

.hw-text18 {
  font-size: 1.8rem;
  line-height: 1.556;
}

.hw-text20 {
  font-size: 2rem;
  line-height: 1.4;
}

.hw-text22 {
  font-size: 2rem;
  line-height: 1.5;
}

.hw-text24 {
  font-size: 2.4rem;
  line-height: 1.5;
}

.hw-line--height1 {
  line-height: 1 !important;
}

.hw-text--uppercase {
  text-transform: uppercase !important;
}

.hw-text--capitalize {
  text-transform: capitalize !important;
}

.hw-text--right {
  text-align: right !important;
}

.hw-line--heightNull {
  line-height: 0 !important;
}

.ms-2 {
  margin-left: .4rem !important;
}

.ms-2half {
  margin-left: .8rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.lm-lrp--1 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.hw-text--muted {
  color: var(--hw-gray-650) !important;
}

.text-center {
  text-align: center !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.d-inlineBlock {
  display: inline-block;
}

img,
svg {
  vertical-align: middle;
}

.hw-position--relative {
  position: relative;
}

.hw-position--abs-bottom {
  position: absolute;
  bottom: -100%;
}

.mt-auto {
  margin-top: auto !important;
}

.my-8 {
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
}

.mt-1 {
  margin-top: .4rem !important;
}

.mt-2 {
  margin-top: .8rem !important;
}

.mt-3 {
  margin-top: 1.6rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-02 {
  margin-bottom: .2rem !important;
}

.mb-3 {
  margin-bottom: 1.6rem !important;
}

.mb-1 {
  margin-bottom: .5rem !important;
}

.mb-2 {
  margin-bottom: 1rem !important;
}

.mb-24 {
  margin-bottom: 2.4rem !important;
}

.mt-3 {
  margin-top: 1.4rem !important;
}

.mt-4 {
  margin-top: 2.4rem !important;
}

.mt-16 {
  margin-top: 1.6rem !important;
}

.mt-6 {
  margin-top: 4rem !important;
}

.ml-6 {
  margin-left: .6rem !important;
}

.ml-10 {
  margin-left: 1rem !important;
}

.pt-null {
  padding-top: 0 !important;
}

.border-none {
  border: none !important;
}

.hw-pt20 {
  padding-top: 2rem !important;
}

.hw-gapxy10 {
  gap: 1rem !important;
}

.flex-end {
  align-items: flex-end !important;
}

.hw-gapx10y20 {
  row-gap: 1rem !important;
  column-gap: 2rem !important;
}

.hw-gapy4 {
  column-gap: .4rem !important;
}

.hw-gapy6 {
  column-gap: .6rem !important;
}

.hw-gapy8 {
  column-gap: .8rem !important;
}

.hw-gapy10 {
  column-gap: 1rem !important;
}

.hw-gapy16 {
  column-gap: 1.6rem !important;
}

.hw-gapy20 {
  column-gap: 2rem !important;
}

.hw-gapx4 {
  row-gap: .4rem !important;
}

.hw-gapx8 {
  row-gap: .8rem !important;
}

.hw-gapx10 {
  row-gap: 1rem !important;
}

.hw-gapx16 {
  row-gap: 1.6rem !important;
}

.color-inherit {
  color: inherit;
}

.hw-2col--grid {
  display: grid;
  grid-template-columns: auto 1fr;
}

.grid-rowspan2 {
  grid-row: span 2;
}

.ms-auto {
  margin-left: auto !important;
}

.w-100 {
  width: 100% !important;
}

.w-50 {
  width: 50% !important;
}

.overflow-hidden {
  overflow: hidden;
}

.hw-align--stretchFull {
  align-items: stretch !important;
  height: 100% !important;
}

.no-wrap {
  white-space: nowrap;
}

.wrap {
  flex-wrap: wrap !important;
}

.overflow-ellipsis {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 750px) {
  .hw-text22 {
    font-size: 2.2rem;
    line-height: 1.27273;
  }
}

.hw-red--alertBox {
  border-radius: 0.5rem;
  background: rgba(218, 16, 42, 0.10);
  padding: 1.6rem;
}

.hw-red--alertBox ol {
  padding: 0;
  list-style-position: inside;
  margin: 0;
}

/*.hw-page--titlebar {
    display: none;
  }*/
.hw-link {
  padding: 0;
  background: rgba(0, 0, 0, 0);
  border: none;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  font-weight: bold;
  color: var(--hw-brand-orange);
  font-size: 1.4rem;
  cursor: pointer;
  transition: color .2s ease;
}

.hw-link:hover {
  color: var(--hw-brand-blue);
}

.hw-link--gray,
.hw-link--grayHover:hover {
  color: var(--hw-gray-800);
}

.hw-link--gray700 {
  color: var(--hw-gray-700);
}

.hw-link--gray:hover,
.hw-link--gray700:hover {
  color: var(--hw-brand-orange);
}

.hw-badge--tooltip {
  background-color: var(--hw-brand-orange-light) !important;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10) !important;
  color: var(--hw-black) !important;
  padding: .6rem 1rem !important;
  white-space: nowrap;
  opacity: 1 !important;
}

.hw-container--full,
.hw-container,
.hw-page--titlebar,
.hw-blue--grid {
  padding-left: 2rem;
  padding-right: 2rem;
}

.hw-blue--grid {
  background-color: var(--hw-brand-blue);
  color: var(--hw-white);
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.hw-form--input {
  background-color: var(--hw-white);
  border: .1rem solid var(--hw-gray-600);
  padding: 1rem 1.2rem;
  border-radius: .5rem;
  font-size: 1.4rem;
  line-height: 1.5;
  color: var(--hw-gray-900);
  letter-spacing: 0;
  min-height: 4.4rem;
  width: 100%;
}

select.hw-form--input {
  color: var(--hw-gray-800);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right 1.5rem center;
  background-size: 2.1rem 2rem;
  -webkit-appearance: none;
  appearance: none;
  padding-right: 3.5rem;
  font-family: var(--hw-body-font-family);
}

.hw-form--input:hover {
  bborder-color: var(--hw-gray-800);
}

.hw-form--input:focus {
  border-color: var(--hw-brand-orange);
  outline: none !important;
}

/* custom plain dropdown (gender / prefix) */
.hw-gsel {
  position: relative;
  width: 100%;
}
.hw-gsel--control {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  width: 100%;
  min-height: 4.4rem;
  padding: 1rem 1.2rem;
  background: var(--hw-white, #fff);
  border: 0.1rem solid var(--hw-gray-600, #d6dbe6);
  border-radius: 0.5rem;
  font-family: inherit;
  font-size: 1.4rem;
  line-height: 1.5;
  color: var(--hw-gray-900, #1b2439);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.hw-gsel--control:hover {
  border-color: var(--hw-gray-800, #9aa3b5);
}
.hw-gsel.is-open .hw-gsel--control {
  border-color: #3264ff;
  /* box-shadow: 0 0 0 0.3rem rgba(50, 100, 255, 0.12); */
}
.hw-gsel.is-error .hw-gsel--control {
  border-color: #e5484d;
}
.hw-gsel--value {
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hw-gsel--value.is-placeholder {
  color: var(--hw-gray-800, #98a2b6);
}
.hw-gsel--chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  color: var(--hw-gray-700, #6b7488);
  transition: transform 0.2s ease;
}
.hw-gsel--chevron svg {
  width: 2rem;
  height: 2rem;
}
.hw-gsel.is-open .hw-gsel--chevron {
  transform: rotate(180deg);
}
.hw-select--chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  color: var(--hw-gray-700, #6b7488);
  transition: transform 0.2s ease;
}
.hw-select--chevron svg {
  width: 2rem;
  height: 2rem;
}
.hw-select--chevron.is-open {
  transform: rotate(180deg);
}
.hw-gsel--menu {
  position: absolute;
  top: calc(100% + 0.6rem);
  left: 0;
  right: 0;
  z-index: 40;
  margin: 0;
  padding: 0.6rem;
  list-style: none;
  background: var(--hw-white, #fff);
  border: 0.1rem solid var(--hw-gray-300, #e6e9f0);
  border-radius: 0.8rem;
  box-shadow: 0 1.2rem 2.8rem rgba(16, 24, 40, 0.14);
  animation: hwGselIn 0.14s ease;
}
@keyframes hwGselIn {
  from { opacity: 0; transform: translateY(-0.4rem); }
  to { opacity: 1; transform: translateY(0); }
}
.hw-gsel--option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  padding: 1rem 1.2rem;
  font-size: 1.4rem;
  color: var(--hw-gray-900, #1b2439);
  border-radius: 0.6rem;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
}
.hw-gsel--option:hover {
  background: var(--hw-gray-100, #f3f5f9);
}
.hw-gsel--option.is-selected {
  color: #3264ff;
  font-weight: 600;
  background: rgba(50, 100, 255, 0.08);
}
.hw-gsel--option svg {
  color: #3264ff;
  flex: none;
}
@media (min-width: 992px) {
  .hw-gsel--control {
    font-size: 1.6rem;
    line-height: 1.75;
  }
}

/* custom phone code dropdown */
.hw-pcsel {
  position: relative;
  display: flex;
  flex: 1;
  min-width: 0;
}
.hw-pcsel--control {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  min-height: 4.4rem;
  padding: 1rem 1.2rem;
  padding-right : 2rem;
  background: transparent;
  border: none;
  border-right: 0.1rem solid var(--hw-gray-600, #D7D7D7);
  font-family: inherit;
  font-size: 1.4rem;
  color: var(--hw-gray-900, #1b2439);
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
}
.hw-pcsel--flag {
  width: 2rem;
  height: 2rem;
  border-radius: 0.2rem;
  object-fit: cover;
  flex: none;
}
.hw-pcsel--input {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
  color: var(--hw-gray-900, #1b2439);
  cursor: pointer;
  text-overflow: ellipsis;
}
.hw-pcsel.is-open .hw-pcsel--input {
  cursor: text;
}
.hw-pcsel--input::placeholder {
  color: var(--hw-gray-800, #98a2b6);
  opacity: 1;
}
.hw-pcsel--chevron {
  display: inline-flex;
  align-items: center;
  padding-left: 0.4rem;
  color: var(--hw-gray-700, #6b7488);
  transition: transform 0.2s ease;
  flex: none;
}
.hw-pcsel--chevron svg {
  width: 1.8rem;
  height: 1.8rem;
}
.hw-pcsel.is-open .hw-pcsel--chevron {
  transform: rotate(180deg);
}
.hw-pcsel.is-error .hw-pcsel--control {
  border-right-color: #e5484d;
}
.hw-pcsel--menu {
  position: fixed;
  z-index: 9999;
  max-width: 86vw;
  background: #fff;
  border: 0.1rem solid var(--hw-gray-300, #e6e9f0);
  border-radius: 0.8rem;
  box-shadow: 0 1.2rem 2.8rem rgba(16, 24, 40, 0.14);
  overflow: hidden;
  animation: hwGselIn 0.14s ease;
}
.hw-pcsel--list {
  list-style: none;
  margin: 0;
  padding: 0.4rem;
  max-height: 23rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: var(--hw-gray-300, #cfd6e4) transparent;
}
.hw-pcsel--list::-webkit-scrollbar {
  width: 6px;
}
.hw-pcsel--list::-webkit-scrollbar-thumb {
  background: var(--hw-gray-300, #cfd6e4);
  border-radius: 999px;
}
.hw-pcsel--list::-webkit-scrollbar-track {
  background: transparent;
}
.hw-pcsel--option {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.9rem 1rem;
  font-size: 1.4rem;
  color: var(--hw-gray-900, #1b2439);
  border-radius: 0.6rem;
  cursor: pointer;
}
.hw-pcsel--option:hover {
  background: var(--hw-gray-100, #f3f5f9);
}
.hw-pcsel--option.is-selected {
  background: rgba(50, 100, 255, 0.08);
  color: #3264ff;
  font-weight: 600;
}
.hw-pcsel--empty {
  padding: 1.2rem 1rem;
  font-size: 1.4rem;
  color: var(--hw-gray-700, #6b7488);
  text-align: center;
}
@media (min-width: 992px) {
  .hw-pcsel--control {
    font-size: 1.6rem;
  }
}

.hw-search--destinationRow>.col-md-3>svg {
  flex-shrink: 0;
}

.row.hw-search--destinationRow {
  min-height: 5rem;
}

.hw-expire--session__bookingConfirmed {
  padding-top: 1.6rem;
  padding-bottom: 1.6rem;
  min-height: 11.2rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.hw-text--right {
  text-align: right !important;
}

.hw-icon--tickcircle svg {
  width: 3rem;
  height: 3rem;
}

.hw-icon--tickcircle .hw-icon--tickcircleBox svg {
  width: 1.8rem;
  height: 1.2rem;
}

.hw-passenger--listShow .hw-inner--fullWidth>div>div {
  min-height: 4.4rem;
  border-radius: .5rem !important;
}

.hw-passenger--listShow .hw-inner--fullWidth>div>div:hover {
  border-color: var(--hw-black);
}

.hw-passenger--listShow .hw-inner--fullWidth>div>div:focus {
  border-color: var(--hw-brand-orange);
  outline: none !important;
}

.hw-icon--tickcircleBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  border-radius: 50%;
  min-width: 3rem;
  min-height: 3rem;
}

@media (min-width: 901px) {
  .row.hw-search--destinationRow {
    --bs-gutter-x: 2rem;
  }

  .hw-expire--session__bookingConfirmed {
    padding-top: 2.4rem;
    padding-bottom: 2.4rem;
  }
}

@media (min-width: 992px) {
  .hw-icon--tickcircle svg {
    width: 5rem;
    height: 5rem;
  }

  .hw-icon--tickcircleBox {
    min-width: 5rem;
    min-height: 5rem;
  }

  .hw-passenger--listShow .hw-inner--fullWidth>div>div {
    min-height: 5rem;
  }

  .hw-bookId {
    padding-left: 8rem;
  }

  .hw-container--full,
  .hw-container {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .hw-page--titlebar,
  .hw-blue--grid {
    padding-left: 3.2rem;
    padding-right: 4rem;
  }

  .hw-form--input {
    font-size: 1.6rem;
    line-height: 1.75;
  }

  .hw-form--input.markup-price {
    padding: 1.2rem 1.5rem;
    border-radius: .8rem;
    font-size: 1.4rem;
    line-height: 1.5;
    min-height: 4.8rem;
  }

  select.hw-form--input {
    background-position: right 2rem center;
    background-size: 2.5rem 2.4rem;
    padding-right: 4rem;
    text-overflow: ellipsis;
  }
}

@media (min-width: 1025px) {
  .row.hw-search--destinationRow {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 1400px) {
  .row.hw-search--destinationRow {
    --bs-gutter-x: 4.8rem;
  }
}

@media (max-width: 1024px) {
  .hw-dtr--mtext {
    font-size: 1.4rem;
    line-height: 1.71429;
  }

  .hw-dtr--dtext {
    font-size: 1.2rem;
    line-height: 1.5;
  }

  .hw-text18.hw-dtr--dtext {
    font-size: 1.8rem;
    line-height: 1.556;
  }

  .row.hw-search--destinationRow .hw-btn {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .row.hw-search--destinationRow .hw-btn svg {
    width: 2rem;
    height: 2rem;
  }
}

@media (max-width: 991px) {
  .hw-2col--grid.hw-gapy20 {
    column-gap: 1rem !important;
  }

  .hw-bookId {
    padding-left: 4.6rem;
    font-size: 1.6rem;
  }
}

@media (max-width: 479px) {

  .hw-container--full,
  .hw-container,
  .hw-page--titlebar,
  .hw-blue--grid {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  /* .hw-widget--flight .hw-widget--card {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    } */

}

.hw-header {
  border-bottom: .1rem solid rgba(51, 51, 51, 0.10);
  background-color: var(--hw-white);
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 99999;
}

.hw-header .hw-container--full {
  min-height: 8.2rem;
}

.hw-announcementBar {
  height: 2.8rem;
  background-color: var(--hw-brand-blue);
  color: var(--hw-white);
}

.hw-announcementList {
  display: flex;
  justify-content: space-between;
  column-gap: 1rem;
  overflow-x: auto;
}

.hw-announcementitem {
  white-space: nowrap;
}

.header-nav .nav-item.dropdown>.nav-link {
  padding: .6rem 1.2rem;
  border-radius: 1rem;
  display: inline-flex;
  align-items: center;
}

.nav-profile {
  column-gap: 1rem;
  font-weight: 500;
  background-color: var(--hw-gray-300);
}

.hw-nav--icon {
  display: inline-flex;
  align-items: center;
  line-height: 0;
}

.hw-nav--icon svg {
  width: 2.4rem;
  height: 2.4rem;
}

.hw-ntf--badge {
  position: absolute;
  background-color: var(--hw-brand-orange);
  width: 1.4rem;
  height: 1.4rem;
  line-height: 1.2;
  font-size: 1.2rem;
  text-align: center;
  border-radius: 50%;
  bottom: 0;
  right: 1.2rem;
  color: var(--hw-white);
  font-weight: normal;
}

.nav-link.nav-notification:hover,
.nav-profile:hover {
  background-color: var(--hw-brand-orange-light);
  color: var(--hw-black);
}

.dropdown-menu {
  background-color: var(--hw-white);
  color: inherit;
  border-radius: 0.5rem;
  min-width: 27rem;
  margin-top: 1rem !important;
  border: none;
  padding: 1.6rem;
  display: none;
  /* position: absolute; */
  margin: 0;
  text-align: left;
  list-style: none;
  background-clip: padding-box;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
}

.dropdown-menu.show {
  display: block;
}

.dropdown-menu-end {
  --hw-position: end;
}

.hw-sidebar {
  position: fixed;
  top: 11rem;
  left: 0;
  bottom: 0;
  width: 26rem;
  z-index: 100;
  transition: width 0.2s ease;
  /* overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: var(--hw-brand-orange-light) var(--hw-gray-100); */
  background-color: var(--hw-gray-300);
  padding: 1rem 0;
  border-top-right-radius: 2rem;
  border-bottom-right-radius: 2rem;
  row-gap: 1rem;
  display: grid;
  grid-template-rows: auto auto 1fr;
}

.hw-sidebar--toggle {
  display: flex;
  justify-content: center;
  /* padding-left: 2rem;
    padding-right: 2rem; */
}

.js-toggle--sidebar {
  padding: 1.2rem;
  line-height: 0;
  position: relative;
  border-radius: 1rem;
  cursor: pointer;
  transition: background-color .2s ease-out;
}

.js-toggle--sidebar:hover {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
}

.hw-sidebar .hw-sidebar--nav {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--hw-brand-orange-light) var(--hw-gray-100);
  padding-left: 1rem;
  padding-right: 1rem;
}

.hw-sidebar--nav>.nav-item+.nav-item {
  margin-top: .8rem;
}

.hw-sidebar--nav .nav-link,
.dropdown-item {
  padding: 1rem 1.2rem;
  background-color: rgba(0, 0, 0, 0);
  transition: background-color .2s ease-in-out;
  display: flex;
  align-items: center;
  column-gap: 1rem;
  white-space: nowrap;
  border-radius: 1rem;
  transition: background-color .2s ease, color .2s ease;
}

.hw-sidebar--nav .nav-link.active {
  background-color: var(--hw-brand-blue);
  color: var(--hw-white);
}

.hw-sidebar--nav .nav-link:not(.active):hover,
.dropdown-item:hover {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
}

.dropdown,
.dropdown-center,
.dropend,
.dropstart,
.dropup,
.dropup-center {
  position: relative;
}

.dropdown-divider {
  border-color: var(--hw-gray-400);
  border-top-width: 0;
}

.hw__dropdown-profile .dropdown-divider {
  margin-left: -2rem;
  margin-right: -2rem;
}

.hw-sidebar--profileImg {
  display: inline-flex;
  width: 10rem;
  height: 10rem;
  align-items: center;
  line-height: 0;
}

.hw-nav--linkIcon {
  display: inline-flex;
  align-items: center;
  line-height: 0;
}

.dropdown-menu.hw__currency-dropdown {
  min-width: 22rem;
}

.dropdown-menu.hw__currency-dropdown li {
  text-transform: uppercase;
  color: var(--hw-black);
  cursor: pointer;
}

.header-nav .nav-link.nav-currency {
  column-gap: .8rem;
}

.header-nav .nav-link.nav-currency.show .hw-nav--icon {
  color: var(--hw-brand-orange);
}

.dropdown-menu.hw__currency-dropdown li:hover {
  color: var(--hw-brand-orange);
}

.dropdown-menu.hw__currency-dropdown li+li {
  margin-top: 1rem;
}

.hw-app--main {
  position: relative;
  /* margin-top: 7rem; */
  min-height: calc(100vh - 7rem);
}

.hw-header.fixed-top+.hw-app--main {
  margin-top: 7rem;
}

.hw-page--titlebar {
  padding-top: 2rem;
}

/*New header*/
.hw-wallet--box {
  background-color: rgba(var(--hw-brand-orange-rgb), 0.10);
  padding: .4rem 1rem;
  border-radius: 0.5rem;
  display: flex;
  min-height: 4.2rem;
  justify-content: center;
  min-width: 4.2rem;
  border: 1px solid var(--hw-brand-orange);
  align-items: center;
  column-gap: 0.4rem;
}

.hw-wallet--box svg {
  width: 1.8rem;
  height: 1.8rem;
  display: block;
}

.hw-nav--profile {
  cursor: pointer;
  color: var(--hw-brand-blue) !important;
  column-gap: 0.4rem;
  padding-right: 3.2rem;
}

.hw-nav--profile img {
  max-width: 40px;
  max-height: 40px;
  overflow: hidden;
  background: var(--hw-gray-100);
  font-size: 0;
}

.header-nav {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.hw-wallet--boxWallet {
  display: flex;
  align-items: center;
  column-gap: 0.4rem;
}

.hw-header--wrapper {
  min-height: 7rem;
  display: flex;
}

.hw-header--wrapper {
  justify-content: space-between;
}

.hw-header--dropdownProfile>.hw-main--menuItem:not(:first-child) .hw-main--menuItemLink {
  padding-top: 1rem;
}

.header-nav .hw-header--dropdownProfile .hw-main--menuItemLink {
  white-space: nowrap;
}

@media (min-width:600px) {
  .hw-wallet--box {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (min-width:990px) {
  .hw-nav--profile {
    column-gap: 1.6rem;
  }

  /* .header-nav {
 min-width: 23.6rem;
} */
  .hw-header--wrapper {
    min-height: 9.6rem;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
  }

  .hw-header--wrapper .header-nav {
    align-items: flex-end;
  }

  .hw-app--main {
    /* margin-top: 9.6rem; */
    min-height: calc(100vh - 9.6rem);
  }

  .hw-header.fixed-top+.hw-app--main {
    margin-top: 9.6rem;
  }
}

@media (min-width: 1300px) {
  .hw-wallet--box {
    padding: .8rem 2.4rem;
    min-height: 6.4rem;
  }
}

@media (max-width:480px) {
  .hw-header--wrapper .header-nav {
    margin-inline: 8px;
  }
}

@media (max-width:990px) {
  .hw-header--wrapper .header-nav {
    margin-inline: auto;
  }

  .hw-header-line {
    display: none !important;
  }
}

/*End Header*/

/*sidebar toggle*/
.notification-item .hw__nav-icon--ntf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.notification-item .hw__nav-icon--ntf {
  width: 2.4rem;
  height: 2.4rem;
  min-width: 2.4rem;
  background-size: 2.4rem 2.4rem;
  background-position: center center;
  background-repeat: no-repeat;
}

.hw__notifications-dropdown .dropdown-divider {
  margin: 1rem -2rem;
}

@media (min-width: 861px) {
  .hw__notifications-dropdown {
    min-width: 34rem;
  }
}

@media (min-width: 1120px) {
  .hw__notifications-dropdown {
    min-width: 58.5rem;
  }
}

@media (min-width: 768px) {
  body {
    font-size: 1.6rem;
  }

  body:not(.sidebar-collapsed) .hw-sidebar {
    width: 9rem;
    padding-left: 0;
    padding-right: 0;
  }

  body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--nav {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  body:not(.sidebar-collapsed) .hw-sidebar--nav .nav-link {
    justify-content: center;
  }

  body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--profileImg {
    width: 9rem;
    height: 9rem;
  }

  .hw-sidebar--nav .nav-link {
    min-height: 4.8rem;
  }

  /* body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--nav {
        padding-left: 2rem;
        padding-right: 2rem;
    } */

  body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--profileImg img {
    transform: scale(.5);
  }

  body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--profile .h6,
  body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--profile .hw-text14 {
    opacity: 0;
  }

  body:not(.sidebar-collapsed) .hw-sidebar .nav-link {
    column-gap: 0;
    /* justify-content: center; */
  }

  body:not(.sidebar-collapsed) .hw-sidebar .nav-link span {
    font-size: 0;
    line-height: 0;
    display: none;
    height: 0;
    width: 0;
  }

  /* .hw-sidebar .hw-sidebar--nav {
        margin-top: 1rem;
    } */
}

@media (max-width: 767px) {
  .hw-sidebar .hw-sidebar--toggle {
    display: none !important;
  }

  .hw-sidebar {
    transition: left .2s ease;
    padding-top: 2rem;
  }

  body:not(.sidebar-collapsed) .hw-sidebar {
    left: -26.5rem;
  }

  .hw-header .hw-logo {
    padding-left: 3.75rem;
  }

  .toggle-sidebar--btn {
    position: fixed;
    top: 5.5rem;
    left: 2rem;
    width: 3rem;
    height: 3rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    left: 1.5rem;
    z-index: 9999;
  }

  .hw__hamburg {
    display: block;
    width: 2rem;
    height: 2rem;
  }

  .hw__hamburg span {
    display: block;
    width: 1.8rem;
    height: .2rem;
    margin-bottom: .4rem;
    position: relative;
    background: var(--hw-black);
    transform-origin: 4px 0px;
    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0), background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0), opacity 0.55s ease;
  }

  .hw__hamburg>span:nth-of-type(3) {
    transform-origin: 0% 0%;
  }

  .sidebar-collapsed .hw__hamburg span {
    opacity: 1;
    transform: rotate(45deg) translate(1px, 1px);
  }

  .sidebar-collapsed .hw__hamburg span:nth-of-type(2) {
    opacity: 0;
    transform: rotate(0deg) scale(0.2, 0.2);
  }

  .sidebar-collapsed .hw__hamburg span:nth-of-type(3) {
    transform: rotate(-45deg) translate(0, -1px);
  }

  body:not(.sidebar-collapsed) .hw-menu--overlay {
    opacity: 0;
  }

  .hw-menu--overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(var(--hw-brand-blue-rgb), .5);
    z-index: 99;
    pointer-events: none;
    opacity: 1;
    transition: opacity .3s ease;
  }
}

/*End sidebar toggle*/
.hw-page--titlebar {
  margin-bottom: 2rem;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
}

.breadcrumb-item+.breadcrumb-item::before {
  float: left;
  padding-right: .4rem;
  padding-left: .4rem;
  color: var(--hw-gray-800);
  content: "/";
}

.breadcrumb .text-muted:not(:hover),
.breadcrumb li {
  color: var(--hw-gray-800);
}

.breadcrumb li {
  font-size: 1.4rem;
  line-height: 1.71429;
  font-weight: 500;
}

.hw-widget--card {
  padding: 1.6rem;
  background-color: var(--hw-gray-300);
  border-radius: 0.5rem;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.hw-widget.hw-widget--flight.hw-widget--flight__open {
  padding: 0;
  /* min-height: 23.3rem; */
  /* min-height: 16.5rem; */
  /* position: relative; */
  position: sticky;
  top: 0;
  z-index: 1000;
  /* position: sticky;
    top: 0;
    z-index: 2; */
}

.hw-widget.hw-widget--flight.hw-widget--flight__open {
  background-color: var(--hw-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);
}

.hw-widget.hw-widget--flight.hw-widget--flight__open .hw-widget--card {
  padding-left: 0;
  padding-right: 0;
}


.hw-widget.hw-widget--flight.hw-widget--flight__open .hw-widget--card label.hw-black {
  color: var(--hw-white) !important;
}

.hw-tab {
  display: flex;
  flex-wrap: wrap;
  column-gap: .5rem;
  margin-bottom: 1.2rem;
  row-gap: .5rem;
}

.hw-tab button {
  padding: 0.4rem 1.2rem 0.4rem 3.6rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  font-size: 1.4rem;
  line-height: 1.55556;
  background-color: var(--hw-white);
  text-transform: capitalize;
  transition: .2s ease;
  color: var(--hw-brand-blue);
  position: relative;
}

.hw-tab button:not(.active):hover {
  background-color: var(--hw-brand-orange-light);
  border-color: var(--hw-brand-orange-light);
  color: var(--hw-black);
}

.hw-tab button.active {
  background-color: var(--hw-brand-orange-light);
}

.hw-tab button::before {
  content: '';
  position: absolute;
  width: 1.6rem;
  height: 1.6rem;
  border: 1px solid var(--hw-brand-blue);
  left: 1.2rem;
  border-radius: 999px;
}

.hw-tab button.active::before {
  background-color: var(--hw-brand-orange);
  outline: 1px solid var(--hw-brand-orange);
  border-color: var(--hw-white);
  border-width: 2px;
}

@media (min-width: 576px) {
  .hw-tab button {
    font-size: 1.6rem;
  }
}


/*input related css*/
.hw-row--input .css-1u9des2-indicatorSeparator {
  display: none !important;
}

.hw-row--input .css-1jqq78o-placeholder {
  color: var(--hw-brand-blue);
  font-weight: 500;
  padding-left: 3.4rem;
}

/* .hw-row--input .css-1xc3v61-indicatorContainer {
    color: var(--hw-gray-800);
} */
.hw-input--switchGroup div svg {
  color: inherit !important;
}

.hw-row--input .css-1u80x8j-control {
  border-color: var(--hw-gray-600) !important;
  background-color: var(--hw-white) !important;
  border-radius: 0.5rem !important;
  width: 100%;
  /* min-height: 5rem; */
  min-height: 5.4rem;
  margin: 0 !important;
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}

/* .hw-row--input .css-1pc1zkh-control {
    margin: 0 !important;
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  } */
.hw-row--input .hw-input--switchGroup .css-1u80x8j-control,
.hw-row--input .hw-input--switchGroup .css-1pc1zkh-control {}

.hw-row--input .hw-input--switchGroup>div>div:hover {
  border-color: var(--hw-brand-orange) !important;
  background-color: var(--hw-brand-orange-light) !important;
  cursor: pointer;
}

.hw-row--input .hw-input--switchGroup>div>div {
  padding-left: 3.5rem !important;
}

.hw-input--switchGroup>div>div {
  width: auto !important;
  min-height: 5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: left 1rem center;
  background-size: 2rem 2rem;
  margin: 0 !important;
  padding-left: 4.4rem !important;
  padding-right: 2rem !important;
}

.hw-input--switchGroup div {
  margin: 0 !important;
  padding: 0 !important;
  color: var(--hw-brand-blue);
  font-weight: bold;
}

.hw-input--switchGroup {
  display: flex;
  align-items: center;
  column-gap: 0;
  width: 40%;
  position: relative;
}

.hw-input--error-search {
  color: var(--hw-red);
  position: absolute;
  bottom: -26px;
  left: 0;
  font-size: 1.2rem;
  line-height: 1.5;
  z-index: 11;
  background: #fbe7e9;
  padding: 0.4rem;
  border-radius: 0.5rem;
}

.hw-input--error-search.left {
  left: 0;
}

.hw-input--error-search.right {
  left: auto;
  right: 0;
}

.hw-input--switchGroup>div {
  flex: 1;
}

.hw-row--input .css-1pc1zkh-control {
  background-color: var(--hw-brand-orange-light) !important;
  border-color: var(--hw-brand-orange) !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  outline: none !important;
}

/* .hw-row--input .hw-input--switchGroup .css-1jqq78o-placeholder + div {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M2.49984 18.9998H21.4998V20.9998H2.49984V18.9998ZM22.0698 9.63982C21.8598 8.83982 21.0298 8.35982 20.2298 8.57982L14.9198 9.99982L8.01984 3.56982L6.08984 4.07982L10.2298 11.2498L5.25984 12.5798L3.28984 11.0398L1.83984 11.4298L4.42984 15.9198L20.9998 11.4898C21.8098 11.2598 22.2798 10.4398 22.0698 9.63982Z' fill='%23283D6B'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 3.4rem;
    background-size: 2.4rem 2.4rem;
    margin: 0 !important;
  } */

.hw-input--switchGroup .hw-switch {
  background-color: var(--hw-white);
  color: var(--hw-brand-orange);
  width: 3.4rem;
  height: 3.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  margin: 0 -12px;
  position: relative;
  z-index: 1;
  border: 1px solid var(--hw-brand-orange);
  cursor: pointer;
}

.hw-input--switchGroup .hw-switch:hover {
  background-color: var(--hw-brand-orange-light);
}

.hw-input--switchGroup .hw-switch svg {
  width: 2rem;
  height: 2rem;
}

.hw-input--groupCol {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: flex-start;
  column-gap: 1rem;
}

.hw-filter--searchBtn {
  background-color: var(--hw-brand-orange);
  min-height: 4rem;
  border: none;
  padding: 1rem;
  border-radius: 0.5rem;
  color: var(--hw-white);
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  transition: background-color .2s ease;
  cursor: pointer;
  font-weight: bold;
  font-size: 1.4rem;
  min-width: 15rem;
}

.hw-filter--searchBtn:hover {
  background-color: var(--hw-brand-orange-hover);
}

.hw-input--input {
  background-color: var(--hw-white);
  display: flex;
  align-items: center;
  min-height: 5rem;
  border: .1rem solid var(--hw-gray-400);
  border-radius: 0.5rem;
  padding: .2rem 1rem;
  color: var(--hw-gray-800);
  column-gap: .5rem;
  cursor: pointer;
}

.hw-input--input.disabled {
  background-color: var(--hw-gray-300);
  color: var(--hw-gray-400);
  border-color: var(--hw-gray-400) !important;
  cursor: no-drop;
}

.hw-input--input.disabled svg {
  opacity: .2;
}

.hw-inputCheck--airline__js {
  cursor: pointer;
}

.hw-inputCheck--airline__js svg {
  color: var(--hw-black);
}

.hw-row--input.hw-row--inputFirst>.hw-input--input {
  display: grid;
  grid-template-columns: auto 1fr;
}

.hw-passenger--getValue {
  color: var(--hw-gray-650);
  font-size: 1.4rem;
  line-height: 1;
}

.hw-row--input.hw-row--inputFirst>.hw-input--input svg {
  grid-row: span 2;
}

.hw-input--input:not(.active):hover {
  border-color: var(--hw-brand-orange) !important;
  background-color: var(--hw-brand-orange-light);
}

.hw-input--input.active {
  border-color: var(--hw-brand-orange);
  /* background-color: var(--hw-brand-orange-light); */
}

.hw-input--input.active svg {
  color: var(--hw-brand-orange) !important;
}

.hw-input--input svg {
  flex-shrink: 0;
}

.hw-row--input.hw-row--inputFirst {
  display: flex;
  column-gap: 0;
  flex-wrap: wrap;
}

.hw-row--inputFirst .react-datepicker-wrapper {
  width: 24%;
}

.hw-row--input.hw-row--inputFirst>.hw-input--input svg {
  color: var(--hw-brand-blue) !important;
}

.hw-text--hidden44 {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 4.4rem);
}

.hw-text--hidden {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.hw-row--input.hw-row--inputFirst+.hw-row--inputCheck {
  margin-top: 2.4rem;
}

.hw-flight--list svg {
  color: var(--hw-brand-orange);
  display: block;
  margin-top: .4rem;
  flex-shrink: 0;
  width: 2.4rem;
  height: 2.4rem;
}

.hw-flight--lists {
  padding: .8rem 1.6rem;
  transition: background-color .2s ease;
}

.hw-flight--lists:hover {
  background-color: var(--hw-brand-orange-light);
}

.hw-inputCheck--airline {
  position: relative;
}

.hw-inputCheck--airline .hw-flight--lists:hover,
.hw-inputCheck--airline .hw-select--option:hover,
.hw-inputCheck--airline .hw-select--option.is-focused {
  background-color: transparent;
}

.hw-inputCheck--airline .hw-select--option,
.hw-inputCheck--airline .hw-flight--lists {
  border: 0;
}

.hw-inputCheck--airline .dropdown-container {
  position: absolute;
  z-index: 10;
  width: 28rem;
  background-color: var(--hw-white);
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.12);
  border: 1px solid #e2e6ee;
  border-radius: 1rem;
  overflow: hidden;
}

/**/
.hw-calender--removeBtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1rem;
  line-height: 0;
  color: var(--hw-brand-blue);
  font-size: 1.6rem;
  cursor: pointer;
}

input[type="checkbox"] {
  --hw-form-check-bg: var(--hw-white);
  width: 2.2rem;
  height: 2.2rem;
  margin: 0;
  vertical-align: top;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: var(--hw-white);
  background-image: var(--hw-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: .1rem solid var(--hw-gray-700);
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  print-color-adjust: exact;
  border-radius: .5rem;
}

input[type="radio"] {
  --hw-form-check-bg: var(--hw-white);
  width: 2.2rem;
  height: 2.2rem;
  margin: 0;
  vertical-align: top;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: var(--hw-white);
  background-image: var(--hw-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: .1rem solid var(--hw-gray-400);
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  print-color-adjust: exact;
  border-radius: 50%;
}

input:checked[type="radio"] {
  --hw-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-color: var(--hw-white);
  border-color: var(--hw-brand-orange);
}

input:checked[type="checkbox"] {
  --hw-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-color: var(--hw-brand-orange);
  border-color: var(--hw-brand-orange);
}

.hw-hotel--Checkbox li label input[type="checkbox"] {
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 0.4rem;
}

.hw-hotel--Checkbox li label:hover input[type="checkbox"] {
  border-color: var(--hw-brand-orange);
}

.hw-input--multicityGroup {
  display: flex;
  flex-direction: column;
  row-gap: 1.2rem;
}

.hw-row--inputCheck {
  margin-top: 1.2rem;
}

/* Trip-type row: tabs + preferred-airline/direct/nearby controls on one line.
   Zero the children's own margins so they sit on the same baseline; the row
   itself carries the bottom spacing. */
.hw-tripType--row .hw-tab {
  margin-bottom: 0;
}

.hw-multiCity--field.hw-input--input svg+div {
  display: grid;
}

@media (max-width: 575px) {
  .hw-date-range-picker .hw-calender--removeBtn {
    right: 2rem;
  }

  .hw-date-range-picker .hw-calender--removeBtn svg {
    width: 1.4rem;
    height: 1.4rem;
  }
}

/*popup*/
.hw-input--groupColLeft {
  position: relative;
}

.paasenger-modal {
  position: absolute;
  right: 0;
  top: 26rem;
  z-index: 12;
  width: 100%;
  max-width: 47.4rem;
}

.paasenger-modal .DT--card-container {
  border: 1px solid var(--hw-gray-600);
  background: var(--hw-white);
  border-radius: 0.5rem;
}

.DT--section {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  padding: 1.6rem 1.6rem 0;
}

.DT--title {
  color: var(--hw-black);
  font-weight: 500;
  text-transform: capitalize;
}

.DT--passenger-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: .5rem;
}

.DT--class-selector {
  padding: 1.6rem 1.6rem 0 1.6rem;
}

.DT--button-selector {
  padding: 0 1.6rem 1.6rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 2rem;
  row-gap: 1rem;
}

.DT--button-selector .hw-btn {
  padding-left: 1.6rem;
  padding-right: 1.6rem;
}

.DT--passenger-age {
  color: var(--hw-gray-800);
}

.DT--counter {
  display: flex;
  flex-shrink: 0;
  border-radius: 1rem;
  border: .1rem solid var(--hw-gray-600);
  align-items: center;
  width: 15.7rem;
  overflow: hidden;
  max-width: 12.8rem;
}

.DT--counter button {
  padding: 1rem;
  border: none;
  box-shadow: none;
  outline: none;
  background-color: rgba(0, 0, 0, 0);
  color: var(--hw-gray-800);
  font-size: 2.4rem;
  line-height: 1;
  cursor: pointer;
  min-width: 4.4rem;
  transition: .2s ease;
}

.DT--counter-display {
  flex: 1 1 auto;
  text-align: center;
  font-weight: 500;
  color: var(--hw-black-900);
}

.DT--counter button:hover {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
}

.DT-field--checkboxGroup {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-top: 1rem;
}

.DT-field--checkboxGroup .DT--class-item {
  display: flex;
  align-items: center;
  column-gap: 1rem;
  flex-grow: 1;
}

.DT-field--checkboxGroup .DT--class-item input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  border: none;
}

.DT-field--checkboxGroup .DT--class-item label {
  color: var(--hw-gray-800);
  font-weight: 500;
  padding: .6rem 1.2rem;
  font-size: 1.4rem;
  line-height: 1.71429;
  border: 1px solid var(--hw-gray-600);
  border-radius: 0.5rem;
  width: 100%;
  text-align: center;
  cursor: pointer;
}

.DT-field--checkboxGroup input:checked[type="radio"]+.DT--class-label {
  background-color: var(--hw-brand-orange-light);
  background-color: rgba(var(--hw-brand-orange-rgb), 0.1);
  border-color: var(--hw-brand-orange);
  color: var(--hw-brand-orange);
}

.DT-field--checkboxGroup .DT--class-item label {
  color: var(--hw-gray-800);
  font-weight: 500;
}

.DT--divider {
  background-color: var(--hw-gray-600);
  height: .1rem;
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
}


.DT--section {
  row-gap: 1rem;
  column-gap: 1rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.DT--section select {
  background-color: var(--hw-white);
  border: .1rem solid var(--hw-gray-400);
  padding: .5rem 1rem;
  border-radius: .4rem;
  flex: 1 0 0;
  color: var(--hw-black-900);
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: 1rem 0.6rem;
}

.DT--passenger-item {
  row-gap: 1rem;
  flex-direction: column;
  flex: 1 0 0;
  align-items: flex-start;
}

.DT--passenger-item .DT--passenger-label {
  font-size: 1.3rem;
  color: var(--hw-black-900);
}

.DT--passenger-item .DT--passenger-label b {
  font-weight: 500;
  font-size: 1.6rem;
}

.DT--section .hw-btn {
  grid-column: 3;
}

.DT--counter-display {
  width: 100%;
  max-width: 100%;
}

.DT--counter {
  width: 100%;
}

.DT--counter-value input {
  width: 100%;
}

.DT--section>hr {
  grid-column: span 3;
  width: calc(100% + 4rem);
  background-color: var(--hw-gray-400);
  border: none !important;
  height: .1rem;
  margin: 1.6rem -2rem;
}

.DT--section>hr+label {
  color: var(--hw-black);
  font-weight: 500;
  grid-column: span 3;
  margin-top: -1rem;
}

.hw-dt--selectChild {
  display: flex;
  column-gap: .2rem;
  align-items: center;
}

.hw-dt--selectChild label {
  color: var(--hw-black);
  font-weight: 500;
  min-width: 5rem;
  font-size: 1.4rem;
}

.DT--counter-value input[type="number"]::-webkit-outer-spin-button,
.DT--counter-value input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.DT--counter-value input[type="number"] {
  -moz-appearance: textfield;
}

@media (min-width: 641px) {
  .hw-widget--card {
    padding: 2rem;
    border-radius: 1rem;
  }
}

@media (min-width: 768px) {
  .hw-calender--removeBtn {
    right: 2rem;
  }

  .hw-row--input .hw-input--switchGroup>div>div {
    padding-left: 5.4rem !important;
  }

  .hw-input--switchGroup>div>div {
    background-position: left 2rem center;
    background-size: 2.4rem 2.4rem;
    padding-left: 5.4rem !important;
  }

  .hw-input--switchGroup>div {
    max-width: calc(50% - 0.6rem);
  }
}

@media (min-width: 576px) {
  .paasenger-modal {
    top: 20rem;
  }
}

@media (min-width: 768px) {
  .paasenger-modal {
    top: 13rem;
  }
}

@media (min-width: 1025px) {
  .paasenger-modal {
    /* top: 8.6rem; */
    top: 6.6rem;
  }
}

@media (max-width: 899px) {
  .paasenger-modal {

    max-width: 100%;
  }
}

@media (max-width: 640px) {
  .DT--passenger-item .DT--passenger-label {
    font-size: 1.2rem;
  }

  .DT--passenger-item .DT--passenger-label b {
    font-size: 1.4rem;
  }
}

@media (max-width: 479px) {
  .DT--passenger-item {
    row-gap: .5rem;
  }

  .paasenger-modal .DT--card-container .DT--section {
    column-gap: .5rem;
  }

  .DT--passenger-item .DT--passenger-label {
    display: flex;
    flex-direction: column;
    line-height: 1.5;
  }

  .DT--passenger-item .DT--counter button {
    padding: .6rem;
    font-size: 2rem;
    min-width: 3.2rem;
  }

  .DT--section>hr {
    margin: 1rem -1.5rem;
    width: calc(100% + 3rem);
  }

  .hw-dt--selectChild {
    align-items: stretch;
    flex-direction: column;
    row-gap: .2rem;
  }
}

/*End popup*/
.hw-btn {
  padding: 0.8rem 2rem;
  font-size: 1.4rem;
  line-height: 1.5;
  font-weight: bold;
  display: inline-flex;
  justify-content: center;
  column-gap: 1rem;
  align-items: center;
  border: .1rem solid rgba(0, 0, 0, 0);
  background-color: rgba(0, 0, 0, 0);
  color: var(--hw-black);
  cursor: pointer;
  border-radius: 0.5rem;
  transition: background-color .2s ease, color .2s ease, border-color .2s ease;
}

.hw-btn--smallSize {
  font-size: 1.4rem !important;
  line-height: 1.71429 !important;
}

.hw-btn--mdSize {
  font-size: 1.6rem;
  line-height: 1.75;
}

.hw-btn--lg {
  padding-left: 3rem;
  padding-right: 3rem;
}

.hw-btn--xl {
  padding: 1.5rem 2.8rem;
}

.hw-btn--round {
  border-radius: 999px;
}

.hw-btn--primary {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  border: none !important;
}

.hw-arrow-btn {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  border: none !important;
  font-size: 16px;
  cursor: pointer;
  border-radius: 0.5rem;
  padding: 0.6rem 1.2rem;
  transition: background-color .2s ease, color .2s ease, border-color .2s ease;
}

.hw-btn--primary:hover {
  background-color: var(--hw-brand-orange-hover);
  color: var(--hw-white);
}

.hw-btn--grayOutline {
  background: rgba(139, 139, 139, 0.20);
  color: var(--hw-gray-500);
  border: 1px solid rgba(0, 0, 0, 0);
}

.hw-btn.hw-btn--grayOutline:hover {
  border-color: var(--hw-gray-500);
}

.hw-btn--primaryOutline {
  color: var(--hw-brand-orange);
  /* background-color: var(--hw-brand-orange-light); */
  background-color: rgba(50, 100, 255, 0.10);
  border: 1px solid var(--hw-brand-orange);
}

.hw-btn--primaryOutline:hover {
  color: var(--hw-white);
  background-color: var(--hw-brand-orange);
  border-color: var(--hw-brand-orange);
}

.hw-btn--secondary,
.hw-btn--secondaryPrimaryHover {
  background-color: var(--hw-brand-orange-light);
  color: var(--hw-brand-orange);
  border: none !important;
}

.hw-btn--secondaryOutline {
  background-color: var(--hw-brand-orange-light);
  color: var(--hw-brand-orange);
  border: 1px solid rgba(0, 0, 0, 0);
}

.hw-btn--primaryOutlineActive {
  background-color: var(--hw-brand-orange-light);
  color: var(--hw-brand-orange);
  border-color: var(--hw-brand-orange);
}

.hw-btn--secondaryOutline:hover {
  background-color: var(--hw-brand-orange-light);
  color: var(--hw-brand-orange);
  border-color: var(--hw-brand-orange);
}

.hw-btn--white-outline {
  border: .1rem solid var(--hw-gray-400);
  background-color: var(--hw-white);
  color: var(--hw-body-color);
}

.hw-btn--secondaryPrimaryHover:hover {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
}

.hw-btn--white-outline:hover {
  background-color: var(--hw-brand-orange-light);
  border-color: var(--hw-brand-orange);
}

.hw-btn--secondary:hover {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
}

.hw-btn--secondaryDefault {
  border-color: var(--hw-brand-blue);
  color: var(--hw-brand-blue);
}

.hw-btn--whiteDefault {
  border-color: var(--hw-white);
  color: var(--hw-white);
}

.hw-btn.hw-btn--whiteDefault:hover {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  border-color: var(--hw-brand-orange);
}

.hw-btn--secondaryDefault:hover {
  background-color: var(--hw-brand-blue);
  color: var(--hw-white);
}

.hw-btn--mn140 {
  min-width: 14rem;
  justify-content: center;
}

.hw-btn--mn176 {
  min-width: 17.6rem;
  justify-content: center;
}

.react-datepicker__tab-loop {
  position: absolute;
  z-index: 9999;
}

.hw-input--multicityGroup .hw-date-range-picker+.react-datepicker__tab-loop {
  position: absolute;
  min-width: 100%;
}

.hw-row--inputCheck {
  flex-wrap: wrap;
}

.hw-filter--actionBtn {
  /* padding-left: 1rem; */
  display: flex;
  column-gap: 1rem;
  align-items: center;
}


/* .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst:not(:last-child) {
    width: 80%;
    max-width: calc(100% - 36.6rem);
  } */
/* .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst > div:last-child {
    display: none !important;
  }
  .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst:not(:last-child) {
    width: calc(100% - 31.7rem);
  }

  .hw-filter--actionBtn {

    min-width: 31.7rem;
  }   */
.hw-filter--actionBtn .hw-btn {
  min-height: 4.4rem;
}

.hw-filter--actionBtn .hw-btn.hw-btn--secondaryOutline {
  padding-left: 1rem;
  padding-right: 1rem;
  column-gap: 0.5rem;
}

.hw-filter--actionBtn>.hw-btn.hw-btn--grayOutline {
  padding: 1rem;
}

.hw-btn svg,
.hw-filter--searchBtn svg {
  width: 2rem;
  height: 2rem;
  display: block;
}

/*List page*/
.hw-mnh--76 {
  min-height: 7.6rem;
}

.hw-grid--2auto {
  display: grid;
  align-items: center;
  column-gap: 1rem;
  grid-template-columns: 1fr auto;
  width: 100%;
}

.hw-search--flightFilter {
  grid-template-rows: auto 1fr;
  display: grid;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--hw-gray-200) var(--hw-gray-100);
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.3s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: var(--hw-white);
  border-radius: 0.5rem;
}

.hw-search--flightList {
  position: relative;
  /* padding-top: 2.4rem; */
}

.hw-search--flightFilterResult {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 1.2rem;
  padding-bottom: 2rem;
  padding-top: 2.4rem;
}

.hw-search--flightCheckbox>li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .8rem 0;
  column-gap: .5rem;
}

.hw-search--flightFilterResult__list {
  display: flex;
  flex-direction: column;
  /* row-gap: 1.2rem; */
  row-gap: 0.8rem;
}

.hw-search--flightFilterResult__listItem {
  padding: 1.5rem;
  background-color: var(--hw-white);
  border-radius: 0.5rem;
  position: relative;
  /* box-shadow: 0px 0px 10px 0px rgba(var(--hw-black-rgb), 0.10); */
}

.hw-flight--listBox {
  display: flex;
  justify-content: space-between;
  column-gap: 2rem;
  position: relative;
}

.hw-flight--listBox .destination {
  display: flex;
  align-items: center;
  gap: 1.6rem;
  flex: 1 0 0;
  justify-content: space-between;
}

.hw-flight--listBox__flight {
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1 0 0;
  text-align: center;
}

.hw-flight--line {
  display: flex;
  align-items: center;
  gap: 0;
  margin: -.2rem 0;
  position: relative;
}

.hw-flight--line--stop {
  width: 0.8rem;
  height: 0.8rem;
  background-color: var(--hw-gray-500);
  border-radius: 50%;
  position: absolute;
}

.hw-flight--line--stop.hw-linestop1 {
  left: 50%;
  transform: translateX(-50%);
}

.hw-flight--line--stop.hw-linestopfull {
  left: 25%;
  transform: translateX(-25%);
}

.hw-flight--line--stop.hw-linestopfull+.hw-flight--line--stop.hw-linestopfull {
  left: 75%;
  transform: translateX(-75%);
}

.hw-flight--line--stop.hw-linestopfull+.hw-flight--line--stop.hw-linestopfull+.hw-flight--line--stop.hw-linestopfull {
  left: 50%;
  transform: translateX(-50%);
}

.hw-flight--line--stop:nth-of-type(1)+.hw-flight--line--stop {}

.hw-flight--line .circle {
  width: 0.8rem;
  height: 0.8rem;
  background-color: var(--hw-gray-500);
  border-radius: 50%;
  flex-shrink: 0;
}

.hw-flight--line .line {
  background-color: var(--hw-gray-500);
  height: .2rem;
  flex: 1 1 auto;
}

.hw-flight--iconFlight {
  line-height: 0;
  padding-left: 0.4rem;
}

.hw-search--flightFilter__frame {
  overflow: hidden;
}

.hw-search--flightFilter__frame+.hw-search--flightFilter__frame {
  margin-top: 1rem;
}


.hw-search--flightFilter__widget.duration-widget .hw-search--flightFilter__frame .bottom {
  padding: 1.6rem 1rem 4rem 0;
}

.hw-range--line {
  background-color: var(--hw-brand-orange-light);
  border-radius: 99.9rem;
}

.hw-range--line>div {
  outline: none !important;
}

.hw-range--mtext {
  white-space: nowrap;
  top: 2rem;
  font-size: 1.4rem;
  right: 0;
}

.hw-range--line .hw-range--text {
  font-size: 1.4rem;
  line-height: 1.71429;
  display: inline-flex;
  position: relative;
  top: 1.6rem;
}

.hw-range--line .hw-range--text.right {
  float: right;
}

.hw-search--flightFilter__frame .top,
.hw-search--flightFilter__frame .middle {
  padding: .4rem 0;
}



.js-toggleFilter,
.hw-search--flightFilter__action .hw-link {
  padding: 1.4rem 1.6rem;
}

.hw-search--destinationRow>.col-md-1 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.hw-search--destinationRow>.col-md-1 .hw-btn {
  padding: 1.2rem;
}

.hw-search--destinationRow>div:not(:last-child) {
  border-right: .1rem solid var(--hw-gray-500);
}

.hw-search--flightFilter__top {
  background-color: var(--hw-white);
}


.hw-search--flightFilter__action {
  display: flex;
  justify-content: space-between;
  column-gap: .5rem;
  align-items: center;
  /* padding: 1.2rem 1.6rem; */
  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.hw-search--flightFilter__action div {
  color: var(--hw-brand-blue);
  font-weight: bold;
}

.hw-search--flightFilter__action .hw-link {
  transition: opacity 0.2s ease, transform 0.2s ease;
  white-space: nowrap;
}

.hw-search--flightFilter__bodyBox {
  /* overflow: hidden; */
  transition: opacity 0.25s ease, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.hw-search--flightFilter__body {
  padding: 2rem 1.6rem;
  display: flex;
  flex-direction: column;
  /* row-gap: 2.4rem; */
  row-gap: 1.2rem;
  transition: opacity 0.25s ease, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.hw-hotel--asideFilter .hw-search--flightFilter__body {
  row-gap: 1rem;
}

.hw-search--flightFilter__widget.price-widget .hw-search--flightFilter__title.active+.hw-search--flightFilter__widgetContent {
  padding: 0 1rem 4rem;
}

.hw-search--flightFilter__title {
  padding: 0 0 0.8rem 0;
  color: var(--hw-brand-blue);
  cursor: pointer;
}

/* .hw-search--flightFilter__title.active {
    color: var(--hw-black);
  } */
.hw-search--flightFilter__iconText {
  display: flex;
  /* column-gap: 1.2rem; */
  column-gap: 0.4rem;
}

.hw-search--flightFilter__iconText>span {
  border: .1rem solid var(--hw-gray-600);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 0.4rem;
  padding: 0.8rem;
  flex: 1;
  cursor: pointer;
  font-weight: 500;
  color: var(--hw-black-900);
  transition: background-color .2s ease, color .2s ease;
  font-size: 1.2rem;
  line-height: 1.33333;
  border-radius: 0.5rem;
  text-align: center;
}

.hw-search--flightFilter__widget.stops-widget .hw-search--flightFilter__iconText>span {
  flex: 1 1 auto;
}


.hw-search--flightFilter__iconText>span:not(.active):hover {
  background-color: var(--hw-brand-orange-light);
  border-color: var(--hw-brand-orange);
}

.hw-search--flightFilter__iconText>span.active {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  border-color: var(--hw-brand-orange);
}

.hw-twoLine--icon {
  border: .1rem solid var(--hw-gray-400);
  border-radius: 1rem;
  padding: .8rem 1.2rem;
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 1rem;
  align-items: center;
  font-size: 1.4rem;
  line-height: 1.71429;
  cursor: pointer;
}

.hw-twoLine--icon:not(.active):hover {
  background-color: var(--hw-white);
  border-color: var(--hw-gray-800);
}

.hw-twoLine--icon.active {
  border-color: var(--hw-brand-orange);
  color: var(--hw-black);
}

.hw-twoLine--icon svg {
  grid-row: span 2;
}

.hw-twoLine--icon.active svg {
  color: var(--hw-brand-orange);
}

.hw-search--flightFilterResult__top .d-flex {
  column-gap: 1rem;
}

.hw-nav--tab {
  display: flex;
  align-items: center;
}

.hw-nav--tab.hw-nav--tabStyle1 {
  align-items: stretch;
}

.hw-nav--tab.hw-nav--tabStyle1 .hw-nav--tabItem {
  display: flex;
  flex: 1 0 0;
}

.hw-nav-tabLink {
  padding: .7rem 1.6rem;
  background-color: var(--hw-white);
  border: none;
  border-bottom-width: medium;
  border-bottom-style: none;
  border-bottom-color: currentcolor;
  border-bottom: .2rem solid rgba(0, 0, 0, 0);
  border-bottom-color: rgba(0, 0, 0, 0);
  font-size: 1.6rem;
  line-height: 1.75;
  font-weight: bold;
  cursor: pointer;
  color: var(--hw-gray-500);
  transition: .3s ease;
  width: 100%;
}

.hw-nav--tabStyle1 .hw-nav-tabLink {
  font-size: 1.4rem;
  line-height: 1.71429;
  border-radius: 0;
}

.hw-nav-tabLink.active {
  background-color: var(--hw-brand-orange-light);
  border-bottom-color: var(--hw-brand-orange);
  color: var(--hw-brand-blue);
  cursor: default;
}

.hw-nav-tabLink:not(.active):hover {
  color: var(--hw-brand-blue);
}

.p-null,
.p-null p {
  margin-bottom: 0 !important;
}

.hw-search--flightFilterResult__listItemDetails {
  padding-top: 1rem;
}

.hw-search--flightFilterResult__tab {
  border-top: .1rem solid var(--hw-gray-400);
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding: 1.5rem 1.5rem 0;
}

.hw-search--flightFilterResult__fareDetailsList {
  border-top: .1rem solid var(--hw-gray-400);
  margin: 1.5rem -1.5rem 0;
  padding: 1.5rem 1.5rem 0;
}

.hw-search--innerflight__listItem .flight-list {
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
  row-gap: 0.8rem;
}

.hw-search--innerflight__list {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
}

.divider-badge {
  background-color: var(--hw-gray-100);
  display: flex;
  align-items: center;
  column-gap: 1rem;
  font-size: 1.4rem;
  padding: .4rem 1.6rem;
  border-radius: 0.5rem;
  font-weight: 500;
  line-height: 1.286;
  text-align: center;
  row-gap: .5rem;
  flex-wrap: wrap;
  justify-content: center;
  color: var(--hw-brand-blue);
}

.hw-search--innerflight__divider {
  display: flex;
  align-items: center;
}

.hw-search--innerflight__divider>span {
  background-color: var(--hw-gray-600);
  height: .1rem;
  flex: 1 0 0;
  min-width: 2.5rem;
}

.hw-nav--tabFlightDetails .hw-search--innerflight__list {
  border: .1rem solid var(--hw-gray-600);
  border-radius: 0.5rem;
  background-color: var(--hw-white);
  padding: 1rem;
}

.hw-search--innerflight__listItem {
  display: flex;
  column-gap: 2rem;
  /* padding: 1.6rem; */
  align-items: center;
}

.hw-search--innerflight__listItem .flight-list .hw-flight--listBox__flight {
  min-width: 40%;
}

.hw-info--tooltip {
  display: inline-flex;
  align-items: center;
  column-gap: .5rem;
  position: relative;
  padding-top: 10px;
  margin-top: -10px;
}

.hw-info--tooltip svg {
  color: var(--hw-brand-orange);
  width: 2rem;
  height: 2rem;
}

.hw-info--hoverBox {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
  padding: 1.6rem;
  background-color: var(--hw-white);
  border-radius: 0.5rem;
  position: absolute;
  width: 100%;
  min-width: 31.1rem;
  bottom: calc(100% - 10px);
  left: -3.7rem;
  /* margin-bottom: 1.5rem; */
  display: none;
  z-index: 1;
  border: 1px solid var(--hw-gray-600);
}

/* .hw-info--hoverBox::after {
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='19' viewBox='0 0 21 19' fill='none'%3E%3Cpath d='M10.5 18.6211L20.8923 0.621094H0.107696L10.5 18.6211Z' fill='%23FEF4E7'/%3E%3C/svg%3E");
    position: absolute;
    width: 2.1rem;
    height: 1.9rem;
    bottom: -1.5rem;
    right: 48%;
  } */
.hw-info--hoverBox .list {
  display: flex;
  justify-content: space-between;
  column-gap: .5rem;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 1.71;
}

.hw-info--hoverBox .list>span:last-child:not(first-child) {
  color: var(--hw-gray-800);
  font-weight: normal;
}

.hw-info--hoverBox .list+.list {
  margin-top: 0.4rem;
}

.hw-info--tooltip:hover .hw-info--hoverBox {
  display: block;
}

.hw-info--hoverBox .list>span:last-child {
  flex-shrink: 0;
}

.hw-line--pb {
  padding: 0 1rem 1rem;
  border-bottom: .1rem solid var(--hw-black);
}

.hw-tab--textCombine {
  display: flex;
  justify-content: space-between;
}

.hw-tab--textCombineText {
  background-color: var(--hw-gray-100);
  /* border-bottom: .2rem solid var(--hw-gray-400); */
  padding: .4rem 1rem;
  flex-shrink: 0;
  width: 15rem;
}

.hw-table--border.first-td--fixed tbody>tr>td:first-child {
  width: 15rem;
}

.hw-tab--textCombine .hw-nav--tab {
  flex: 1 0 0;
}

.hw-p--gap6>p:not(:last-child) {
  margin-bottom: .6rem;
}

.hw-p--gap6>p:last-child {
  margin-bottom: 0;
}

.hw-noWrap {
  white-space: nowrap;
}

.hw-fare--listPointItem {
  font-size: 1.4rem;
  line-height: 1.71429;
}

.hw-fare--listPointItem+.hw-fare--listPointItem {
  margin-top: .6rem;
}

.hw-fare--listPointItem>span.flex-shrink--null {
  min-width: 28rem;
}

/*Table*/
.hw-table--normal {
  border-collapse: collapse;
}

.hw-table--normal thead th,
.hw-table--normal tbody td {
  padding: .5rem .4rem;
}

.hw-table--normal tbody td {
  color: var(--hw-black-900);
  font-weight: 500;
}

.hw-table--normal tfoot th {
  border-top: .1rem solid var(--hw-gray-600);
  padding: 1.5rem .4rem .5rem;
  font-size: 1.6rem;
  line-height: 1.5;
}

.hw-table--normal thead tr th:first-child,
.hw-table--normal tbody tr td:first-child,
.hw-table--normal tfoot tr th:first-child {
  padding-left: 0;
}

.hw-table--normal tbody tr:last-child td {
  padding-bottom: 2rem;
}

.hw-table--normal th {
  color: var(--hw-black-900);
  font-weight: bold;
}

.hw-table--border {
  border-collapse: collapse;
  width: 100%;
}

.hw-table--border.lr-borderNull {
  border: .1rem solid var(--hw-gray-600);
  border-collapse: separate;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  overflow: hidden;
  border-spacing: 0;
}

.hw-table--border.lr-borderNull th,
.hw-table--border.lr-borderNull td {
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 0;
}

.hw-table--border.lr-borderNull tbody>tr:last-child td {
  border-bottom-width: 0;
}

.hw-table--border thead th {
  font-weight: bold;
  color: var(--hw-brand-blue);
  background-color: rgba(215, 215, 215, 0.20);
  padding: 1.2rem 2rem;
  border: .1rem solid var(--hw-gray-600);
}

.hw-table--border tbody td {
  border: .1rem solid var(--hw-gray-400);
  padding: 1.2rem 2rem;
  font-size: 1.4rem;
  color: var(--hw-black-900);
  font-weight: 500;
}

.hw-sticky--top {
  position: sticky;
  z-index: 2;
  top: 0;
}

@media (min-width: 576px) {

  .hw-table--normal thead th,
  .hw-table--normal tbody td {
    padding: .5rem 2rem;
  }

  .hw-table--normal tfoot th {
    border-top: .1rem solid var(--hw-gray-600);
    padding: 2rem 2rem .5rem;
    font-size: 2rem;
    line-height: 1.4;
  }

  .hw-nav--tabContent.hw-nav--tabContentRound .hw-search--innerflight__listItem .flight-list>div:not(.hw-flight--listBox__flight) {
    width: 100%;
  }
}

@media (min-width: 600px) {
  .hw-table--border tbody td {
    font-size: 1.6rem;
    line-height: 1.75;
  }
}

@media (min-width: 768px) {

  .hw-table--border.xl-big tbody td,
  .hw-table--border.xl-big thead th {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .hw-table--border.xl-big tbody td {
    font-size: 1.6rem;
    line-height: 1.75;
  }
}

@media (min-width: 950px) {
  .hw-info--hoverBox {
    min-width: 55rem;
  }
}

@media (max-width: 479px) {
  .hw-nav--tabStyle1 .hw-nav-tabLink {
    font-size: 1.2rem;
    font-weight: 600;
  }
}

/*End table*/

@media (min-width: 768px) {
  .hw-search--flightFilterResult__listItem {
    /* padding: 2rem; */
  }

  .hw-nav--tabFlightDetails .hw-search--innerflight__list {
    padding: 1.6rem;
  }

  /* @media (min-width: 990px) {
    .hw-nav--tabFlightDetails .hw-search--innerflight__list {
      padding: 2rem;
    }
  } */

  /* .hw-search--innerflight__listItem {
   padding: 1.6rem 2rem;
} */
  .hw-link {
    font-size: 1.6rem;
  }

  .hw-search--flightFilterResult__tab {
    /* margin-left: -2rem;
    margin-right: -2rem;
    padding: 1.6rem 2rem 0; */
    margin-left: -1.6rem;
    margin-right: -1.6rem;
    padding: 1.6rem 1.6rem 0;
  }

  .hw-search--flightFilterResult__fareDetailsList {
    padding: 2rem 2rem 0;
    margin: 2rem -2rem 0;
  }
}

@media (min-width: 901px) {
  .hw-search--flightFilterResult {
    padding-left: 2rem;
  }

  .hw-search--flightList {
    height: 100%;
    display: flex;
    flex: 1;
  }

  .hw-search--flightFilter {
    width: 32rem;
    position: sticky;
    min-width: 32rem;
    max-width: 32rem;
    margin-top: 2.4rem;
    max-height: calc(100dvh - var(--flight-header-h, 18rem) - 3rem);
    top: calc(var(--flight-header-h, 18rem) + 1.6rem);
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.3s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    /* overflow: hidden; */
  }

  .hw-widget--flight.hw-widget--flight__open.filter-visible~.hw-page--width .hw-search--flightFilter {
    max-height: calc(100dvh - 7rem);
    top: 7rem;
  }

  .hw-search--flightFilterResult {
    width: calc(100% - 32rem);
    flex-grow: 1;
  }

  .filter-collapsed .hw-search--flightFilterResult {
    width: calc(100% - 7.4rem);
  }

  .hw-search--flightFilterResult,
  .hw-search--flightListBottom {
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .hw-search--flightListBottom {
    width: calc(100% - 32rem);
    margin-left: auto;
  }

  .hw-search--flightFilter__widget {
    min-width: 28rem;
  }

  .hw-search--flightFilter__top {
    position: sticky;
    top: 0;
    border-bottom: .1rem solid var(--hw-gray-400);
    z-index: 1;
  }

  .filter-collapsed .hw-search--flightFilter {
    width: 7.4rem;
    min-width: 7.4rem;
    max-width: 7.4rem;
  }

  .filter-collapsed .hw-search--flightListBottom {
    width: 100%;
  }

  .filter-collapsed .hw-search--flightFilter__bodyBox {
    opacity: 0;
    pointer-events: none;
    transform: translateX(-15px);
    max-height: 0;
    overflow: hidden;
  }

  .filter-collapsed .hw-search--flightFilter__body {
    opacity: 0;
    pointer-events: none;
    transform: translateX(-15px);
  }

  .filter-collapsed .hw-search--flightFilter__action {
    padding: 1.2rem 0.6rem;
    justify-content: center;
  }

  .filter-collapsed .hw-search--flightFilter__action .hw-link {
    opacity: 0;
    pointer-events: none;
    width: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
    position: absolute;
    transform: translateX(-10px);
  }

  .filter-collapsed .js-toggleFilter {
    background-color: var(--hw-brand-orange);
    color: var(--hw-white);
    flex-direction: column;
    font-size: 1.4rem;
    font-weight: 500;
    width: 100%;
    padding: 1rem 0.5rem;
    border-radius: 0.4rem;
    cursor: pointer;
    justify-content: center;
    text-align: center;
  }
}

@media (min-width: 1025px) {
  .hw-search--flightFilter {
    top: calc(var(--flight-header-h, 18rem) + 1.6rem);
    max-height: calc(100dvh - var(--flight-header-h, 18rem) - 3rem);
  }
}

@media (min-width: 1200px) {
  .hw-tab--textCombineText {
    width: 25.2rem;
  }

  .hw-table--border.first-td--fixed tbody>tr>td:first-child {
    width: 25.2rem;
  }
}

@media (min-width: 1400px) {
  .hw-flight--listBox {
    column-gap: 6rem;
  }

  .hw-gapy50--xxl {
    column-gap: 5rem !important;
  }

  .hw-search--innerflight__listItem {
    column-gap: 4rem;
  }

  .divider-badge {
    column-gap: 2rem;
  }
}

@media (min-width: 1440px) {

  /* .hw-search--flightList {
      background-color: var(--hw-brand-orange-light);
    }
    .hw-search--flightList > .hw-search--flightFilter + .hw-search--flightFilterResult {
      max-width: 103rem;
    } */
  .hw-search--flightList>.hw-search--flightFilter {
    background-color: var(--hw-white);
  }
}

@media (max-width: 1239px) {
  .hw-expire--session__bookingConfirmed>.d-flex {
    flex-direction: column;
    align-items: flex-start !important;
  }
}

@media (max-width: 1199px) {
  .hw-tab--textCombine .hw-nav--tab {
    flex-direction: column;
  }

  .hw-nav-tabLink {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    font-size: 1.4rem;
    line-height: 1.71429;
  }
}

@media (max-width: 1100px) {
  .hw-flight--listBox {
    column-gap: 1rem;
    flex-wrap: wrap;
    row-gap: 1rem;
  }

  .hw-flight--listBox .destination {
    gap: 1rem;
    flex: 1 1 100%;
    width: 100%;
  }

  .hw-search--innerflight__listItem {
    flex-direction: column;
    align-items: flex-start;
    column-gap: 0;
    row-gap: .5rem;
  }
}

@media (max-width: 900px) {
  .hw-flight--listBox .hw-text20 {
    font-size: 1.8rem;
  }

  .hw-flight--listBox .hw-text18 {
    font-size: 1.6rem;
    line-height: 1.5;
  }

  .hw-btn--mdSize {
    font-size: 1.4rem;
    line-height: 1.5;
    padding: .8rem 1.6rem;
    border-radius: .4rem;
  }

  .hw-search--flightFilterResult {
    padding-bottom: 7rem;
  }

  .hw-search--flightFilter__top {
    position: fixed;
    border-top: .1rem solid var(--hw-gray-400);
    bottom: 0;
    left: 0;
    right: 0;
    top: auto;
    z-index: 11112;
  }

  .sidebar-collapsed .hw-search--flightFilter__top {
    left: 26rem;
  }

  .hw-search--flightFilter__bodyBox {
    position: fixed;
    width: 100%;
    height: calc(100dvh + -5rem);
    background-color: rgba(0, 0, 0, 0.6);
    top: 0;
    z-index: 111111;
    left: 0;
    right: 0;
    transition: opacity 0.3s ease-in-out;
  }

  .hw-search--flightFilter__body {

    height: calc(100dvh + -5rem);
    background: var(--hw-white);
    overflow-y: auto;
    width: 30rem;
    left: -31rem;
    position: relative;
    transition: transform 0.3s ease-in-out;
  }

  /* .hw-hotel--asideFilter .hw-search--flightFilter__body {
    background: var(--hw-gray-100);
  } */

  body:not(.filter-collapsed) .hw-search--flightFilter__bodyBox {
    opacity: 0;
    pointer-events: none;
  }

  /* .filter-collapsed .hw-search--flightFilter__bodyBox {
    display: block;
  } */
  .filter-collapsed .hw-search--flightFilter__body {
    transform: translateX(31rem);
  }

  .filter-collapsed .hw-search--flightFilter__top {
    left: 0;
  }

  .sidebar-collapsed .hw-search--flightFilter__top {
    left: 0;
  }

  body:not(.filter-collapsed) .hw-search--flightFilter__action .hw-link {
    display: none;
  }

  body:not(.filter-collapsed) .js-toggleFilter {
    background-color: var(--hw-brand-orange);
    color: var(--hw-white);
    /* flex-direction: column; */
    /* font-size: 1.4rem; */
    /* font-weight: 500; */
    width: 100%;
    cursor: pointer;
  }

  .body:not(.filter-collapsed) .hw-search--flightFilter__top {
    border-top-color: var(--hw-brand-orange);
  }

  .hw-search--destinationRow>div:not(:last-child) {
    border-bottom: .1rem solid var(--hw-gray-400);
    padding-bottom: .25rem;
    padding-top: .25rem;
    border-right-width: 0;
  }

  .row.hw-search--destinationRow>div {
    width: 100%;
    flex: 1 1 100%;
    min-width: 34rem;
  }

  .row.hw-search--destinationRow>div:last-child {
    padding-top: 1rem;
  }

  .row.hw-search--destinationRow>div:last-child .hw-btn {
    width: 100%;
  }

  .hw-search--destinationRow>.hw-search-scroller {
    max-width: 100%;
  }
}

@media (max-width: 767px) {
  .hw-search--flightFilter__top {
    left: 0 !important;
  }

  .hw-info--hoverBox {
    left: -3.2rem;
    min-width: 27.1rem;
  }

  .hw-info--hoverBox .list {
    font-size: 1.2rem;
    line-height: 1.5;
  }

}

@media (max-width: 575px) {
  .divider-badge {
    column-gap: .5rem;
    font-size: 1.2rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .hw-search--innerflight__listItem .flight-list>div {
    width: 100%;
  }

  .hw-flight--listBox .hw-text20 {
    font-size: 1.6rem;
  }

  .hw-flight--listBox .hw-text18 {
    font-size: 1.4rem;
    line-height: 1.5;
  }

  .hw-flight--listBox .hw-text14 {
    font-size: 1.2rem;
    line-height: 1.5;
  }

  .hw-table--border tbody td,
  .hw-table--border thead th {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .hw-table--responsive table th,
  .hw-table--responsive table td {
    white-space: nowrap;
  }

  .hw-search--flightFilterResult__fareDetailsList .hw-fare--listPoint .hw-fare--listPointItem span.flex-shrink--null {
    min-width: auto;
    flex: 1 0 0;
  }
}

@media (max-width: 479px) {
  .hw-nav-tabLink {
    padding-left: .5rem;
    padding-right: .5rem;
    font-size: 1.2rem;
    line-height: 1.5;
  }

  .hw-search--flightFilterResult__tab .hw-nav--tabContent .hw-text18 {
    font-size: 1.6rem;
  }
}

/*End page*/
/*Passenger page*/
.hw-search--visible-next-list .hw-btn {
  padding: .8rem;
  border-radius: 99.9rem;
}

.hw-passenger--fareSummary__tbodyRowMain {
  cursor: pointer;
}

.hw-inner--fullWidth>div>div {
  width: 100%;
}

.hw-inner--fullWidth.HwSelect-ErrorState {
  border: 1px solid red;
  border-radius: 1rem;
  padding: .8rem;
  margin-left: .8rem;
}

.hw-passenger--fareShowToggleContent .react-datepicker-wrapper {
  width: 100%;
}

.hw-flight--stepsWrapper {
  /* position: sticky;
  top: 0;
  z-index: 1; */

  background-color: var(--hw-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);
}

.hw-flight--steps {
  overflow: hidden;
  display: grid;
}

.hw-passenger--pageList {
  display: grid;
  grid-template-rows: auto 1fr;
  /*
  flex: 1 0 0; */
}

@media (max-width: 1024px) {
  .hw-passenger--pageList {
    display: block;
  }
}

.lm-icon--grid {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 1rem;
  align-items: center;
}

.lm-i {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  line-height: 1.55556;
}

/* .hw-step.active .lm-i  {
  background-color: var(--hw-brand-blue);
  color: var(--hw-white);
} */
/* .hw-step.complete .lm-i {
  background-color: var(--hw-green);
  color: var(--hw-white);
} */
.hw-step.complete .lm-i {
  --hw-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  border-color: var(--hw-brand-orange);
  background-image: var(--hw-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  font-size: 0;
  background-size: 2.4rem 2.4rem;
}

.hw-step.complete .hw-black {
  color: var(--hw-green) !important;
}

.lm-i svg {
  width: 2.8rem;
  height: 2.8rem;
}

.hw-flight--steps .row {
  --bs-gutter-x: 2rem;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.hw-step {
  display: flex;
  align-items: center;
  /* column-gap: var(--bs-gutter-x); */
  margin-top: 1.2rem;
  margin-bottom: 1.2rem;
}

.hw-step .lm-icon--grid {
  white-space: nowrap;
}

.hw-flight--steps .row>.hw-step:not(:last-child)::after {
  content: '';
  background-color: var(--hw-gray-400);
  height: .2rem;
  min-width: 10rem;
  display: inline-flex;
  flex: 1;
}

/* .hw-flight--steps .row > .hw-step.complete::after {
  background-color: var(--hw-green);
} */
/* .hw-expire--session {
  border-top: 1px solid var(--hw-gray-600);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
} */
.hw-passenger--wrapper {
  display: grid;
  grid-template-columns: 1fr;
  padding-top: 4.1rem;
}

.hw-passenger--list {
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
}

.hw-passenger--fareSummary {
  display: flex;
  flex-direction: column;
  background-color: var(--hw-white);
  border-radius: 0.5rem;
}

.hw-after--bookingWidget {
  background-color: var(--hw-white);
  padding: 2.4rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 1.2rem;
}

.hw-after--bookingWidget+.hw-after--bookingWidget {
  margin-top: 2rem;
}

.hw-passenger--head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hw-passenger--head .hw-link {
  flex-shrink: 0;
}

.hw-passenger--fareSummary__thead,
.hw-passenger--fareSummary__tbodyTR,
.hw-passenger--fareSummary__tfoot {
  display: flex;
  justify-content: space-between;
  column-gap: .5rem;
}

.hw-passenger--fareSummary__tfoot {
  border-top: 1px solid var(--hw-gray-600);
  padding-top: 2rem;
  /* margin-top: 2rem !important; */
}

.hw-passenger--fareSummary__tfoot > span,
.hw-passenger--fareSummary__tfoot > .d-flex > span {
  font-size: 1.8rem;
}

.hw-passenger--fareSummary__tbodyRowInner .hw-passenger--fareSummary__tbodyTR {
  padding-top: .4rem;
  padding-bottom: .4rem;
}

.hw-apply--coupenField {
  display: flex;
  column-gap: 1.2rem;
}

/* .hw-apply--coupenField input {
  width: 50%;
} */

.hw-apply--coupenField .hw-btn {
  min-width: 11.3rem;
}

.hw-passenger--listShow__widget .hw-search--innerflight__listItem {
  /* flex-direction: column;
  align-items: flex-start; */
  /* display: block; */
  flex-direction: column;
  align-items: stretch;
  row-gap: .8rem;
}

.hw-single--lineDivider {
  background-color: var(--hw-gray-800);
  width: .1rem;
  margin: auto 1rem;
  height: 2rem;
}

.hw-badge--time {
  font-size: 1.6rem;
  line-height: 1.75;
  background-color: var(--hw-brand-orange-light);
  padding: .2rem .8rem;
  text-align: center;
  color: var(--hw-black);
  border-radius: .6rem;
}

.hw-badge--time strong {
  font-weight: bold;
}

.hw-content--container {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.hw-passenger--fareSummary__box {
  padding: 1.5rem;
}

.hw-select--payment {
  display: flex;
  flex-direction: column;
  row-gap: 1.2rem;
}

.hw-radio--inline {
  display: flex;
  flex-wrap: wrap;
  gap: 1.6rem;
}

.hw-radio--item {
  display: inline-flex;
  align-items: center;
  column-gap: 1rem;
}

.hw-radio--item label {
  font-weight: 500;
  color: var(--hw-black);
}

.hw-term--condition {
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
}

.hw-term--conditionInput {
  display: flex;
  align-items: center;
  column-gap: .4rem;
}

.hw-term--conditionInput label {
  font-size: 1.4rem;
  line-height: 1.71429;
  display: inline-flex;
  flex-wrap: wrap;
  column-gap: .4rem;
  font-weight: 500;
}

.hw-link--line {
  color: var(--hw-brand-orange);
  text-decoration: underline;
}

.hw-link--line:hover {
  color: var(--hw-brand-blue);
}

.hw-passenger--listShow {
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
  column-gap: 0;
}

.hw-passenger--listShow__widget {
  padding: 1.5rem;
  background-color: var(--hw-white);
  border-radius: 0.5rem;
}

.hw-flight--placeTime {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.hw-baggage--line {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: flex-start;
  row-gap: .6rem;
}

.hw-passenger--fareShow__widget {
  background-color: var(--hw-white);
  border: .1rem solid rgba(0, 0, 0, 0);
  border-radius: 0.5rem;
}

.hw-passenger--fareShowToggle {
  padding: 1.2rem 2rem;
  cursor: pointer;
}

.hw-passenger--fareShowToggle svg {
  width: 2.4rem;
  height: 2.4rem;
}

.hw-passenger--fareShowToggleContent {
  padding: 1.6rem;
  /*border-top: .1rem solid var(--hw-gray-600);*/
}

/* .hw-passenger--detailsGroupItem .hw-passenger--fareShowToggle {
  background-color: var(--hw-gray-300);
  border-radius: 1rem;
} */
.hw-passenger--detailsGroup {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 2.4rem;
  margin-top: 2.4rem;
}

.hw-add--bagagge {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 1.6rem;
}

.hw-add--bagagge+.hw-add--bagagge {
  margin-top: 3.2rem;
}

.hw-passenger--detailsGroupItem .hw-passenger--fareShowToggleContent {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 1.6rem;
}

.hw-passenger--detailsGroupItem.fare-toggle-parent.active .hw-passenger--fareShowToggle {
  border-bottom: 1px solid var(--hw-gray-600);
}

.hw-passenger--detailsGroupItem {
  border: 1px solid var(--hw-gray-600);
  border-radius: 0.5rem;
}

.hw-gst--checkboxWrapper input:not(:checked)~.hw-gst--checkboxWrapperBox {
  opacity: 0;
  pointer-events: none;
  display: none;
}

.hw-gst--checkboxWrapper {
  position: relative;
  padding: 2rem 2rem 0;
}

.hw-gst--checkboxWrapper label {
  color: var(--hw-black);
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 1.55556;
  margin-left: 1rem;
}

.hw-gst--checkboxWrapperBox {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
  background-color: var(--hw-white);
  padding: 5rem 2rem 2rem;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 2rem;
  margin: -4.5rem -2rem 0;
}

.hw-widget--flight-close {
  position: absolute;
  right: 0;
  top: 0;
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.hw-widget--flight-close button {
  border: .1rem solid var(--hw-white);
  background-color: rgba(0, 0, 0, 0);
  outline: none;
  color: var(--hw-white);
  padding: 1.1rem;
  border-radius: 1rem;
  cursor: pointer;
  transition: .2s ease;
}

.hw-widget--flight-close button:hover {
  background-color: var(--hw-white);
  color: var(--hw-brand-blue);
}

.hw-passenger--listShow__widget .hw-search--innerflight__listItem .flight-list .hw-flight--listBox__flight {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.hw-apply--coupenAdded {
  display: flex;
  justify-content: space-between;
  column-gap: .5rem;
  border: .1rem dashed var(--hw-brand-orange);
  background-color: var(--hw-brand-orange-light);
  border-radius: 1rem;
  padding: 1rem 2rem;
  min-height: 5.8rem;
  align-items: center;
}

.hw-table--defaultDiv {
  margin-top: 2rem;
}

.hw-table--default {
  border-collapse: collapse;
}

.hw-table--defaultDiv table {
  width: 100%;
  border: .1rem solid var(--hw-gray-400);
  border-collapse: separate;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  overflow: hidden;
  border-spacing: 0;
}

.hw-table--default thead th {
  background-color: rgba(215, 215, 215, 0.20);
  font-weight: bold;
  color: var(--hw-black-900);
}

.hw-table--default th,
.hw-table--default td {
  padding: .5rem 1rem;
}

.hw-table--default td {
  font-size: 1.4rem;
  line-height: 1.71429;
}

.hw-passenger--details-meal-details>.hw-table--lList+.hw-table--lList {
  margin-top: 1rem;
}

.hw-table--defaultDiv table thead th,
.hw-table--defaultDiv table tbody tr:not(:last-child) td {
  border-bottom: .1rem solid var(--hw-gray-400);
}

.hw-contact--badge {
  border-radius: 0.5rem;
  background: var(--hw-white);
  padding: 2.4rem;
  overflow: hidden;
}

.hw-contact--badgeHead {
  font-size: 2rem;
  line-height: 1.4;
  font-weight: bold;
  color: var(--hw-black-900);
}

.hw-contact--badgeBody {
  padding-top: 2rem;
}

.hw-passenger--listShow__widgetContact .row {
  row-gap: 1.5rem;
}

.hw-table--lList>div+div {
  margin-top: 1rem;
}

/* .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__thead,.hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tbody,.hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tfoot {
  background-color: var(--hw-gray-300);
  border-radius: 1rem;
} */
.hw-passenger--fareSummary__tfoot span {
  font-size: 1.8rem;
}

.hw-passenger--fareShowToggle .icon-chevronDown,
.hw-passenger--fareShowToggle .icon-chevronUp {
  color: var(--hw-brand-blue);
}

/*Modal*/
.hw-modal {
  --bs-modal-margin: 0.5rem;
  --bs-modal-border-radius: 1rem;
  --bs-modal-width: 50rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.hw-modal.show {
  display: block;
}

.fade {
  transition: opacity .15s linear;
}

.hw-modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}

.warning-modal-dialog {
  max-width: 460px !important;
  align-items: center;
  gap: 24px;
}

.warning-modal-title {
  color: var(--Violet, #121826);
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.warning-body p {
  color: var(--hw-gray-800);
  font-family: "DM Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 150% */
}

@media (max-width: 479px) {
  .warning-modal-dialog {
    max-width: 100% !important;
  }
}

.hw-modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}

.hw-modal.fade .hw-modal-dialog {
  transition: transform .3s ease-out;
  transform: translate(0, -50px);
}

.hw-modal.show .hw-modal-dialog {
  transform: none;
}

.hw-modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.hw-modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: var(--hw-white);
  background-clip: padding-box;
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.hw-modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}

.hw-modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.hw-modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: 1.6rem 1.6rem 1rem;
  column-gap: 1rem;
  background-color: var(--hw-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.10);
}

.warning-modal-header {
  box-shadow: none;
  padding: 1rem !important;
}

.warning-modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-inline: 3rem;
  padding-block: 2rem;
}

.warning-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  /* justify-content: center; */
  /* align-items: center; */

}

.hw-modal-headerTitle {
  color: var(--hw-brand-blue);
  font-size: 2rem;
  line-height: 1.5;
  font-weight: 600;
  margin-bottom: 0;
  display: inline-flex;
  align-items: center;
  column-gap: 0.8rem;
}

.warning-modal--close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  background-color: transparent;
  border: none;
  outline: none;
}

.hw-modal--close {
  color: var(--hw-gray-800);
  border: none;
  outline: none;
  background: rgba(0, 0, 0, 0);
  padding: .4rem;
  margin-left: auto;
  border-radius: .4rem;
  transition: .2s ease-out;
  cursor: pointer;
}

.hw-modal--close:hover {
  color: var(--hw-gray-800);
  background-color: var(--hw-gray-100);
}

.hw-modal-body {
  padding: 1.2rem 1.6rem 1.6rem 1.6rem;
}

.hw-modal-dialog-scrollable .hw-modal-content {
  max-height: 100%;
  overflow: hidden;
}

.hw-modal-dialog-scrollable .hw-modal-body {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--hw-gray-200) var(--hw-gray-100);
}

.hw--online-stripe-payment-popup .hw-modal-header {
  box-shadow: none;
  /* padding: 2.5rem 3rem 0; */
}

.hw--online-stripe-payment-popup .hw-modal-body {
  padding: 1rem 3.2rem 4rem 3.2rem;
}

.hw--online-stripe-payment-popup label.hw-fontWeight--500 {
  font-weight: normal !important;
}

@media (min-width: 576px) {
  .hw-modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-width: 90%;
  }

  .hw-modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }

  .hw--online-stripe-payment-popup {
    max-width: 50rem;
  }
}

@media (min-width: 768px) {
  .hw--online-stripe-payment-popup .hw-modal-headerTitle {
    font-size: 3rem;
    line-height: 1.5;
  }
}

/* Payment popup enhancements */
.hw-payment--container {
  row-gap: 1.2rem;
}

.hw-label {
  color: var(--hw-gray-800);
}

.hw-stripe-input {
  border: 1px solid var(--hw-gray-400);
  border-radius: .6rem;
  padding: 1.2rem 1.2rem;
  transition: border-color .2s ease, box-shadow .2s ease;
  background-color: var(--hw-white);
}

.hw-stripe-input.is-error {
  border-color: #d92d20;
  box-shadow: 0 0 0 3px rgba(217, 45, 32, .08);
}

.hw-stripe-input:focus-within {
  border-color: var(--hw-brand-blue);
  box-shadow: 0 0 0 3px rgba(0, 82, 204, .1);
}

.hw-help-text {
  color: var(--hw-gray-700);
  font-size: 1.2rem;
}

.hw-payment--summary {
  padding: 1.2rem 0 0.4rem;
  border-top: 1px dashed var(--hw-gray-300);
  margin-top: .4rem;
}

.hw-payment--actions {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Centered loader for hotel gallery images */
.hw-gallery-main-image,
.hw-gallery-zoom-image {
  position: relative;
}

.hw-gallery-image-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

@media (min-width: 768px) {
  .hw-modal-headerTitle {
    /* font-size: 2rem; */
    font-size: 2.5rem;
    line-height: 1.4;
  }

  .hw-modal-header {
    padding: 3.2rem 3.2rem 2.4rem;
  }

  .hw-modal-body {
    padding: 2.4rem 3.2rem 4rem 3.2rem;
    ;
  }

  .hw-modal {
    --bs-modal-border-radius: 0.5rem;
  }

  .hw-table--default th,
  .hw-table--default td {
    padding: 1rem 2rem;
  }

  .hw-table--default thead th {
    font-size: 1.6rem;
    line-height: 1.5;
  }

  .hw-step {
    margin-top: 2.4rem;
    margin-bottom: 2.4rem;
  }
}

@media (min-width: 810px) {
  .hw-modal .hw-modal--mediumSmall {
    --bs-modal-width: 65rem;
  }
}

@media (min-width: 1024px) {
  .hw-modal {
    --bs-modal-width: 97rem;
  }

  .hw-passenger--fareSummary__tfoot > span,
  .hw-passenger--fareSummary__tfoot > .d-flex > span {
    font-size: 2rem;
  }
}

@media (min-width: 1080px) {
  .hw-modal {
    --bs-modal-width: 104.4rem;
  }

  .hw-modal .hw-modal--medium {
    --bs-modal-width: 80rem;
  }

  .hw-modal .hw-modal--markupAmount {
    --bs-modal-width: 55rem;
  }

  .hw-modal .hw-modal--sendEmail {
    --bs-modal-width: 55rem;
  }
}

@media (max-width: 479px) {
  .hw-table--default .hw-text14 {
    font-size: 1.2rem;
    line-height: 1.5;
  }

  .hw-table--lList>div+div {
    margin-top: .5rem;
  }

  .hw-table--lList svg {
    width: 2rem;
    height: 2rem;
  }

  .hw-table--lList {
    display: flex;
    flex-direction: column;
  }

  .hw-table--lList .hw-gapy10 {
    column-gap: .5rem !important;
  }
}

.hw-row--input .css-yw323g-control:hover {
  border-color: var(--hw-black);
}

/*End Modal*/
.hw-unstyled {
  margin: 0;
  padding: 0;
  list-style: none;
}

/*Date Picker*/
body .react-datepicker {
  font-family: var(--hw-body-font-family);
  font-size: 1.2rem;
  border: 1px solid var(--hw-gray-600);
  background-color: var(--hw-white);
  border-radius: 0.5rem;
  padding: .5rem;
}

body .react-datepicker__current-month,
body .react-datepicker-time__header,
body .react-datepicker-year-header {
  font-size: 1.6rem;
  font-family: inherit;
  letter-spacing: 0 !important;
  line-height: 1.75;
  font-weight: bold;
  color: var(--hw-brand-blue);
}

body .react-datepicker__header {
  border-radius: 0 !important;
  border-bottom-color: var(--hw-gray-400);
  padding: 0;
  background-color: rgba(0, 0, 0, 0) !important;
}

body .react-datepicker__day-names {
  display: flex;
  column-gap: .2rem;
  margin-bottom: 0;
  margin-top: .2rem;
}

.hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {
  /* transform: translate(235.833px, 78.3333px) !important; */
  transform: translate(235.833px, 63.3333px) !important;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {
  display: none !important;
}

body .react-datepicker__day-name {
  width: auto;
  height: auto;
  color: var(--hw-gray-700);
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.5;
  padding: .4rem;
  margin: 0;
  min-height: 2.7rem;
}

body .react-datepicker__month {
  margin: .8rem 0 0 0;
}

body .react-datepicker__week {
  display: flex;
  column-gap: .5rem;
}

.react-datepicker__week+.react-datepicker__week {
  /* margin-top: 0.8rem; */
  margin-top: 0.4rem;
}

body .react-datepicker__day {
  margin: 0;
  flex: 1 0 0;
  min-height: 2.7rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: .4rem;
  width: auto;
  height: auto;
  font-weight: 500;
}

.react-datepicker .react-datepicker__navigation {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: 1.8rem 1.8rem;
  background-repeat: no-repeat;
  background-position: center center;
  width: 3rem;
  height: 3rem;
  top: 1.6rem;
  border-radius: 0.5rem;
  background-color: rgba(50, 100, 255, 0.10);
}

.react-datepicker .react-datepicker__navigation>* {
  visibility: hidden;
  opacity: 0;
}

.react-datepicker .react-datepicker__navigation--next {
  right: 1rem;
}

.react-datepicker .react-datepicker__navigation--previous {
  left: 1rem;
  transform: scaleX(-1);
}

.react-datepicker__day.react-datepicker__day--outside-month {
  background-color: rgba(0, 0, 0, 0) !important;
  cursor: default;
  color: var(--hw-gray-400);
}

.react-datepicker__day:not([aria-disabled="true"]):hover {
  background-color: var(--hw-brand-orange-light);
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  background-color: var(--hw-brand-orange) !important;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  background-color: var(--hw-brand-orange) !important;
  color: var(--hw-white) !important;
}

/* body .react-datepicker__day--in-selecting-range {
  background-color: var(--hw-brand-blue-light) !important;
} */
/* body .react-datepicker__day {
    color: var(--hw-black-900);
  } */
.react-datepicker__month-container+.react-datepicker__month-container {
  margin-left: 1rem;
}

@media (min-width: 768px) {
  .react-datepicker__month-container+.react-datepicker__month-container {
    margin-left: 2rem;
  }

  body .react-datepicker {
    font-size: 1.4rem;
    padding: 1.6rem;
  }

  body .react-datepicker__day {
    min-height: 3.7rem;
  }

  body .react-datepicker__day-name {
    font-size: 1.4rem;


  }

  body .react-datepicker__day-names {
    column-gap: .5rem;
    margin-top: .5rem;
  }
}

@media (min-width: 900px) {

  body .react-datepicker__day-name {
    min-width: 3rem;
    min-height: 3rem;
  }
}

@media (min-width: 1024px) {
  body .react-datepicker {
    font-size: 1.6rem;

  }

  body .react-datepicker__day {
    min-height: 4.7rem;
  }

  body .react-datepicker__day-name {
    padding: .4rem 1rem;
  }
}

@media (min-width: 1025px) {
  .react-datepicker__month-container+.react-datepicker__month-container {
    margin-left: 3.2rem;
  }

  body .react-datepicker__day-names {
    column-gap: 1rem;
    margin-top: 1rem;
  }

  body .react-datepicker__day-name {
    min-width: 4.3rem;
    height: 3.2rem;
  }
}

@media (max-width : 1099px) and (min-width : 1025px) {
  .hw-hotes-module.hw-hotel--widget .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {
    transform: translate(0, 130px) !important;
  }
}

@media (max-width : 1075px) {
  .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {
    transform: translate(182.833px, 65.3333px) !important;
  }
}

@media (max-width : 1024px) {
  .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {
    /* transform: translate(-47px, 158.3333px) !important; */
    transform: translate(0px, 130px) !important;
  }
}

@media (max-width : 767px) {
  .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {
    transform: translate(0px, 200px) !important;
  }

  .hw-hotes-module.hw-hotel--widget .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {
    transform: translate(0px, 130px) !important;
  }
}

@media (max-width : 600px) {
  .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {
    /* transform: translate(47px, 158.3333px) !important; */
    transform: translate(0px, 195px) !important;
  }
}

@media (max-width : 439px) {
  .hw-hotes-module.hw-hotel--widget .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {
    transform: translate(0px, 194px) !important;
  }
}

/*End date picker*/
.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--list {
  border-right-color: rgba(0, 0, 0, 0);
}

.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary {
  background-color: var(--hw-brand-orange-light);
}

.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary .hw-passenger--fareSummary__box {
  padding-top: 0;
}

.hw-passenger--pageList.loader>* {
  opacity: .4;
}

.hw-passenger--pageList.loader {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.hw-main--loaderM {
  position: relative;
  height: calc(100dvh - 11rem);
  display: flex;
  justify-content: center;
  align-items: center;
}

.hw-main--loaderCommon {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 10rem;
  width: 100%;
}

.hw-passenger--pageList.loader::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -30px;
  margin-left: -30px;
  width: 4rem;
  height: 4rem;
  border-radius: 4rem;
  border: .5rem solid var(--hw-brand-orange-light);
  border-top-color: var(--hw-brand-orange);
  animation: loading 2s linear infinite;
}

.hw-main--loaderM::after,
.hw-main--loaderCommon::after {
  content: '';
  position: absolute;
  width: 3rem;
  height: 3rem;
  border-radius: 3rem;
  border: .4rem solid var(--hw-brand-orange-light);
  border-top-color: var(--hw-brand-orange);
  animation: loading 2s linear infinite;
  inset: 0;
  margin: auto;
}

.hw-list--circleSmall {
  padding-left: 2rem;
  margin-top: 0;
  margin-bottom: 0;
}

.hw-list--circleSmall li {
  font-size: 1.4rem;
  line-height: 1.71429;
}

.hw-btn--tabLink {
  background-color: var(--hw-white);
  border: none;
  outline: none;
  font-weight: 500;
  color: var(--hw-black-900);
}

.hw-btn.hw-btn--tabLink.active {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.hw-passenger--fareSummary .hw-passenger--head {
  border-bottom: 1px solid var(--hw-gray-600);
}

.hw-passenger--fareSummary__table>*+* {
  margin-top: 1.6rem;
}

.hw-passenger--fareSummary__tbody>.hw-passenger--fareSummary__tbodyRowMain+.hw-passenger--fareSummary__tbodyRowMain {
  margin-top: 1.6rem;
}

.hw-passenger--fareSummary__tbodyTR svg {
  color: var(--hw-brand-orange);
  width: 2rem;
  height: 2rem;
}

@media (min-width: 768px) {

  .hw-widget--flight-close {
    right: 3.2rem;
    top: 3.2rem;
    width: 5rem;
    height: 5rem;
  }

  .hw-passenger--listShow__widget .hw-search--innerflight__listItem {
    row-gap: 1.6rem;
  }

  .hw-baggage--line {
    grid-template-columns: auto 1fr auto;
  }

}

@media (min-width: 1025px) {
  .hw-lg--onlyIcon {
    display: none !important;
  }

  .hw-passenger--wrapper {
    grid-template-columns: 1fr 450px;
    align-items: flex-start;
    column-gap: 2rem;
  }

  .hw-passenger--fareSummary {
    position: sticky;
    /* top: 11.2rem; */
    top: 2.4rem;
    -webkit-position: sticky;
  }

  .hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary {
    top: 2rem;
  }

  .hw-passenger--list {
    display: grid;
    grid-template-rows: auto 1fr;
    height: 100%;
    overflow-y: auto;
  }

  .hw-flight--listBox .destination {
    gap: 2.4rem;
  }

  .hw-flight--listBox__flight {
    max-width: 39.2rem;
  }
}

@media (min-width: 1025px) and (max-width: 1239px) {

  .hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary {
    top: 3rem;
  }
}

@media (min-width: 1200px) {
  .hw-passenger--listShow__widgetContact .row {
    --bs-gutter-x: 2rem;
  }

  .hw-passenger--listShow__widget .hw-search--innerflight__listItem .flight-list .hw-flight--listBox__flight {
    min-width: clamp(20%, 20%, 40%);
  }

  .hw-flight--placeTime {
    min-width: 20.4rem;
    max-width: 20.4rem;
  }

  .hw-flight--splaceTime {
    min-width: 30.4rem;
    margin-left: -10.4rem;
    max-width: 30rem;
    text-align: right;

  }

  .hw-xltext--right {
    text-align: right !important;
  }

  .hw-flight--aplaceTime {
    min-width: 30.4rem;
    margin-right: -10.4rem;
    max-width: 30rem;
    text-align: left;
  }
}

@media (min-width: 1400px) {
  .hw-passenger--wrapper {
    grid-template-columns: 1fr 450px;
  }
}

@media (max-width: 1199px) {
  .hw-passenger--listShow .flight-list {
    flex-wrap: wrap;
    column-gap: 0;
    row-gap: 1rem;
  }

  .hw-passenger--listShow .flight-list>* {
    width: 100%;
  }
}

@media (max-width: 1024px) {

  /* .hw-passenger--fareSummary {
     background-color: var(--hw-white);
    position: sticky;
    bottom: 0;
    max-height: 40vh;
    overflow-y: auto;
    display: grid;
    grid-template-rows: auto 1fr;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
  } */
  .hw-lg--onlyIcon {
    color: var(--hw-black);
  }

  /* .hw-passenger--fareSummary > .hw-passenger--head:not(.active) {
    border-bottom-color: rgba(0,0,0,0);
  }

    .hw-passenger--fareSummary > .hw-passenger--head:not(.active) + .hw-passenger--fareSummary__box {
    padding-top: 0;
  }
  .hw-passenger--fareSummary > .hw-passenger--head:not(.active) + .hw-passenger--fareSummary__box .hw-passenger--fareSummary__table {
  display: none;
}
.hw-passenger--fareSummary > .hw-passenger--head:not(.active) + .hw-passenger--fareSummary__box .mt-6 {
  margin-top: 0 !important;
}
.hw-passenger--fareSummary > .hw-passenger--head.active + .hw-passenger--fareSummary__box .mt-6 {
  margin-top: 1.5rem !important;
} */
  /* .hw-passenger--fareSummary .hw-passenger--head {
    position: sticky;
    top: 0;
    background-color: var(--hw-white);
    z-index: 1;
  } */
}

@media (max-width: 767px) {
  .hw-baggage--line .hw-link {
    grid-row: 1;
    grid-column: 2;
  }

  .hw-baggage--line>div.d-flex {
    grid-column: span 2;
  }

  .hw-passenger--detailsGroupItem .hw-passenger--fareShowToggleContent .row,
  .hw-passenger--wrapper .hw-passenger--listShow__widget .row {
    row-gap: 2rem;
  }
}

@media (max-width: 599px) {
  .hw-passenger--listShow__widget .hw-search--innerflight__listItem .hw-text18 {
    font-size: 1.6rem;
    line-height: 1.5;
  }

  .hw-twoLine--iconFilter .hw-twoLine--icon {
    width: 100%;
    grid-template-columns: auto 1fr;
  }

  .hw-xstext16 {
    font-size: 1.6rem !important;
  }
}

/*End passenger page*/
/* @media (min-width: 1301px) {
    .hw-input--switchGroup {
       width: 52%;
    }
    .hw-filter--actionBtn {
       width: 24%;
    max-width: 36.6rem;
    }
} */
/* @media (min-width: 992px) and (max-width: 1300px) {
    .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst .hw-input--switchGroup {
        width: calc(67% - .4rem * 1 / 2);
      }
      .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst .react-datepicker-wrapper {
        width: calc(33% - .4rem * 1 / 2);
        max-width: calc(33% - .4rem * 1 / 2);
      }

} */

@media (min-width: 1025px) {
  .hw-input--switchGroup {
    width: 52%;
  }

  .hw-filter--actionBtn {
    width: 24%;
    max-width: 36.6rem;
    padding-left: 1.2rem;
  }

  .hw-row--inputFirst .react-datepicker-wrapper {

    padding-left: 1.2rem;
  }

  .hw-row--input.hw-row--inputFirst>.hw-input--input {
    margin-left: 1.2rem;
    width: calc(24% - 1.2rem);
  }
}

@media (max-width: 1024px) {
  .hw-input--switchGroup {
    width: 100%;
    max-width: 100%;
  }

  .hw-row--inputFirst .react-datepicker-wrapper,
  .hw-row--input.hw-row--inputFirst>.hw-input--input {
    width: calc(50% - 1.2rem * 1 / 2);
    max-width: calc(50% - 1.2rem * 1 / 2);
  }

  /* .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst .react-datepicker-wrapper {
        width: 100%;
        max-width: 100%;
    } */
  .hw-row--input.hw-row--inputFirst {
    row-gap: 1.2rem;
    column-gap: 1.2rem;
  }

  .hw-row--input.hw-row--inputFirst>.hw-input--input {
    margin-left: 0;
  }

}

@media (min-width: 1025px) and (max-width: 1239px) {
  .hw-input--switchGroup {
    width: 46%;
  }

  .hw-row--inputFirst .react-datepicker-wrapper {
    width: 27%;
  }

  .hw-filter--actionBtn {
    width: 27%;
  }

  .hw-row--input.hw-row--inputFirst>.hw-input--input {
    width: calc(27% - 1.2rem);
  }

  .hw-filter--actionBtn .hw-btn.hw-btn--secondaryOutline {
    padding-left: 1rem;
    padding-right: 1rem;
    flex-grow: 1;
  }
}

@media (max-width: 1300px) {
  .hw-filter--actionBtn .hw-btn {
    justify-content: center;
  }

  .hw-filter--actionBtn .hw-btn.hw-btn--secondary {
    flex: 1 1 auto;
    width: 100%;
  }



}

@media (min-width: 480px) {
  .hw-content--container {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .hw-passenger--listShow__widget {
    padding: 2rem;
  }
}


@media (min-width: 768px) {
  .hw-passenger--listShow__widget {
    padding: 2.4rem;
  }

  .hw-btn svg {
    width: 2.4rem;
    height: 2.4rem;
  }

  .hw-btn {
    font-size: 1.6rem;
    line-height: 1.75;
  }

  .hw-filter--searchBtn svg {
    width: 2rem;
    height: 2rem;
  }

  /* .hw-filter--actionBtn .hw-btn {
        min-height: 6.8rem;
      } */
  .hw-widget--card {
    padding: 3.2rem;
  }

  .hw-tab {
    column-gap: 1rem;
    /* margin-bottom: 2.4rem; */
  }

  .hw-input--input {
    padding: .5rem 2rem;
    column-gap: 1rem;
  }

  .hw-input--input,
  .hw-row--input .css-1u80x8j-control,
  .hw-input--switchGroup>div>div {
    min-height: 5.4rem;
  }

  /* body:not(.sidebar-collapsed) .hw-app--main {
        margin-left: 9rem;
    }

    .hw-app--main {
        margin-left: 26rem;
        transition: margin-left .2s ease;
    } */
  .hw-filter--searchBtn {
    min-height: 5.4rem;
    font-size: 1.6rem;
    /* min-width: 6.8rem; */
  }

  .hw-flight--lists {
    padding: 1.2rem 2rem;
  }

  /* .hw-input--multicityGroup {
    row-gap: 2.4rem;
  } */

  /* .hw-row--inputCheck {
    margin-top: 2.4rem;
  } */
}


@media (min-width: 992px) {
  .hw-header--menu {
    margin: 0;
    flex: 1;
    column-gap: 4rem;
    justify-content: center;
  }

  .hw-flight--steps .row {
    --bs-gutter-x: 2.4rem;
  }

  .lm-i svg {
    width: 3.2rem;
    height: 3.2rem;
  }

  .hw-content--container {
    padding-right: 4rem;
  }

  .hw-passenger--fareSummary__box {
    padding: 1.6rem 2.4rem 2.4rem;
  }

  .hw-passenger--fareSummary .hw-passenger--head {
    padding: 2.4rem 2.4rem 1.6rem 2.4rem;
  }
}

@media (min-width: 1240px) {

  .hw-input--input,
  .hw-row--input .css-1u80x8j-control,
  .hw-input--switchGroup>div>div,
  .hw-filter--searchBtn {
    /* min-height: 7.6rem; */
    min-height: 5.4rem;
  }
}

@media (max-width: 991px) {
  .hw-header--menu {
    display: none !important;
  }

}

@media (max-width: 767px) {

  /* .hw-logo img {
        max-width: 14rem;
        max-height: 4.9rem;
    } */
  .hw-input--switchGroup {
    flex-direction: column;
    row-gap: .2rem;
  }

  .hw-input--switchGroup>div {
    width: 100%;
  }

  .hw-input--switchGroup .hw-switch {
    margin: -1.2rem 0;
  }

  .hw-input--switchGroup .hw-switch svg {
    transform: rotate(90deg);
  }

  .hw-row--input.hw-row--inputFirst>.hw-input--input .hw-text14 {
    font-size: 1.2rem;
    line-height: 1.5rem;
  }

  .lm-icon--grid .hw-text14 {
    font-size: 1.2rem;
    line-height: 1.5;
  }
}

@media (max-width: 640px) {
  .hw-input--groupCol {
    grid-template-columns: 1fr;
    column-gap: 0;
    row-gap: 1rem;
  }

  .hw-row--inputCheck {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
}

@media (max-width: 575px) {
  .header-nav .nav-item.dropdown>.nav-link {
    padding: .5rem;
  }

  .nav-profile span,
  .nav-profile .hw-nav--icon {
    display: none !important;
  }

  .nav-profile {
    border-radius: 50% !important;
  }

  .hw-tab {
    flex-direction: column;
  }

  .hw-widget.hw-widget--flight .hw-tab {
    flex-direction: row;
  }

  .hw-row--input.hw-row--inputFirst>.hw-input--input,
  .hw-row--inputFirst .react-datepicker-wrapper {
    width: 100%;
    max-width: 100%;
  }

  .hw-input--input svg {
    width: 2rem;
    height: 2rem;
  }

  .react-datepicker-wrapper .hw-text14,
  .hw-input--input .hw-text14 {
    font-size: 1.2rem;
    line-height: 1.5;
  }

  .hw-calender--removeBtn svg {
    width: 1.6rem;
    height: 1.6rem;
  }

  .hw-input--input .grid-rowspan2 span.hw-text--hidden {
    line-height: 1.5;
  }

}

@media (max-width: 479px) {
  .hw-passenger--listShow__widget .hw-text20 {
    font-size: 1.6rem;
  }

  .hw-passenger--listShow__widget .hw-text18,
  .hw-passenger--listShow__widget .hw-badge--time,
  .hw-table--normal tfoot th {
    font-size: 1.4rem;
  }

  .xs-text12,
  .hw-nav--tabFareDetails .hw-table--normal tbody td {
    font-size: 1.2rem;
  }

}





.lds-ellipsis {
  /* change color here */
  color: var(--hw-black)
}

.lds-ellipsis,
.lds-ellipsis div {
  box-sizing: border-box;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 3rem;
  height: 3rem;
}

.lds-ellipsis div {
  position: absolute;
  top: 1.2rem;
  width: .5rem;
  height: .5rem;
  border-radius: 50%;
  background: currentColor;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: .2rem;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: .8rem;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 1.6rem;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 2.4rem;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(10px, 0);
  }
}


.hw-search--innerflight__list>.hw-search--visible-next-list~li.hw-search--innerflight__divider:last-child {
  display: none;
}

.hw-p-error-cls {
  color: var(--hw-red);
  font-size: 1.4rem;
}

.hw--error-cls-date-input {
  border: 1px solid red;
}

/*Round trip css*/
/*
.hw-passenger--details-meal-details > .hw-table--lList:not(:last-child) + .hw-table--lList {
    display: none;
}
*/

.hw-hotes-module .hw-row--inputFirst .react-datepicker-wrapper {
  width: 34%;
  padding-left: .4rem;
}

.hw-hotes-module .room-row {
  display: flex;
  justify-content: space-between;
}

.hw-flight--listBoxInner {
  flex: 1 1 auto
}

.hw-flight--listBoxInnerList+.hw-flight--listBoxInnerList {
  margin-top: 1.6rem;
  padding-top: 1.6rem;
  border-top: 1px solid var(--hw-gray-600);
}

.hw-btn--white-button {
  background-color: var(--hw-white);
  border: .1rem solid rgba(0, 0, 0, 0);
}

.hw-btn--white-button:hover {
  background: none;
  border-color: var(--hw-brand-orange);
}

.hw-btn--white-button:hover svg {
  color: var(--hw-brand-orange);
}

.hw-search--flightFilterResult__top.d-flex {
  justify-content: space-between;
}

.align-item-center {
  align-items: center;
}

.hw-sticky--bottom {
  position: sticky;
  z-index: 1;
  bottom: 0;
}

.mr-1 {
  margin-right: 1rem !important;
}

.hw-sidebar-stops--btn {
  display: flex;
  margin-bottom: 1rem;
  gap: 1rem
}

.hw-sidebar-stops--btn button {
  padding: 0.2rem 1rem;
}

@media screen and (max-height: 800px) {
  .hw-sidebar--nav .nav-link {
    font-size: 1.4rem;
  }
}

@media (min-width: 1024px) {
  .hw-modal.error-modal {
    --bs-modal-width: 60rem;
  }
}

.hw-input--switchGroup>div:nth-of-type(2)>div {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

/*Round trip css*/
.hw-search--flightScrollerTab {
  overflow-x: auto;
  /* padding-bottom: 1rem; */
}

.hw-search--roundTripBreadcrumbs {
  display: flex;
  column-gap: 0rem;
  row-gap: 1rem;
  background-color: var(--hw-white);
  border-radius: 0.5rem;
  width: 100%;
}


.hw-search--roundTripBreadcrumbs .item {
  position: relative;
  background-color: var(--hw-white);
  /* min-height: 5.4rem; */
  min-height: 5rem;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  white-space: nowrap;
  flex-shrink: 0;
  color: var(--hw-black-900);
  min-width: 10rem;
  text-align: center;
  cursor: pointer;
  border-radius: 0.5rem;
}

/* .hw-search--roundTripBreadcrumbs > .item:first-child {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.hw-search--roundTripBreadcrumbs > .item:last-child {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
} */

.hw-search--roundTripBreadcrumbs .item div+div {
  font-size: 1.4rem;
  line-height: 1.71429;

}

.hw-search--roundTripBreadcrumbs .item:not(.active) div+div {
  color: var(--hw-gray-500);
}

.hw-search--roundTripBreadcrumbs .item.active {
  /* background-color: var(--hw-brand-orange); */
  color: var(--hw-white);
  background: linear-gradient(90deg, #3264FF 21.17%, #1846D6 82.33%);
}

.hw-search--roundTripBreadcrumbs .item:not(.active):hover {
  background-color: var(--hw-brand-orange-light);
}

.hw-search--roundTripBreadcrumbs .item.active::after {
  background: var(--hw-brand-orange);
}

@media (min-width: 600px) {
  .hw-search--roundTripBreadcrumbs .item {
    min-height: 5.8rem;
    padding-right: 4rem;
    padding-left: 4rem;
    min-width: 22.5rem;
  }
}

@media (max-width: 599px) {
  .hw-search--roundTripBreadcrumbs .item {
    flex-grow: 1;
  }

  .hw-search--roundTripBreadcrumbs .item div+div {
    line-height: 1.5;
  }
}



/*End round trip css*/
/*after fixed round trip css*/
/* .hw-nav--tabContentRound .hw-search--innerflight__list {
  border: .1rem solid var(--hw-gray-600);
  border-radius: 0.5rem;
  background-color: var(--hw-white);
} */
/* .hw-nav--tabContentRound .hw-search--innerflight__list .hw-search--innerflight__listItem {
  border: none;
  border-radius: 0;
  background-color: rgba(0,0,0,0)
} */
.hw-nav--tabContentRound .hw-search--innerflight__list .hw-search--innerflight__divider {
  /* background-color: var(--hw-gray-100); */
  padding-top: .9rem;
  padding-bottom: .9rem;
}

/* .hw-nav--tabContentRound .hw-search--innerflight__list .hw-search--innerflight__divider > span {
opacity: 0;
} */
.hw-nav--tabContentRound .hw-search--innerflight__list .hw-search--innerflight__divider svg {
  color: var(--hw-brand-blue);
  margin-right: .8rem;
}

.hw-nav--tabContentRound>.hw-nav--tabPane+.hw-nav--tabPane {
  margin-top: 1.5rem;
}

.hw-hover--link {
  cursor: pointer;
}

.hw-hover--link:hover {
  color: var(--hw-brand-orange);
  border-color: var(--hw-brand-orange);
}

.hw-hover--link.active {
  color: var(--hw-black-900);
  border-color: var(--hw-black-900);
  cursor: default;
}

.hw-primary--text {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  font-size: 1.4rem;
  border-radius: 1rem;
  padding: 1rem;
  line-height: 1.286;
  font-weight: bold;
}

/* .hw-blue--grid.hw-search--flightListBottom  .row {
  flex-wrap: nowrap;
}
.hw-blue--grid.hw-search--flightListBottom .col.col-scroll {
  overflow-x: auto;
} */
.hw-search--destinationRow {}

/* .hw-blue--grid.hw-search--flightListBottom {
  padding-left: 2rem;
  padding-right: 2rem;
} */
.hw-search--destinationRowMain {
  display: flex;
  flex-wrap: nowrap;
  column-gap: 2rem;
  justify-content: space-between;
}

.hw-search--destinationRowMain .col-scroll {
  overflow: hidden;
}

.hw-search--destinationRowMain .row.hw-search--destinationRow {
  flex-wrap: nowrap;
  overflow-x: auto;
}

.hw-nav--tabPane.hw-nav--tabFareDetails table.hw-table--normal {
  min-width: 80%;
}

.hw-table--withLightOutline {
  border: 1px solid var(--hw-gray-600);
  border-radius: 0.5rem;
  padding: 1rem 1.6rem;
  display: inline-block;
}

@media (max-width: 900px) {
  .hw-search--flightListBottom.hw-sticky--bottom {
    bottom: 5.6rem;
  }

  .hw-search--flightListBottom.hw-sticky--bottom .hw-search--destinationRow>div:not(:last-child) {
    border-right-width: .1rem;
    border-bottom-width: 0;
  }
}

@media (max-width: 767px) {
  .hw-search--flightListBottom.hw-sticky--bottom {
    bottom: 5.3rem;
  }
}

/*End after fixed round trip css*/

.hw-before-loader--status::before {
  content: "";
  background-color: var(--hw-brand-orange);
  position: absolute;
  width: 0;
  height: 10px;
  left: 0;
  top: 0;
  /*transition: width .5s ease-in-out;*/
  -webkit-animation: progress-in-out 60s linear forwards;
  animation: progress-in-out 60s linear forwards;
  animation-iteration-count: 1;
}

.hw-before-loader--status-half::before {
  content: "";
  background-color: var(--hw-brand-orange);
  position: absolute;
  width: 0;
  height: 10px;
  left: 0;
  top: 0;
  /*transition: width .5s ease-in-out;*/
  -webkit-animation: progress-in-out-half 60s linear forwards;
  animation: progress-in-out-half 60s linear forwards;
  animation-iteration-count: 1;
}


.hw-before-loader--status {
  position: absolute;
  top: 0;
  background-color: var(--hw-brand-orange-light);
  background: linear-gradient(0deg, #E6EFFF 0%, #E6EFFF 100%), #015FFF;
  left: 0;
  z-index: 9;
  min-height: 150px;
  display: grid;
  right: 0;
  grid-template-rows: auto 1fr;
  height: 100vh;
  transition: left .2s ease-in-out;
}

.hw-before-loader--status-half {
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0);
  left: 0;
  z-index: 9;
  min-height: 10px;
  display: grid;
  right: 0;
  grid-template-rows: auto 1fr;
  height: 10px;
  transition: left .2s ease-in-out;
}

.hw-loader--image {
  display: flex;
  justify-content: center;
  padding: 5.6rem 2rem;
}


.hw-loader--text {
  background-color: var(--hw-gray-100);
  text-align: center;
  padding: 2rem 2rem 2rem;
  font-weight: bold;
  color: var(--hw-black);
  font-size: 1.6rem;
}



@media (min-width: 901px) {
  .hw-loader--text {
    font-size: 1.8rem;
  }

  .hw-before-loader--status,
  .hw-before-loader--status-half {
    left: 32rem;
  }

  .filter-collapsed .hw-before-loader--status,
  .filter-collapsed .hw-before-loader--status-half {
    left: 7.4rem;
  }
}

@-webkit-keyframes progress-in-out {
  0% {
    width: 0;
  }

  16% {
    width: 60%;
  }

  25% {
    width: 70%;
  }

  50% {
    width: 80%;
  }

  75% {
    width: 90%;
  }

  100% {
    width: 99%;
  }
}

@keyframes progress-in-out {
  0% {
    width: 0;
  }

  16% {
    width: 60%;
  }

  25% {
    width: 70%;
  }

  50% {
    width: 80%;
  }

  75% {
    width: 90%;
  }

  100% {
    width: 99%;
  }
}

@-webkit-keyframes progress-in-out-half {
  0% {
    width: 60%;
  }

  16% {
    width: 70%;
  }

  25% {
    width: 73%;
  }

  50% {
    width: 80%;
  }

  75% {
    width: 90%;
  }

  100% {
    width: 99%;
  }
}

@keyframes progress-in-out-half {
  0% {
    width: 60%;
  }

  16% {
    width: 70%;
  }

  25% {
    width: 73%;
  }

  50% {
    width: 80%;
  }

  75% {
    width: 90%;
  }

  100% {
    width: 99%;
  }
}


.hw-search-scroller {
  overflow-x: auto;
  max-width: 40%;
  scrollbar-width: thin;
  scrollbar-color: var(--hw-gray-100) var(--hw-brand-blue);
}

.hw-search-scroller>div:not(:last-child) {
  border-right: .1rem solid var(--hw-gray-400);
  padding-right: 2rem;

}

.row.hw-search--destinationRow {
  scrollbar-width: thin;
  scrollbar-color: var(--hw-gray-400) var(--hw-brand-orange-light);
}

.hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom {
  padding-top: 0;
  padding-bottom: 0;
}

.hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .row.hw-search--destinationRow {
  padding-top: 1rem;
  padding-bottom: 1rem;
  scrollbar-color: var(--hw-gray-100) var(--hw-brand-blue);
  line-height: 125%;
}


/* .hw-blue--grid.hw-search--destinationMultiCity {
  overflow-x: hidden;
} */
/* .hw-search--flightScrollerTab {
  overflow-x: auto;
  padding-bottom: 1rem;
  padding-top: 0;
} */
.hw-break--word {
  word-break: break-word;
}

.align-items-start {
  align-items: flex-start !important;
}

@media (min-width: 901px) {
  .hw-blue--grid.hw-search--destinationMultiCity {
    padding-top: 0;
    padding-bottom: 0;
  }

  .hw-blue--grid.hw-search--destinationMultiCity .hw-search--destinationRow>div {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}

@media (max-width: 900px) {

  .hw-widget.hw-widget--flight.hw-widget--flight__open .hw-widget--card .hw-widget--flight-close {
    right: 1.5rem;
    top: 2.5rem;
  }
}

@media (max-width: 767px) {
  .hw-flight--listBoxInner.hw-mlCity {
    width: 100%;
  }
}

/* @media (min-width: 480px) and (max-width: 991px) {
  .hw-search--flightScrollerTab {
    margin-right: -2rem;
    margin-left: -2rem;
  }
} */

@media (max-width: 479px) {
  .hw-nav--tabPane.hw-nav--tabFareDetails table.hw-table--normal {
    min-width: 100%;
  }

  .hw-search--priceTitleBar {
    flex-direction: column;
    row-gap: .4rem;
    margin-bottom: .8rem;
  }

  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .hw-search--destinationRowMain {
    column-gap: 1rem;
  }

  .hw-search--priceTitleBar .d-flex.hw-gapy50--xxl {
    justify-content: space-between;
  }

  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .col-fix-right {
    flex-direction: column;
    justify-content: center;
    align-items: flex-end !important;
    row-gap: .5rem;
  }

  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .col-fix-right .hw-btn {
    font-size: 1.2rem;
    padding: .4rem;
    min-width: 10rem;
  }

  .hw-search--flightScrollerTab {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }

  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .row.hw-search--destinationRow .hw-dtr--mtext {
    font-size: 1.2rem;
    line-height: 1.25;
  }

  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .row.hw-search--destinationRow .hw-gapy10,
  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .row.hw-search--destinationRow .hw-gapy16 {
    column-gap: .5rem !important;
  }

  .hw-xs--rowLayout {
    flex-direction: column !important;
    row-gap: .4rem;
  }

  .hw-xs--rowLayout>.d-flex {
    justify-content: space-between;
  }

  .hw-xs--rowLayout+.hw-fare--listPoint {
    margin-top: .8rem;
  }
}

@media (max-width: 370px) {
  .hw-header .hw-logo {
    padding-left: 3rem;
  }

  .hw-logo img {
    max-width: clamp(11rem, 36vw, 14rem);
  }

  .hw-header .nav-link.nav-profile img {
    max-width: 4rem;
    max-height: 4rem;
  }
}

.hw--vendor-img img {
  object-fit: cover;
}

/* Seat Map Style Starts */

.hw-seatmap--selection-layout {
  border-radius: 5px;
  width: 100%;
  background: #f7f8fa;
}

.hw-seatmap--seat-map-wrapper {
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
}

.hw-seatmap--aircraft {
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  max-height: 500px;
  overflow-y: auto;
}

.hw-passenger-data {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: sticky;
  top: 0;
  z-index: 2;
  width: 100%;
}

.hw-passenger-header {
  color: black;
  font-size: 2rem;
  line-height: 1.75;
  font-weight: bold;
}

.hw-passenger-detail {
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
  /* justify-content: space-between; */
  /* padding: 5px 15px; */
  /* margin-inline: 1rem; */
  border-radius: 5px;
}

.hw-passenger-data {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 1rem;
}

.hw-seatmap--confirm-price {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: 1.6rem;
  align-items: flex-end;
  /* font-weight: bold; */
}

.hw-seatmap--plane-fuselage {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  padding: 1rem;
  background-color: #F5F7FF;
}

.hw-seatmap--fuselage-seats {
  background: white;
  box-shadow: none;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  width: 100%;
  /* border-radius: 10px; */
}

.hw-seatmap--row {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  position: relative;
}

.hw-seatmap--row:last-child {
  margin-bottom: 0;
}

.hw-seatmap--row::before {
  content: attr(data-row-number);
  position: absolute;
  left: -30px;
  top: 50%;
  transform: translateY(-50%);
  color: #424242;
  font-family: "roboto";
  font-size: 12px;
  font-weight: 500;
}

.hw-seatmap--seat-wrapper {
  margin: 0 8px;
  position: relative;
}

.hw-segment--data {
  display: flex;
  gap: 7px;
}

.dot-separator {
  width: 5px;
  height: 5px;
  background-color: #999;
  border-radius: 50%;
  margin-top: .7rem;
}

.pipe-separator {
  width: 2px;
  height: 10px;
  background-color: #999;
  margin-top: .7rem;
}

@media only screen and (min-width: 980px) {
  .hw-seatmap--seat-wrapper {
    margin: 0 6px;
  }
}

.hw-seatmap--seat-wrapper.hw-seatmap--extra-legroom .hw-seatmap--seat {
  border-color: #00c446;
  background-color: #ebffed;
}

.hw-seatmap--seat-wrapper.hw-seatmap--emergency-exit-row .hw-seatmap--seat {
  border-color: #ff5736;
  background-color: #ffde70;
}

.hw-seatmap--seat.hw-seatmap--occupied .hw-seatmap--seat-cross {
  color: #283D6B;
}

.hw-seatmap--seat.hw-seatmap--selected .hw-seatmap--seat-cross {
  color: #fff;
  opacity: 0.7;
}

.hw-seatmap--seat {
  width: 38px;
  height: 38px;
  /* border: 1px solid #8e9195; */
  border: 2px solid blue;
  background-color: #ffffff;
  border-radius: 14px;
  box-sizing: border-box;
  position: relative;
  transition: all 0.2s ease;
}

.hw-seatmap--seat.hw-seatmap--not {
  border-color: gray;
  border-width: 1px;
  background-color: #f5f5f5;
}

.hw-seatmap--seat.hw-seatmap--selected,
.hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available,
.hw-seatmap--seat.hw-seatmap--selected:hover {
  border-color: #007bff;
  border-width: 1px;
}

.hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip),
.hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip):before,
.hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip):after,
.hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip),
.hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip):before,
.hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip):after,
.hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip),
.hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip):before,
.hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip):after {
  color: #007bff !important;
}


.hw-seatmap--seat.hw-seatmap--available {
  border-color: rgb(68, 68, 237);
  border-width: 1.5px;
}

.hw-seatmap--seat.hw-seatmap--available:not(.hw-seatmap--info-box) {
  cursor: pointer;
}

.hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) {
  background-color: rgba(0, 123, 255, 0.1);
}

.hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) .hw-seatmap--seat-number {
  color: #ffffff;
}

.hw-seatmap--seat.hw-seatmap--unavailable {
  border-color: #8e9195;
  background-color: #f5f5f5;
}

.hw-seatmap--seat.hw-seatmap--unavailable::before,
.hw-seatmap--seat.hw-seatmap--unavailable::after {
  background-color: #8e9195;
}

.hw-seatmap--seat.hw-seatmap--occupied {
  border-color: #283D6B;
  background-color: #e8f2ff;
}

.hw-seatmap--seat.hw-seatmap--occupied::before,
.hw-seatmap--seat.hw-seatmap--occupied::after {
  background-color: #283D6B;
}

.hw-seatmap--seat.hw-seatmap--unavailable,
.hw-seatmap--seat.hw-seatmap--occupied {
  position: relative;
  overflow: hidden;
}

.hw-seatmap--seat.hw-seatmap--unavailable::before,
.hw-seatmap--seat.hw-seatmap--unavailable::after,
.hw-seatmap--seat.hw-seatmap--occupied::before,
.hw-seatmap--seat.hw-seatmap--occupied::after {
  content: "";
  position: absolute;
  top: -52.5%;
  width: 1px;
  height: 56px;
}

.hw-seatmap--seat.hw-seatmap--unavailable::before,
.hw-seatmap--seat.hw-seatmap--occupied::before {
  transform: rotate(45deg);
  right: calc(50% + 1px);
}

.hw-seatmap--seat.hw-seatmap--unavailable::after,
.hw-seatmap--seat.hw-seatmap--occupied::after {
  transform: rotate(-45deg);
  left: calc(50% + 1px);
}

.hw-seatmap--seat.hw-seatmap--unavailable:not(.hw-seatmap--info-box),
.hw-seatmap--seat.hw-seatmap--occupied:not(.hw-seatmap--info-box) {
  cursor: not-allowed;
}

.hw-seatmap--seat.hw-seatmap--unavailable .hw-seatmap--seat-number,
.hw-seatmap--seat.hw-seatmap--occupied .hw-seatmap--seat-number {
  display: none;
}

@media only screen and (min-width: 612px) {
  .hw-seatmap--seat {
    width: 50px;
    height: 50px;
    border: 1px solid #8e9195;
    background-color: #ffffff;
    border-radius: 18px;
    box-sizing: border-box;
  }

  .hw-seatmap--seat.hw-seatmap--selected,
  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available,
  .hw-seatmap--seat.hw-seatmap--selected:hover {
    border-color: #007bff;
  }

  .hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip),
  .hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip):before,
  .hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip):after,
  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip),
  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip):before,
  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip):after,
  .hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip),
  .hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip):before,
  .hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip):after {
    color: #ffffff !important;
  }

  .hw-seatmap--seat.hw-seatmap--available {
    border-color: #007bff;
  }

  .hw-seatmap--seat.hw-seatmap--available:not(.hw-seatmap--info-box) {
    cursor: pointer;
  }

  .hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) {
    background-color: #007bff;
  }

  .hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) .hw-seatmap--seat-number {
    color: #ffffff;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable {
    border-color: #8e9195;
    background-color: #f5f5f5;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable::before,
  .hw-seatmap--seat.hw-seatmap--unavailable::after {
    background-color: #8e9195;
  }

  .hw-seatmap--seat.hw-seatmap--occupied {
    border-color: #283D6B;
    background-color: #e8f2ff;
  }

  .hw-seatmap--seat.hw-seatmap--occupied::before,
  .hw-seatmap--seat.hw-seatmap--occupied::after {
    background-color: #283D6B;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable,
  .hw-seatmap--seat.hw-seatmap--occupied {
    position: relative;
    overflow: hidden;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable::before,
  .hw-seatmap--seat.hw-seatmap--unavailable::after,
  .hw-seatmap--seat.hw-seatmap--occupied::before,
  .hw-seatmap--seat.hw-seatmap--occupied::after {
    content: "";
    position: absolute;
    top: -52.5%;
    width: 1px;
    height: 84px;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable::before,
  .hw-seatmap--seat.hw-seatmap--occupied::before {
    transform: rotate(45deg);
    right: calc(50% + 1px);
  }

  .hw-seatmap--seat.hw-seatmap--unavailable::after,
  .hw-seatmap--seat.hw-seatmap--occupied::after {
    transform: rotate(-45deg);
    left: calc(50% + 1px);
  }

  .hw-seatmap--seat.hw-seatmap--unavailable:not(.hw-seatmap--info-box),
  .hw-seatmap--seat.hw-seatmap--occupied:not(.hw-seatmap--info-box) {
    cursor: not-allowed;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable .hw-seatmap--seat-number,
  .hw-seatmap--seat.hw-seatmap--occupied .hw-seatmap--seat-number {
    display: none;
  }
}

@media only screen and (min-width: 980px) {
  .hw-seatmap--seat {
    width: 50px;
    height: 50px;
    border: 1.5px solid #8e9195;
    /* background-color: #ffffff; */
    background-color: rgba(68, 68, 237, 0.574);
    border-radius: 16px;
    box-sizing: border-box;
  }

  .hw-seatmap--seat.hw-seatmap--selected,
  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available,
  .hw-seatmap--seat.hw-seatmap--selected:hover {
    /* border-color:var(--hw-brand-blue); */
    /* background-color: var(--hw-brand-blue) !important; */
    border-color: #007bff;
  }

  .hw-seatmap--seat.hw-seatmap--selected>*:not(.hw-seatmap--tooltip),
  .hw-seatmap--seat.hw-seatmap--selected>*:not(.hw-seatmap--tooltip):before,
  .hw-seatmap--seat.hw-seatmap--selected>*:not(.hw-seatmap--tooltip):after,
  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available>*:not(.hw-seatmap--tooltip),
  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available>*:not(.hw-seatmap--tooltip):before,
  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available>*:not(.hw-seatmap--tooltip):after,
  .hw-seatmap--seat.hw-seatmap--selected:hover>*:not(.hw-seatmap--tooltip),
  .hw-seatmap--seat.hw-seatmap--selected:hover>*:not(.hw-seatmap--tooltip):before,
  .hw-seatmap--seat.hw-seatmap--selected:hover>*:not(.hw-seatmap--tooltip):after {
    color: #007bff !important;
  }

  .hw-seatmap--seat.hw-seatmap--available {
    /* border-color: var(--hw-brand-blue); */
    border-color: #007bff;
  }

  .hw-seatmap--seat.hw-seatmap--available:not(.hw-seatmap--info-box) {
    cursor: pointer;
  }

  .hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) {
    /* background-color: var(--hw-brand-blue); */
    background-color: rgba(0, 123, 255, 0.1);
  }

  .hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) .hw-seatmap--seat-number {
    color: #007bff;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable {
    border-color: #8e9195;
    background-color: #f5f5f5;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable::before,
  .hw-seatmap--seat.hw-seatmap--unavailable::after {
    background-color: #8e9195;
  }

  .hw-seatmap--seat.hw-seatmap--occupied {
    border-color: var(--hw-brand-blue);
    background-color: #e8f2ff;
  }

  .hw-seatmap--seat.hw-seatmap--occupied::before,
  .hw-seatmap--seat.hw-seatmap--occupied::after {
    background-color: var(--hw-brand-blue);
  }

  .hw-seatmap--seat.hw-seatmap--unavailable,
  .hw-seatmap--seat.hw-seatmap--occupied {
    position: relative;
    overflow: hidden;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable::before,
  .hw-seatmap--seat.hw-seatmap--unavailable::after,
  .hw-seatmap--seat.hw-seatmap--occupied::before,
  .hw-seatmap--seat.hw-seatmap--occupied::after {
    content: "";
    position: absolute;
    top: -52.5%;
    width: 1px;
    height: 84px;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable::before,
  .hw-seatmap--seat.hw-seatmap--occupied::before {
    transform: rotate(45deg);
    right: calc(50% + 1px);
  }

  .hw-seatmap--seat.hw-seatmap--unavailable::after,
  .hw-seatmap--seat.hw-seatmap--occupied::after {
    transform: rotate(-45deg);
    left: calc(50% + 1px);
  }

  .hw-seatmap--seat.hw-seatmap--unavailable:not(.hw-seatmap--info-box),
  .hw-seatmap--seat.hw-seatmap--occupied:not(.hw-seatmap--info-box) {
    cursor: not-allowed;
  }

  .hw-seatmap--seat.hw-seatmap--unavailable .hw-seatmap--seat-number,
  .hw-seatmap--seat.hw-seatmap--occupied .hw-seatmap--seat-number {
    display: none;
  }
}

.hw-seatmap--seat.hw-seatmap--extra-legroom {
  border-color: #00c446;
  background-color: #ebffed;
}

.hw-seatmap--seat.hw-seatmap--extra-legroom:hover:not(.hw-seatmap--selected, .hw-seatmap--unavailable, .hw-seatmap--occupied) {
  background-color: #d0ffd4;
  border-color: #00b054;
}

.hw-seatmap--seat.hw-seatmap--exit-row {
  border-color: #ff5736;
  background-color: #ffde70;
}

.hw-seatmap--seat.hw-seatmap--exit-row:hover:not(.hw-seatmap--selected, .hw-seatmap--unavailable, .hw-seatmap--occupied) {
  background-color: #ffde70;
  border-color: #f74433;
}

.hw-seatmap--seat.hw-seatmap--selected {
  border-color: gray;
  /* background-color: var(--hw-brand-blue); */
  transform: scale(1.05);
  /* box-shadow: 0 4px 12px rgba(33, 62, 148, 0.3); */
}

.hw-seatmap--seat.hw-seatmap--selected .hw-seatmap--seat-number {
  color: #ffffff;
  font-weight: 600;
}

.hw-seatmap--seat.hw-seatmap--available {
  /* border-color:var(--hw-brand-blue); */
  background-color: #E5F2FF;
  border-color: #007bff;
}

.hw-seatmap--seat.hw-seatmap--available-free {
  background-color: #F1FDF5;
  border-color: #28a745;
}

.hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected) {
  /* background-color: var(--hw-brand-blue); */
  background-color: rgba(0, 123, 255, 0.1);
  transform: scale(1.02);
  /* box-shadow: 0 2px 8px rgba(33, 62, 148, 0.2); */
}

.hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected) .hw-seatmap--seat-number {
  color: #007bff;
}

.hw-seatmap--seat.hw-seatmap--available-free:hover:not(.hw-seatmap--selected) {
  background-color: rgba(40, 167, 69, 0.1);
  /* Green hover effect for free seats */
  transform: scale(1.02);
}

.hw-seatmap--seat.hw-seatmap--available-free:hover:not(.hw-seatmap--selected) .hw-seatmap--seat-number {
  color: #28a745;
  /* Green text color on hover for free seats */
}

.hw-seatmap--seat.hw-seatmap--unavailable {
  border-color: #8e9195;
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.hw-seatmap--seat.hw-seatmap--unavailable::before,
.hw-seatmap--seat.hw-seatmap--unavailable::after {
  background-color: #8e9195;
}

.hw-seatmap--seat.hw-seatmap--unavailable .hw-seatmap--seat-number {
  display: none;
}

.hw-seatmap--seat.hw-seatmap--occupied {
  border-color: var(--hw-brand-blue);
  background-color: #e8f2ff;
  cursor: not-allowed;
}

.hw-seatmap--seat.hw-seatmap--occupied::before,
.hw-seatmap--seat.hw-seatmap--occupied::after {
  background-color: var(--hw-brand-blue);
}

.hw-seatmap--seat.hw-seatmap--occupied .hw-seatmap--seat-number {
  display: none;
}

.hw-seatmap--seat-number {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #007bff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  transition: color 0.2s ease;
}

.hw-seatmap--seat.hw-seatmap--available-free .hw-seatmap--seat-number {
  color: #28a745;
}

@media only screen and (min-width: 612px) {
  .hw-seatmap--seat-number {
    font-size: 1.1rem;
  }
}

@media only screen and (min-width: 980px) {
  .hw-seatmap--seat-number {
    font-size: 1.5rem;
  }
}

.hw-seatmap--seat-number div {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  align-self: auto;
  min-width: 0;
  min-height: auto;
}

@media only screen and (min-width: 612px) {
  .hw-seatmap--row {
    margin-bottom: 8px;
  }

  .hw-seatmap--seat-wrapper {
    margin: 0 4px;
  }
}

@media only screen and (min-width: 980px) {
  .hw-seatmap--row {
    margin-bottom: 12px;
  }
}

@media (max-width: 900px) {
  .filter-collapsed .hw--listing-buttons-container {
    z-index: 10 !important;
  }

  .hw-seatmap--selection-layout {
    flex-direction: column;
    height: auto;
  }

  .hw-seatmap--aircraft {
    flex-direction: column !important;
  }

  .hw-passenger-data {
    order: 1;
    width: 100%;
    position: relative;
    margin-bottom: 1rem;
  }

  .hw-seatmap--plane-fuselage {
    order: 2;
    width: 100%;
  }

  .hw-seatmap--confirm-price {
    align-items: flex-start;
  }
}

@media only screen and (min-width: 980px) {
  .hw-seatmap--aircraft {
    padding: 24px;
    box-shadow: none;
  }
}

@media (max-width: 530px) {
  .hw-seatmap--row {
    margin-bottom: 0;
  }

  .hw-passenger-data {
    position: relative;
    margin-bottom: 1rem;
  }

  .hw-passenger-detail {
    max-width: 100%;
  }

  .hw-seatmap--confirm-price {
    align-items: flex-start;
  }

  .hw-seatmap--seat-wrapper {
    margin: 0 2px;
  }
}

@media (max-width : 350px) {
  .hw-seatmap--seat {
    width: 30px;
    height: 30px;
    border-radius: 10px;
  }
}

.hw-seatmap--gap {
  width: 20px;
  min-width: 20px;
  display: inline-block;
  height: 40px;
  border-radius: 8px;
  /* margin: 0 8px; */
}

/* Exit row marker */
.hw-seatmap--exit {
  width: 100%;
  text-align: center;
  color: var(--hw-brand-orange);
  ;
  font-weight: bold;
  padding: 4px 0 4px 0;
  border-radius: 6px;
  margin: 4px 0 4px 0;
  letter-spacing: 2px;
  font-size: 1.2rem;
}

.hw-seatmap--exit-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0 16px 0;
  width: 100%;
}

.hw-seatmap--exit-label {
  color: var(--hw-brand-orange);
  ;
  /* background: var(--hw-brand-orange); */
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 1.2rem;
  letter-spacing: 2px;
}

.hw-seatmap--exit-space {
  flex: 1;
  height: 32px;
  background: transparent;
}

.hw-seatmap--exit-vertical-line {
  /* height: 24px;
  width: 4px;
  background-color: var(--hw-brand-orange); */
  /* margin-left: 5px; */
}

.hw-seat-not-selected {
  width: 40px;
  height: 40px;
  border: 1px solid #007bff;
  border-radius: 14px;
  background-color: rgba(0, 123, 255, 0.1);
}

.hw-seat-available-free {
  width: 40px;
  height: 40px;
  border: 1px solid #28a745;
  border-radius: 14px;
  background-color: rgba(40, 167, 69, 0.1);
}

.hw-seat-extra-legroom {
  width: 40px;
  height: 40px;
  border: 1px solid #8e9195;
  border-radius: 14px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.hw-seat-selected {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #8e9195;
  /* background-color: #f5f5f5; */
}

.hw-selected-passenger {
  color: #007bff;
}

.hw-seatmap-legend {
  border-top: 1px solid #eee;
  padding: 16px 0 0 0;
  background: #fff;
  /* position: sticky; */
  bottom: 0;
  z-index: 10;
  text-align: left;
  display: flex;
  gap: 1rem
}

.hw-seatmap--tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fffefe;
  color: black !important;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 100000;
  transition: opacity 0.2s ease;
  border: 1px solid rgb(50, 50, 50);
}

/* Arrow border */
.hw-seatmap--tooltip::before {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 7px;
  border-style: solid;
  border-color: rgb(50, 50, 50) transparent transparent transparent;
  /* border */
}

/* Arrow fill */
.hw-seatmap--tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: #fffefe transparent transparent transparent;
  /* background */
}

.hw-seatmap--seat:hover .hw-seatmap--tooltip {
  visibility: visible;
  opacity: 1;
}


/*new css*/
.pt-48 {
  padding-top: 4.8rem;
}

.hw-box--gridWhite {
  background-color: var(--hw-white);
  border-radius: 0.5rem;
  padding: 1.6rem;
}

.hw-recent--viewed .hw-box--gridWhite {
  padding-bottom: 1rem;
  padding-right: 0;
}

.hw-light--badgeBlue {
  display: inline-flex;
  align-items: center;
  column-gap: 0.8rem;
  background-color: var(--hw-brand-orange-light);
  color: var(--hw-brand-orange);
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: bold;
}

.hw-light--badgesmall svg {
  display: block;
  width: 1.8rem;
  height: 1.8rem;
}

.hw-light--badgesmall {
  font-size: 1.2rem;
  line-height: 1.33333;
}

.hw-recent--middleText {
  column-gap: 0.8rem;
}

.hw-recent--innerList {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 0.6rem;
}

.hw-recent--middleIcon {
  flex-grow: 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 15rem;
  max-width: 19.4rem;
}

.hw-recent--middleText>span:not(.hw-recent--middleIcon) {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 10rem;
}

.hw-recent--middleIcon hr {
  background: var(--hw-white);
  border-width: 1px;
  border-style: solid;
  /* border-image: repeating-linear-gradient(45deg,rgba(var(--hw-brand-orange-rgb),0.5),rgba(var(--hw-brand-orange-rgb),0.5) 10px,transparent 6px,transparent 15px) 10; */
  border-image: repeating-linear-gradient(45deg, rgba(var(--hw-brand-orange-rgb), 0.5), rgba(var(--hw-brand-orange-rgb), 0.5) 8px, transparent 2px, transparent 10px) 10;
  position: absolute;
  width: 100%;
}

.hw-recent--middleIcon .svg-wrapper {
  line-height: 0;
  border: 1px solid var(--hw-brand-orange);
  background-color: var(--hw-white);
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: var(--hw-brand-orange);
}

.hw-head--textWrap {
  margin-bottom: 0.8rem;
}

.hw-head--textWrapMedium {
  margin-bottom: 1rem;
}

.hw-head--textWrap .h3+* {
  margin-top: 0.4rem;
}

.hw-head--textWrap>*:first-child,
.hw-head--textWrap>*:last-child {
  margin-bottom: 0;
}

.hw-flight--faq .hw-faq--item {
  border-bottom: 1px solid #d7d7d7;
}

.hw-faq--item .hw-faq--title {
  display: flex;
  justify-content: space-between;
  padding-top: 1.6rem;
  padding-bottom: 1.6rem;
  color: var(--hw-black-900);
  font-size: 1.6rem;
  line-height: 1.5;
  font-weight: 500;
  cursor: pointer;
}

.hw-faq--desc {
  padding: 0 0 1.6rem 0;
}

.hw-faq--desc a {
  font-weight: 500;
}

.hw-flight--faq>.hw-faq--item:first-child .hw-faq--title {
  padding-top: 0;
}

.hw-flight--faq>.hw-faq--item:last-child {
  border-bottom-width: 0;
}

.hw-multiCity--field {
  flex-grow: 1;
  margin: 0 !important;
}

@media (min-width: 641px) {
  .hw-box--gridWhite {
    padding: 2.4rem;
  }

  .hw-head--textWrap .h3+* {
    margin-top: 0.8rem;
  }

  .hw-head--textWrap {
    margin-bottom: 1.6rem;
  }
}

@media (min-width: 990px) {
  .hw-head--textWrap {
    margin-bottom: 3.2rem;
  }

  .hw-head--textWrapMedium {
    margin-bottom: 2rem;
  }

  .hw-faq--item .hw-faq--title {
    font-size: 1.8rem;
    line-height: 1.55556;
  }
}

@media (max-width: 749px) {

  .hw-head--textWrap .h3,
  .hw-box--gridWhite .h3 {
    font-size: 2rem;
    line-height: 1.5;
  }
}

@media (max-width: 640px) {
  .hw-horizontal--card .mt-16 {
    margin-top: 0.8rem !important;
  }
}

/*Grid css*/
.hw-vertical--grid,
.hw-horizontal--grid {
  display: grid;
  gap: 1.2rem;
}

.hw-vertical--grid3 {
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  align-items: start;
}

.hw-horizontal--grid4 {
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  align-items: start;
}

.hw-vertical--card {
  display: flex;
  align-items: center;
  column-gap: 1.6rem;
}

.hw-img--aspect1 {
  position: relative;
  overflow: hidden;
  aspect-ratio: 1/1;
}

.hw-horizontal--card .hw-hover--scaleImg {
  border-radius: 1rem;
}

.hw-img--aspect1 img {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  object-fit: cover;
}

.hw-hover--scaleImg img {
  transition: transform 0.3s ease-out;
  will-change: transform;
}

.hw-vertical--card .hw-img--aspect1 {
  min-width: 7rem;
  max-width: 7rem;
  border-radius: 0.5rem;
  flex-shrink: 0;
}

.hw-hover--scale:hover .hw-hover--scaleImg img {
  transform: scale(1.12);
  transform-origin: center center;
}

.hw-text--hiddenL {
  overflow: hidden;
}

.hw-text--hiddenL svg {
  display: block;
  flex-shrink: 0;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}

.hw-vertical--card .hw-text--hidden {
  width: max-content;
}

.hw-date--selectedDate {
  font-weight: bold;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hw-wholeBox--link {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  cursor: pointer;
}

.hw-icon--fixRight {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1rem;
}

.hw-input--input.active .hw-icon--fixRight svg {
  transform: scaleY(-1);
}

.hw-date-range-picker .hw-input--input {
  padding-right: 3.5rem;
}

@media (min-width: 768px) {
  .hw-icon--fixRight {
    right: 2rem;
  }
}

@media (min-width: 990px) {

  .hw-vertical--grid,
  .hw-horizontal--grid {
    gap: 2.4rem;
  }

  .hw-horizontal--grid4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .hw-vertical--grid3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: start;
  }

  .hw-vertical--card .hw-img--aspect1 {
    min-width: 10rem;
    max-width: 10rem;
  }
}

@media (max-width: 749px) {
  .hw-vertical--grid .hw-text18 {
    font-size: 1.6rem;
    line-height: 1.5;
  }
}

@media (max-width: 640px) {
  .hw-mobile--scroller {
    display: flex;
    overflow-x: auto;
    margin-right: -1.6rem;
    padding-right: 1.6rem;
    margin-left: -1.6rem;
    padding-left: 1.6rem;
  }

  .hw-mobile--scroller .hw-horizontal--card {
    min-width: 220px;
  }

  .hw-flight--faq {
    margin-top: 1.6rem;
  }
}

/*End Grid css*/
/*Header*/

.hw-profile--dropdown .hw-header--dropdownProfile {
  margin-top: 1rem !important;
  right: 0 !important;
  left: auto !important;
  padding: 2rem;
  z-index: 1001;
}

@media (min-width: 990px) {
  .hw-profile--dropdown .hw-header--dropdownProfile {
    margin-top: 2.4rem !important;
  }

  .hw-header--dropdownRight {
    right: 0 !important;
    left: auto !important;
  }
}

/*End header*/
/*Footer*/
.hw-footer {
  position: relative;
  background-color: var(--hw-gray-100);
  padding-top: 5rem;
  padding-bottom: 0;
  z-index: 10;
}

.hw-footer--wraper {
  background-color: var(--hw-white);
  padding: 2.4rem 0 1.2rem 0;
}

.hw-footer--copyRight {
  border-top: .1rem solid var(--hw-gray-200);
  margin-top: 1.2rem;
  padding-top: 1.2rem;
}

.hw-footer--copyRight a {
  color: inherit;
  /* text-decoration: underline;
    text-underline-offset: .2rem; */
}

.hw-footer--copyRight a:hover {
  color: var(--hw-black);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

.hw-footer--social {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.hw-footer__social-link {
  display: block;
  color: var(--social-color);
  border: 0.1rem solid var(--social-color);
  padding: 0.5rem;
  border-radius: 10rem;
  transition: 0.2s ease-out;
}

.hw-footer__social-link:hover {
  background-color: var(--social-color);
  color: var(--hw-white);
  border-color: var(--social-color);
}

.hw-footer__social-link svg {
  display: block;
  width: 1.6rem;
  height: 1.6rem;
}

.hw-footer--links {
  justify-content: end;
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  /* max-width: 70rem; */
  max-width: 76rem;
}

.hw-footer--brandLogo {
  display: flex;
  flex-direction: column;
  row-gap: 1.6rem;
}

.hw-footer--menuTitle {
  color: var(--hw-black-900);
  font-weight: bold;
  margin-bottom: 0.8rem;
}

.hw-footer--linksItem a {
  display: inline-block;
  text-underline-offset: 0.5rem;
  transition: text-decoration 0.3s ease-out;
}

.hw-footer--linksItem a:hover {
  text-decoration: underline;
}

.hw-footer--linksItem li+li {
  margin-top: 0.4rem;
}

.hw-box--textShow {
  background-color: rgba(215, 215, 215, 0.20);
  padding: 1.2rem;
}

.hw-paymentMethods {
  column-gap: 0.5rem;
}

.hw-paymentMethods>div {
  border-radius: 2px;
  border: 0.5px solid rgba(50, 100, 255, 0.20);
  background-color: var(--hw-white);
  min-width: 4rem;
  text-align: center;
}

@media (min-width: 750px) {
  .hw-footer--links {
    column-gap: 5rem;
    width: 70%;
  }

  .hw-box--textShow {
    padding: 1.6rem 2.4rem;
  }

  .hw-footer--brandLogo {
    row-gap: 2.4rem;
  }

  .hw-footer--copyRight {
    margin-top: 2.4rem;
    padding-top: 2.4rem;
  }
}

@media (min-width: 990px) {
  .hw-footer--links {
    column-gap: 6.5rem;
  }

  .hw-footer--wraper {
    padding-top: 4.8rem;
    padding-bottom: 2.4rem;
  }

  .hw-footer__social-link {
    padding: 0.6rem;
  }

  .hw-footer__social-link svg {
    width: 1.8rem;
    height: 1.8rem;
  }
}

@media (max-width: 749px) {
  .hw-footer--brandInfo {
    flex-direction: column;
    row-gap: 2rem;
  }

  .hw-footer--links {
    justify-content: space-between;
  }
}

/*End footer*/
/*End new css*/
@media (max-width: 1024px) {
  .hw-passenger--wrapper {
    row-gap: 2.4rem;
  }
}

@media (max-width: 989px) {
  .sidebar-collapsed .hw-widget.hw-widget--flight.hw-widget--flight__open {
    z-index: 99;
  }
}

@media (max-width: 991px) {
  .hw-passenger--fareSummary .hw-passenger--head {
    padding: 1.6rem;
  }
}

.hw-footer--links .column ul li a:hover {
  cursor: pointer;
}

.hw-seatmap--seat-text {
  display: flex;
  flex-direction: column;
  line-height: 70%;
}

.d-block {
  display: block;
}

.hw-hightlight-fare-rule-ai-summary {
  border: 2px dashed rgba(50, 100, 255, 0.50);
  padding: 2.4rem;
  background-color: rgba(29, 78, 229, 0.03);
  border-radius: 5px;
}



.hw--fare-rule-summary-ai-point li::marker {
  color: var(--hw-blue-new);
}

.hw--fare-rule-summary-ai-point {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0;
  margin-left: -1rem;
}

.hw-notfound-container {
  display: grid;
  place-content: center;
  height: 100vh;
  gap: 1rem;
  padding: 1rem;
}

.hw-notfound-container img {
  margin-inline: auto;
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

.hw-notfound-container .hw-notfound-content {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 0.5rem;
}

@media (max-width: 768px) {
  .hw-notfound-container {
    padding: 2rem 1rem;
  }

  .hw-notfound-container img {
    max-width: 70%;
  }

  .hw-notfound-container .hw-notfound-content {
    text-align: center;
    gap: 0.75rem;
  }
}

@media (max-width: 480px) {
  .hw-notfound-container img {
    max-width: 60%;
  }

  .hw-notfound-container {
    padding: 3rem 1rem;
  }
}

.hw-search-center {
  width: 100%;
  padding-left: 0 !important;
}

.hw-search-notavailabel {
  padding-block: 5rem;
}

.hw-search--flightFilterResult.hw-search-center {
  padding-top: 0.8rem;
}

.hw-search-notavailabel.hw-flight--ntavailable {
  margin-top: 0;
}

.hw-search-notavailabel button {
  margin-top: 2rem;
}

.hw-input--error-search .hw-input--switchGroup .hw-input--error-search.right {
  left: 0;
  right: auto;
}

@media (min-width: 767px) {
  .hw-input--switchGroup .hw-input--error-search.right {
    left: calc(50% + 0.5rem);
    right: auto;
  }
}

@media (max-width: 766px) {
  .hw-input--switchGroup .hw-input--error-search.left {
    top: 5rem;
    bottom: auto;
  }

  .hw-input--switchGroup .hw-input--error-search.right {
    left: 0;
    right: auto
  }
}

.hw-person-error--modal {
  color: var(--hw-red);
  position: absolute;
  top: 0;
  right: 0;
  font-size: 1.2rem;
  line-height: 1.5;
  z-index: 11;
  background: #fbe7e9;
  padding: 0.4rem;
  border-radius: 0.5rem;
}

.white-space-nowrap {
  white-space: nowrap !important;
}

.hw-airline--grid {
  display: grid;
  cursor: pointer;
  grid-template-columns: auto auto 1fr auto;
  /*flex: 1;*/
  /*max-width: 71%;*/
}

.hw-fare--slider .swiper-slide:hover {
  border-color: var(--hw-brand-orange);
}

.hw-dates-slider-container {
  display: flex;
  align-items: stretch;
  gap: 0;
  width: 100%;
  position: relative;
  border-radius: 0.3125rem;
  background: var(--White, #FFF);
  pointer-events: all;
}

.hw-dates-skeleton-slider {
  display: flex;
  gap: 8px;
  /* spacing between items */
  overflow-x: auto;
  /* horizontal scroll if needed */
  white-space: nowrap;
  scroll-snap-align: center;
  /* keep items in single line */
}

.hw-dates-skeleton-slider::-webkit-scrollbar {
  display: none;
}

.hw-dates-btn-prev,
.hw-dates-btn-next {
  width: 35px;
  /*height: 100%;*/
  background: transparent;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

.hw-dates-btn-next {
  border-left: 0.5px solid #D7D7D7;
}

.hw-dates-btn-prev {
  border-right: .5px solid #D7D7D7;
}

.hw-date-item {
  background: white;
  border-left: 0.5px solid #D7D7D7;
  cursor: pointer;
  text-align: center;
  display: flex;
  /* width: 15rem;
  flex: 0 0 13rem; */
  /* padding: 1rem 1.4375rem; */
  padding: 0.8rem 0.2rem 0.4rem 0.2rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* gap: .25rem; */
  scroll-snap-align: center;
  border-bottom: 4px solid transparent;
  width: 33.33%;
  flex-basis: 33.33%;
  min-width: 33.33%;
}

@media (min-width : 575px) {
  .hw-date-item {
    width: 25%;
    flex-basis: 25%;
    min-width: 25%;
  }
}

@media (min-width : 1024px) {
  .hw-date-item {
    width: 20%;
    flex-basis: 20%;
    min-width: 20%;
  }
}

@media (min-width : 1200px) {
  .hw-date-item {
    width: calc(100% / 7);
    flex-basis: calc(100% / 7);
    min-width: calc(100% / 7);
  }
}

.hw-date-item.selected {
  border-bottom: 4px solid var(--Blue, #3264FF);
}

.hw-date-range {
  color: var(--Violet, #121826);
  font-family: "DM Sans";
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
  /* line-height: 2.5rem; */
}

.hw-price {
  color: var(--Blue, #3264FF);
  text-align: center;
  font-family: "DM Sans";
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 500;
  /* line-height: 0.5rem; */
}

.hw-no-price {
  color: var(--Blue, #3264FF);
  text-align: center;
  font-family: "DM Sans";
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 500;
  /* line-height: .5rem; */
}

.hw-flight--cTab .hw-no-price {
  line-height: 1;
}

.hw-dates-slider {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  display: flex;
  flex: 1 0 0;
  overflow-y: auto;
  pointer-events: all;
  margin-left: -3px;
}

.hw-dates-slider::-webkit-scrollbar {
  display: none;
}

.hw-dates--roundtrip .hw-date-range,
.hw-dates--roundtrip .hw-price,
.hw-dates--roundtrip .hw-no-price {
  font-size: 1.2rem;
}

.hw-dates-slider-header {
  display: flex;
  justify-content: space-between;
  background: linear-gradient(90deg, #3264FF 21.17%, #1846D6 82.33%);
  color: var(--hw-white);
  padding: 0.6rem 1.2rem;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  align-items: center;
}

.hw-dates-rotate-text {
  position: relative;
  height: 2.4rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.hw-loader {
  width: 1.6rem;
  height: 1.6rem;
  border: 0.2rem solid #d3d3d3;
  border-top: 0.2rem solid var(--hw-white);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  flex-shrink: 0;
  will-change: transform;
  backface-visibility: hidden;
  transform-origin: center;
}



.hw-dates-rotate-text-inner {
  display: flex;
  flex-direction: column;
  animation: scrollUp 5s linear infinite;
}

.hw-dates-rotate-text span {
  height: 3.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width : 600px) {
  .hw-dates-slider-header {
    padding: 0.4rem 2rem;
  }
}

@media (max-width : 599px) {
  .hw-dates-slider-header {
    font-size: 1.2rem;
  }

  .hw-dates-slider-header .hw-text14 {
    /* font-size: 1rem !important; */
    font-size: 1.2rem !important;
    line-height: 1.5;
  }
}

@media (max-width : 479px) {
  .hw-dates-slider-header>.hw-fontBold {
    max-width: 14rem;
  }
}

@keyframes scrollUp {
  0% {
    transform: translateY(0)
  }

  50% {
    transform: translateY(-20%)
  }

  100% {
    transform: translateY(-50%)
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.hw-ndc-fare {
  padding: 0.4rem 0.8rem;
  font-size: 1.4rem;
  line-height: 1.5;
  font-weight: bold;
  display: inline-flex;
  justify-content: center;
  column-gap: 1rem;
  align-items: center;
  border: none;
  cursor: pointer;
  border-radius: 0.5rem;
  color: var(--hw-brand-orange);
  background-color: rgba(50, 100, 255, 0.10);
}

.hw-airline-filter .hw-form--input {
  padding: 0.8rem 3rem 0.8rem 1rem;
}

.hw-airline-filter>svg {
  position: absolute;
  right: 1.6rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--hw-brand-orange);
  display: block;
  width: 2rem;
  height: 2rem;
  pointer-events: none;
}

.hw-animated-placeholder {
  position: absolute;
  left: 3rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  width: calc(100% - 100px);
  z-index: 2;
  height: 1.5em;
  color: var(--Dark-Blue, #0F294D);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
}

.hw-placeholder-item {
  position: absolute;
  left: 8.5rem;
  top: 0;
  opacity: 0;
  transform: translateY(30px);
  transition: all .1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  animation: scrollUpExcursion 1.2s ease-in-out infinite;
}

.hw-placeholder-item.active {
  opacity: 1;
  transform: translateY(0);
  z-index: 2;
}

/* .hw-cursor {
  display: inline-block;
  margin-left: 4px;
  animation: scrollUp 1s linear infinite;
} */
@keyframes scrollUpExcursion {
  0% {
    transform: translateY(0)
  }

  to {
    transform: translateY(-80%)
  }
}

.hw-contact--inputSingleField .css-1wy0on6 {
  flex-direction: row-reverse !important;
}

.hw-add--bagagge .hw-select__control {
  min-height: 5rem;
  border-color: #CCCCCC !important;
  outline: none !important;
  box-shadow: none;
}

.hw-add--bagagge .hw-select__placeholder {
  color: var(--hw-gray-800);
}

.hw-add--bagagge .hw-select__indicator.hw-select__dropdown-indicator {
  color: var(--hw-gray-800);
}

.hw-currency {
  font-family: 'aedregular', sans-serif !important;
}

.hw-action-tooltipWrap {
  position: relative;
  display: inline-flex;
}

.hw-action-tooltipText {
  position: absolute;
  right: calc(100% + 10px);
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  color: #222;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.3;
  white-space: nowrap;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.18s ease, visibility 0.18s ease;
  z-index: 20;
}

.hw-action-tooltipText.is-visible {
  opacity: 1;
  visibility: visible;
}

@media (max-width: 767px) {
  .hw-action-tooltipText {
    right: auto;
    left: 50%;
    top: auto;
    bottom: calc(100% + 10px);
    transform: translateX(-50%);
  }
}










/*Flight Hotel UI Redesign*/
:root {
  --newly-added-color: #F3960A;
}

.hw-widget.hw-widget--flight .hw-tab button {
  font-size: 1.4rem;
}

.hw-row--gap4 {
  row-gap: 0.4rem;
}





.hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw--vendor-img .hw-text14 {
  font-size: 1.2rem !important;
}

.hw-search--flightFilterResult__listNew .hw-view--pricesBtn {
  padding: 0.5rem 1.5rem;
  font-size: 1.2rem;
  text-transform: uppercase;
  line-height: 1.5;
}

.hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-print-selection-box {
  position: absolute;
  right: 5px;
  top: 5px;
}

.hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-print-selection-box input {
  width: 1.8rem;
  height: 1.8rem;
}

.hw-flight--listBox .destination .destination-from>.hw-text14,
.hw-flight--listBox .destination .destination-to>.hw-text14 {
  line-height: 1.286;
}

.hw-widget--flight .hw-row--inputCheck input[type="checkbox"],
.hw-search--flightFilter input[type="checkbox"] {
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 0.4rem;
}

.hw-text--100ellipsis {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: fit-content;
}

.hw-flight--listBox__flight {

  max-width: 15rem;
}

/* .hw-search--flightFilterResult__listNew > .hw-search--flightFilterResult__listItem > .hw-search--flightFilterResult__listItemList {
  width: 16rem;
} */
.hw-widget--flight .js-show--topFilter,
.hw-hotel--filterWidgetMain .js-show--topFilter {
  position: absolute;
  bottom: -1rem;
  right: 0;
  background: var(--hw-white);
  border: none;
  padding: 0.5rem 1.6rem;
  font-weight: bold;
  color: var(--hw-brand-orange);
  font-size: 1.4rem;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);
  border-radius: 0.4rem;
  cursor: pointer;
  min-width: 9.5rem;
  justify-content: center;
}

.hw-hotel--filterWidgetMain .js-show--topFilter {
  bottom: -3.5rem;
}

.hw-widget--flight .js-show--topFilter:hover,
.hw-hotel--filterWidgetMain .js-show--topFilter:hover {
  color: var(--hw-brand-blue);
}

.hw-widget--flight.hw-widget--flight__open .hw-widget--card {
  transition: max-height 0.3s ease-out, overflow 0.3s ease-out;
  max-height: max-content;

}

.hw-widget--flight.hw-widget--flight__open.filter-visible {
  min-height: auto;
}

.hw-widget--flight.hw-widget--flight__open.filter-visible .hw-widget--card {
  max-height: 5.8rem;
  overflow: hidden;
  /* padding: 0;  */

}

/* .hw-widget--flight.hw-widget--flight__open.filter-visible .hw-widget--card .hw-tab {
  opacity: 0;
} */

.hw-search--flightFilterResult__listNew .hw-search--flightFilterResult__listItemList span img {
  object-fit: contain;
}

@media (min-width: 1101px) {
  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    padding-top: 2.5rem;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.mb-2 .hw-ndc-fare {
    position: absolute;
    font-size: 1.2rem;
    line-height: normal;
    top: 5px;
    left: 5px;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.hw-flight--listBox {
    flex: 1 1 0;
    column-gap: 2rem;
    padding-left: 2rem;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw--vendor-img {
    position: absolute;
    right: 3rem;
    top: 4px;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-search--flightFilterResult__listItemList {
    width: 12rem;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start !important;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-flight--listBoxAction {
    align-items: flex-end;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.hw-flight--listBox~* {
    width: 100%;
  }

  /*Multi city*/
  .hw-search--flightFilterResult__listNew .hw-flight--listBoxInnerList {
    display: flex;
    column-gap: 2rem;
  }

  /*End*/

}

@media (min-width: 1101px) and (max-width: 1199px) {
  .hw-text--100ellipsis {
    max-width: 7rem;
  }
}

@media (min-width: 1200px) {
  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-search--flightFilterResult__listItemList {
    width: 16rem;
  }
}

@media (min-width: 750px) and (max-width: 900px) {
  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    padding-top: 2.5rem;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.mb-2 .hw-ndc-fare {
    position: absolute;
    font-size: 1.2rem;
    line-height: normal;
    top: 5px;
    left: 5px;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.hw-flight--listBox {
    flex: 1 1 0;
    column-gap: 1rem;
    padding-left: 1rem;
    flex-wrap: nowrap;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw--vendor-img {
    position: absolute;
    right: 3rem;
    top: 4px;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-search--flightFilterResult__listItemList {
    width: 12rem;
    justify-content: center;
    align-items: flex-start !important;
    flex-direction: column;
  }

  .hw-text--100ellipsis {
    max-width: 7rem;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-flight--listBoxAction {
    align-items: flex-end;
    flex-direction: column;
    width: fit-content;
    flex-shrink: 0;
  }

  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.hw-flight--listBox~* {
    width: 100%;
  }

  /*Multi city*/
  .hw-search--flightFilterResult__listNew .hw-flight--listBoxInnerList {
    column-gap: 1rem;
    display: flex;
  }

  /*End*/

}

@media (max-width: 749px) {
  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-search--flightFilterResult__listItemList {
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 640px) {
  .hw-widget--flight .js-show--topFilter {
    bottom: -1.6rem;
    right: -1rem;
    padding: 0.4rem 1.2rem;
    min-width: 8rem;
  }

  .hw-widget--flight .js-show--topFilter svg {
    width: 2rem;
    height: 2rem;
  }

  .hw-search--flightFilterResult__listNew .hw-search--flightFilterResult__listItemList span img {
    width: 3rem;
    height: 3rem;
  }

  .hw-xstext20 {
    font-size: 2rem !important;
  }
}

.hw-search--flightFilterResult__listNew .hw-flight--line .circle,
.hw-search--flightFilterResult__listNew .hw-flight--line .line,
.hw-search--flightFilterResult__listNew .hw-flight--line--stop {
  background-color: var(--newly-added-color);
}

.hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem {
  box-shadow: 0px 4px 20px rgba(15, 23, 42, 0.06);
}

.pl-null {
  padding-left: 0 !important;
}



/*Hotel Redesign UI*/
.hw-hotes-module.hw-hotel--widget.hw-hotel--filterWidgetMain .hw-filter--searchBtn,
.hw-hotes-module .hw-widget--card .hw-input--groupCol .hw-filter--searchBtn {
  min-width: 6.4rem;
  padding-left: 2rem;
  padding-right: 2rem;
}


.hw-hotel-search.nationality-select {
  width: 25rem;
  margin-left: 0.4rem;
  position: relative;
}

.hw-hotel-search.nationality-select>div>div {
  width: 100%;
  padding: 0 !important;
  min-height: 5.4rem;
  border-radius: 0 !important;
}

.hw-hotel-search.nationality-select>div>div>div {
  padding-top: 0;
  padding-bottom: 0;
}

.hw-hotel-search.nationality-select .css-1jqq78o-placeholder {
  margin-left: 0;
  color: var(--hw-brand-blue);
  font-weight: 500;
  padding-left: 0;
}

.hw-hotes-module .hw-input--multicityGroup .hw-hotel-search.nationality-select>div>div>div .css-1xc3v61-indicatorContainer svg {
  color: var(--hw-brand-blue) !important;
}

.hw-row--input .hw-hotel-search.nationality-select:hover .css-1u80x8j-control {
  border-color: var(--hw-brand-orange) !important;
}

.hw-date--calender>div.hw-calender--removeBtn {
  min-height: auto;
  padding: 0.4rem;
  right: 0.8rem !important;
}

.hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {
  padding-left: 1rem;
  padding-right: 1rem;
}

.hw-hotes-module.hw-hotel--widget.hw-hotel--filterWidgetMain {
  position: sticky;
  top: 0;
  z-index: 11;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);
}

@media (min-width: 440px) and (max-width: 1099px) {
  .hw-hotes-module .hw-input--groupCol .hw-input--switchGroup {
    width: 60%;
    flex: 1 0 0;
  }

  .hw-hotel-search.nationality-select {
    width: 38%;
    margin-left: 0;
  }

  .hw-hotel-search.nationality-select>div>div {
    border-radius: 0.5rem !important;
  }
}

@media (min-width: 900px) {
  .hw-hotel--filterWidgetMain .js-show--topFilter {
    display: none !important;
  }
}

@media (max-width: 899px) {
  .hw-hotel--filterWidgetMain .hw-hotes-moduleFilterTop {
    transition: max-height 0.3s ease-out, opacity 0.3s ease-out;
    max-height: 40rem;
    overflow: hidden;
  }

  .hw-hotel--filterWidgetMain.filter-visible .hw-hotes-moduleFilterTop {
    max-height: 0;

  }
}

@media (max-width: 1239px) and (min-width: 768px) {
  .hw--listing-buttons-container {
    right: 0.5rem !important;
    top: 55% !important;
  }

  /* .hw--listing-buttons-container .hw-btn {
    width: 3.5rem !important;
    height: 3.5rem !important;
  } */
}

@media (max-width: 767px) {
  .hw--listing-buttons-container {
    right: 0.5rem !important;
    transform: translateX(0) !important;
    padding: 0.5rem 1rem !important;
    bottom: 5px !important;
  }

  .hw-gapy10.hw--listing-buttons-container {
    column-gap: 0.5rem !important;
  }

  .hw--listing-buttons-container .hw-btn {
    width: 3.2rem !important;
    height: 3.2rem !important;
  }

  .hw-action-tooltipText {
    transform: translateX(-85%);
  }
}

@media (max-width: 439px) {
  .hw-hotel-search.nationality-select {
    width: 100%;
    margin-left: 0;
  }

  .hw-hotel-search.nationality-select>div>div {
    border-radius: 0.5rem !important;
  }

  .hw-hotes-module.hw-hotel--widget .hw-date--calender>div.hw-calender--removeBtn {
    right: 0 !important;
    margin-top: 1rem;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {

  .hw-widget--flight.hw-widget--flight__open.filter-visible .hw-widget--card {
    max-height: 5.4rem;
    overflow: hidden;
  }

}

/*End Hotel UI Redesign*/
/*End Flight Hotel UI Redesign*/

/* ═══════════════════════════════════════════════════════════════════════════
   PASSPORT PHOTO EDITOR  (hw-pe-- prefix)
   All rules below are scoped to the photo-editor page only.
   Colours re-use the existing CSS custom properties wherever possible.
   ═══════════════════════════════════════════════════════════════════════════ */

/* ── Page wrapper ─────────────────────────────────────────────────────────── */
.hw-pe--page {
  padding-top: 2rem;
  padding-bottom: 4rem;
}

/* ── Page heading ─────────────────────────────────────────────────────────── */
.hw-pe--page-header {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  margin-bottom: 2.5rem;
  flex-wrap: wrap;
}

.hw-pe--page-header-icon {
  width: 4.8rem;
  height: 4.8rem;
  background: var(--hw-brand-orange);
  border-radius: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.hw-pe--page-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--hw-black-900);
  margin: 0;
  line-height: 1.2;
}

.hw-pe--page-sub {
  font-size: 1.3rem;
  color: var(--hw-gray-500);
  margin: 0.3rem 0 0;
}

/* ── Mode badge ───────────────────────────────────────────────────────────── */
.hw-pe--mode-badge {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.1rem;
  font-weight: 700;
  padding: 0.4rem 1rem;
  border-radius: 2rem;
}

.hw-pe--mode-dot {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background: currentColor;
}

.hw-pe--mode-ai {
  background: #ede9fe;
  color: #7c3aed;
}

.hw-pe--mode-local {
  background: var(--hw-gray-100);
  color: var(--hw-gray-500);
}

/* ── Stepper ──────────────────────────────────────────────────────────────── */
.hw-pe--stepper-wrap {
  position: relative;
  width: 100%;
  height: 5.6rem;
  margin-bottom: 2.5rem;
}

.hw-pe--stepper-track {
  position: absolute;
  top: 1.6rem;
  left: 1.6rem;
  right: 1.6rem;
  height: 4px;
  background: var(--hw-gray-200);
  border-radius: 99px;
  z-index: 1;
}

.hw-pe--stepper-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--hw-brand-orange), var(--hw-brand-blue));
  border-radius: 99px;
  width: 0%;
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.hw-pe--stepper-steps {
  position: relative;
  display: flex;
  justify-content: space-between;
  z-index: 2;
}

.hw-pe--step-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 3.2rem;
}

.hw-pe--step-circle {
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 700;
  flex-shrink: 0;
  border: 2px solid var(--hw-gray-400);
  color: var(--hw-gray-400);
  background: var(--hw-white);
  transition: all 0.4s ease;
  box-shadow: 0 0 0 6px var(--hw-white);
}

.hw-pe--step-item.active .hw-pe--step-circle {
  border-color: var(--hw-brand-orange);
  background: var(--hw-brand-orange);
  color: var(--hw-white);
  box-shadow: 0 0 0 6px var(--hw-white), 0 4px 10px rgba(255, 122, 0, 0.25);
}

.hw-pe--step-item.done .hw-pe--step-circle {
  border-color: var(--hw-brand-blue);
  background: var(--hw-brand-blue);
  color: var(--hw-white);
}

.hw-pe--step-label {
  position: absolute;
  top: 4rem;
  white-space: nowrap;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--hw-gray-400);
  transition: color 0.4s ease;
  left: 50%;
  transform: translateX(-50%);
}

.hw-pe--stepper-steps .hw-pe--step-item:first-child .hw-pe--step-label {
  left: 0;
  transform: none;
}

.hw-pe--stepper-steps .hw-pe--step-item:last-child .hw-pe--step-label {
  left: auto;
  right: 0;
  transform: none;
}

.hw-pe--step-item.active .hw-pe--step-label {
  color: var(--hw-brand-orange);
}

.hw-pe--step-item.done .hw-pe--step-label {
  color: var(--hw-brand-blue);
}

/* ── Card ─────────────────────────────────────────────────────────────────── */
.hw-pe--card {
  background: var(--hw-white);
  border-radius: 0.5rem;
  padding: 2rem;
  box-shadow: 0px 0px 10px 0px rgba(var(--hw-black-rgb), 0.10);
  margin-bottom: 1.5rem;
}

/* ── Section headings ─────────────────────────────────────────────────────── */
.hw-pe--section-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 0.4rem;
  color: var(--hw-black-900);
}

.hw-pe--section-sub {
  font-size: 1.3rem;
  color: var(--hw-gray-500);
  margin-bottom: 2rem;
}

/* ── Back button ──────────────────────────────────────────────────────────── */
.hw-pe--back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--hw-gray-650);
  cursor: pointer;
  border: 1.5px solid var(--hw-gray-200);
  background: #fff;
  padding: 0.55rem 1.2rem 0.55rem 0.9rem;
  border-radius: 0.6rem;
  margin-bottom: 1.8rem;
  transition: border-color .2s, color .2s, background .2s;
}

.hw-pe--back-btn:hover {
  border-color: var(--hw-brand-orange);
  color: var(--hw-brand-orange);
  background: var(--hw-brand-orange-light);
}

/* ── Continue button ──────────────────────────────────────────────────────── */
.hw-pe--continue-btn {
  margin-top: 1.5rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 2rem;
}

.hw-pe--continue-btn:disabled {
  background-color: var(--hw-gray-200) !important;
  color: var(--hw-gray-500) !important;
  cursor: not-allowed;
}

/* ── Country dropdown ─────────────────────────────────────────────────────── */
.hw-pe--dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  background: var(--hw-white);
  border: 2px solid var(--hw-gray-200);
  border-radius: 0.5rem;
  cursor: pointer;
  transition: border-color .2s;
}

.hw-pe--dropdown-trigger:hover {
  border-color: var(--hw-brand-orange);
}

.hw-pe--dropdown-trigger.open {
  border-color: var(--hw-brand-orange);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.hw-pe--dt-flag {
  font-size: 2rem;
  line-height: 1;
  flex-shrink: 0;
}

.hw-pe--dt-text {
  flex: 1;
}

.hw-pe--dt-name {
  font-size: 1.4rem;
  font-weight: 600;
}

.hw-pe--dt-size {
  font-size: 1.15rem;
  color: var(--hw-gray-400);
}

.hw-pe--dropdown-panel {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 50;
  background: var(--hw-white);
  border: 2px solid var(--hw-brand-orange);
  border-top: none;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .12);
  overflow: hidden;
}

.hw-pe--dp-search {
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid var(--hw-gray-100);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.hw-pe--dp-search input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 1.3rem;
  background: none;
  color: var(--hw-black-900);
}

.hw-pe--dp-list {
  max-height: 28rem;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.hw-pe--dp-list::-webkit-scrollbar {
  width: 6px;
}

.hw-pe--dp-list::-webkit-scrollbar-thumb {
  background: var(--hw-gray-200);
  border-radius: 99px;
}

.hw-pe--dp-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 1rem;
  cursor: pointer;
  transition: background .15s;
}

.hw-pe--dp-item:hover {
  background: var(--hw-gray-100);
}

.hw-pe--dp-item.selected {
  background: var(--hw-brand-orange-light);
}

.hw-pe--dp-flag {
  font-size: 1.8rem;
  line-height: 1;
  flex-shrink: 0;
}

.hw-pe--dp-info {
  flex: 1;
}

.hw-pe--dp-name {
  font-size: 1.3rem;
  font-weight: 600;
}

.hw-pe--dp-dims {
  font-size: 1.1rem;
  color: var(--hw-gray-400);
}

.hw-pe--dp-tick {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: var(--hw-brand-orange);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--hw-white);
}

.hw-pe--dp-empty {
  padding: 1.5rem;
  text-align: center;
  font-size: 1.3rem;
  color: var(--hw-gray-400);
}

/* ── Step 1 layout (2-col: dropdown | spec preview) ──────────────────────── */
.hw-pe--step1-layout {
  display: grid;
  grid-template-columns: 1fr 30rem;
  gap: 1.5rem;
}

@media (max-width: 680px) {
  .hw-pe--step1-layout {
    grid-template-columns: 1fr;
  }
}

/* ── Spec preview ─────────────────────────────────────────────────────────── */
.hw-pe--spec-preview {
  background: var(--hw-brand-orange-light);
  border: 1px solid rgba(var(--hw-brand-orange-rgb), 0.35);
  border-radius: 0.5rem;
  padding: 1.5rem;
  height: fit-content;
}

.hw-pe--sp-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--hw-brand-orange);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.75rem;
}

.hw-pe--sp-flag-name {
  font-size: 1.6rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.6rem;
}

.hw-pe--sp-dims {
  display: inline-block;
  background: var(--hw-white);
  border-radius: 6px;
  padding: 0.4rem 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--hw-brand-orange);
  margin-bottom: 1rem;
}

.hw-pe--sp-reqs {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.hw-pe--sp-reqs li {
  font-size: 1.2rem;
  color: var(--hw-black-500);
  display: flex;
  gap: 0.8rem;
  align-items: flex-start;
  line-height: 1.4;
}

/* ── Upload layout (sidebar | upload area) ────────────────────────────────── */
.hw-pe--upload-layout {
  display: grid;
  grid-template-columns: 26rem 1fr;
  gap: 1.5rem;
  align-items: start;
}

@media (max-width: 640px) {
  .hw-pe--upload-layout {
    grid-template-columns: 1fr;
  }
}

/* ── Requirements panel (sidebar) ────────────────────────────────────────── */
.hw-pe--req-panel {
  background: var(--hw-white);
  border: 1px solid var(--hw-gray-200);
  border-radius: 0.5rem;
  padding: 1.5rem;
}

.hw-pe--req-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.hw-pe--req-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.hw-pe--req-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 1.2rem;
  color: var(--hw-black-500);
  line-height: 1.4;
}

.hw-pe--req-icon {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  background: var(--hw-brand-orange);
  flex-shrink: 0;
  margin-top: 0.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--hw-white);
}

.hw-pe--req-dims {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--hw-gray-100);
  color: var(--hw-gray-400);
  text-align: center;
}

/* ── Drop zone ────────────────────────────────────────────────────────────── */
.hw-pe--drop-zone {
  border: 2px dashed var(--hw-gray-400);
  border-radius: 0.5rem;
  padding: 3rem 1.5rem;
  text-align: center;
  cursor: pointer;
  background: var(--hw-white);
  transition: border-color .2s, background .2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.hw-pe--drop-zone:hover,
.hw-pe--drop-zone.dragover {
  border-color: var(--hw-brand-orange);
  background: var(--hw-brand-orange-light);
}

.hw-pe--dz-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--hw-black-500);
  margin: 0.5rem 0 0;
}

.hw-pe--dz-sub {
  font-size: 1.2rem;
  color: var(--hw-gray-400);
}

/* ── Photo preview (after selection) ─────────────────────────────────────── */
.hw-pe--preview-wrap {
  position: relative;
  border-radius: 0.5rem;
  overflow: hidden;
  margin-bottom: 0;
}

.hw-pe--preview-img {
  width: 100%;
  max-height: 28rem;
  object-fit: contain;
  display: block;
  background: var(--hw-gray-100);
}

.hw-pe--remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, .55);
  color: var(--hw-white);
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: 1.4rem;
  line-height: 28px;
  text-align: center;
  transition: background .2s;
}

.hw-pe--remove-btn:hover {
  background: rgba(0, 0, 0, .8);
}

/* ── Process button ───────────────────────────────────────────────────────── */
.hw-pe--process-btn {
  display: block;
  width: 100%;
  margin-top: 1rem;
  padding: 0.85rem 1.5rem;
  font-size: 1.4rem;
  font-weight: 700;
}

.hw-pe--process-btn:disabled {
  background-color: var(--hw-gray-200) !important;
  color: var(--hw-gray-500) !important;
  cursor: not-allowed;
  transform: none !important;
}

/* ── Progress panel ───────────────────────────────────────────────────────── */
.hw-pe--progress-wrap {
  margin-top: 1rem;
  background: var(--hw-white);
  border: 1px solid var(--hw-gray-200);
  border-radius: 0.5rem;
  padding: 1.5rem;
}

.hw-pe--progress-steps {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.hw-pe--ps-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.3rem;
  color: var(--hw-gray-400);
  transition: color .3s;
}

.hw-pe--ps-item.active {
  color: var(--hw-brand-orange);
  font-weight: 600;
}

.hw-pe--ps-item.done {
  color: var(--hw-green);
}

.hw-pe--ps-dot {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background: var(--hw-gray-200);
  flex-shrink: 0;
  transition: background .3s;
}

.hw-pe--ps-item.active .hw-pe--ps-dot {
  background: var(--hw-brand-orange);
  animation: hw-pe-pulse 1s infinite;
}

.hw-pe--ps-item.done .hw-pe--ps-dot {
  background: var(--hw-green);
  animation: none;
}

@keyframes hw-pe-pulse {

  0%,
  100% {
    opacity: 1
  }

  50% {
    opacity: .4
  }
}

.hw-pe--progress-bar-track {
  background: var(--hw-gray-100);
  border-radius: 9999px;
  height: 6px;
  overflow: hidden;
}

.hw-pe--progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--hw-brand-orange), #60a5fa);
  border-radius: 9999px;
  transition: width .5s ease;
}

/* ── Tips row ─────────────────────────────────────────────────────────────── */
.hw-pe--tips-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
  gap: 0.6rem;
  margin-top: 1.5rem;
}

.hw-pe--tip-card {
  background: var(--hw-brand-orange-light);
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  font-size: 1.2rem;
  color: var(--hw-brand-orange);
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  line-height: 1.4;
}

/* ── Alerts ───────────────────────────────────────────────────────────────── */
.hw-pe--alert {
  border-radius: 0.5rem;
  padding: 0.65rem 0.9rem;
  font-size: 1.25rem;
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  margin-bottom: 0.5rem;
}

.hw-pe--alert-warn {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
}

.hw-pe--alert-error {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

.hw-pe--warnings-box {
  margin-bottom: 1rem;
}

/* ── Result layout (before / after, 2 cols) ──────────────────────────────── */
.hw-pe--result-container {
  width: 100%;
}

.hw-pe--result-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.hw-pe--back-btn-new {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.75rem 1.4rem;
  border-radius: 99px;
  background: var(--hw-white);
  border: 1.5px solid var(--hw-gray-200);
  color: var(--hw-gray-650);
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hw-pe--back-btn-new:hover {
  border-color: var(--hw-brand-blue);
  color: var(--hw-brand-blue);
  background: var(--hw-brand-blue-light);
}

.hw-pe--result-header-status {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 1.2rem;
  border-radius: 99px;
  background: var(--hw-brand-blue-light);
  color: var(--hw-brand-blue);
}

.hw-pe--result-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

@media (max-width: 580px) {
  .hw-pe--result-layout {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .hw-pe--result-header-bar {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
}

.hw-pe--result-card {
  display: flex;
  flex-direction: column;
  border-radius: 1.2rem;
  overflow: hidden;
  height: 34rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.04);
  border: 1px solid var(--hw-gray-200);
  background: var(--hw-white);
  width: 100%;
}

.hw-pe--result-card-header {
  background: var(--hw-white);
  border-bottom: 1px solid var(--hw-gray-200);
  padding: 1.2rem 1.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hw-pe--result-card-title {
  color: var(--hw-gray-650);
  letter-spacing: 0.02em;
  text-transform: none;
}

.hw-pe--tag-new {
  font-size: 1.1rem;
  padding: 3px 8px;
  border-radius: 6px;
}

.tag-raw {
  background: var(--hw-gray-200);
  color: var(--hw-gray-650);
}

.tag-compliant {
  background: #dcfce7;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.hw-pe--result-image-container {
  width: 100%;
  flex: 1;
  background-color: #f8fafc;
  background-image: linear-gradient(45deg, #f1f5f9 25%, transparent 25%),
    linear-gradient(-45deg, #f1f5f9 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #f1f5f9 75%),
    linear-gradient(-45deg, transparent 75%, #f1f5f9 75%);
  background-size: 16px 16px;
  background-position: 0 0, 0 8px, 8px -8px, -8px 0;
  overflow: hidden;
}

.hw-pe--result-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.hw-pe--control-panel {
  background: var(--hw-white);
  border: 1px solid var(--hw-gray-200);
  border-radius: 1.2rem;
  padding: 2.4rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.04);
  width: 100%;
}

.hw-pe--metadata-ribbon {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  flex-wrap: wrap;
}

.hw-pe--meta-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0.6rem 1.2rem;
  border-radius: 99px;
  background: var(--hw-brand-blue-light);
  color: var(--hw-brand-blue);
  font-weight: 700;
}

.hw-pe--meta-flag {
  font-size: 1.4rem;
  line-height: 1;
}

.hw-pe--action-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
}

.hw-pe--download-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 1.2rem 2.8rem;
  border-radius: 0.6rem;
  background: var(--hw-brand-blue);
  color: var(--hw-white);
  font-size: 1.4rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(15, 41, 77, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.hw-pe--download-primary:hover {
  background-color: #1a4d8c;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(15, 41, 77, 0.15);
}

.hw-pe--restart-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 1.2rem 2.4rem;
  border-radius: 0.6rem;
  background: var(--hw-white);
  border: 1.5px solid var(--hw-brand-blue);
  color: var(--hw-brand-blue);
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.hw-pe--restart-secondary:hover {
  background: var(--hw-brand-blue-light);
  border-color: var(--hw-brand-blue);
  transform: translateY(-1px);
}

@media (max-width: 580px) {
  .hw-pe--action-row {
    flex-direction: column;
    width: 100%;
  }

  .hw-pe--download-primary,
  .hw-pe--restart-secondary {
    width: 100%;
  }
}

/* ── Tags ─────────────────────────────────────────────────────────────────── */
.hw-pe--tag {
  font-size: 1rem;
  padding: 2px 7px;
  border-radius: 2rem;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0;
}

.hw-pe--tag-orig {
  background: var(--hw-gray-100);
  color: var(--hw-gray-500);
}

.hw-pe--tag-proc {
  background: #dcfce7;
  color: var(--hw-green);
}

.hw-pe--tag-ai {
  background: #ede9fe;
  color: #7c3aed;
}

/* ── AI Analysis panel ────────────────────────────────────────────────────── */
.hw-pe--analysis-panel {
  background: var(--hw-white);
  border: 1px solid var(--hw-gray-200);
  border-radius: 0.5rem;
  padding: 2rem;
  margin-bottom: 1.5rem;
}

.hw-pe--ap-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--hw-gray-100);
}

.hw-pe--ap-title {
  font-size: 1.5rem;
}

.hw-pe--ap-badge {
  margin-left: auto;
  font-size: 1.1rem;
  font-weight: 700;
  color: #7c3aed;
  background: #ede9fe;
  padding: 3px 10px;
  border-radius: 2rem;
}

.hw-pe--analysis-grid {
  display: grid;
  grid-template-columns: 12rem 1fr 1fr;
  gap: 1.5rem;
  align-items: start;
}

@media (max-width: 540px) {
  .hw-pe--analysis-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.hw-pe--al-head {
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 0.6rem;
}

.hw-pe--al-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.hw-pe--al-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  font-size: 1.2rem;
  color: var(--hw-black-500);
  line-height: 1.4;
}

.hw-pe--dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-top: 0.4em;
  flex-shrink: 0;
}

.hw-pe--al-none {
  font-style: italic;
  color: var(--hw-gray-400);
  font-size: 1.2rem;
}

.hw-pe--attr-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--hw-gray-100);
}

.hw-pe--chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 2rem;
}

.hw-pe--chip-ok {
  background: #dcfce7;
  color: var(--hw-green);
}

.hw-pe--chip-bad {
  background: #fee2e2;
  color: var(--hw-red);
}

.hw-pe--chip-warn {
  background: #fef3c7;
  color: #d97706;
}

/* ── Mobile adjustments ───────────────────────────────────────────────────── */
@media (max-width: 480px) {
  .hw-pe--page {
    padding-top: 1rem;
    padding-bottom: 3rem;
  }

  .hw-pe--stepper-wrap {
    display: none;
  }

  .hw-pe--card {
    padding: 1.5rem;
  }

  .hw-pe--page-header {
    gap: 0.8rem;
  }

  .hw-pe--page-title {
    font-size: 1.6rem;
  }

  .hw-pe--mode-badge {
    display: none;
  }
}

/* ── Photo History section ────────────────────────────────────────────────── */
.hw-pe--history-section {
  margin-top: 3rem;
  padding-top: 2.5rem;
  border-top: 1.5px solid var(--hw-gray-200);
}

.hw-pe--history-hd {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 2rem;
}

.hw-pe--history-hd-icon {
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 0.8rem;
  background: var(--hw-brand-blue-light);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--hw-brand-blue);
  flex-shrink: 0;
}

.hw-pe--history-hd-text {
  flex: 1;
}

.hw-pe--history-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1.5rem;
}

@media (max-width: 991px) {
  .hw-pe--history-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .hw-pe--history-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 400px) {
  .hw-pe--history-grid {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

.hw-pe--history-card {
  border: 1px solid var(--hw-gray-200);
  border-radius: 1rem;
  overflow: hidden;
  background: #fff;
  transition: border-color .25s ease, box-shadow .25s ease, transform .25s ease;
  display: flex;
  flex-direction: column;
}

.hw-pe--history-card:hover {
  border-color: var(--hw-brand-blue);
  box-shadow: 0 10px 25px rgba(15, 41, 77, 0.08);
  transform: translateY(-4px);
}

.hw-pe--history-thumb-wrap {
  position: relative;
  aspect-ratio: 1 / 1;
  background: var(--hw-gray-100);
  overflow: hidden;
}

.hw-pe--history-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.hw-pe--history-badge {
  position: absolute;
  top: 0.8rem;
  left: 0.8rem;
  background: rgba(220, 252, 231, 0.95);
  border: 1px solid #bbf7d0;
  color: #15803d;
  font-size: 1rem;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 99px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.hw-pe--history-meta {
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.hw-pe--history-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.8rem 0 1.2rem 0;
  padding-top: 0.8rem;
  border-top: 1px solid var(--hw-gray-100);
}

.hw-pe--hd-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1.15rem;
  color: var(--hw-gray-500);
}

.hw-pe--hd-item svg {
  color: var(--hw-gray-400);
  flex-shrink: 0;
}

.hw-pe--history-actions {
  display: flex;
  gap: 0.6rem;
  margin-top: auto;
}

.hw-pe--action-dl {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: var(--hw-brand-blue-light);
  border: 1.5px solid transparent;
  border-radius: 0.6rem;
  color: var(--hw-brand-blue);
  font-size: 1.2rem;
  font-weight: 700;
  padding: 0.75rem 1rem;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.hw-pe--action-dl:hover {
  background: var(--hw-brand-blue);
  color: var(--hw-white);
  box-shadow: 0 4px 10px rgba(15, 41, 77, 0.15);
}

.hw-pe--action-del {
  width: 3.2rem;
  height: 3.2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid var(--hw-gray-200);
  border-radius: 0.6rem;
  background: #fff;
  color: var(--hw-gray-500);
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.hw-pe--action-del:hover {
  background: #fee2e2;
  border-color: #fca5a5;
  color: var(--hw-red);
}

.hw-pe--history-flag {
  font-size: 1.6rem;
  line-height: 1;
}

.hw-pe--skel-line-btn {
  height: 3.2rem;
  border-radius: 0.6rem;
  background: linear-gradient(90deg, var(--hw-gray-100) 25%, #e8e8e8 50%, var(--hw-gray-100) 75%);
  background-size: 200% 100%;
  animation: hw-pe-skeleton 1.4s infinite;
}

.hw-pe--skel-thumb {
  aspect-ratio: 1 / 1;
  background: linear-gradient(90deg, var(--hw-gray-100) 25%, #e8e8e8 50%, var(--hw-gray-100) 75%);
  background-size: 200% 100%;
  animation: hw-pe-skeleton 1.4s infinite;
}

.hw-pe--skel-line {
  height: 1.1rem;
  border-radius: 0.4rem;
  background: linear-gradient(90deg, var(--hw-gray-100) 25%, #e8e8e8 50%, var(--hw-gray-100) 75%);
  background-size: 200% 100%;
  animation: hw-pe-skeleton 1.4s infinite;
}

.hw-pe--skel-line-sm {
  height: 0.9rem;
  border-radius: 0.4rem;
  background: linear-gradient(90deg, var(--hw-gray-100) 25%, #e8e8e8 50%, var(--hw-gray-100) 75%);
  background-size: 200% 100%;
  animation: hw-pe-skeleton 1.4s infinite;
}

@keyframes hw-pe-skeleton {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.hw-pe--history-empty {
  padding: 4rem 2rem;
  text-align: center;
  color: var(--hw-gray-500);
  background: var(--hw-gray-100);
  border-radius: 1rem;
  border: 1.5px dashed var(--hw-gray-200);
}

.hw-pe--history-empty-ico {
  opacity: 0.35;
  margin-bottom: 1rem;
}

.hw-pe--pagination-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  margin-top: 3rem;
  border-top: 1px solid var(--hw-gray-100);
  padding-top: 2rem;
}

.hw-pe--pagination-info {
  font-size: 1.2rem;
  color: var(--hw-gray-500);
}

.hw-pe--pagination {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  justify-content: center;
  flex-wrap: wrap;
}

.hw-pe--pg-btn {
  height: 3.6rem;
  min-width: 3.6rem;
  padding: 0 1.2rem;
  border: 1.5px solid var(--hw-gray-200);
  border-radius: 0.6rem;
  background: #fff;
  color: var(--hw-gray-650);
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.hw-pe--pg-btn:hover:not(:disabled) {
  border-color: var(--hw-brand-blue);
  color: var(--hw-brand-blue);
  background: var(--hw-brand-blue-light);
}

.hw-pe--pg-btn.active {
  background: var(--hw-brand-orange);
  border-color: var(--hw-brand-orange);
  color: #fff;
  box-shadow: 0 4px 10px rgba(255, 122, 0, 0.25);
}

.hw-pe--pg-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: var(--hw-gray-200);
  color: var(--hw-gray-400);
  background: #fff;
}

@media (max-width: 480px) {
  .hw-pe--pg-txt {
    display: none;
  }

  .hw-pe--pg-btn {
    min-width: 3.6rem;
    padding: 0;
  }

  .hw-pe--pagination-wrap {
    gap: 1rem;
  }
}

.hw-pe--demo-wrap {
  padding-top: 2rem;
  border-top: 1px solid var(--hw-gray-200);
  max-width: 44rem;
}

.hw-pe--demo-title {
  color: var(--hw-brand-blue);
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.hw-pe--demo-grid {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.2rem;
}

.hw-pe--demo-arrow-indicator {
  position: absolute;
  top: 10.7rem;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  background: var(--hw-white);
  border: 1px solid var(--hw-gray-200);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--hw-brand-orange);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  z-index: 3;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.hw-pe--demo-wrap:hover .hw-pe--demo-arrow-indicator {
  transform: translate(-50%, -50%) scale(1.15);
  box-shadow: 0 6px 14px rgba(15, 41, 77, 0.12);
  border-color: var(--hw-brand-orange);
  color: var(--hw-brand-blue);
}

.hw-pe--demo-card {
  display: flex;
  flex-direction: column;
}

.hw-pe--demo-img-wrap {
  position: relative;
  aspect-ratio: 1 / 1;
  border-radius: 0.8rem;
  overflow: hidden;
  border: 1px solid var(--hw-gray-200);
  background: var(--hw-gray-100);
}

.hw-pe--demo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.hw-pe--demo-badge {
  position: absolute;
  top: 0.6rem;
  left: 0.6rem;
  font-size: 0.9rem;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}

.badge-before {
  background: #fee2e2;
  color: var(--hw-red);
  border: 1px solid #fca5a5;
}

.badge-after {
  background: #dcfce7;
  color: var(--hw-green);
  border: 1px solid #bbf7d0;
}

.hw-pe--demo-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.hw-pe--demo-item {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 1.1rem;
  line-height: 1.3;
}

.item-bad {
  color: var(--hw-gray-500);
}

.item-bad svg {
  color: var(--hw-red);
  flex-shrink: 0;
  margin-top: 2px;
}

.item-good {
  color: var(--hw-black-900);
  font-weight: 600;
}

.item-good svg {
  color: var(--hw-green);
  flex-shrink: 0;
  margin-top: 2px;
}

.hw-pe--demo-divider {
  height: 1px;
  background: var(--hw-gray-200);
  margin: 1.5rem 0;
}

/* ─────────────────────────────────────────────────────────────────────────── */
.hw-arrow-btn {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  border: none !important;
  font-size: 16px;
  cursor: pointer;
  border-radius: 0.5rem;
  padding: 0.6rem 1.2rem;
  transition: background-color .2s ease, color .2s ease, border-color .2s ease;
}

.filter-active {
  background-color: var(--hw-blue-new) !important;
  color: white !important;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/Style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,wBAAwB;;EAExB,yBAAyB;EACzB,sCAAsC;EACtC,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,mCAAmC;EACnC,gCAAgC;;EAEhC,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,sNAAsN;EACtN,yGAAyG;EACzG,4CAA4C;EAC5C,4CAA4C;EAC5C,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;EAC/B;AACF;;AAEA;EACE,yBAAyB;EACzB;0DAC8D;EAC9D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,2BAA2B;EAC3B,gBAAgB;EAChB,mCAAmC;EACnC,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;;;;;EAKE,uCAAuC;AACzC;;AAEA;;;;;;;;;;;;EAYE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE;;IAEE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;;EAEE;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,SAAS;AACX;;AAEA;;IAEI;AACJ;EACE,UAAU;EACV,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,yDAAyD;EACzD,2DAA2D;EAC3D,iCAAiC;EACjC,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;EAIE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yDAA2f;EAC3f,4BAA4B;EAC5B,wCAAwC;EACxC,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;EACjC,gDAAgD;EAChD,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gDAAgD;EAChD,qBAAqB;EACrB,kDAAkD;EAClD,8BAA8B;AAChC;AACA;EACE,OAAO,UAAU,EAAE,8BAA8B,EAAE;EACnD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,sDAAsD;EACtD,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,+BAA+B;EAC/B,UAAU;AACZ;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,qBAAqB;EACrB,kDAAkD;EAClD,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,UAAU;AACZ;AACA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA;;EAEE;;;;IAIE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;;;OAGK;;AAEP;;AAEA;EACE,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B;;;uEAGqE;EACrE,oCAAoC;EACpC,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB;0BACwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gEAAgE;EAChE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,kCAAkC;EAClC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;;EAEE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,wDAAwD;EACxD,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;GAEC;EACD;IACE,kBAAkB;IAClB,aAAa;IACb,mCAAmC;EACrC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,aAAa;;AAEb,iBAAiB;AACjB;EACE,yDAAu8B;AACz8B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;OAGK;;EAEL;IACE,oBAAoB;EACtB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,aAAa;IACb,SAAS;IACT,QAAQ;EACV;;EAEA;;OAEK;AACP;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IACzB,qIAAqI;EACvI;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,4CAA4C;EAC9C;;EAEA;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oDAAoD;IACpD,WAAW;IACX,oBAAoB;IACpB,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,qBAAqB;EACrB,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb;;iBAEe;AACjB;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,sCAAsC;EACtC,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA,oBAAoB;AACpB;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;GAEG;AACH;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,gCAAgC;EAChC,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;;;KAIK;AACL;4DAC4D;;AAE5D;EACE,+CAA+C;EAC/C,yDAAyD;EACzD,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yDAAshC;EACthC,4BAA4B;EAC5B,qCAAqC;EACrC,0BAA0B;EAC1B,oBAAoB;EACpB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,yDAAyD;EACzD,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;;;;;;;KAOK;;AAEL;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gDAAgD;EAChD,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,GAAG;AACH;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;EACjC,+CAA+C;EAC/C,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,sCAAsC;EACtC,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;EACjC,+CAA+C;EAC/C,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,sCAAsC;EACtC,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iEAAoK;EACpK,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,iEAA0iB;EAC1iB,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;uCAEuC;AACvC;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA,QAAQ;AACR;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,cAAc;EACd,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,uDAAuD;EACvD,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,sCAAsC;EACtC,yDAAyQ;EACzQ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oCAAoC;EACpC,uBAAuB;EACvB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,qCAAqC;IACrC,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,cAAc;EAChB;AACF;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,4EAA4E;AAC9E;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,4EAA4E;AAC9E;;AAEA;EACE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,oDAAoD;EACpD,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;;EAEE,8CAA8C;EAC9C,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;;;KAGK;AACL;;;;;;;;;;OAUO;AACP;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;EACtD,6IAA6I;EAC7I,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;;;AAIA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;AACnC;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,2EAA2E;AAC7E;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;KAEK;AACL;EACE,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qDAAqD;EACrD,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,2CAA2C;EAC3C,qCAAqC;EACrC,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,2CAA2C;EAC3C,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;EAC1C,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;;;;;KAQK;AACL;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,2CAA2C;EAC3C,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,MAAM;AACR;;AAEA;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,wBAAwB;IACxB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;;EAEE;;IAEE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,YAAY;;AAEZ;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;KAIG;;EAEH;;GAEC;EACD;IACE,iBAAiB;EACnB;;EAEA;IACE;;6BAEyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,OAAO;EACT;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,+DAA+D;IAC/D,iDAAiD;IACjD,6IAA6I;IAC7I,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;IAC/B,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,mDAAmD;EACrD;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,6CAA6C;IAC7C,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,4BAA4B;IAC5B,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,wCAAwC;IACxC,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iDAAiD;IACjD,+DAA+D;EACjE;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;;;;;OAKK;EACL;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,SAAS;IACT,cAAc;IACd,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,0CAA0C;IAC1C,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,4BAA4B;IAC5B,oCAAoC;IACpC,MAAM;IACN,eAAe;IACf,OAAO;IACP,QAAQ;IACR,oCAAoC;EACtC;;EAEA;;IAEE,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;;KAEG;;EAEH;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;;KAEG;EACH;IACE,4BAA4B;EAC9B;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wCAAwC;IACxC,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,6CAA6C;IAC7C,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,WAAW;AACX,iBAAiB;AACjB;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;eAEa;;EAEb,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B;gBACc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;GAGG;AACH;;;GAGG;AACH;EACE,iEAAskB;EACtkB,oCAAoC;EACpC,+CAA+C;EAC/C,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,OAAO;AACT;;AAEA;;GAEG;AACH;;;;GAIG;AACH;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE;4BAC0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,8CAA8C;EAC9C,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA;;;GAGG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;EAChD,iCAAiC;EACjC,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,2CAA2C;EAC3C,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;GAGG;AACH;EACE,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,QAAQ;AACR;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,cAAc;EACd,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,4BAA4B;EAC5B,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;;AAE3B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,+BAA+B;AAC/B;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,sBAAsB;EACtB,sDAAsD;EACtD,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,6CAA6C;AAC7C;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE;IACE,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kCAAkC;;EAEpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,uCAAuC;EACvC,iBAAiB;EACjB,oCAAoC;EACpC,iCAAiC;EACjC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2DAA2D;EAC3D,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yDAAqsB;EACrsB,8BAA8B;EAC9B,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;;;;;;;;;;;EAYE,mDAAmD;AACrD;;AAEA;;;;EAIE,mDAAmD;EACnD,iCAAiC;AACnC;;AAEA;;GAEG;AACH;;KAEK;AACL;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;;;EAGnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;;EAEE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;;EAEnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,wDAAwD;IACxD,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,uDAAuD;IACvD,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,wCAAwC;EACxC,qCAAqC;EACrC,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE;IACE,aAAa;IACb,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oCAAoC;EACtC;;AAEF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;IAChC,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;;EAEnB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;IACb,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;EAEE;;;;;;;;;KASG;EACH;IACE,sBAAsB;EACxB;;EAEA;;;;;;;;;;;;;;;GAeC;EACD;;;;;KAKG;AACL;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,+BAA+B;EACjC;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,qBAAqB;AACrB;;;;;;;;GAQG;AACH;;;;;;;;;GASG;;AAEH;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,iCAAiC;IACjC,qCAAqC;EACvC;;EAEA;;;OAGK;EACL;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;;;AAIF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;SAEO;EACP;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;;;;;;;OAOK;EACL;IACE,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;KAEG;;EAEH;;KAEG;AACL;;;AAGA;EACE;IACE,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;;EAEE;;;;IAIE,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;AAEF;;AAEA;;EAEE;;;OAGK;EACL;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;AAEF;;;;;;AAMA;EACE,sBAAsB;EACtB;AACF;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;;;;CAIC;;AAED;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,yDAA+iC;AACjjC;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,iCAAiC;EACjC,qBAAqB;EACrB,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,iBAAiB;EACjB,oBAAoB;;AAEtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;;;AAIA,qBAAqB;AACrB,6BAA6B;AAC7B;;;;GAIG;AACH;;;;GAIG;AACH;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;GAEG;AACH;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;;GAKG;AACH,4BAA4B;;AAE5B;;;GAGG;AACH;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,iCAAiC;;AAEjC;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,MAAM;EACN,qCAAqC;EACrC,sDAAsD;EACtD,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,MAAM;EACN,qCAAqC;EACrC,2DAA2D;EAC3D,mDAAmD;EACnD,4BAA4B;AAC9B;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,8CAA8C;EAC9C,oEAAoE;EACpE,OAAO;EACP,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,4BAA4B;EAC5B,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,4BAA4B;EAC5B,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;;AAGA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;;;;AAIA;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;;AAErB;;AAEA;EACE,qBAAqB;EACrB,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,wDAAwD;EACxD,iBAAiB;AACnB;;;AAGA;;GAEG;AACH;;;;GAIG;AACH;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;;EAEE;IACE,aAAa;IACb,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;;;;;GAKG;;AAEH;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0BAA0B;;AAE1B;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;EAGE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;;;;;;EASE,yBAAyB;AAC3B;;;AAGA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;;;IAGE,qBAAqB;EACvB;;EAEA;;;;;;;;;IASE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;;;IAIE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;;IAEE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,+BAA+B;IAC/B,0CAA0C;IAC1C,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;;;IAGE,uCAAuC;IACvC,uDAAuD;IACvD,qBAAqB;EACvB;;EAEA;;;;;;;;;IASE,yBAAyB;EAC3B;;EAEA;IACE,wCAAwC;IACxC,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4CAA4C;IAC5C,wCAAwC;EAC1C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;EAC3B;;EAEA;;IAEE,sCAAsC;EACxC;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;;;IAIE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;;IAEE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8JAA8J;EAC9J,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;;EAE7B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,6BAA6B;;EAE7B,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;;6CAE2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,iEAAiE;EACjE,WAAW;AACb;;AAEA,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;EACzD,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;;AAGA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,uKAAuK;EACvK,sKAAsK;EACtK,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;;EAEE;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA,WAAW;AACX;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;;EAEE;;IAEE,WAAW;EACb;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;IAChD,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,eAAe;AACf,SAAS;;AAET;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,aAAa;AACf;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA,aAAa;AACb,SAAS;AACT;EACE,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd;mCACiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,wCAAwC;EACxC,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,iCAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,aAAa;AACb,cAAc;AACd;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,yCAAyC;EACzC,kBAAkB;AACpB;;;;AAIA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE;IACE,wBAAwB;IACxB,WAAW;EACb;AACF;;AAEA;EACE;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,OAAO;IACP;EACF;AACF;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yCAAyC;EACzC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb;oBACkB;EAClB,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,UAAU;IACV,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,yBAAyB;EAC3B;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kEAAkE;EAClE,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;AAC1B;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,4BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,UAAU;EACV,2BAA2B;EAC3B,wDAAwD;EACxD,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,UAAU;AACZ;;AAEA;;;;GAIG;AACH;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,SAAS;IACT,SAAS;IACT,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;;;;;;;;;;AAWA,2BAA2B;AAC3B;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;;;;;AAMA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;GAEG;AACH;;EAEE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;EAC3C,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,4DAA4D;EAC5D,uBAAuB;;AAEzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,kCAAkC;EACpC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA,aAAa;EACb;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA,MAAM;;AAER;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,kCAAkC;IAClC,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA,aAAa;EACb;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA,MAAM;;AAER;;AAEA;EACE;IACE,eAAe;IACf,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;AAC5B;;;;AAIA,oBAAoB;AACpB;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;;EAEf;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;;;KAGG;AACL;;AAEA;EACE;IACE,wBAAwB;IACxB,mCAAmC;IACnC,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;AAEF;;AAEA,wBAAwB;AACxB,+BAA+B;;AAE/B;;;;gFAIgF;;AAEhF,gFAAgF;AAChF;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gFAAgF;EAChF,mBAAmB;EACnB,SAAS;EACT,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,sBAAsB;EACtB,yEAAyE;AAC3E;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gFAAgF;AAChF;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,4DAA4D;EAC5D,qBAAqB;AACvB;;AAEA,gFAAgF;AAChF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,sCAAsC;EACtC,qBAAqB;EACrB,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,wCAAwC;EACxC,gBAAgB;EAChB,iCAAiC;EACjC,kCAAkC;EAClC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,gFAAgF;AAChF;EACE,wCAAwC;EACxC,wDAAwD;EACxD,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,+EAA+E;AAC/E;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,qCAAqC;EACrC,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gFAAgF;AAChF;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,gFAAgF;AAChF;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;EAEE;;IAEE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mEAAmE;EACnE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;EACtC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB;;;yDAGuD;EACvD,0BAA0B;EAC1B,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,wCAAwC;EACxC,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,gFAAgF;AAChF;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,6EAA6E;EAC7E,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sCAAsC;EACtC,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,+FAA+F;EAC/F,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,+FAA+F;EAC/F,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,+FAA+F;EAC/F,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,+FAA+F;EAC/F,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,0CAA0C;EAC1C,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,4CAA4C;EAC5C,6CAA6C;EAC7C,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,wCAAwC;EACxC,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,4EAA4E;AAC9E;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[":root {\n  --hw-red: #DA102A;\n  --hw-yellow: #ffc107;\n  --hw-green: #0A7519;\n  --hw-black: #000;\n  --hw-black-500: #434444;\n  --hw-black-900: #121826;\n  --hw-gray-100: #F2F2F2;\n  --hw-gray-200: #DFDFDF;\n  --hw-gray-300: #F9F9F9;\n  --hw-gray-400: #CCCCCC;\n  --hw-gray-500: #8B8B8B;\n  --hw-gray-600: #D7D7D7;\n  --hw-gray-650: #626262;\n  --hw-gray-700: #656565;\n  --hw-gray-800: #555555;\n  --hw-gray-900: #151515;\n  --hw-white: #fff;\n  --hw-brand-orange: #3264FF;\n  --hw-brand-orange-hover: #1D4EE5;\n  /* --hw-brand-blue: #283D6B;  */\n  --hw-brand-blue: #0F294D;\n\n  --hw-brand-brown: #823719;\n  /* --hw-brand-orange-light: #EEF5FF; */\n  --hw-brand-orange-light: #EBEFFF;\n  --hw-brand-blue-light: #EBEFFF;\n  --hw-bg-light1: #FBF0EB;\n  --hw-bg-light2: #F3EBE8;\n  --hw-bg-light3: #F0E7E8;\n  --hw-brand-orange-rgb: 50, 100, 255;\n  --hw-brand-blue-rgb: 40, 61, 107;\n\n  --hw-brand-brown-rgb: 130, 55, 25;\n  --hw-black-rgb: 0, 0, 0;\n  --hw-white-rgb: 255, 255, 255;\n  --hw-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Poppins, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --hw-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --hw-body-font-family: 'DM Sans', sans-serif;\n  --hw-head-font-family: 'Poppins', sans-serif;\n  --hw-body-font-size: 1.4rem;\n  --hw-body-font-weight: 400;\n  --hw-body-line-height: 1.75;\n  --hw-body-color: #555555;\n  --hw-body-color2: #5E5E5E;\n  --hw-body-color-rgb: 21, 21, 21;\n  --hw-body-bg: #fff;\n  --hw-body-bg-rgb: 255, 255, 255;\n  --hw-heading-color: #000\n}\n\n@font-face {\n  font-family: 'aedregular';\n  src: url('/public/fonts/aed-regular-webfont.woff2') format('woff2'),\n    url('/public/fonts/aed-regular-webfont.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n.hw-blackout-date {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  color: #dc3545;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: not-allowed;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nhtml {\n  box-sizing: border-box;\n  font-size: calc(1.0 * 62.5%);\n}\n\nbody {\n  margin: 0;\n  font-family: var(--hw-body-font-family);\n  font-size: var(--hw-body-font-size);\n  font-weight: var(--hw-body-font-weight);\n  line-height: var(--hw-body-line-height);\n  color: var(--hw-body-color);\n  text-align: left;\n  background-color: var(--hw-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nbutton,\ntable td,\ntable th,\na,\ninput {\n  font-family: var(--hw-body-font-family);\n}\n\nh6,\n.h6,\nh5,\n.h5,\nh4,\n.h4,\nh3,\n.h3,\nh2,\n.h2,\nh1,\n.h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--hw-heading-color);\n  font-family: var(--hw-head-font-family);\n}\n\nh1,\n.h1 {\n  font-size: calc(1.375rem + 1.5vw);\n}\n\n.h2 {\n  font-size: 2.5rem;\n  line-height: 1.52;\n}\n\nh3,\n.h3 {\n  font-size: 2.5rem;\n  line-height: 1.52;\n}\n\nh4,\n.h4 {\n  font-size: 1.8rem;\n  line-height: 1.556;\n}\n\nh6,\n.h6 {\n  font-size: 1.6rem;\n  line-height: 1.75;\n}\n\n@media (min-width: 768px) {\n\n  h4,\n  .h4 {\n    font-size: 2.2rem;\n    line-height: 1.5;\n  }\n\n  .h2 {\n    font-size: 3rem;\n    line-height: normal;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  h1,\n  .h1 {\n    font-size: 5rem;\n  }\n\n  .hw-h2 {\n    font-size: 3.5rem;\n  }\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\na {\n  color: var(--hw-black-900);\n  font-weight: normal;\n  text-decoration: none;\n  transition: color .3s ease;\n}\n\na:hover {\n  color: var(--hw-brand-orange);\n}\n\n.hw-success {\n  color: var(--hw-green) !important;\n}\n\n.hw-primary {\n  color: var(--hw-brand-orange) !important;\n}\n\n.hw-black {\n  color: var(--hw-black) !important;\n}\n\n.hw-white {\n  color: var(--hw-white) !important;\n}\n\n.hw-body-alt {\n  color: var(--hw-body-color2) !important;\n}\n\n.hw-red {\n  color: var(--hw-red) !important;\n}\n\n.hw-blue {\n  color: var(--hw-brand-blue) !important;\n}\n\n.hw-grayk500 {\n  color: var(--hw-gray-500) !important;\n}\n\n.hw-gray650 {\n  color: var(--hw-gray-650) !important;\n}\n\n.hw-black800 {\n  color: var(--hw-gray-800) !important;\n}\n\n.hw-black500 {\n  color: var(--hw-black-500) !important;\n}\n\n.hw-black900 {\n  color: var(--hw-black-900) !important;\n}\n\n.hw-gray-900 {\n  color: var(--hw-gray-900) !important;\n}\n\n.hw-fontNormal {\n  font-weight: normal !important;\n}\n\n.hw-fontWeight--500 {\n  font-weight: 500 !important;\n}\n\n.hw-fontBold {\n  font-weight: bold !important;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n  margin: 0;\n}\n\n.hw-text12 {\n  font-size: 1.2rem !important;\n}\n\n.hw-text14 {\n  font-size: 1.4rem !important;\n  line-height: 1.71429\n}\n\n.hw-text16 {\n  font-size: 1.6rem;\n  line-height: 1.75;\n}\n\n.hw-text18 {\n  font-size: 1.8rem;\n  line-height: 1.556;\n}\n\n.hw-text20 {\n  font-size: 2rem;\n  line-height: 1.4;\n}\n\n.hw-text22 {\n  font-size: 2rem;\n  line-height: 1.5;\n}\n\n.hw-text24 {\n  font-size: 2.4rem;\n  line-height: 1.5;\n}\n\n.hw-line--height1 {\n  line-height: 1 !important;\n}\n\n.hw-text--uppercase {\n  text-transform: uppercase !important;\n}\n\n.hw-text--capitalize {\n  text-transform: capitalize !important;\n}\n\n.hw-text--right {\n  text-align: right !important;\n}\n\n.hw-line--heightNull {\n  line-height: 0 !important;\n}\n\n.ms-2 {\n  margin-left: .4rem !important;\n}\n\n.ms-2half {\n  margin-left: .8rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.lm-lrp--1 {\n  padding-left: 1rem !important;\n  padding-right: 1rem !important;\n}\n\n.hw-text--muted {\n  color: var(--hw-gray-650) !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.d-inlineBlock {\n  display: inline-block;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n.hw-position--relative {\n  position: relative;\n}\n\n.hw-position--abs-bottom {\n  position: absolute;\n  bottom: -100%;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.my-8 {\n  margin-top: 0.8rem;\n  margin-bottom: 0.8rem;\n}\n\n.mt-1 {\n  margin-top: .4rem !important;\n}\n\n.mt-2 {\n  margin-top: .8rem !important;\n}\n\n.mt-3 {\n  margin-top: 1.6rem !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-02 {\n  margin-bottom: .2rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1.6rem !important;\n}\n\n.mb-1 {\n  margin-bottom: .5rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-24 {\n  margin-bottom: 2.4rem !important;\n}\n\n.mt-3 {\n  margin-top: 1.4rem !important;\n}\n\n.mt-4 {\n  margin-top: 2.4rem !important;\n}\n\n.mt-16 {\n  margin-top: 1.6rem !important;\n}\n\n.mt-6 {\n  margin-top: 4rem !important;\n}\n\n.ml-6 {\n  margin-left: .6rem !important;\n}\n\n.ml-10 {\n  margin-left: 1rem !important;\n}\n\n.pt-null {\n  padding-top: 0 !important;\n}\n\n.border-none {\n  border: none !important;\n}\n\n.hw-pt20 {\n  padding-top: 2rem !important;\n}\n\n.hw-gapxy10 {\n  gap: 1rem !important;\n}\n\n.flex-end {\n  align-items: flex-end !important;\n}\n\n.hw-gapx10y20 {\n  row-gap: 1rem !important;\n  column-gap: 2rem !important;\n}\n\n.hw-gapy4 {\n  column-gap: .4rem !important;\n}\n\n.hw-gapy6 {\n  column-gap: .6rem !important;\n}\n\n.hw-gapy8 {\n  column-gap: .8rem !important;\n}\n\n.hw-gapy10 {\n  column-gap: 1rem !important;\n}\n\n.hw-gapy16 {\n  column-gap: 1.6rem !important;\n}\n\n.hw-gapy20 {\n  column-gap: 2rem !important;\n}\n\n.hw-gapx4 {\n  row-gap: .4rem !important;\n}\n\n.hw-gapx8 {\n  row-gap: .8rem !important;\n}\n\n.hw-gapx10 {\n  row-gap: 1rem !important;\n}\n\n.hw-gapx16 {\n  row-gap: 1.6rem !important;\n}\n\n.color-inherit {\n  color: inherit;\n}\n\n.hw-2col--grid {\n  display: grid;\n  grid-template-columns: auto 1fr;\n}\n\n.grid-rowspan2 {\n  grid-row: span 2;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.hw-align--stretchFull {\n  align-items: stretch !important;\n  height: 100% !important;\n}\n\n.no-wrap {\n  white-space: nowrap;\n}\n\n.wrap {\n  flex-wrap: wrap !important;\n}\n\n.overflow-ellipsis {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (min-width: 750px) {\n  .hw-text22 {\n    font-size: 2.2rem;\n    line-height: 1.27273;\n  }\n}\n\n.hw-red--alertBox {\n  border-radius: 0.5rem;\n  background: rgba(218, 16, 42, 0.10);\n  padding: 1.6rem;\n}\n\n.hw-red--alertBox ol {\n  padding: 0;\n  list-style-position: inside;\n  margin: 0;\n}\n\n/*.hw-page--titlebar {\n    display: none;\n  }*/\n.hw-link {\n  padding: 0;\n  background: rgba(0, 0, 0, 0);\n  border: none;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  font-weight: bold;\n  color: var(--hw-brand-orange);\n  font-size: 1.4rem;\n  cursor: pointer;\n  transition: color .2s ease;\n}\n\n.hw-link:hover {\n  color: var(--hw-brand-blue);\n}\n\n.hw-link--gray,\n.hw-link--grayHover:hover {\n  color: var(--hw-gray-800);\n}\n\n.hw-link--gray700 {\n  color: var(--hw-gray-700);\n}\n\n.hw-link--gray:hover,\n.hw-link--gray700:hover {\n  color: var(--hw-brand-orange);\n}\n\n.hw-badge--tooltip {\n  background-color: var(--hw-brand-orange-light) !important;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10) !important;\n  color: var(--hw-black) !important;\n  padding: .6rem 1rem !important;\n  white-space: nowrap;\n  opacity: 1 !important;\n}\n\n.hw-container--full,\n.hw-container,\n.hw-page--titlebar,\n.hw-blue--grid {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n.hw-blue--grid {\n  background-color: var(--hw-brand-blue);\n  color: var(--hw-white);\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.hw-form--input {\n  background-color: var(--hw-white);\n  border: .1rem solid var(--hw-gray-600);\n  padding: 1rem 1.2rem;\n  border-radius: .5rem;\n  font-size: 1.4rem;\n  line-height: 1.5;\n  color: var(--hw-gray-900);\n  letter-spacing: 0;\n  min-height: 4.4rem;\n  width: 100%;\n}\n\nselect.hw-form--input {\n  color: var(--hw-gray-800);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'%3E%3Cpath d='M5.62615 9.29289C6.01667 8.90237 6.64983 8.90237 7.04036 9.29289L12.3333 14.5858L17.6261 9.29289C18.0167 8.90237 18.6498 8.90237 19.0404 9.29289C19.4309 9.68342 19.4309 10.3166 19.0404 10.7071L13.0404 16.7071C12.6498 17.0976 12.0167 17.0976 11.6261 16.7071L5.62615 10.7071C5.23562 10.3166 5.23562 9.68342 5.62615 9.29289Z' fill='%23555555'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1.5rem center;\n  background-size: 2.1rem 2rem;\n  -webkit-appearance: none;\n  appearance: none;\n  padding-right: 3.5rem;\n  font-family: var(--hw-body-font-family);\n}\n\n.hw-form--input:hover {\n  bborder-color: var(--hw-gray-800);\n}\n\n.hw-form--input:focus {\n  border-color: var(--hw-brand-orange);\n  outline: none !important;\n}\n\n/* custom plain dropdown (gender / prefix) */\n.hw-gsel {\n  position: relative;\n  width: 100%;\n}\n.hw-gsel--control {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.8rem;\n  width: 100%;\n  min-height: 4.4rem;\n  padding: 1rem 1.2rem;\n  background: var(--hw-white, #fff);\n  border: 0.1rem solid var(--hw-gray-600, #d6dbe6);\n  border-radius: 0.5rem;\n  font-family: inherit;\n  font-size: 1.4rem;\n  line-height: 1.5;\n  color: var(--hw-gray-900, #1b2439);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.hw-gsel--control:hover {\n  border-color: var(--hw-gray-800, #9aa3b5);\n}\n.hw-gsel.is-open .hw-gsel--control {\n  border-color: #3264ff;\n  /* box-shadow: 0 0 0 0.3rem rgba(50, 100, 255, 0.12); */\n}\n.hw-gsel.is-error .hw-gsel--control {\n  border-color: #e5484d;\n}\n.hw-gsel--value {\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.hw-gsel--value.is-placeholder {\n  color: var(--hw-gray-800, #98a2b6);\n}\n.hw-gsel--chevron {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  color: var(--hw-gray-700, #6b7488);\n  transition: transform 0.2s ease;\n}\n.hw-gsel--chevron svg {\n  width: 2rem;\n  height: 2rem;\n}\n.hw-gsel.is-open .hw-gsel--chevron {\n  transform: rotate(180deg);\n}\n.hw-select--chevron {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  color: var(--hw-gray-700, #6b7488);\n  transition: transform 0.2s ease;\n}\n.hw-select--chevron svg {\n  width: 2rem;\n  height: 2rem;\n}\n.hw-select--chevron.is-open {\n  transform: rotate(180deg);\n}\n.hw-gsel--menu {\n  position: absolute;\n  top: calc(100% + 0.6rem);\n  left: 0;\n  right: 0;\n  z-index: 40;\n  margin: 0;\n  padding: 0.6rem;\n  list-style: none;\n  background: var(--hw-white, #fff);\n  border: 0.1rem solid var(--hw-gray-300, #e6e9f0);\n  border-radius: 0.8rem;\n  box-shadow: 0 1.2rem 2.8rem rgba(16, 24, 40, 0.14);\n  animation: hwGselIn 0.14s ease;\n}\n@keyframes hwGselIn {\n  from { opacity: 0; transform: translateY(-0.4rem); }\n  to { opacity: 1; transform: translateY(0); }\n}\n.hw-gsel--option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.8rem;\n  padding: 1rem 1.2rem;\n  font-size: 1.4rem;\n  color: var(--hw-gray-900, #1b2439);\n  border-radius: 0.6rem;\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n.hw-gsel--option:hover {\n  background: var(--hw-gray-100, #f3f5f9);\n}\n.hw-gsel--option.is-selected {\n  color: #3264ff;\n  font-weight: 600;\n  background: rgba(50, 100, 255, 0.08);\n}\n.hw-gsel--option svg {\n  color: #3264ff;\n  flex: none;\n}\n@media (min-width: 992px) {\n  .hw-gsel--control {\n    font-size: 1.6rem;\n    line-height: 1.75;\n  }\n}\n\n/* custom phone code dropdown */\n.hw-pcsel {\n  position: relative;\n  display: flex;\n  flex: 1;\n  min-width: 0;\n}\n.hw-pcsel--control {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  width: 100%;\n  min-height: 4.4rem;\n  padding: 1rem 1.2rem;\n  padding-right : 2rem;\n  background: transparent;\n  border: none;\n  border-right: 0.1rem solid var(--hw-gray-600, #D7D7D7);\n  font-family: inherit;\n  font-size: 1.4rem;\n  color: var(--hw-gray-900, #1b2439);\n  text-align: left;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.hw-pcsel--flag {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.2rem;\n  object-fit: cover;\n  flex: none;\n}\n.hw-pcsel--input {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100%;\n  padding: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: inherit;\n  color: var(--hw-gray-900, #1b2439);\n  cursor: pointer;\n  text-overflow: ellipsis;\n}\n.hw-pcsel.is-open .hw-pcsel--input {\n  cursor: text;\n}\n.hw-pcsel--input::placeholder {\n  color: var(--hw-gray-800, #98a2b6);\n  opacity: 1;\n}\n.hw-pcsel--chevron {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0.4rem;\n  color: var(--hw-gray-700, #6b7488);\n  transition: transform 0.2s ease;\n  flex: none;\n}\n.hw-pcsel--chevron svg {\n  width: 1.8rem;\n  height: 1.8rem;\n}\n.hw-pcsel.is-open .hw-pcsel--chevron {\n  transform: rotate(180deg);\n}\n.hw-pcsel.is-error .hw-pcsel--control {\n  border-right-color: #e5484d;\n}\n.hw-pcsel--menu {\n  position: fixed;\n  z-index: 9999;\n  max-width: 86vw;\n  background: #fff;\n  border: 0.1rem solid var(--hw-gray-300, #e6e9f0);\n  border-radius: 0.8rem;\n  box-shadow: 0 1.2rem 2.8rem rgba(16, 24, 40, 0.14);\n  overflow: hidden;\n  animation: hwGselIn 0.14s ease;\n}\n.hw-pcsel--list {\n  list-style: none;\n  margin: 0;\n  padding: 0.4rem;\n  max-height: 23rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n  scrollbar-color: var(--hw-gray-300, #cfd6e4) transparent;\n}\n.hw-pcsel--list::-webkit-scrollbar {\n  width: 6px;\n}\n.hw-pcsel--list::-webkit-scrollbar-thumb {\n  background: var(--hw-gray-300, #cfd6e4);\n  border-radius: 999px;\n}\n.hw-pcsel--list::-webkit-scrollbar-track {\n  background: transparent;\n}\n.hw-pcsel--option {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 0.9rem 1rem;\n  font-size: 1.4rem;\n  color: var(--hw-gray-900, #1b2439);\n  border-radius: 0.6rem;\n  cursor: pointer;\n}\n.hw-pcsel--option:hover {\n  background: var(--hw-gray-100, #f3f5f9);\n}\n.hw-pcsel--option.is-selected {\n  background: rgba(50, 100, 255, 0.08);\n  color: #3264ff;\n  font-weight: 600;\n}\n.hw-pcsel--empty {\n  padding: 1.2rem 1rem;\n  font-size: 1.4rem;\n  color: var(--hw-gray-700, #6b7488);\n  text-align: center;\n}\n@media (min-width: 992px) {\n  .hw-pcsel--control {\n    font-size: 1.6rem;\n  }\n}\n\n.hw-search--destinationRow>.col-md-3>svg {\n  flex-shrink: 0;\n}\n\n.row.hw-search--destinationRow {\n  min-height: 5rem;\n}\n\n.hw-expire--session__bookingConfirmed {\n  padding-top: 1.6rem;\n  padding-bottom: 1.6rem;\n  min-height: 11.2rem;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.hw-text--right {\n  text-align: right !important;\n}\n\n.hw-icon--tickcircle svg {\n  width: 3rem;\n  height: 3rem;\n}\n\n.hw-icon--tickcircle .hw-icon--tickcircleBox svg {\n  width: 1.8rem;\n  height: 1.2rem;\n}\n\n.hw-passenger--listShow .hw-inner--fullWidth>div>div {\n  min-height: 4.4rem;\n  border-radius: .5rem !important;\n}\n\n.hw-passenger--listShow .hw-inner--fullWidth>div>div:hover {\n  border-color: var(--hw-black);\n}\n\n.hw-passenger--listShow .hw-inner--fullWidth>div>div:focus {\n  border-color: var(--hw-brand-orange);\n  outline: none !important;\n}\n\n.hw-icon--tickcircleBox {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  border-radius: 50%;\n  min-width: 3rem;\n  min-height: 3rem;\n}\n\n@media (min-width: 901px) {\n  .row.hw-search--destinationRow {\n    --bs-gutter-x: 2rem;\n  }\n\n  .hw-expire--session__bookingConfirmed {\n    padding-top: 2.4rem;\n    padding-bottom: 2.4rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .hw-icon--tickcircle svg {\n    width: 5rem;\n    height: 5rem;\n  }\n\n  .hw-icon--tickcircleBox {\n    min-width: 5rem;\n    min-height: 5rem;\n  }\n\n  .hw-passenger--listShow .hw-inner--fullWidth>div>div {\n    min-height: 5rem;\n  }\n\n  .hw-bookId {\n    padding-left: 8rem;\n  }\n\n  .hw-container--full,\n  .hw-container {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n\n  .hw-page--titlebar,\n  .hw-blue--grid {\n    padding-left: 3.2rem;\n    padding-right: 4rem;\n  }\n\n  .hw-form--input {\n    font-size: 1.6rem;\n    line-height: 1.75;\n  }\n\n  .hw-form--input.markup-price {\n    padding: 1.2rem 1.5rem;\n    border-radius: .8rem;\n    font-size: 1.4rem;\n    line-height: 1.5;\n    min-height: 4.8rem;\n  }\n\n  select.hw-form--input {\n    background-position: right 2rem center;\n    background-size: 2.5rem 2.4rem;\n    padding-right: 4rem;\n    text-overflow: ellipsis;\n  }\n}\n\n@media (min-width: 1025px) {\n  .row.hw-search--destinationRow {\n    --bs-gutter-x: 3rem;\n  }\n}\n\n@media (min-width: 1400px) {\n  .row.hw-search--destinationRow {\n    --bs-gutter-x: 4.8rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .hw-dtr--mtext {\n    font-size: 1.4rem;\n    line-height: 1.71429;\n  }\n\n  .hw-dtr--dtext {\n    font-size: 1.2rem;\n    line-height: 1.5;\n  }\n\n  .hw-text18.hw-dtr--dtext {\n    font-size: 1.8rem;\n    line-height: 1.556;\n  }\n\n  .row.hw-search--destinationRow .hw-btn {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .row.hw-search--destinationRow .hw-btn svg {\n    width: 2rem;\n    height: 2rem;\n  }\n}\n\n@media (max-width: 991px) {\n  .hw-2col--grid.hw-gapy20 {\n    column-gap: 1rem !important;\n  }\n\n  .hw-bookId {\n    padding-left: 4.6rem;\n    font-size: 1.6rem;\n  }\n}\n\n@media (max-width: 479px) {\n\n  .hw-container--full,\n  .hw-container,\n  .hw-page--titlebar,\n  .hw-blue--grid {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  /* .hw-widget--flight .hw-widget--card {\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n    } */\n\n}\n\n.hw-header {\n  border-bottom: .1rem solid rgba(51, 51, 51, 0.10);\n  background-color: var(--hw-white);\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 99999;\n}\n\n.hw-header .hw-container--full {\n  min-height: 8.2rem;\n}\n\n.hw-announcementBar {\n  height: 2.8rem;\n  background-color: var(--hw-brand-blue);\n  color: var(--hw-white);\n}\n\n.hw-announcementList {\n  display: flex;\n  justify-content: space-between;\n  column-gap: 1rem;\n  overflow-x: auto;\n}\n\n.hw-announcementitem {\n  white-space: nowrap;\n}\n\n.header-nav .nav-item.dropdown>.nav-link {\n  padding: .6rem 1.2rem;\n  border-radius: 1rem;\n  display: inline-flex;\n  align-items: center;\n}\n\n.nav-profile {\n  column-gap: 1rem;\n  font-weight: 500;\n  background-color: var(--hw-gray-300);\n}\n\n.hw-nav--icon {\n  display: inline-flex;\n  align-items: center;\n  line-height: 0;\n}\n\n.hw-nav--icon svg {\n  width: 2.4rem;\n  height: 2.4rem;\n}\n\n.hw-ntf--badge {\n  position: absolute;\n  background-color: var(--hw-brand-orange);\n  width: 1.4rem;\n  height: 1.4rem;\n  line-height: 1.2;\n  font-size: 1.2rem;\n  text-align: center;\n  border-radius: 50%;\n  bottom: 0;\n  right: 1.2rem;\n  color: var(--hw-white);\n  font-weight: normal;\n}\n\n.nav-link.nav-notification:hover,\n.nav-profile:hover {\n  background-color: var(--hw-brand-orange-light);\n  color: var(--hw-black);\n}\n\n.dropdown-menu {\n  background-color: var(--hw-white);\n  color: inherit;\n  border-radius: 0.5rem;\n  min-width: 27rem;\n  margin-top: 1rem !important;\n  border: none;\n  padding: 1.6rem;\n  display: none;\n  /* position: absolute; */\n  margin: 0;\n  text-align: left;\n  list-style: none;\n  background-clip: padding-box;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-menu-end {\n  --hw-position: end;\n}\n\n.hw-sidebar {\n  position: fixed;\n  top: 11rem;\n  left: 0;\n  bottom: 0;\n  width: 26rem;\n  z-index: 100;\n  transition: width 0.2s ease;\n  /* overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: var(--hw-brand-orange-light) var(--hw-gray-100); */\n  background-color: var(--hw-gray-300);\n  padding: 1rem 0;\n  border-top-right-radius: 2rem;\n  border-bottom-right-radius: 2rem;\n  row-gap: 1rem;\n  display: grid;\n  grid-template-rows: auto auto 1fr;\n}\n\n.hw-sidebar--toggle {\n  display: flex;\n  justify-content: center;\n  /* padding-left: 2rem;\n    padding-right: 2rem; */\n}\n\n.js-toggle--sidebar {\n  padding: 1.2rem;\n  line-height: 0;\n  position: relative;\n  border-radius: 1rem;\n  cursor: pointer;\n  transition: background-color .2s ease-out;\n}\n\n.js-toggle--sidebar:hover {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n}\n\n.hw-sidebar .hw-sidebar--nav {\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: var(--hw-brand-orange-light) var(--hw-gray-100);\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.hw-sidebar--nav>.nav-item+.nav-item {\n  margin-top: .8rem;\n}\n\n.hw-sidebar--nav .nav-link,\n.dropdown-item {\n  padding: 1rem 1.2rem;\n  background-color: rgba(0, 0, 0, 0);\n  transition: background-color .2s ease-in-out;\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n  white-space: nowrap;\n  border-radius: 1rem;\n  transition: background-color .2s ease, color .2s ease;\n}\n\n.hw-sidebar--nav .nav-link.active {\n  background-color: var(--hw-brand-blue);\n  color: var(--hw-white);\n}\n\n.hw-sidebar--nav .nav-link:not(.active):hover,\n.dropdown-item:hover {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n}\n\n.dropdown,\n.dropdown-center,\n.dropend,\n.dropstart,\n.dropup,\n.dropup-center {\n  position: relative;\n}\n\n.dropdown-divider {\n  border-color: var(--hw-gray-400);\n  border-top-width: 0;\n}\n\n.hw__dropdown-profile .dropdown-divider {\n  margin-left: -2rem;\n  margin-right: -2rem;\n}\n\n.hw-sidebar--profileImg {\n  display: inline-flex;\n  width: 10rem;\n  height: 10rem;\n  align-items: center;\n  line-height: 0;\n}\n\n.hw-nav--linkIcon {\n  display: inline-flex;\n  align-items: center;\n  line-height: 0;\n}\n\n.dropdown-menu.hw__currency-dropdown {\n  min-width: 22rem;\n}\n\n.dropdown-menu.hw__currency-dropdown li {\n  text-transform: uppercase;\n  color: var(--hw-black);\n  cursor: pointer;\n}\n\n.header-nav .nav-link.nav-currency {\n  column-gap: .8rem;\n}\n\n.header-nav .nav-link.nav-currency.show .hw-nav--icon {\n  color: var(--hw-brand-orange);\n}\n\n.dropdown-menu.hw__currency-dropdown li:hover {\n  color: var(--hw-brand-orange);\n}\n\n.dropdown-menu.hw__currency-dropdown li+li {\n  margin-top: 1rem;\n}\n\n.hw-app--main {\n  position: relative;\n  /* margin-top: 7rem; */\n  min-height: calc(100vh - 7rem);\n}\n\n.hw-header.fixed-top+.hw-app--main {\n  margin-top: 7rem;\n}\n\n.hw-page--titlebar {\n  padding-top: 2rem;\n}\n\n/*New header*/\n.hw-wallet--box {\n  background-color: rgba(var(--hw-brand-orange-rgb), 0.10);\n  padding: .4rem 1rem;\n  border-radius: 0.5rem;\n  display: flex;\n  min-height: 4.2rem;\n  justify-content: center;\n  min-width: 4.2rem;\n  border: 1px solid var(--hw-brand-orange);\n  align-items: center;\n  column-gap: 0.4rem;\n}\n\n.hw-wallet--box svg {\n  width: 1.8rem;\n  height: 1.8rem;\n  display: block;\n}\n\n.hw-nav--profile {\n  cursor: pointer;\n  color: var(--hw-brand-blue) !important;\n  column-gap: 0.4rem;\n  padding-right: 3.2rem;\n}\n\n.hw-nav--profile img {\n  max-width: 40px;\n  max-height: 40px;\n  overflow: hidden;\n  background: var(--hw-gray-100);\n  font-size: 0;\n}\n\n.header-nav {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.hw-wallet--boxWallet {\n  display: flex;\n  align-items: center;\n  column-gap: 0.4rem;\n}\n\n.hw-header--wrapper {\n  min-height: 7rem;\n  display: flex;\n}\n\n.hw-header--wrapper {\n  justify-content: space-between;\n}\n\n.hw-header--dropdownProfile>.hw-main--menuItem:not(:first-child) .hw-main--menuItemLink {\n  padding-top: 1rem;\n}\n\n.header-nav .hw-header--dropdownProfile .hw-main--menuItemLink {\n  white-space: nowrap;\n}\n\n@media (min-width:600px) {\n  .hw-wallet--box {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n@media (min-width:990px) {\n  .hw-nav--profile {\n    column-gap: 1.6rem;\n  }\n\n  /* .header-nav {\n min-width: 23.6rem;\n} */\n  .hw-header--wrapper {\n    min-height: 9.6rem;\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n  }\n\n  .hw-header--wrapper .header-nav {\n    align-items: flex-end;\n  }\n\n  .hw-app--main {\n    /* margin-top: 9.6rem; */\n    min-height: calc(100vh - 9.6rem);\n  }\n\n  .hw-header.fixed-top+.hw-app--main {\n    margin-top: 9.6rem;\n  }\n}\n\n@media (min-width: 1300px) {\n  .hw-wallet--box {\n    padding: .8rem 2.4rem;\n    min-height: 6.4rem;\n  }\n}\n\n@media (max-width:480px) {\n  .hw-header--wrapper .header-nav {\n    margin-inline: 8px;\n  }\n}\n\n@media (max-width:990px) {\n  .hw-header--wrapper .header-nav {\n    margin-inline: auto;\n  }\n\n  .hw-header-line {\n    display: none !important;\n  }\n}\n\n/*End Header*/\n\n/*sidebar toggle*/\n.notification-item .hw__nav-icon--ntf {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.5019 2.13509C17.8102 2.31401 18 2.64353 18 3V7C19.1848 7 20.2502 7.51635 20.9812 8.33309C21.614 9.0401 22 9.97617 22 11C22 12.0238 21.614 12.9599 20.9812 13.6669C20.2502 14.4836 19.1848 15 18 15V19C18 19.3565 17.8102 19.686 17.5019 19.8649C17.1936 20.0438 16.8134 20.0451 16.5039 19.8682L10 16.1518V21C10 21.5523 9.55228 22 9 22H5C4.44772 22 4 21.5523 4 21V16C2.89543 16 2 15.1046 2 14V8C2 6.89543 2.89543 6 4 6H9.73444L16.5039 2.13176C16.8134 1.9549 17.1936 1.95617 17.5019 2.13509ZM10 14C10.174 14 10.345 14.0454 10.4961 14.1318L16 17.2768V4.72318L10.4961 7.86824C10.345 7.95458 10.174 8 10 8H4V14H10ZM6 16V20H8V16H6ZM18 13C18.5922 13 19.1233 12.7438 19.491 12.3331C19.8083 11.9786 20 11.5129 20 11C20 10.4871 19.8083 10.0214 19.491 9.66691C19.1233 9.25615 18.5922 9 18 9V13Z' fill='%233264FF'/%3E%3C/svg%3E\");\n}\n\n.notification-item .hw__nav-icon--ntf {\n  width: 2.4rem;\n  height: 2.4rem;\n  min-width: 2.4rem;\n  background-size: 2.4rem 2.4rem;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n.hw__notifications-dropdown .dropdown-divider {\n  margin: 1rem -2rem;\n}\n\n@media (min-width: 861px) {\n  .hw__notifications-dropdown {\n    min-width: 34rem;\n  }\n}\n\n@media (min-width: 1120px) {\n  .hw__notifications-dropdown {\n    min-width: 58.5rem;\n  }\n}\n\n@media (min-width: 768px) {\n  body {\n    font-size: 1.6rem;\n  }\n\n  body:not(.sidebar-collapsed) .hw-sidebar {\n    width: 9rem;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--nav {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  body:not(.sidebar-collapsed) .hw-sidebar--nav .nav-link {\n    justify-content: center;\n  }\n\n  body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--profileImg {\n    width: 9rem;\n    height: 9rem;\n  }\n\n  .hw-sidebar--nav .nav-link {\n    min-height: 4.8rem;\n  }\n\n  /* body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--nav {\n        padding-left: 2rem;\n        padding-right: 2rem;\n    } */\n\n  body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--profileImg img {\n    transform: scale(.5);\n  }\n\n  body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--profile .h6,\n  body:not(.sidebar-collapsed) .hw-sidebar .hw-sidebar--profile .hw-text14 {\n    opacity: 0;\n  }\n\n  body:not(.sidebar-collapsed) .hw-sidebar .nav-link {\n    column-gap: 0;\n    /* justify-content: center; */\n  }\n\n  body:not(.sidebar-collapsed) .hw-sidebar .nav-link span {\n    font-size: 0;\n    line-height: 0;\n    display: none;\n    height: 0;\n    width: 0;\n  }\n\n  /* .hw-sidebar .hw-sidebar--nav {\n        margin-top: 1rem;\n    } */\n}\n\n@media (max-width: 767px) {\n  .hw-sidebar .hw-sidebar--toggle {\n    display: none !important;\n  }\n\n  .hw-sidebar {\n    transition: left .2s ease;\n    padding-top: 2rem;\n  }\n\n  body:not(.sidebar-collapsed) .hw-sidebar {\n    left: -26.5rem;\n  }\n\n  .hw-header .hw-logo {\n    padding-left: 3.75rem;\n  }\n\n  .toggle-sidebar--btn {\n    position: fixed;\n    top: 5.5rem;\n    left: 2rem;\n    width: 3rem;\n    height: 3rem;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    left: 1.5rem;\n    z-index: 9999;\n  }\n\n  .hw__hamburg {\n    display: block;\n    width: 2rem;\n    height: 2rem;\n  }\n\n  .hw__hamburg span {\n    display: block;\n    width: 1.8rem;\n    height: .2rem;\n    margin-bottom: .4rem;\n    position: relative;\n    background: var(--hw-black);\n    transform-origin: 4px 0px;\n    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0), background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0), opacity 0.55s ease;\n  }\n\n  .hw__hamburg>span:nth-of-type(3) {\n    transform-origin: 0% 0%;\n  }\n\n  .sidebar-collapsed .hw__hamburg span {\n    opacity: 1;\n    transform: rotate(45deg) translate(1px, 1px);\n  }\n\n  .sidebar-collapsed .hw__hamburg span:nth-of-type(2) {\n    opacity: 0;\n    transform: rotate(0deg) scale(0.2, 0.2);\n  }\n\n  .sidebar-collapsed .hw__hamburg span:nth-of-type(3) {\n    transform: rotate(-45deg) translate(0, -1px);\n  }\n\n  body:not(.sidebar-collapsed) .hw-menu--overlay {\n    opacity: 0;\n  }\n\n  .hw-menu--overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(var(--hw-brand-blue-rgb), .5);\n    z-index: 99;\n    pointer-events: none;\n    opacity: 1;\n    transition: opacity .3s ease;\n  }\n}\n\n/*End sidebar toggle*/\n.hw-page--titlebar {\n  margin-bottom: 2rem;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n  float: left;\n  padding-right: .4rem;\n  padding-left: .4rem;\n  color: var(--hw-gray-800);\n  content: \"/\";\n}\n\n.breadcrumb .text-muted:not(:hover),\n.breadcrumb li {\n  color: var(--hw-gray-800);\n}\n\n.breadcrumb li {\n  font-size: 1.4rem;\n  line-height: 1.71429;\n  font-weight: 500;\n}\n\n.hw-widget--card {\n  padding: 1.6rem;\n  background-color: var(--hw-gray-300);\n  border-radius: 0.5rem;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n.hw-widget.hw-widget--flight.hw-widget--flight__open {\n  padding: 0;\n  /* min-height: 23.3rem; */\n  /* min-height: 16.5rem; */\n  /* position: relative; */\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  /* position: sticky;\n    top: 0;\n    z-index: 2; */\n}\n\n.hw-widget.hw-widget--flight.hw-widget--flight__open {\n  background-color: var(--hw-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);\n}\n\n.hw-widget.hw-widget--flight.hw-widget--flight__open .hw-widget--card {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n\n.hw-widget.hw-widget--flight.hw-widget--flight__open .hw-widget--card label.hw-black {\n  color: var(--hw-white) !important;\n}\n\n.hw-tab {\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: .5rem;\n  margin-bottom: 1.2rem;\n  row-gap: .5rem;\n}\n\n.hw-tab button {\n  padding: 0.4rem 1.2rem 0.4rem 3.6rem;\n  border-radius: 0.5rem;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  font-size: 1.4rem;\n  line-height: 1.55556;\n  background-color: var(--hw-white);\n  text-transform: capitalize;\n  transition: .2s ease;\n  color: var(--hw-brand-blue);\n  position: relative;\n}\n\n.hw-tab button:not(.active):hover {\n  background-color: var(--hw-brand-orange-light);\n  border-color: var(--hw-brand-orange-light);\n  color: var(--hw-black);\n}\n\n.hw-tab button.active {\n  background-color: var(--hw-brand-orange-light);\n}\n\n.hw-tab button::before {\n  content: '';\n  position: absolute;\n  width: 1.6rem;\n  height: 1.6rem;\n  border: 1px solid var(--hw-brand-blue);\n  left: 1.2rem;\n  border-radius: 999px;\n}\n\n.hw-tab button.active::before {\n  background-color: var(--hw-brand-orange);\n  outline: 1px solid var(--hw-brand-orange);\n  border-color: var(--hw-white);\n  border-width: 2px;\n}\n\n@media (min-width: 576px) {\n  .hw-tab button {\n    font-size: 1.6rem;\n  }\n}\n\n\n/*input related css*/\n.hw-row--input .css-1u9des2-indicatorSeparator {\n  display: none !important;\n}\n\n.hw-row--input .css-1jqq78o-placeholder {\n  color: var(--hw-brand-blue);\n  font-weight: 500;\n  padding-left: 3.4rem;\n}\n\n/* .hw-row--input .css-1xc3v61-indicatorContainer {\n    color: var(--hw-gray-800);\n} */\n.hw-input--switchGroup div svg {\n  color: inherit !important;\n}\n\n.hw-row--input .css-1u80x8j-control {\n  border-color: var(--hw-gray-600) !important;\n  background-color: var(--hw-white) !important;\n  border-radius: 0.5rem !important;\n  width: 100%;\n  /* min-height: 5rem; */\n  min-height: 5.4rem;\n  margin: 0 !important;\n  padding-left: 2rem !important;\n  padding-right: 2rem !important;\n}\n\n/* .hw-row--input .css-1pc1zkh-control {\n    margin: 0 !important;\n    padding-left: 2rem !important;\n    padding-right: 2rem !important;\n  } */\n.hw-row--input .hw-input--switchGroup .css-1u80x8j-control,\n.hw-row--input .hw-input--switchGroup .css-1pc1zkh-control {}\n\n.hw-row--input .hw-input--switchGroup>div>div:hover {\n  border-color: var(--hw-brand-orange) !important;\n  background-color: var(--hw-brand-orange-light) !important;\n  cursor: pointer;\n}\n\n.hw-row--input .hw-input--switchGroup>div>div {\n  padding-left: 3.5rem !important;\n}\n\n.hw-input--switchGroup>div>div {\n  width: auto !important;\n  min-height: 5rem;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cg clip-path='url(%23clip0_1252_2042)'%3E%3Cpath d='M14.639 10.258L19.469 8.96401C19.7245 8.89023 19.9921 8.86813 20.2562 8.89901C20.5203 8.92989 20.7756 9.01312 21.0071 9.14384C21.2387 9.27456 21.4419 9.45014 21.6047 9.66032C21.7676 9.87049 21.887 10.111 21.9558 10.3679C22.0246 10.6247 22.0415 10.8927 22.0055 11.1562C21.9695 11.4196 21.8814 11.6733 21.7462 11.9022C21.611 12.1312 21.4315 12.3309 21.2182 12.4897C21.0049 12.6485 20.7621 12.7632 20.504 12.827L6.015 16.71L1.565 11.69L4.462 10.914L6.912 12.328L9.809 11.552L6.066 5.30801L8.964 4.53101L14.639 10.258Z' stroke='%230F294D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M3 21H21' stroke='%230F294D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1252_2042'%3E%3Crect width='24' height='24' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: left 1rem center;\n  background-size: 2rem 2rem;\n  margin: 0 !important;\n  padding-left: 4.4rem !important;\n  padding-right: 2rem !important;\n}\n\n.hw-input--switchGroup div {\n  margin: 0 !important;\n  padding: 0 !important;\n  color: var(--hw-brand-blue);\n  font-weight: bold;\n}\n\n.hw-input--switchGroup {\n  display: flex;\n  align-items: center;\n  column-gap: 0;\n  width: 40%;\n  position: relative;\n}\n\n.hw-input--error-search {\n  color: var(--hw-red);\n  position: absolute;\n  bottom: -26px;\n  left: 0;\n  font-size: 1.2rem;\n  line-height: 1.5;\n  z-index: 11;\n  background: #fbe7e9;\n  padding: 0.4rem;\n  border-radius: 0.5rem;\n}\n\n.hw-input--error-search.left {\n  left: 0;\n}\n\n.hw-input--error-search.right {\n  left: auto;\n  right: 0;\n}\n\n.hw-input--switchGroup>div {\n  flex: 1;\n}\n\n.hw-row--input .css-1pc1zkh-control {\n  background-color: var(--hw-brand-orange-light) !important;\n  border-color: var(--hw-brand-orange) !important;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  outline: none !important;\n}\n\n/* .hw-row--input .hw-input--switchGroup .css-1jqq78o-placeholder + div {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M2.49984 18.9998H21.4998V20.9998H2.49984V18.9998ZM22.0698 9.63982C21.8598 8.83982 21.0298 8.35982 20.2298 8.57982L14.9198 9.99982L8.01984 3.56982L6.08984 4.07982L10.2298 11.2498L5.25984 12.5798L3.28984 11.0398L1.83984 11.4298L4.42984 15.9198L20.9998 11.4898C21.8098 11.2598 22.2798 10.4398 22.0698 9.63982Z' fill='%23283D6B'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: left center;\n    padding-left: 3.4rem;\n    background-size: 2.4rem 2.4rem;\n    margin: 0 !important;\n  } */\n\n.hw-input--switchGroup .hw-switch {\n  background-color: var(--hw-white);\n  color: var(--hw-brand-orange);\n  width: 3.4rem;\n  height: 3.4rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0.5rem;\n  margin: 0 -12px;\n  position: relative;\n  z-index: 1;\n  border: 1px solid var(--hw-brand-orange);\n  cursor: pointer;\n}\n\n.hw-input--switchGroup .hw-switch:hover {\n  background-color: var(--hw-brand-orange-light);\n}\n\n.hw-input--switchGroup .hw-switch svg {\n  width: 2rem;\n  height: 2rem;\n}\n\n.hw-input--groupCol {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: flex-start;\n  column-gap: 1rem;\n}\n\n.hw-filter--searchBtn {\n  background-color: var(--hw-brand-orange);\n  min-height: 4rem;\n  border: none;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  color: var(--hw-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 0;\n  transition: background-color .2s ease;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 1.4rem;\n  min-width: 15rem;\n}\n\n.hw-filter--searchBtn:hover {\n  background-color: var(--hw-brand-orange-hover);\n}\n\n.hw-input--input {\n  background-color: var(--hw-white);\n  display: flex;\n  align-items: center;\n  min-height: 5rem;\n  border: .1rem solid var(--hw-gray-400);\n  border-radius: 0.5rem;\n  padding: .2rem 1rem;\n  color: var(--hw-gray-800);\n  column-gap: .5rem;\n  cursor: pointer;\n}\n\n.hw-input--input.disabled {\n  background-color: var(--hw-gray-300);\n  color: var(--hw-gray-400);\n  border-color: var(--hw-gray-400) !important;\n  cursor: no-drop;\n}\n\n.hw-input--input.disabled svg {\n  opacity: .2;\n}\n\n.hw-inputCheck--airline__js {\n  cursor: pointer;\n}\n\n.hw-inputCheck--airline__js svg {\n  color: var(--hw-black);\n}\n\n.hw-row--input.hw-row--inputFirst>.hw-input--input {\n  display: grid;\n  grid-template-columns: auto 1fr;\n}\n\n.hw-passenger--getValue {\n  color: var(--hw-gray-650);\n  font-size: 1.4rem;\n  line-height: 1;\n}\n\n.hw-row--input.hw-row--inputFirst>.hw-input--input svg {\n  grid-row: span 2;\n}\n\n.hw-input--input:not(.active):hover {\n  border-color: var(--hw-brand-orange) !important;\n  background-color: var(--hw-brand-orange-light);\n}\n\n.hw-input--input.active {\n  border-color: var(--hw-brand-orange);\n  /* background-color: var(--hw-brand-orange-light); */\n}\n\n.hw-input--input.active svg {\n  color: var(--hw-brand-orange) !important;\n}\n\n.hw-input--input svg {\n  flex-shrink: 0;\n}\n\n.hw-row--input.hw-row--inputFirst {\n  display: flex;\n  column-gap: 0;\n  flex-wrap: wrap;\n}\n\n.hw-row--inputFirst .react-datepicker-wrapper {\n  width: 24%;\n}\n\n.hw-row--input.hw-row--inputFirst>.hw-input--input svg {\n  color: var(--hw-brand-blue) !important;\n}\n\n.hw-text--hidden44 {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: calc(100% - 4.4rem);\n}\n\n.hw-text--hidden {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.hw-row--input.hw-row--inputFirst+.hw-row--inputCheck {\n  margin-top: 2.4rem;\n}\n\n.hw-flight--list svg {\n  color: var(--hw-brand-orange);\n  display: block;\n  margin-top: .4rem;\n  flex-shrink: 0;\n  width: 2.4rem;\n  height: 2.4rem;\n}\n\n.hw-flight--lists {\n  padding: .8rem 1.6rem;\n  transition: background-color .2s ease;\n}\n\n.hw-flight--lists:hover {\n  background-color: var(--hw-brand-orange-light);\n}\n\n.hw-inputCheck--airline {\n  position: relative;\n}\n\n.hw-inputCheck--airline .hw-flight--lists:hover,\n.hw-inputCheck--airline .hw-select--option:hover,\n.hw-inputCheck--airline .hw-select--option.is-focused {\n  background-color: transparent;\n}\n\n.hw-inputCheck--airline .hw-select--option,\n.hw-inputCheck--airline .hw-flight--lists {\n  border: 0;\n}\n\n.hw-inputCheck--airline .dropdown-container {\n  position: absolute;\n  z-index: 10;\n  width: 28rem;\n  background-color: var(--hw-white);\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.12);\n  border: 1px solid #e2e6ee;\n  border-radius: 1rem;\n  overflow: hidden;\n}\n\n/**/\n.hw-calender--removeBtn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 1rem;\n  line-height: 0;\n  color: var(--hw-brand-blue);\n  font-size: 1.6rem;\n  cursor: pointer;\n}\n\ninput[type=\"checkbox\"] {\n  --hw-form-check-bg: var(--hw-white);\n  width: 2.2rem;\n  height: 2.2rem;\n  margin: 0;\n  vertical-align: top;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: var(--hw-white);\n  background-image: var(--hw-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: .1rem solid var(--hw-gray-700);\n  -webkit-print-color-adjust: exact;\n  color-adjust: exact;\n  print-color-adjust: exact;\n  border-radius: .5rem;\n}\n\ninput[type=\"radio\"] {\n  --hw-form-check-bg: var(--hw-white);\n  width: 2.2rem;\n  height: 2.2rem;\n  margin: 0;\n  vertical-align: top;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: var(--hw-white);\n  background-image: var(--hw-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: .1rem solid var(--hw-gray-400);\n  -webkit-print-color-adjust: exact;\n  color-adjust: exact;\n  print-color-adjust: exact;\n  border-radius: 50%;\n}\n\ninput:checked[type=\"radio\"] {\n  --hw-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2.8' fill='%233264FF'/%3e%3c/svg%3e\");\n  background-color: var(--hw-white);\n  border-color: var(--hw-brand-orange);\n}\n\ninput:checked[type=\"checkbox\"] {\n  --hw-form-check-bg-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'%3E%3Cpath d='M15.4983 4.18945C15.8079 4.46464 15.8358 4.93869 15.5606 5.24828L7.56056 14.2483C7.41824 14.4084 7.21424 14.5 7.00001 14.5C6.78578 14.5 6.58178 14.4084 6.43945 14.2483L2.43945 9.74828C2.16426 9.43869 2.19215 8.96464 2.50174 8.68945C2.81132 8.41426 3.28538 8.44215 3.56056 8.75173L7.00001 12.6211L14.4395 4.25174C14.7146 3.94215 15.1887 3.91426 15.4983 4.18945Z' fill='%23ffffff'/%3E%3C/svg%3E\");\n  background-color: var(--hw-brand-orange);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-hotel--Checkbox li label input[type=\"checkbox\"] {\n  width: 1.8rem;\n  height: 1.8rem;\n  border-radius: 0.4rem;\n}\n\n.hw-hotel--Checkbox li label:hover input[type=\"checkbox\"] {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-input--multicityGroup {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.2rem;\n}\n\n.hw-row--inputCheck {\n  margin-top: 1.2rem;\n}\n\n/* Trip-type row: tabs + preferred-airline/direct/nearby controls on one line.\n   Zero the children's own margins so they sit on the same baseline; the row\n   itself carries the bottom spacing. */\n.hw-tripType--row .hw-tab {\n  margin-bottom: 0;\n}\n\n.hw-multiCity--field.hw-input--input svg+div {\n  display: grid;\n}\n\n@media (max-width: 575px) {\n  .hw-date-range-picker .hw-calender--removeBtn {\n    right: 2rem;\n  }\n\n  .hw-date-range-picker .hw-calender--removeBtn svg {\n    width: 1.4rem;\n    height: 1.4rem;\n  }\n}\n\n/*popup*/\n.hw-input--groupColLeft {\n  position: relative;\n}\n\n.paasenger-modal {\n  position: absolute;\n  right: 0;\n  top: 26rem;\n  z-index: 12;\n  width: 100%;\n  max-width: 47.4rem;\n}\n\n.paasenger-modal .DT--card-container {\n  border: 1px solid var(--hw-gray-600);\n  background: var(--hw-white);\n  border-radius: 0.5rem;\n}\n\n.DT--section {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1rem;\n  padding: 1.6rem 1.6rem 0;\n}\n\n.DT--title {\n  color: var(--hw-black);\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.DT--passenger-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: .5rem;\n}\n\n.DT--class-selector {\n  padding: 1.6rem 1.6rem 0 1.6rem;\n}\n\n.DT--button-selector {\n  padding: 0 1.6rem 1.6rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  column-gap: 2rem;\n  row-gap: 1rem;\n}\n\n.DT--button-selector .hw-btn {\n  padding-left: 1.6rem;\n  padding-right: 1.6rem;\n}\n\n.DT--passenger-age {\n  color: var(--hw-gray-800);\n}\n\n.DT--counter {\n  display: flex;\n  flex-shrink: 0;\n  border-radius: 1rem;\n  border: .1rem solid var(--hw-gray-600);\n  align-items: center;\n  width: 15.7rem;\n  overflow: hidden;\n  max-width: 12.8rem;\n}\n\n.DT--counter button {\n  padding: 1rem;\n  border: none;\n  box-shadow: none;\n  outline: none;\n  background-color: rgba(0, 0, 0, 0);\n  color: var(--hw-gray-800);\n  font-size: 2.4rem;\n  line-height: 1;\n  cursor: pointer;\n  min-width: 4.4rem;\n  transition: .2s ease;\n}\n\n.DT--counter-display {\n  flex: 1 1 auto;\n  text-align: center;\n  font-weight: 500;\n  color: var(--hw-black-900);\n}\n\n.DT--counter button:hover {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n}\n\n.DT-field--checkboxGroup {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n  margin-top: 1rem;\n}\n\n.DT-field--checkboxGroup .DT--class-item {\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n  flex-grow: 1;\n}\n\n.DT-field--checkboxGroup .DT--class-item input {\n  position: absolute;\n  width: 0;\n  height: 0;\n  opacity: 0;\n  font-size: 0;\n  line-height: 0;\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n\n.DT-field--checkboxGroup .DT--class-item label {\n  color: var(--hw-gray-800);\n  font-weight: 500;\n  padding: .6rem 1.2rem;\n  font-size: 1.4rem;\n  line-height: 1.71429;\n  border: 1px solid var(--hw-gray-600);\n  border-radius: 0.5rem;\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n}\n\n.DT-field--checkboxGroup input:checked[type=\"radio\"]+.DT--class-label {\n  background-color: var(--hw-brand-orange-light);\n  background-color: rgba(var(--hw-brand-orange-rgb), 0.1);\n  border-color: var(--hw-brand-orange);\n  color: var(--hw-brand-orange);\n}\n\n.DT-field--checkboxGroup .DT--class-item label {\n  color: var(--hw-gray-800);\n  font-weight: 500;\n}\n\n.DT--divider {\n  background-color: var(--hw-gray-600);\n  height: .1rem;\n  margin-top: 1.6rem;\n  margin-bottom: 1.6rem;\n}\n\n\n.DT--section {\n  row-gap: 1rem;\n  column-gap: 1rem;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.DT--section select {\n  background-color: var(--hw-white);\n  border: .1rem solid var(--hw-gray-400);\n  padding: .5rem 1rem;\n  border-radius: .4rem;\n  flex: 1 0 0;\n  color: var(--hw-black-900);\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8' viewBox='0 0 14 8' fill='none'%3E%3Cpath d='M1 1L7 7L13 1' stroke='%23555555' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-size: 1rem 0.6rem;\n}\n\n.DT--passenger-item {\n  row-gap: 1rem;\n  flex-direction: column;\n  flex: 1 0 0;\n  align-items: flex-start;\n}\n\n.DT--passenger-item .DT--passenger-label {\n  font-size: 1.3rem;\n  color: var(--hw-black-900);\n}\n\n.DT--passenger-item .DT--passenger-label b {\n  font-weight: 500;\n  font-size: 1.6rem;\n}\n\n.DT--section .hw-btn {\n  grid-column: 3;\n}\n\n.DT--counter-display {\n  width: 100%;\n  max-width: 100%;\n}\n\n.DT--counter {\n  width: 100%;\n}\n\n.DT--counter-value input {\n  width: 100%;\n}\n\n.DT--section>hr {\n  grid-column: span 3;\n  width: calc(100% + 4rem);\n  background-color: var(--hw-gray-400);\n  border: none !important;\n  height: .1rem;\n  margin: 1.6rem -2rem;\n}\n\n.DT--section>hr+label {\n  color: var(--hw-black);\n  font-weight: 500;\n  grid-column: span 3;\n  margin-top: -1rem;\n}\n\n.hw-dt--selectChild {\n  display: flex;\n  column-gap: .2rem;\n  align-items: center;\n}\n\n.hw-dt--selectChild label {\n  color: var(--hw-black);\n  font-weight: 500;\n  min-width: 5rem;\n  font-size: 1.4rem;\n}\n\n.DT--counter-value input[type=\"number\"]::-webkit-outer-spin-button,\n.DT--counter-value input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.DT--counter-value input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n@media (min-width: 641px) {\n  .hw-widget--card {\n    padding: 2rem;\n    border-radius: 1rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .hw-calender--removeBtn {\n    right: 2rem;\n  }\n\n  .hw-row--input .hw-input--switchGroup>div>div {\n    padding-left: 5.4rem !important;\n  }\n\n  .hw-input--switchGroup>div>div {\n    background-position: left 2rem center;\n    background-size: 2.4rem 2.4rem;\n    padding-left: 5.4rem !important;\n  }\n\n  .hw-input--switchGroup>div {\n    max-width: calc(50% - 0.6rem);\n  }\n}\n\n@media (min-width: 576px) {\n  .paasenger-modal {\n    top: 20rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .paasenger-modal {\n    top: 13rem;\n  }\n}\n\n@media (min-width: 1025px) {\n  .paasenger-modal {\n    /* top: 8.6rem; */\n    top: 6.6rem;\n  }\n}\n\n@media (max-width: 899px) {\n  .paasenger-modal {\n\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 640px) {\n  .DT--passenger-item .DT--passenger-label {\n    font-size: 1.2rem;\n  }\n\n  .DT--passenger-item .DT--passenger-label b {\n    font-size: 1.4rem;\n  }\n}\n\n@media (max-width: 479px) {\n  .DT--passenger-item {\n    row-gap: .5rem;\n  }\n\n  .paasenger-modal .DT--card-container .DT--section {\n    column-gap: .5rem;\n  }\n\n  .DT--passenger-item .DT--passenger-label {\n    display: flex;\n    flex-direction: column;\n    line-height: 1.5;\n  }\n\n  .DT--passenger-item .DT--counter button {\n    padding: .6rem;\n    font-size: 2rem;\n    min-width: 3.2rem;\n  }\n\n  .DT--section>hr {\n    margin: 1rem -1.5rem;\n    width: calc(100% + 3rem);\n  }\n\n  .hw-dt--selectChild {\n    align-items: stretch;\n    flex-direction: column;\n    row-gap: .2rem;\n  }\n}\n\n/*End popup*/\n.hw-btn {\n  padding: 0.8rem 2rem;\n  font-size: 1.4rem;\n  line-height: 1.5;\n  font-weight: bold;\n  display: inline-flex;\n  justify-content: center;\n  column-gap: 1rem;\n  align-items: center;\n  border: .1rem solid rgba(0, 0, 0, 0);\n  background-color: rgba(0, 0, 0, 0);\n  color: var(--hw-black);\n  cursor: pointer;\n  border-radius: 0.5rem;\n  transition: background-color .2s ease, color .2s ease, border-color .2s ease;\n}\n\n.hw-btn--smallSize {\n  font-size: 1.4rem !important;\n  line-height: 1.71429 !important;\n}\n\n.hw-btn--mdSize {\n  font-size: 1.6rem;\n  line-height: 1.75;\n}\n\n.hw-btn--lg {\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n\n.hw-btn--xl {\n  padding: 1.5rem 2.8rem;\n}\n\n.hw-btn--round {\n  border-radius: 999px;\n}\n\n.hw-btn--primary {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  border: none !important;\n}\n\n.hw-arrow-btn {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  border: none !important;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 0.5rem;\n  padding: 0.6rem 1.2rem;\n  transition: background-color .2s ease, color .2s ease, border-color .2s ease;\n}\n\n.hw-btn--primary:hover {\n  background-color: var(--hw-brand-orange-hover);\n  color: var(--hw-white);\n}\n\n.hw-btn--grayOutline {\n  background: rgba(139, 139, 139, 0.20);\n  color: var(--hw-gray-500);\n  border: 1px solid rgba(0, 0, 0, 0);\n}\n\n.hw-btn.hw-btn--grayOutline:hover {\n  border-color: var(--hw-gray-500);\n}\n\n.hw-btn--primaryOutline {\n  color: var(--hw-brand-orange);\n  /* background-color: var(--hw-brand-orange-light); */\n  background-color: rgba(50, 100, 255, 0.10);\n  border: 1px solid var(--hw-brand-orange);\n}\n\n.hw-btn--primaryOutline:hover {\n  color: var(--hw-white);\n  background-color: var(--hw-brand-orange);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-btn--secondary,\n.hw-btn--secondaryPrimaryHover {\n  background-color: var(--hw-brand-orange-light);\n  color: var(--hw-brand-orange);\n  border: none !important;\n}\n\n.hw-btn--secondaryOutline {\n  background-color: var(--hw-brand-orange-light);\n  color: var(--hw-brand-orange);\n  border: 1px solid rgba(0, 0, 0, 0);\n}\n\n.hw-btn--primaryOutlineActive {\n  background-color: var(--hw-brand-orange-light);\n  color: var(--hw-brand-orange);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-btn--secondaryOutline:hover {\n  background-color: var(--hw-brand-orange-light);\n  color: var(--hw-brand-orange);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-btn--white-outline {\n  border: .1rem solid var(--hw-gray-400);\n  background-color: var(--hw-white);\n  color: var(--hw-body-color);\n}\n\n.hw-btn--secondaryPrimaryHover:hover {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n}\n\n.hw-btn--white-outline:hover {\n  background-color: var(--hw-brand-orange-light);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-btn--secondary:hover {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n}\n\n.hw-btn--secondaryDefault {\n  border-color: var(--hw-brand-blue);\n  color: var(--hw-brand-blue);\n}\n\n.hw-btn--whiteDefault {\n  border-color: var(--hw-white);\n  color: var(--hw-white);\n}\n\n.hw-btn.hw-btn--whiteDefault:hover {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-btn--secondaryDefault:hover {\n  background-color: var(--hw-brand-blue);\n  color: var(--hw-white);\n}\n\n.hw-btn--mn140 {\n  min-width: 14rem;\n  justify-content: center;\n}\n\n.hw-btn--mn176 {\n  min-width: 17.6rem;\n  justify-content: center;\n}\n\n.react-datepicker__tab-loop {\n  position: absolute;\n  z-index: 9999;\n}\n\n.hw-input--multicityGroup .hw-date-range-picker+.react-datepicker__tab-loop {\n  position: absolute;\n  min-width: 100%;\n}\n\n.hw-row--inputCheck {\n  flex-wrap: wrap;\n}\n\n.hw-filter--actionBtn {\n  /* padding-left: 1rem; */\n  display: flex;\n  column-gap: 1rem;\n  align-items: center;\n}\n\n\n/* .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst:not(:last-child) {\n    width: 80%;\n    max-width: calc(100% - 36.6rem);\n  } */\n/* .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst > div:last-child {\n    display: none !important;\n  }\n  .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst:not(:last-child) {\n    width: calc(100% - 31.7rem);\n  }\n\n  .hw-filter--actionBtn {\n\n    min-width: 31.7rem;\n  }   */\n.hw-filter--actionBtn .hw-btn {\n  min-height: 4.4rem;\n}\n\n.hw-filter--actionBtn .hw-btn.hw-btn--secondaryOutline {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  column-gap: 0.5rem;\n}\n\n.hw-filter--actionBtn>.hw-btn.hw-btn--grayOutline {\n  padding: 1rem;\n}\n\n.hw-btn svg,\n.hw-filter--searchBtn svg {\n  width: 2rem;\n  height: 2rem;\n  display: block;\n}\n\n/*List page*/\n.hw-mnh--76 {\n  min-height: 7.6rem;\n}\n\n.hw-grid--2auto {\n  display: grid;\n  align-items: center;\n  column-gap: 1rem;\n  grid-template-columns: 1fr auto;\n  width: 100%;\n}\n\n.hw-search--flightFilter {\n  grid-template-rows: auto 1fr;\n  display: grid;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--hw-gray-200) var(--hw-gray-100);\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.3s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n}\n\n.hw-search--flightList {\n  position: relative;\n  /* padding-top: 2.4rem; */\n}\n\n.hw-search--flightFilterResult {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.2rem;\n  padding-bottom: 2rem;\n  padding-top: 2.4rem;\n}\n\n.hw-search--flightCheckbox>li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: .8rem 0;\n  column-gap: .5rem;\n}\n\n.hw-search--flightFilterResult__list {\n  display: flex;\n  flex-direction: column;\n  /* row-gap: 1.2rem; */\n  row-gap: 0.8rem;\n}\n\n.hw-search--flightFilterResult__listItem {\n  padding: 1.5rem;\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n  position: relative;\n  /* box-shadow: 0px 0px 10px 0px rgba(var(--hw-black-rgb), 0.10); */\n}\n\n.hw-flight--listBox {\n  display: flex;\n  justify-content: space-between;\n  column-gap: 2rem;\n  position: relative;\n}\n\n.hw-flight--listBox .destination {\n  display: flex;\n  align-items: center;\n  gap: 1.6rem;\n  flex: 1 0 0;\n  justify-content: space-between;\n}\n\n.hw-flight--listBox__flight {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  flex: 1 0 0;\n  text-align: center;\n}\n\n.hw-flight--line {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  margin: -.2rem 0;\n  position: relative;\n}\n\n.hw-flight--line--stop {\n  width: 0.8rem;\n  height: 0.8rem;\n  background-color: var(--hw-gray-500);\n  border-radius: 50%;\n  position: absolute;\n}\n\n.hw-flight--line--stop.hw-linestop1 {\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.hw-flight--line--stop.hw-linestopfull {\n  left: 25%;\n  transform: translateX(-25%);\n}\n\n.hw-flight--line--stop.hw-linestopfull+.hw-flight--line--stop.hw-linestopfull {\n  left: 75%;\n  transform: translateX(-75%);\n}\n\n.hw-flight--line--stop.hw-linestopfull+.hw-flight--line--stop.hw-linestopfull+.hw-flight--line--stop.hw-linestopfull {\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.hw-flight--line--stop:nth-of-type(1)+.hw-flight--line--stop {}\n\n.hw-flight--line .circle {\n  width: 0.8rem;\n  height: 0.8rem;\n  background-color: var(--hw-gray-500);\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.hw-flight--line .line {\n  background-color: var(--hw-gray-500);\n  height: .2rem;\n  flex: 1 1 auto;\n}\n\n.hw-flight--iconFlight {\n  line-height: 0;\n  padding-left: 0.4rem;\n}\n\n.hw-search--flightFilter__frame {\n  overflow: hidden;\n}\n\n.hw-search--flightFilter__frame+.hw-search--flightFilter__frame {\n  margin-top: 1rem;\n}\n\n\n.hw-search--flightFilter__widget.duration-widget .hw-search--flightFilter__frame .bottom {\n  padding: 1.6rem 1rem 4rem 0;\n}\n\n.hw-range--line {\n  background-color: var(--hw-brand-orange-light);\n  border-radius: 99.9rem;\n}\n\n.hw-range--line>div {\n  outline: none !important;\n}\n\n.hw-range--mtext {\n  white-space: nowrap;\n  top: 2rem;\n  font-size: 1.4rem;\n  right: 0;\n}\n\n.hw-range--line .hw-range--text {\n  font-size: 1.4rem;\n  line-height: 1.71429;\n  display: inline-flex;\n  position: relative;\n  top: 1.6rem;\n}\n\n.hw-range--line .hw-range--text.right {\n  float: right;\n}\n\n.hw-search--flightFilter__frame .top,\n.hw-search--flightFilter__frame .middle {\n  padding: .4rem 0;\n}\n\n\n\n.js-toggleFilter,\n.hw-search--flightFilter__action .hw-link {\n  padding: 1.4rem 1.6rem;\n}\n\n.hw-search--destinationRow>.col-md-1 {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.hw-search--destinationRow>.col-md-1 .hw-btn {\n  padding: 1.2rem;\n}\n\n.hw-search--destinationRow>div:not(:last-child) {\n  border-right: .1rem solid var(--hw-gray-500);\n}\n\n.hw-search--flightFilter__top {\n  background-color: var(--hw-white);\n}\n\n\n.hw-search--flightFilter__action {\n  display: flex;\n  justify-content: space-between;\n  column-gap: .5rem;\n  align-items: center;\n  /* padding: 1.2rem 1.6rem; */\n  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hw-search--flightFilter__action div {\n  color: var(--hw-brand-blue);\n  font-weight: bold;\n}\n\n.hw-search--flightFilter__action .hw-link {\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  white-space: nowrap;\n}\n\n.hw-search--flightFilter__bodyBox {\n  /* overflow: hidden; */\n  transition: opacity 0.25s ease, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hw-search--flightFilter__body {\n  padding: 2rem 1.6rem;\n  display: flex;\n  flex-direction: column;\n  /* row-gap: 2.4rem; */\n  row-gap: 1.2rem;\n  transition: opacity 0.25s ease, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hw-hotel--asideFilter .hw-search--flightFilter__body {\n  row-gap: 1rem;\n}\n\n.hw-search--flightFilter__widget.price-widget .hw-search--flightFilter__title.active+.hw-search--flightFilter__widgetContent {\n  padding: 0 1rem 4rem;\n}\n\n.hw-search--flightFilter__title {\n  padding: 0 0 0.8rem 0;\n  color: var(--hw-brand-blue);\n  cursor: pointer;\n}\n\n/* .hw-search--flightFilter__title.active {\n    color: var(--hw-black);\n  } */\n.hw-search--flightFilter__iconText {\n  display: flex;\n  /* column-gap: 1.2rem; */\n  column-gap: 0.4rem;\n}\n\n.hw-search--flightFilter__iconText>span {\n  border: .1rem solid var(--hw-gray-600);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  row-gap: 0.4rem;\n  padding: 0.8rem;\n  flex: 1;\n  cursor: pointer;\n  font-weight: 500;\n  color: var(--hw-black-900);\n  transition: background-color .2s ease, color .2s ease;\n  font-size: 1.2rem;\n  line-height: 1.33333;\n  border-radius: 0.5rem;\n  text-align: center;\n}\n\n.hw-search--flightFilter__widget.stops-widget .hw-search--flightFilter__iconText>span {\n  flex: 1 1 auto;\n}\n\n\n.hw-search--flightFilter__iconText>span:not(.active):hover {\n  background-color: var(--hw-brand-orange-light);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-search--flightFilter__iconText>span.active {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-twoLine--icon {\n  border: .1rem solid var(--hw-gray-400);\n  border-radius: 1rem;\n  padding: .8rem 1.2rem;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  column-gap: 1rem;\n  align-items: center;\n  font-size: 1.4rem;\n  line-height: 1.71429;\n  cursor: pointer;\n}\n\n.hw-twoLine--icon:not(.active):hover {\n  background-color: var(--hw-white);\n  border-color: var(--hw-gray-800);\n}\n\n.hw-twoLine--icon.active {\n  border-color: var(--hw-brand-orange);\n  color: var(--hw-black);\n}\n\n.hw-twoLine--icon svg {\n  grid-row: span 2;\n}\n\n.hw-twoLine--icon.active svg {\n  color: var(--hw-brand-orange);\n}\n\n.hw-search--flightFilterResult__top .d-flex {\n  column-gap: 1rem;\n}\n\n.hw-nav--tab {\n  display: flex;\n  align-items: center;\n}\n\n.hw-nav--tab.hw-nav--tabStyle1 {\n  align-items: stretch;\n}\n\n.hw-nav--tab.hw-nav--tabStyle1 .hw-nav--tabItem {\n  display: flex;\n  flex: 1 0 0;\n}\n\n.hw-nav-tabLink {\n  padding: .7rem 1.6rem;\n  background-color: var(--hw-white);\n  border: none;\n  border-bottom-width: medium;\n  border-bottom-style: none;\n  border-bottom-color: currentcolor;\n  border-bottom: .2rem solid rgba(0, 0, 0, 0);\n  border-bottom-color: rgba(0, 0, 0, 0);\n  font-size: 1.6rem;\n  line-height: 1.75;\n  font-weight: bold;\n  cursor: pointer;\n  color: var(--hw-gray-500);\n  transition: .3s ease;\n  width: 100%;\n}\n\n.hw-nav--tabStyle1 .hw-nav-tabLink {\n  font-size: 1.4rem;\n  line-height: 1.71429;\n  border-radius: 0;\n}\n\n.hw-nav-tabLink.active {\n  background-color: var(--hw-brand-orange-light);\n  border-bottom-color: var(--hw-brand-orange);\n  color: var(--hw-brand-blue);\n  cursor: default;\n}\n\n.hw-nav-tabLink:not(.active):hover {\n  color: var(--hw-brand-blue);\n}\n\n.p-null,\n.p-null p {\n  margin-bottom: 0 !important;\n}\n\n.hw-search--flightFilterResult__listItemDetails {\n  padding-top: 1rem;\n}\n\n.hw-search--flightFilterResult__tab {\n  border-top: .1rem solid var(--hw-gray-400);\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n  padding: 1.5rem 1.5rem 0;\n}\n\n.hw-search--flightFilterResult__fareDetailsList {\n  border-top: .1rem solid var(--hw-gray-400);\n  margin: 1.5rem -1.5rem 0;\n  padding: 1.5rem 1.5rem 0;\n}\n\n.hw-search--innerflight__listItem .flight-list {\n  width: 100%;\n  justify-content: space-between;\n  flex-direction: column;\n  row-gap: 0.8rem;\n}\n\n.hw-search--innerflight__list {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1rem;\n}\n\n.divider-badge {\n  background-color: var(--hw-gray-100);\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n  font-size: 1.4rem;\n  padding: .4rem 1.6rem;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  line-height: 1.286;\n  text-align: center;\n  row-gap: .5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n  color: var(--hw-brand-blue);\n}\n\n.hw-search--innerflight__divider {\n  display: flex;\n  align-items: center;\n}\n\n.hw-search--innerflight__divider>span {\n  background-color: var(--hw-gray-600);\n  height: .1rem;\n  flex: 1 0 0;\n  min-width: 2.5rem;\n}\n\n.hw-nav--tabFlightDetails .hw-search--innerflight__list {\n  border: .1rem solid var(--hw-gray-600);\n  border-radius: 0.5rem;\n  background-color: var(--hw-white);\n  padding: 1rem;\n}\n\n.hw-search--innerflight__listItem {\n  display: flex;\n  column-gap: 2rem;\n  /* padding: 1.6rem; */\n  align-items: center;\n}\n\n.hw-search--innerflight__listItem .flight-list .hw-flight--listBox__flight {\n  min-width: 40%;\n}\n\n.hw-info--tooltip {\n  display: inline-flex;\n  align-items: center;\n  column-gap: .5rem;\n  position: relative;\n  padding-top: 10px;\n  margin-top: -10px;\n}\n\n.hw-info--tooltip svg {\n  color: var(--hw-brand-orange);\n  width: 2rem;\n  height: 2rem;\n}\n\n.hw-info--hoverBox {\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);\n  padding: 1.6rem;\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n  position: absolute;\n  width: 100%;\n  min-width: 31.1rem;\n  bottom: calc(100% - 10px);\n  left: -3.7rem;\n  /* margin-bottom: 1.5rem; */\n  display: none;\n  z-index: 1;\n  border: 1px solid var(--hw-gray-600);\n}\n\n/* .hw-info--hoverBox::after {\n    content: '';\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='19' viewBox='0 0 21 19' fill='none'%3E%3Cpath d='M10.5 18.6211L20.8923 0.621094H0.107696L10.5 18.6211Z' fill='%23FEF4E7'/%3E%3C/svg%3E\");\n    position: absolute;\n    width: 2.1rem;\n    height: 1.9rem;\n    bottom: -1.5rem;\n    right: 48%;\n  } */\n.hw-info--hoverBox .list {\n  display: flex;\n  justify-content: space-between;\n  column-gap: .5rem;\n  font-weight: 500;\n  font-size: 1.4rem;\n  line-height: 1.71;\n}\n\n.hw-info--hoverBox .list>span:last-child:not(first-child) {\n  color: var(--hw-gray-800);\n  font-weight: normal;\n}\n\n.hw-info--hoverBox .list+.list {\n  margin-top: 0.4rem;\n}\n\n.hw-info--tooltip:hover .hw-info--hoverBox {\n  display: block;\n}\n\n.hw-info--hoverBox .list>span:last-child {\n  flex-shrink: 0;\n}\n\n.hw-line--pb {\n  padding: 0 1rem 1rem;\n  border-bottom: .1rem solid var(--hw-black);\n}\n\n.hw-tab--textCombine {\n  display: flex;\n  justify-content: space-between;\n}\n\n.hw-tab--textCombineText {\n  background-color: var(--hw-gray-100);\n  /* border-bottom: .2rem solid var(--hw-gray-400); */\n  padding: .4rem 1rem;\n  flex-shrink: 0;\n  width: 15rem;\n}\n\n.hw-table--border.first-td--fixed tbody>tr>td:first-child {\n  width: 15rem;\n}\n\n.hw-tab--textCombine .hw-nav--tab {\n  flex: 1 0 0;\n}\n\n.hw-p--gap6>p:not(:last-child) {\n  margin-bottom: .6rem;\n}\n\n.hw-p--gap6>p:last-child {\n  margin-bottom: 0;\n}\n\n.hw-noWrap {\n  white-space: nowrap;\n}\n\n.hw-fare--listPointItem {\n  font-size: 1.4rem;\n  line-height: 1.71429;\n}\n\n.hw-fare--listPointItem+.hw-fare--listPointItem {\n  margin-top: .6rem;\n}\n\n.hw-fare--listPointItem>span.flex-shrink--null {\n  min-width: 28rem;\n}\n\n/*Table*/\n.hw-table--normal {\n  border-collapse: collapse;\n}\n\n.hw-table--normal thead th,\n.hw-table--normal tbody td {\n  padding: .5rem .4rem;\n}\n\n.hw-table--normal tbody td {\n  color: var(--hw-black-900);\n  font-weight: 500;\n}\n\n.hw-table--normal tfoot th {\n  border-top: .1rem solid var(--hw-gray-600);\n  padding: 1.5rem .4rem .5rem;\n  font-size: 1.6rem;\n  line-height: 1.5;\n}\n\n.hw-table--normal thead tr th:first-child,\n.hw-table--normal tbody tr td:first-child,\n.hw-table--normal tfoot tr th:first-child {\n  padding-left: 0;\n}\n\n.hw-table--normal tbody tr:last-child td {\n  padding-bottom: 2rem;\n}\n\n.hw-table--normal th {\n  color: var(--hw-black-900);\n  font-weight: bold;\n}\n\n.hw-table--border {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.hw-table--border.lr-borderNull {\n  border: .1rem solid var(--hw-gray-600);\n  border-collapse: separate;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  overflow: hidden;\n  border-spacing: 0;\n}\n\n.hw-table--border.lr-borderNull th,\n.hw-table--border.lr-borderNull td {\n  border-left-width: 0;\n  border-right-width: 0;\n  border-top-width: 0;\n}\n\n.hw-table--border.lr-borderNull tbody>tr:last-child td {\n  border-bottom-width: 0;\n}\n\n.hw-table--border thead th {\n  font-weight: bold;\n  color: var(--hw-brand-blue);\n  background-color: rgba(215, 215, 215, 0.20);\n  padding: 1.2rem 2rem;\n  border: .1rem solid var(--hw-gray-600);\n}\n\n.hw-table--border tbody td {\n  border: .1rem solid var(--hw-gray-400);\n  padding: 1.2rem 2rem;\n  font-size: 1.4rem;\n  color: var(--hw-black-900);\n  font-weight: 500;\n}\n\n.hw-sticky--top {\n  position: sticky;\n  z-index: 2;\n  top: 0;\n}\n\n@media (min-width: 576px) {\n\n  .hw-table--normal thead th,\n  .hw-table--normal tbody td {\n    padding: .5rem 2rem;\n  }\n\n  .hw-table--normal tfoot th {\n    border-top: .1rem solid var(--hw-gray-600);\n    padding: 2rem 2rem .5rem;\n    font-size: 2rem;\n    line-height: 1.4;\n  }\n\n  .hw-nav--tabContent.hw-nav--tabContentRound .hw-search--innerflight__listItem .flight-list>div:not(.hw-flight--listBox__flight) {\n    width: 100%;\n  }\n}\n\n@media (min-width: 600px) {\n  .hw-table--border tbody td {\n    font-size: 1.6rem;\n    line-height: 1.75;\n  }\n}\n\n@media (min-width: 768px) {\n\n  .hw-table--border.xl-big tbody td,\n  .hw-table--border.xl-big thead th {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .hw-table--border.xl-big tbody td {\n    font-size: 1.6rem;\n    line-height: 1.75;\n  }\n}\n\n@media (min-width: 950px) {\n  .hw-info--hoverBox {\n    min-width: 55rem;\n  }\n}\n\n@media (max-width: 479px) {\n  .hw-nav--tabStyle1 .hw-nav-tabLink {\n    font-size: 1.2rem;\n    font-weight: 600;\n  }\n}\n\n/*End table*/\n\n@media (min-width: 768px) {\n  .hw-search--flightFilterResult__listItem {\n    /* padding: 2rem; */\n  }\n\n  .hw-nav--tabFlightDetails .hw-search--innerflight__list {\n    padding: 1.6rem;\n  }\n\n  /* @media (min-width: 990px) {\n    .hw-nav--tabFlightDetails .hw-search--innerflight__list {\n      padding: 2rem;\n    }\n  } */\n\n  /* .hw-search--innerflight__listItem {\n   padding: 1.6rem 2rem;\n} */\n  .hw-link {\n    font-size: 1.6rem;\n  }\n\n  .hw-search--flightFilterResult__tab {\n    /* margin-left: -2rem;\n    margin-right: -2rem;\n    padding: 1.6rem 2rem 0; */\n    margin-left: -1.6rem;\n    margin-right: -1.6rem;\n    padding: 1.6rem 1.6rem 0;\n  }\n\n  .hw-search--flightFilterResult__fareDetailsList {\n    padding: 2rem 2rem 0;\n    margin: 2rem -2rem 0;\n  }\n}\n\n@media (min-width: 901px) {\n  .hw-search--flightFilterResult {\n    padding-left: 2rem;\n  }\n\n  .hw-search--flightList {\n    height: 100%;\n    display: flex;\n    flex: 1;\n  }\n\n  .hw-search--flightFilter {\n    width: 32rem;\n    position: sticky;\n    min-width: 32rem;\n    max-width: 32rem;\n    margin-top: 2.4rem;\n    max-height: calc(100dvh - var(--flight-header-h, 18rem) - 3rem);\n    top: calc(var(--flight-header-h, 18rem) + 1.6rem);\n    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.3s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    /* overflow: hidden; */\n  }\n\n  .hw-widget--flight.hw-widget--flight__open.filter-visible~.hw-page--width .hw-search--flightFilter {\n    max-height: calc(100dvh - 7rem);\n    top: 7rem;\n  }\n\n  .hw-search--flightFilterResult {\n    width: calc(100% - 32rem);\n    flex-grow: 1;\n  }\n\n  .filter-collapsed .hw-search--flightFilterResult {\n    width: calc(100% - 7.4rem);\n  }\n\n  .hw-search--flightFilterResult,\n  .hw-search--flightListBottom {\n    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  .hw-search--flightListBottom {\n    width: calc(100% - 32rem);\n    margin-left: auto;\n  }\n\n  .hw-search--flightFilter__widget {\n    min-width: 28rem;\n  }\n\n  .hw-search--flightFilter__top {\n    position: sticky;\n    top: 0;\n    border-bottom: .1rem solid var(--hw-gray-400);\n    z-index: 1;\n  }\n\n  .filter-collapsed .hw-search--flightFilter {\n    width: 7.4rem;\n    min-width: 7.4rem;\n    max-width: 7.4rem;\n  }\n\n  .filter-collapsed .hw-search--flightListBottom {\n    width: 100%;\n  }\n\n  .filter-collapsed .hw-search--flightFilter__bodyBox {\n    opacity: 0;\n    pointer-events: none;\n    transform: translateX(-15px);\n    max-height: 0;\n    overflow: hidden;\n  }\n\n  .filter-collapsed .hw-search--flightFilter__body {\n    opacity: 0;\n    pointer-events: none;\n    transform: translateX(-15px);\n  }\n\n  .filter-collapsed .hw-search--flightFilter__action {\n    padding: 1.2rem 0.6rem;\n    justify-content: center;\n  }\n\n  .filter-collapsed .hw-search--flightFilter__action .hw-link {\n    opacity: 0;\n    pointer-events: none;\n    width: 0;\n    padding: 0;\n    margin: 0;\n    overflow: hidden;\n    position: absolute;\n    transform: translateX(-10px);\n  }\n\n  .filter-collapsed .js-toggleFilter {\n    background-color: var(--hw-brand-orange);\n    color: var(--hw-white);\n    flex-direction: column;\n    font-size: 1.4rem;\n    font-weight: 500;\n    width: 100%;\n    padding: 1rem 0.5rem;\n    border-radius: 0.4rem;\n    cursor: pointer;\n    justify-content: center;\n    text-align: center;\n  }\n}\n\n@media (min-width: 1025px) {\n  .hw-search--flightFilter {\n    top: calc(var(--flight-header-h, 18rem) + 1.6rem);\n    max-height: calc(100dvh - var(--flight-header-h, 18rem) - 3rem);\n  }\n}\n\n@media (min-width: 1200px) {\n  .hw-tab--textCombineText {\n    width: 25.2rem;\n  }\n\n  .hw-table--border.first-td--fixed tbody>tr>td:first-child {\n    width: 25.2rem;\n  }\n}\n\n@media (min-width: 1400px) {\n  .hw-flight--listBox {\n    column-gap: 6rem;\n  }\n\n  .hw-gapy50--xxl {\n    column-gap: 5rem !important;\n  }\n\n  .hw-search--innerflight__listItem {\n    column-gap: 4rem;\n  }\n\n  .divider-badge {\n    column-gap: 2rem;\n  }\n}\n\n@media (min-width: 1440px) {\n\n  /* .hw-search--flightList {\n      background-color: var(--hw-brand-orange-light);\n    }\n    .hw-search--flightList > .hw-search--flightFilter + .hw-search--flightFilterResult {\n      max-width: 103rem;\n    } */\n  .hw-search--flightList>.hw-search--flightFilter {\n    background-color: var(--hw-white);\n  }\n}\n\n@media (max-width: 1239px) {\n  .hw-expire--session__bookingConfirmed>.d-flex {\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n}\n\n@media (max-width: 1199px) {\n  .hw-tab--textCombine .hw-nav--tab {\n    flex-direction: column;\n  }\n\n  .hw-nav-tabLink {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    font-size: 1.4rem;\n    line-height: 1.71429;\n  }\n}\n\n@media (max-width: 1100px) {\n  .hw-flight--listBox {\n    column-gap: 1rem;\n    flex-wrap: wrap;\n    row-gap: 1rem;\n  }\n\n  .hw-flight--listBox .destination {\n    gap: 1rem;\n    flex: 1 1 100%;\n    width: 100%;\n  }\n\n  .hw-search--innerflight__listItem {\n    flex-direction: column;\n    align-items: flex-start;\n    column-gap: 0;\n    row-gap: .5rem;\n  }\n}\n\n@media (max-width: 900px) {\n  .hw-flight--listBox .hw-text20 {\n    font-size: 1.8rem;\n  }\n\n  .hw-flight--listBox .hw-text18 {\n    font-size: 1.6rem;\n    line-height: 1.5;\n  }\n\n  .hw-btn--mdSize {\n    font-size: 1.4rem;\n    line-height: 1.5;\n    padding: .8rem 1.6rem;\n    border-radius: .4rem;\n  }\n\n  .hw-search--flightFilterResult {\n    padding-bottom: 7rem;\n  }\n\n  .hw-search--flightFilter__top {\n    position: fixed;\n    border-top: .1rem solid var(--hw-gray-400);\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: auto;\n    z-index: 11112;\n  }\n\n  .sidebar-collapsed .hw-search--flightFilter__top {\n    left: 26rem;\n  }\n\n  .hw-search--flightFilter__bodyBox {\n    position: fixed;\n    width: 100%;\n    height: calc(100dvh + -5rem);\n    background-color: rgba(0, 0, 0, 0.6);\n    top: 0;\n    z-index: 111111;\n    left: 0;\n    right: 0;\n    transition: opacity 0.3s ease-in-out;\n  }\n\n  .hw-search--flightFilter__body {\n\n    height: calc(100dvh + -5rem);\n    background: var(--hw-white);\n    overflow-y: auto;\n    width: 30rem;\n    left: -31rem;\n    position: relative;\n    transition: transform 0.3s ease-in-out;\n  }\n\n  /* .hw-hotel--asideFilter .hw-search--flightFilter__body {\n    background: var(--hw-gray-100);\n  } */\n\n  body:not(.filter-collapsed) .hw-search--flightFilter__bodyBox {\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  /* .filter-collapsed .hw-search--flightFilter__bodyBox {\n    display: block;\n  } */\n  .filter-collapsed .hw-search--flightFilter__body {\n    transform: translateX(31rem);\n  }\n\n  .filter-collapsed .hw-search--flightFilter__top {\n    left: 0;\n  }\n\n  .sidebar-collapsed .hw-search--flightFilter__top {\n    left: 0;\n  }\n\n  body:not(.filter-collapsed) .hw-search--flightFilter__action .hw-link {\n    display: none;\n  }\n\n  body:not(.filter-collapsed) .js-toggleFilter {\n    background-color: var(--hw-brand-orange);\n    color: var(--hw-white);\n    /* flex-direction: column; */\n    /* font-size: 1.4rem; */\n    /* font-weight: 500; */\n    width: 100%;\n    cursor: pointer;\n  }\n\n  .body:not(.filter-collapsed) .hw-search--flightFilter__top {\n    border-top-color: var(--hw-brand-orange);\n  }\n\n  .hw-search--destinationRow>div:not(:last-child) {\n    border-bottom: .1rem solid var(--hw-gray-400);\n    padding-bottom: .25rem;\n    padding-top: .25rem;\n    border-right-width: 0;\n  }\n\n  .row.hw-search--destinationRow>div {\n    width: 100%;\n    flex: 1 1 100%;\n    min-width: 34rem;\n  }\n\n  .row.hw-search--destinationRow>div:last-child {\n    padding-top: 1rem;\n  }\n\n  .row.hw-search--destinationRow>div:last-child .hw-btn {\n    width: 100%;\n  }\n\n  .hw-search--destinationRow>.hw-search-scroller {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 767px) {\n  .hw-search--flightFilter__top {\n    left: 0 !important;\n  }\n\n  .hw-info--hoverBox {\n    left: -3.2rem;\n    min-width: 27.1rem;\n  }\n\n  .hw-info--hoverBox .list {\n    font-size: 1.2rem;\n    line-height: 1.5;\n  }\n\n}\n\n@media (max-width: 575px) {\n  .divider-badge {\n    column-gap: .5rem;\n    font-size: 1.2rem;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .hw-search--innerflight__listItem .flight-list>div {\n    width: 100%;\n  }\n\n  .hw-flight--listBox .hw-text20 {\n    font-size: 1.6rem;\n  }\n\n  .hw-flight--listBox .hw-text18 {\n    font-size: 1.4rem;\n    line-height: 1.5;\n  }\n\n  .hw-flight--listBox .hw-text14 {\n    font-size: 1.2rem;\n    line-height: 1.5;\n  }\n\n  .hw-table--border tbody td,\n  .hw-table--border thead th {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .hw-table--responsive table th,\n  .hw-table--responsive table td {\n    white-space: nowrap;\n  }\n\n  .hw-search--flightFilterResult__fareDetailsList .hw-fare--listPoint .hw-fare--listPointItem span.flex-shrink--null {\n    min-width: auto;\n    flex: 1 0 0;\n  }\n}\n\n@media (max-width: 479px) {\n  .hw-nav-tabLink {\n    padding-left: .5rem;\n    padding-right: .5rem;\n    font-size: 1.2rem;\n    line-height: 1.5;\n  }\n\n  .hw-search--flightFilterResult__tab .hw-nav--tabContent .hw-text18 {\n    font-size: 1.6rem;\n  }\n}\n\n/*End page*/\n/*Passenger page*/\n.hw-search--visible-next-list .hw-btn {\n  padding: .8rem;\n  border-radius: 99.9rem;\n}\n\n.hw-passenger--fareSummary__tbodyRowMain {\n  cursor: pointer;\n}\n\n.hw-inner--fullWidth>div>div {\n  width: 100%;\n}\n\n.hw-inner--fullWidth.HwSelect-ErrorState {\n  border: 1px solid red;\n  border-radius: 1rem;\n  padding: .8rem;\n  margin-left: .8rem;\n}\n\n.hw-passenger--fareShowToggleContent .react-datepicker-wrapper {\n  width: 100%;\n}\n\n.hw-flight--stepsWrapper {\n  /* position: sticky;\n  top: 0;\n  z-index: 1; */\n\n  background-color: var(--hw-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);\n}\n\n.hw-flight--steps {\n  overflow: hidden;\n  display: grid;\n}\n\n.hw-passenger--pageList {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  /*\n  flex: 1 0 0; */\n}\n\n@media (max-width: 1024px) {\n  .hw-passenger--pageList {\n    display: block;\n  }\n}\n\n.lm-icon--grid {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  column-gap: 1rem;\n  align-items: center;\n}\n\n.lm-i {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  width: 3.2rem;\n  height: 3.2rem;\n  border-radius: 10rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.8rem;\n  line-height: 1.55556;\n}\n\n/* .hw-step.active .lm-i  {\n  background-color: var(--hw-brand-blue);\n  color: var(--hw-white);\n} */\n/* .hw-step.complete .lm-i {\n  background-color: var(--hw-green);\n  color: var(--hw-white);\n} */\n.hw-step.complete .lm-i {\n  --hw-form-check-bg-image: url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2718%27 height=%2719%27 viewBox=%270 0 18 19%27 fill=%27none%27%3E%3Cpath d=%27M15.4983 4.18945C15.8079 4.46464 15.8358 4.93869 15.5606 5.24828L7.56056 14.2483C7.41824 14.4084 7.21424 14.5 7.00001 14.5C6.78578 14.5 6.58178 14.4084 6.43945 14.2483L2.43945 9.74828C2.16426 9.43869 2.19215 8.96464 2.50174 8.68945C2.81132 8.41426 3.28538 8.44215 3.56056 8.75173L7.00001 12.6211L14.4395 4.25174C14.7146 3.94215 15.1887 3.91426 15.4983 4.18945Z%27 fill=%27%23ffffff%27/%3E%3C/svg%3E\");\n  border-color: var(--hw-brand-orange);\n  background-image: var(--hw-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  font-size: 0;\n  background-size: 2.4rem 2.4rem;\n}\n\n.hw-step.complete .hw-black {\n  color: var(--hw-green) !important;\n}\n\n.lm-i svg {\n  width: 2.8rem;\n  height: 2.8rem;\n}\n\n.hw-flight--steps .row {\n  --bs-gutter-x: 2rem;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n}\n\n.hw-step {\n  display: flex;\n  align-items: center;\n  /* column-gap: var(--bs-gutter-x); */\n  margin-top: 1.2rem;\n  margin-bottom: 1.2rem;\n}\n\n.hw-step .lm-icon--grid {\n  white-space: nowrap;\n}\n\n.hw-flight--steps .row>.hw-step:not(:last-child)::after {\n  content: '';\n  background-color: var(--hw-gray-400);\n  height: .2rem;\n  min-width: 10rem;\n  display: inline-flex;\n  flex: 1;\n}\n\n/* .hw-flight--steps .row > .hw-step.complete::after {\n  background-color: var(--hw-green);\n} */\n/* .hw-expire--session {\n  border-top: 1px solid var(--hw-gray-600);\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n} */\n.hw-passenger--wrapper {\n  display: grid;\n  grid-template-columns: 1fr;\n  padding-top: 4.1rem;\n}\n\n.hw-passenger--list {\n  display: flex;\n  flex-direction: column;\n  row-gap: 2rem;\n}\n\n.hw-passenger--fareSummary {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n}\n\n.hw-after--bookingWidget {\n  background-color: var(--hw-white);\n  padding: 2.4rem;\n  border-radius: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  row-gap: 1.2rem;\n}\n\n.hw-after--bookingWidget+.hw-after--bookingWidget {\n  margin-top: 2rem;\n}\n\n.hw-passenger--head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.hw-passenger--head .hw-link {\n  flex-shrink: 0;\n}\n\n.hw-passenger--fareSummary__thead,\n.hw-passenger--fareSummary__tbodyTR,\n.hw-passenger--fareSummary__tfoot {\n  display: flex;\n  justify-content: space-between;\n  column-gap: .5rem;\n}\n\n.hw-passenger--fareSummary__tfoot {\n  border-top: 1px solid var(--hw-gray-600);\n  padding-top: 2rem;\n  /* margin-top: 2rem !important; */\n}\n\n.hw-passenger--fareSummary__tfoot > span,\n.hw-passenger--fareSummary__tfoot > .d-flex > span {\n  font-size: 1.8rem;\n}\n\n.hw-passenger--fareSummary__tbodyRowInner .hw-passenger--fareSummary__tbodyTR {\n  padding-top: .4rem;\n  padding-bottom: .4rem;\n}\n\n.hw-apply--coupenField {\n  display: flex;\n  column-gap: 1.2rem;\n}\n\n/* .hw-apply--coupenField input {\n  width: 50%;\n} */\n\n.hw-apply--coupenField .hw-btn {\n  min-width: 11.3rem;\n}\n\n.hw-passenger--listShow__widget .hw-search--innerflight__listItem {\n  /* flex-direction: column;\n  align-items: flex-start; */\n  /* display: block; */\n  flex-direction: column;\n  align-items: stretch;\n  row-gap: .8rem;\n}\n\n.hw-single--lineDivider {\n  background-color: var(--hw-gray-800);\n  width: .1rem;\n  margin: auto 1rem;\n  height: 2rem;\n}\n\n.hw-badge--time {\n  font-size: 1.6rem;\n  line-height: 1.75;\n  background-color: var(--hw-brand-orange-light);\n  padding: .2rem .8rem;\n  text-align: center;\n  color: var(--hw-black);\n  border-radius: .6rem;\n}\n\n.hw-badge--time strong {\n  font-weight: bold;\n}\n\n.hw-content--container {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.hw-passenger--fareSummary__box {\n  padding: 1.5rem;\n}\n\n.hw-select--payment {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.2rem;\n}\n\n.hw-radio--inline {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.6rem;\n}\n\n.hw-radio--item {\n  display: inline-flex;\n  align-items: center;\n  column-gap: 1rem;\n}\n\n.hw-radio--item label {\n  font-weight: 500;\n  color: var(--hw-black);\n}\n\n.hw-term--condition {\n  display: flex;\n  flex-direction: column;\n  row-gap: 2rem;\n}\n\n.hw-term--conditionInput {\n  display: flex;\n  align-items: center;\n  column-gap: .4rem;\n}\n\n.hw-term--conditionInput label {\n  font-size: 1.4rem;\n  line-height: 1.71429;\n  display: inline-flex;\n  flex-wrap: wrap;\n  column-gap: .4rem;\n  font-weight: 500;\n}\n\n.hw-link--line {\n  color: var(--hw-brand-orange);\n  text-decoration: underline;\n}\n\n.hw-link--line:hover {\n  color: var(--hw-brand-blue);\n}\n\n.hw-passenger--listShow {\n  display: flex;\n  flex-direction: column;\n  row-gap: 2rem;\n  column-gap: 0;\n}\n\n.hw-passenger--listShow__widget {\n  padding: 1.5rem;\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n}\n\n.hw-flight--placeTime {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.hw-baggage--line {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: flex-start;\n  row-gap: .6rem;\n}\n\n.hw-passenger--fareShow__widget {\n  background-color: var(--hw-white);\n  border: .1rem solid rgba(0, 0, 0, 0);\n  border-radius: 0.5rem;\n}\n\n.hw-passenger--fareShowToggle {\n  padding: 1.2rem 2rem;\n  cursor: pointer;\n}\n\n.hw-passenger--fareShowToggle svg {\n  width: 2.4rem;\n  height: 2.4rem;\n}\n\n.hw-passenger--fareShowToggleContent {\n  padding: 1.6rem;\n  /*border-top: .1rem solid var(--hw-gray-600);*/\n}\n\n/* .hw-passenger--detailsGroupItem .hw-passenger--fareShowToggle {\n  background-color: var(--hw-gray-300);\n  border-radius: 1rem;\n} */\n.hw-passenger--detailsGroup {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  row-gap: 2.4rem;\n  margin-top: 2.4rem;\n}\n\n.hw-add--bagagge {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  row-gap: 1.6rem;\n}\n\n.hw-add--bagagge+.hw-add--bagagge {\n  margin-top: 3.2rem;\n}\n\n.hw-passenger--detailsGroupItem .hw-passenger--fareShowToggleContent {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  row-gap: 1.6rem;\n}\n\n.hw-passenger--detailsGroupItem.fare-toggle-parent.active .hw-passenger--fareShowToggle {\n  border-bottom: 1px solid var(--hw-gray-600);\n}\n\n.hw-passenger--detailsGroupItem {\n  border: 1px solid var(--hw-gray-600);\n  border-radius: 0.5rem;\n}\n\n.hw-gst--checkboxWrapper input:not(:checked)~.hw-gst--checkboxWrapperBox {\n  opacity: 0;\n  pointer-events: none;\n  display: none;\n}\n\n.hw-gst--checkboxWrapper {\n  position: relative;\n  padding: 2rem 2rem 0;\n}\n\n.hw-gst--checkboxWrapper label {\n  color: var(--hw-black);\n  font-weight: 500;\n  font-size: 1.8rem;\n  line-height: 1.55556;\n  margin-left: 1rem;\n}\n\n.hw-gst--checkboxWrapperBox {\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);\n  background-color: var(--hw-white);\n  padding: 5rem 2rem 2rem;\n  border-radius: 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  row-gap: 2rem;\n  margin: -4.5rem -2rem 0;\n}\n\n.hw-widget--flight-close {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 2.4rem;\n  height: 2.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.hw-widget--flight-close button {\n  border: .1rem solid var(--hw-white);\n  background-color: rgba(0, 0, 0, 0);\n  outline: none;\n  color: var(--hw-white);\n  padding: 1.1rem;\n  border-radius: 1rem;\n  cursor: pointer;\n  transition: .2s ease;\n}\n\n.hw-widget--flight-close button:hover {\n  background-color: var(--hw-white);\n  color: var(--hw-brand-blue);\n}\n\n.hw-passenger--listShow__widget .hw-search--innerflight__listItem .flight-list .hw-flight--listBox__flight {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.hw-apply--coupenAdded {\n  display: flex;\n  justify-content: space-between;\n  column-gap: .5rem;\n  border: .1rem dashed var(--hw-brand-orange);\n  background-color: var(--hw-brand-orange-light);\n  border-radius: 1rem;\n  padding: 1rem 2rem;\n  min-height: 5.8rem;\n  align-items: center;\n}\n\n.hw-table--defaultDiv {\n  margin-top: 2rem;\n}\n\n.hw-table--default {\n  border-collapse: collapse;\n}\n\n.hw-table--defaultDiv table {\n  width: 100%;\n  border: .1rem solid var(--hw-gray-400);\n  border-collapse: separate;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  overflow: hidden;\n  border-spacing: 0;\n}\n\n.hw-table--default thead th {\n  background-color: rgba(215, 215, 215, 0.20);\n  font-weight: bold;\n  color: var(--hw-black-900);\n}\n\n.hw-table--default th,\n.hw-table--default td {\n  padding: .5rem 1rem;\n}\n\n.hw-table--default td {\n  font-size: 1.4rem;\n  line-height: 1.71429;\n}\n\n.hw-passenger--details-meal-details>.hw-table--lList+.hw-table--lList {\n  margin-top: 1rem;\n}\n\n.hw-table--defaultDiv table thead th,\n.hw-table--defaultDiv table tbody tr:not(:last-child) td {\n  border-bottom: .1rem solid var(--hw-gray-400);\n}\n\n.hw-contact--badge {\n  border-radius: 0.5rem;\n  background: var(--hw-white);\n  padding: 2.4rem;\n  overflow: hidden;\n}\n\n.hw-contact--badgeHead {\n  font-size: 2rem;\n  line-height: 1.4;\n  font-weight: bold;\n  color: var(--hw-black-900);\n}\n\n.hw-contact--badgeBody {\n  padding-top: 2rem;\n}\n\n.hw-passenger--listShow__widgetContact .row {\n  row-gap: 1.5rem;\n}\n\n.hw-table--lList>div+div {\n  margin-top: 1rem;\n}\n\n/* .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__thead,.hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tbody,.hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tfoot {\n  background-color: var(--hw-gray-300);\n  border-radius: 1rem;\n} */\n.hw-passenger--fareSummary__tfoot span {\n  font-size: 1.8rem;\n}\n\n.hw-passenger--fareShowToggle .icon-chevronDown,\n.hw-passenger--fareShowToggle .icon-chevronUp {\n  color: var(--hw-brand-blue);\n}\n\n/*Modal*/\n.hw-modal {\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-border-radius: 1rem;\n  --bs-modal-width: 50rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10000;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.hw-modal.show {\n  display: block;\n}\n\n.fade {\n  transition: opacity .15s linear;\n}\n\n.hw-modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n\n.warning-modal-dialog {\n  max-width: 460px !important;\n  align-items: center;\n  gap: 24px;\n}\n\n.warning-modal-title {\n  color: var(--Violet, #121826);\n  font-family: Poppins;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.warning-body p {\n  color: var(--hw-gray-800);\n  font-family: \"DM Sans\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  /* 150% */\n}\n\n@media (max-width: 479px) {\n  .warning-modal-dialog {\n    max-width: 100% !important;\n  }\n}\n\n.hw-modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.hw-modal.fade .hw-modal-dialog {\n  transition: transform .3s ease-out;\n  transform: translate(0, -50px);\n}\n\n.hw-modal.show .hw-modal-dialog {\n  transform: none;\n}\n\n.hw-modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.hw-modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: var(--hw-white);\n  background-clip: padding-box;\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.hw-modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n\n.hw-modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.hw-modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: 1.6rem 1.6rem 1rem;\n  column-gap: 1rem;\n  background-color: var(--hw-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.10);\n}\n\n.warning-modal-header {\n  box-shadow: none;\n  padding: 1rem !important;\n}\n\n.warning-modal-body {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-inline: 3rem;\n  padding-block: 2rem;\n}\n\n.warning-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem;\n  /* justify-content: center; */\n  /* align-items: center; */\n\n}\n\n.hw-modal-headerTitle {\n  color: var(--hw-brand-blue);\n  font-size: 2rem;\n  line-height: 1.5;\n  font-weight: 600;\n  margin-bottom: 0;\n  display: inline-flex;\n  align-items: center;\n  column-gap: 0.8rem;\n}\n\n.warning-modal--close {\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  height: 2.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  outline: none;\n}\n\n.hw-modal--close {\n  color: var(--hw-gray-800);\n  border: none;\n  outline: none;\n  background: rgba(0, 0, 0, 0);\n  padding: .4rem;\n  margin-left: auto;\n  border-radius: .4rem;\n  transition: .2s ease-out;\n  cursor: pointer;\n}\n\n.hw-modal--close:hover {\n  color: var(--hw-gray-800);\n  background-color: var(--hw-gray-100);\n}\n\n.hw-modal-body {\n  padding: 1.2rem 1.6rem 1.6rem 1.6rem;\n}\n\n.hw-modal-dialog-scrollable .hw-modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.hw-modal-dialog-scrollable .hw-modal-body {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--hw-gray-200) var(--hw-gray-100);\n}\n\n.hw--online-stripe-payment-popup .hw-modal-header {\n  box-shadow: none;\n  /* padding: 2.5rem 3rem 0; */\n}\n\n.hw--online-stripe-payment-popup .hw-modal-body {\n  padding: 1rem 3.2rem 4rem 3.2rem;\n}\n\n.hw--online-stripe-payment-popup label.hw-fontWeight--500 {\n  font-weight: normal !important;\n}\n\n@media (min-width: 576px) {\n  .hw-modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-width: 90%;\n  }\n\n  .hw-modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .hw--online-stripe-payment-popup {\n    max-width: 50rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .hw--online-stripe-payment-popup .hw-modal-headerTitle {\n    font-size: 3rem;\n    line-height: 1.5;\n  }\n}\n\n/* Payment popup enhancements */\n.hw-payment--container {\n  row-gap: 1.2rem;\n}\n\n.hw-label {\n  color: var(--hw-gray-800);\n}\n\n.hw-stripe-input {\n  border: 1px solid var(--hw-gray-400);\n  border-radius: .6rem;\n  padding: 1.2rem 1.2rem;\n  transition: border-color .2s ease, box-shadow .2s ease;\n  background-color: var(--hw-white);\n}\n\n.hw-stripe-input.is-error {\n  border-color: #d92d20;\n  box-shadow: 0 0 0 3px rgba(217, 45, 32, .08);\n}\n\n.hw-stripe-input:focus-within {\n  border-color: var(--hw-brand-blue);\n  box-shadow: 0 0 0 3px rgba(0, 82, 204, .1);\n}\n\n.hw-help-text {\n  color: var(--hw-gray-700);\n  font-size: 1.2rem;\n}\n\n.hw-payment--summary {\n  padding: 1.2rem 0 0.4rem;\n  border-top: 1px dashed var(--hw-gray-300);\n  margin-top: .4rem;\n}\n\n.hw-payment--actions {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n/* Centered loader for hotel gallery images */\n.hw-gallery-main-image,\n.hw-gallery-zoom-image {\n  position: relative;\n}\n\n.hw-gallery-image-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n@media (min-width: 768px) {\n  .hw-modal-headerTitle {\n    /* font-size: 2rem; */\n    font-size: 2.5rem;\n    line-height: 1.4;\n  }\n\n  .hw-modal-header {\n    padding: 3.2rem 3.2rem 2.4rem;\n  }\n\n  .hw-modal-body {\n    padding: 2.4rem 3.2rem 4rem 3.2rem;\n    ;\n  }\n\n  .hw-modal {\n    --bs-modal-border-radius: 0.5rem;\n  }\n\n  .hw-table--default th,\n  .hw-table--default td {\n    padding: 1rem 2rem;\n  }\n\n  .hw-table--default thead th {\n    font-size: 1.6rem;\n    line-height: 1.5;\n  }\n\n  .hw-step {\n    margin-top: 2.4rem;\n    margin-bottom: 2.4rem;\n  }\n}\n\n@media (min-width: 810px) {\n  .hw-modal .hw-modal--mediumSmall {\n    --bs-modal-width: 65rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .hw-modal {\n    --bs-modal-width: 97rem;\n  }\n\n  .hw-passenger--fareSummary__tfoot > span,\n  .hw-passenger--fareSummary__tfoot > .d-flex > span {\n    font-size: 2rem;\n  }\n}\n\n@media (min-width: 1080px) {\n  .hw-modal {\n    --bs-modal-width: 104.4rem;\n  }\n\n  .hw-modal .hw-modal--medium {\n    --bs-modal-width: 80rem;\n  }\n\n  .hw-modal .hw-modal--markupAmount {\n    --bs-modal-width: 55rem;\n  }\n\n  .hw-modal .hw-modal--sendEmail {\n    --bs-modal-width: 55rem;\n  }\n}\n\n@media (max-width: 479px) {\n  .hw-table--default .hw-text14 {\n    font-size: 1.2rem;\n    line-height: 1.5;\n  }\n\n  .hw-table--lList>div+div {\n    margin-top: .5rem;\n  }\n\n  .hw-table--lList svg {\n    width: 2rem;\n    height: 2rem;\n  }\n\n  .hw-table--lList {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .hw-table--lList .hw-gapy10 {\n    column-gap: .5rem !important;\n  }\n}\n\n.hw-row--input .css-yw323g-control:hover {\n  border-color: var(--hw-black);\n}\n\n/*End Modal*/\n.hw-unstyled {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n/*Date Picker*/\nbody .react-datepicker {\n  font-family: var(--hw-body-font-family);\n  font-size: 1.2rem;\n  border: 1px solid var(--hw-gray-600);\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n  padding: .5rem;\n}\n\nbody .react-datepicker__current-month,\nbody .react-datepicker-time__header,\nbody .react-datepicker-year-header {\n  font-size: 1.6rem;\n  font-family: inherit;\n  letter-spacing: 0 !important;\n  line-height: 1.75;\n  font-weight: bold;\n  color: var(--hw-brand-blue);\n}\n\nbody .react-datepicker__header {\n  border-radius: 0 !important;\n  border-bottom-color: var(--hw-gray-400);\n  padding: 0;\n  background-color: rgba(0, 0, 0, 0) !important;\n}\n\nbody .react-datepicker__day-names {\n  display: flex;\n  column-gap: .2rem;\n  margin-bottom: 0;\n  margin-top: .2rem;\n}\n\n.hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {\n  /* transform: translate(235.833px, 78.3333px) !important; */\n  transform: translate(235.833px, 63.3333px) !important;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle {\n  display: none !important;\n}\n\nbody .react-datepicker__day-name {\n  width: auto;\n  height: auto;\n  color: var(--hw-gray-700);\n  font-weight: 500;\n  font-size: 1.2rem;\n  line-height: 1.5;\n  padding: .4rem;\n  margin: 0;\n  min-height: 2.7rem;\n}\n\nbody .react-datepicker__month {\n  margin: .8rem 0 0 0;\n}\n\nbody .react-datepicker__week {\n  display: flex;\n  column-gap: .5rem;\n}\n\n.react-datepicker__week+.react-datepicker__week {\n  /* margin-top: 0.8rem; */\n  margin-top: 0.4rem;\n}\n\nbody .react-datepicker__day {\n  margin: 0;\n  flex: 1 0 0;\n  min-height: 2.7rem;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: .4rem;\n  width: auto;\n  height: auto;\n  font-weight: 500;\n}\n\n.react-datepicker .react-datepicker__navigation {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cg clip-path='url(%23clip0_2109_14175)'%3E%3Cpath d='M14.25 9H3.75' stroke='%233264FF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M14.25 9L9.75 13.5' stroke='%233264FF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M14.25 9L9.75 4.5' stroke='%233264FF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2109_14175'%3E%3Crect width='18' height='18' fill='white' transform='matrix(-1 0 0 1 18 0)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n  background-size: 1.8rem 1.8rem;\n  background-repeat: no-repeat;\n  background-position: center center;\n  width: 3rem;\n  height: 3rem;\n  top: 1.6rem;\n  border-radius: 0.5rem;\n  background-color: rgba(50, 100, 255, 0.10);\n}\n\n.react-datepicker .react-datepicker__navigation>* {\n  visibility: hidden;\n  opacity: 0;\n}\n\n.react-datepicker .react-datepicker__navigation--next {\n  right: 1rem;\n}\n\n.react-datepicker .react-datepicker__navigation--previous {\n  left: 1rem;\n  transform: scaleX(-1);\n}\n\n.react-datepicker__day.react-datepicker__day--outside-month {\n  background-color: rgba(0, 0, 0, 0) !important;\n  cursor: default;\n  color: var(--hw-gray-400);\n}\n\n.react-datepicker__day:not([aria-disabled=\"true\"]):hover {\n  background-color: var(--hw-brand-orange-light);\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  background-color: var(--hw-brand-orange) !important;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background-color: var(--hw-brand-orange) !important;\n  color: var(--hw-white) !important;\n}\n\n/* body .react-datepicker__day--in-selecting-range {\n  background-color: var(--hw-brand-blue-light) !important;\n} */\n/* body .react-datepicker__day {\n    color: var(--hw-black-900);\n  } */\n.react-datepicker__month-container+.react-datepicker__month-container {\n  margin-left: 1rem;\n}\n\n@media (min-width: 768px) {\n  .react-datepicker__month-container+.react-datepicker__month-container {\n    margin-left: 2rem;\n  }\n\n  body .react-datepicker {\n    font-size: 1.4rem;\n    padding: 1.6rem;\n  }\n\n  body .react-datepicker__day {\n    min-height: 3.7rem;\n  }\n\n  body .react-datepicker__day-name {\n    font-size: 1.4rem;\n\n\n  }\n\n  body .react-datepicker__day-names {\n    column-gap: .5rem;\n    margin-top: .5rem;\n  }\n}\n\n@media (min-width: 900px) {\n\n  body .react-datepicker__day-name {\n    min-width: 3rem;\n    min-height: 3rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  body .react-datepicker {\n    font-size: 1.6rem;\n\n  }\n\n  body .react-datepicker__day {\n    min-height: 4.7rem;\n  }\n\n  body .react-datepicker__day-name {\n    padding: .4rem 1rem;\n  }\n}\n\n@media (min-width: 1025px) {\n  .react-datepicker__month-container+.react-datepicker__month-container {\n    margin-left: 3.2rem;\n  }\n\n  body .react-datepicker__day-names {\n    column-gap: 1rem;\n    margin-top: 1rem;\n  }\n\n  body .react-datepicker__day-name {\n    min-width: 4.3rem;\n    height: 3.2rem;\n  }\n}\n\n@media (max-width : 1099px) and (min-width : 1025px) {\n  .hw-hotes-module.hw-hotel--widget .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {\n    transform: translate(0, 130px) !important;\n  }\n}\n\n@media (max-width : 1075px) {\n  .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {\n    transform: translate(182.833px, 65.3333px) !important;\n  }\n}\n\n@media (max-width : 1024px) {\n  .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {\n    /* transform: translate(-47px, 158.3333px) !important; */\n    transform: translate(0px, 130px) !important;\n  }\n}\n\n@media (max-width : 767px) {\n  .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {\n    transform: translate(0px, 200px) !important;\n  }\n\n  .hw-hotes-module.hw-hotel--widget .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {\n    transform: translate(0px, 130px) !important;\n  }\n}\n\n@media (max-width : 600px) {\n  .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {\n    /* transform: translate(47px, 158.3333px) !important; */\n    transform: translate(0px, 195px) !important;\n  }\n}\n\n@media (max-width : 439px) {\n  .hw-hotes-module.hw-hotel--widget .hw-date-range-picker+.react-datepicker__tab-loop .react-datepicker-popper {\n    transform: translate(0px, 194px) !important;\n  }\n}\n\n/*End date picker*/\n.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--list {\n  border-right-color: rgba(0, 0, 0, 0);\n}\n\n.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary {\n  background-color: var(--hw-brand-orange-light);\n}\n\n.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary .hw-passenger--fareSummary__box {\n  padding-top: 0;\n}\n\n.hw-passenger--pageList.loader>* {\n  opacity: .4;\n}\n\n.hw-passenger--pageList.loader {\n  position: relative;\n  height: 100%;\n  overflow: hidden;\n}\n\n.hw-main--loaderM {\n  position: relative;\n  height: calc(100dvh - 11rem);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.hw-main--loaderCommon {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 10rem;\n  width: 100%;\n}\n\n.hw-passenger--pageList.loader::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -30px;\n  margin-left: -30px;\n  width: 4rem;\n  height: 4rem;\n  border-radius: 4rem;\n  border: .5rem solid var(--hw-brand-orange-light);\n  border-top-color: var(--hw-brand-orange);\n  animation: loading 2s linear infinite;\n}\n\n.hw-main--loaderM::after,\n.hw-main--loaderCommon::after {\n  content: '';\n  position: absolute;\n  width: 3rem;\n  height: 3rem;\n  border-radius: 3rem;\n  border: .4rem solid var(--hw-brand-orange-light);\n  border-top-color: var(--hw-brand-orange);\n  animation: loading 2s linear infinite;\n  inset: 0;\n  margin: auto;\n}\n\n.hw-list--circleSmall {\n  padding-left: 2rem;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.hw-list--circleSmall li {\n  font-size: 1.4rem;\n  line-height: 1.71429;\n}\n\n.hw-btn--tabLink {\n  background-color: var(--hw-white);\n  border: none;\n  outline: none;\n  font-weight: 500;\n  color: var(--hw-black-900);\n}\n\n.hw-btn.hw-btn--tabLink.active {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n}\n\n@keyframes loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.hw-passenger--fareSummary .hw-passenger--head {\n  border-bottom: 1px solid var(--hw-gray-600);\n}\n\n.hw-passenger--fareSummary__table>*+* {\n  margin-top: 1.6rem;\n}\n\n.hw-passenger--fareSummary__tbody>.hw-passenger--fareSummary__tbodyRowMain+.hw-passenger--fareSummary__tbodyRowMain {\n  margin-top: 1.6rem;\n}\n\n.hw-passenger--fareSummary__tbodyTR svg {\n  color: var(--hw-brand-orange);\n  width: 2rem;\n  height: 2rem;\n}\n\n@media (min-width: 768px) {\n\n  .hw-widget--flight-close {\n    right: 3.2rem;\n    top: 3.2rem;\n    width: 5rem;\n    height: 5rem;\n  }\n\n  .hw-passenger--listShow__widget .hw-search--innerflight__listItem {\n    row-gap: 1.6rem;\n  }\n\n  .hw-baggage--line {\n    grid-template-columns: auto 1fr auto;\n  }\n\n}\n\n@media (min-width: 1025px) {\n  .hw-lg--onlyIcon {\n    display: none !important;\n  }\n\n  .hw-passenger--wrapper {\n    grid-template-columns: 1fr 450px;\n    align-items: flex-start;\n    column-gap: 2rem;\n  }\n\n  .hw-passenger--fareSummary {\n    position: sticky;\n    /* top: 11.2rem; */\n    top: 2.4rem;\n    -webkit-position: sticky;\n  }\n\n  .hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary {\n    top: 2rem;\n  }\n\n  .hw-passenger--list {\n    display: grid;\n    grid-template-rows: auto 1fr;\n    height: 100%;\n    overflow-y: auto;\n  }\n\n  .hw-flight--listBox .destination {\n    gap: 2.4rem;\n  }\n\n  .hw-flight--listBox__flight {\n    max-width: 39.2rem;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1239px) {\n\n  .hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary {\n    top: 3rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .hw-passenger--listShow__widgetContact .row {\n    --bs-gutter-x: 2rem;\n  }\n\n  .hw-passenger--listShow__widget .hw-search--innerflight__listItem .flight-list .hw-flight--listBox__flight {\n    min-width: clamp(20%, 20%, 40%);\n  }\n\n  .hw-flight--placeTime {\n    min-width: 20.4rem;\n    max-width: 20.4rem;\n  }\n\n  .hw-flight--splaceTime {\n    min-width: 30.4rem;\n    margin-left: -10.4rem;\n    max-width: 30rem;\n    text-align: right;\n\n  }\n\n  .hw-xltext--right {\n    text-align: right !important;\n  }\n\n  .hw-flight--aplaceTime {\n    min-width: 30.4rem;\n    margin-right: -10.4rem;\n    max-width: 30rem;\n    text-align: left;\n  }\n}\n\n@media (min-width: 1400px) {\n  .hw-passenger--wrapper {\n    grid-template-columns: 1fr 450px;\n  }\n}\n\n@media (max-width: 1199px) {\n  .hw-passenger--listShow .flight-list {\n    flex-wrap: wrap;\n    column-gap: 0;\n    row-gap: 1rem;\n  }\n\n  .hw-passenger--listShow .flight-list>* {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1024px) {\n\n  /* .hw-passenger--fareSummary {\n     background-color: var(--hw-white);\n    position: sticky;\n    bottom: 0;\n    max-height: 40vh;\n    overflow-y: auto;\n    display: grid;\n    grid-template-rows: auto 1fr;\n    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);\n  } */\n  .hw-lg--onlyIcon {\n    color: var(--hw-black);\n  }\n\n  /* .hw-passenger--fareSummary > .hw-passenger--head:not(.active) {\n    border-bottom-color: rgba(0,0,0,0);\n  }\n\n    .hw-passenger--fareSummary > .hw-passenger--head:not(.active) + .hw-passenger--fareSummary__box {\n    padding-top: 0;\n  }\n  .hw-passenger--fareSummary > .hw-passenger--head:not(.active) + .hw-passenger--fareSummary__box .hw-passenger--fareSummary__table {\n  display: none;\n}\n.hw-passenger--fareSummary > .hw-passenger--head:not(.active) + .hw-passenger--fareSummary__box .mt-6 {\n  margin-top: 0 !important;\n}\n.hw-passenger--fareSummary > .hw-passenger--head.active + .hw-passenger--fareSummary__box .mt-6 {\n  margin-top: 1.5rem !important;\n} */\n  /* .hw-passenger--fareSummary .hw-passenger--head {\n    position: sticky;\n    top: 0;\n    background-color: var(--hw-white);\n    z-index: 1;\n  } */\n}\n\n@media (max-width: 767px) {\n  .hw-baggage--line .hw-link {\n    grid-row: 1;\n    grid-column: 2;\n  }\n\n  .hw-baggage--line>div.d-flex {\n    grid-column: span 2;\n  }\n\n  .hw-passenger--detailsGroupItem .hw-passenger--fareShowToggleContent .row,\n  .hw-passenger--wrapper .hw-passenger--listShow__widget .row {\n    row-gap: 2rem;\n  }\n}\n\n@media (max-width: 599px) {\n  .hw-passenger--listShow__widget .hw-search--innerflight__listItem .hw-text18 {\n    font-size: 1.6rem;\n    line-height: 1.5;\n  }\n\n  .hw-twoLine--iconFilter .hw-twoLine--icon {\n    width: 100%;\n    grid-template-columns: auto 1fr;\n  }\n\n  .hw-xstext16 {\n    font-size: 1.6rem !important;\n  }\n}\n\n/*End passenger page*/\n/* @media (min-width: 1301px) {\n    .hw-input--switchGroup {\n       width: 52%;\n    }\n    .hw-filter--actionBtn {\n       width: 24%;\n    max-width: 36.6rem;\n    }\n} */\n/* @media (min-width: 992px) and (max-width: 1300px) {\n    .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst .hw-input--switchGroup {\n        width: calc(67% - .4rem * 1 / 2);\n      }\n      .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst .react-datepicker-wrapper {\n        width: calc(33% - .4rem * 1 / 2);\n        max-width: calc(33% - .4rem * 1 / 2);\n      }\n\n} */\n\n@media (min-width: 1025px) {\n  .hw-input--switchGroup {\n    width: 52%;\n  }\n\n  .hw-filter--actionBtn {\n    width: 24%;\n    max-width: 36.6rem;\n    padding-left: 1.2rem;\n  }\n\n  .hw-row--inputFirst .react-datepicker-wrapper {\n\n    padding-left: 1.2rem;\n  }\n\n  .hw-row--input.hw-row--inputFirst>.hw-input--input {\n    margin-left: 1.2rem;\n    width: calc(24% - 1.2rem);\n  }\n}\n\n@media (max-width: 1024px) {\n  .hw-input--switchGroup {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .hw-row--inputFirst .react-datepicker-wrapper,\n  .hw-row--input.hw-row--inputFirst>.hw-input--input {\n    width: calc(50% - 1.2rem * 1 / 2);\n    max-width: calc(50% - 1.2rem * 1 / 2);\n  }\n\n  /* .hw-input--multicityGroup .hw-row--inputFirst + .hw-row--inputFirst .react-datepicker-wrapper {\n        width: 100%;\n        max-width: 100%;\n    } */\n  .hw-row--input.hw-row--inputFirst {\n    row-gap: 1.2rem;\n    column-gap: 1.2rem;\n  }\n\n  .hw-row--input.hw-row--inputFirst>.hw-input--input {\n    margin-left: 0;\n  }\n\n}\n\n@media (min-width: 1025px) and (max-width: 1239px) {\n  .hw-input--switchGroup {\n    width: 46%;\n  }\n\n  .hw-row--inputFirst .react-datepicker-wrapper {\n    width: 27%;\n  }\n\n  .hw-filter--actionBtn {\n    width: 27%;\n  }\n\n  .hw-row--input.hw-row--inputFirst>.hw-input--input {\n    width: calc(27% - 1.2rem);\n  }\n\n  .hw-filter--actionBtn .hw-btn.hw-btn--secondaryOutline {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    flex-grow: 1;\n  }\n}\n\n@media (max-width: 1300px) {\n  .hw-filter--actionBtn .hw-btn {\n    justify-content: center;\n  }\n\n  .hw-filter--actionBtn .hw-btn.hw-btn--secondary {\n    flex: 1 1 auto;\n    width: 100%;\n  }\n\n\n\n}\n\n@media (min-width: 480px) {\n  .hw-content--container {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  .hw-passenger--listShow__widget {\n    padding: 2rem;\n  }\n}\n\n\n@media (min-width: 768px) {\n  .hw-passenger--listShow__widget {\n    padding: 2.4rem;\n  }\n\n  .hw-btn svg {\n    width: 2.4rem;\n    height: 2.4rem;\n  }\n\n  .hw-btn {\n    font-size: 1.6rem;\n    line-height: 1.75;\n  }\n\n  .hw-filter--searchBtn svg {\n    width: 2rem;\n    height: 2rem;\n  }\n\n  /* .hw-filter--actionBtn .hw-btn {\n        min-height: 6.8rem;\n      } */\n  .hw-widget--card {\n    padding: 3.2rem;\n  }\n\n  .hw-tab {\n    column-gap: 1rem;\n    /* margin-bottom: 2.4rem; */\n  }\n\n  .hw-input--input {\n    padding: .5rem 2rem;\n    column-gap: 1rem;\n  }\n\n  .hw-input--input,\n  .hw-row--input .css-1u80x8j-control,\n  .hw-input--switchGroup>div>div {\n    min-height: 5.4rem;\n  }\n\n  /* body:not(.sidebar-collapsed) .hw-app--main {\n        margin-left: 9rem;\n    }\n\n    .hw-app--main {\n        margin-left: 26rem;\n        transition: margin-left .2s ease;\n    } */\n  .hw-filter--searchBtn {\n    min-height: 5.4rem;\n    font-size: 1.6rem;\n    /* min-width: 6.8rem; */\n  }\n\n  .hw-flight--lists {\n    padding: 1.2rem 2rem;\n  }\n\n  /* .hw-input--multicityGroup {\n    row-gap: 2.4rem;\n  } */\n\n  /* .hw-row--inputCheck {\n    margin-top: 2.4rem;\n  } */\n}\n\n\n@media (min-width: 992px) {\n  .hw-header--menu {\n    margin: 0;\n    flex: 1;\n    column-gap: 4rem;\n    justify-content: center;\n  }\n\n  .hw-flight--steps .row {\n    --bs-gutter-x: 2.4rem;\n  }\n\n  .lm-i svg {\n    width: 3.2rem;\n    height: 3.2rem;\n  }\n\n  .hw-content--container {\n    padding-right: 4rem;\n  }\n\n  .hw-passenger--fareSummary__box {\n    padding: 1.6rem 2.4rem 2.4rem;\n  }\n\n  .hw-passenger--fareSummary .hw-passenger--head {\n    padding: 2.4rem 2.4rem 1.6rem 2.4rem;\n  }\n}\n\n@media (min-width: 1240px) {\n\n  .hw-input--input,\n  .hw-row--input .css-1u80x8j-control,\n  .hw-input--switchGroup>div>div,\n  .hw-filter--searchBtn {\n    /* min-height: 7.6rem; */\n    min-height: 5.4rem;\n  }\n}\n\n@media (max-width: 991px) {\n  .hw-header--menu {\n    display: none !important;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  /* .hw-logo img {\n        max-width: 14rem;\n        max-height: 4.9rem;\n    } */\n  .hw-input--switchGroup {\n    flex-direction: column;\n    row-gap: .2rem;\n  }\n\n  .hw-input--switchGroup>div {\n    width: 100%;\n  }\n\n  .hw-input--switchGroup .hw-switch {\n    margin: -1.2rem 0;\n  }\n\n  .hw-input--switchGroup .hw-switch svg {\n    transform: rotate(90deg);\n  }\n\n  .hw-row--input.hw-row--inputFirst>.hw-input--input .hw-text14 {\n    font-size: 1.2rem;\n    line-height: 1.5rem;\n  }\n\n  .lm-icon--grid .hw-text14 {\n    font-size: 1.2rem;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width: 640px) {\n  .hw-input--groupCol {\n    grid-template-columns: 1fr;\n    column-gap: 0;\n    row-gap: 1rem;\n  }\n\n  .hw-row--inputCheck {\n    margin-top: 2rem;\n    margin-bottom: 1rem;\n  }\n}\n\n@media (max-width: 575px) {\n  .header-nav .nav-item.dropdown>.nav-link {\n    padding: .5rem;\n  }\n\n  .nav-profile span,\n  .nav-profile .hw-nav--icon {\n    display: none !important;\n  }\n\n  .nav-profile {\n    border-radius: 50% !important;\n  }\n\n  .hw-tab {\n    flex-direction: column;\n  }\n\n  .hw-widget.hw-widget--flight .hw-tab {\n    flex-direction: row;\n  }\n\n  .hw-row--input.hw-row--inputFirst>.hw-input--input,\n  .hw-row--inputFirst .react-datepicker-wrapper {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .hw-input--input svg {\n    width: 2rem;\n    height: 2rem;\n  }\n\n  .react-datepicker-wrapper .hw-text14,\n  .hw-input--input .hw-text14 {\n    font-size: 1.2rem;\n    line-height: 1.5;\n  }\n\n  .hw-calender--removeBtn svg {\n    width: 1.6rem;\n    height: 1.6rem;\n  }\n\n  .hw-input--input .grid-rowspan2 span.hw-text--hidden {\n    line-height: 1.5;\n  }\n\n}\n\n@media (max-width: 479px) {\n  .hw-passenger--listShow__widget .hw-text20 {\n    font-size: 1.6rem;\n  }\n\n  .hw-passenger--listShow__widget .hw-text18,\n  .hw-passenger--listShow__widget .hw-badge--time,\n  .hw-table--normal tfoot th {\n    font-size: 1.4rem;\n  }\n\n  .xs-text12,\n  .hw-nav--tabFareDetails .hw-table--normal tbody td {\n    font-size: 1.2rem;\n  }\n\n}\n\n\n\n\n\n.lds-ellipsis {\n  /* change color here */\n  color: var(--hw-black)\n}\n\n.lds-ellipsis,\n.lds-ellipsis div {\n  box-sizing: border-box;\n}\n\n.lds-ellipsis {\n  display: inline-block;\n  position: relative;\n  width: 3rem;\n  height: 3rem;\n}\n\n.lds-ellipsis div {\n  position: absolute;\n  top: 1.2rem;\n  width: .5rem;\n  height: .5rem;\n  border-radius: 50%;\n  background: currentColor;\n  animation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n\n.lds-ellipsis div:nth-child(1) {\n  left: .2rem;\n  animation: lds-ellipsis1 0.6s infinite;\n}\n\n.lds-ellipsis div:nth-child(2) {\n  left: .8rem;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n\n.lds-ellipsis div:nth-child(3) {\n  left: 1.6rem;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n\n.lds-ellipsis div:nth-child(4) {\n  left: 2.4rem;\n  animation: lds-ellipsis3 0.6s infinite;\n}\n\n@keyframes lds-ellipsis1 {\n  0% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes lds-ellipsis3 {\n  0% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n@keyframes lds-ellipsis2 {\n  0% {\n    transform: translate(0, 0);\n  }\n\n  100% {\n    transform: translate(10px, 0);\n  }\n}\n\n\n.hw-search--innerflight__list>.hw-search--visible-next-list~li.hw-search--innerflight__divider:last-child {\n  display: none;\n}\n\n.hw-p-error-cls {\n  color: var(--hw-red);\n  font-size: 1.4rem;\n}\n\n.hw--error-cls-date-input {\n  border: 1px solid red;\n}\n\n/*Round trip css*/\n/*\n.hw-passenger--details-meal-details > .hw-table--lList:not(:last-child) + .hw-table--lList {\n    display: none;\n}\n*/\n\n.hw-hotes-module .hw-row--inputFirst .react-datepicker-wrapper {\n  width: 34%;\n  padding-left: .4rem;\n}\n\n.hw-hotes-module .room-row {\n  display: flex;\n  justify-content: space-between;\n}\n\n.hw-flight--listBoxInner {\n  flex: 1 1 auto\n}\n\n.hw-flight--listBoxInnerList+.hw-flight--listBoxInnerList {\n  margin-top: 1.6rem;\n  padding-top: 1.6rem;\n  border-top: 1px solid var(--hw-gray-600);\n}\n\n.hw-btn--white-button {\n  background-color: var(--hw-white);\n  border: .1rem solid rgba(0, 0, 0, 0);\n}\n\n.hw-btn--white-button:hover {\n  background: none;\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-btn--white-button:hover svg {\n  color: var(--hw-brand-orange);\n}\n\n.hw-search--flightFilterResult__top.d-flex {\n  justify-content: space-between;\n}\n\n.align-item-center {\n  align-items: center;\n}\n\n.hw-sticky--bottom {\n  position: sticky;\n  z-index: 1;\n  bottom: 0;\n}\n\n.mr-1 {\n  margin-right: 1rem !important;\n}\n\n.hw-sidebar-stops--btn {\n  display: flex;\n  margin-bottom: 1rem;\n  gap: 1rem\n}\n\n.hw-sidebar-stops--btn button {\n  padding: 0.2rem 1rem;\n}\n\n@media screen and (max-height: 800px) {\n  .hw-sidebar--nav .nav-link {\n    font-size: 1.4rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .hw-modal.error-modal {\n    --bs-modal-width: 60rem;\n  }\n}\n\n.hw-input--switchGroup>div:nth-of-type(2)>div {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cg clip-path='url(%23clip0_1252_2048)'%3E%3Cpath d='M14.429 11.7527L19.247 13.0907C19.5045 13.1569 19.7463 13.2738 19.9581 13.4345C20.17 13.5952 20.3476 13.7965 20.4807 14.0267C20.6138 14.2569 20.6997 14.5114 20.7333 14.7751C20.7669 15.0389 20.7475 15.3067 20.6764 15.5629C20.6052 15.8192 20.4837 16.0586 20.3189 16.2673C20.1541 16.476 19.9494 16.6497 19.7166 16.7783C19.4839 16.9069 19.2279 16.9878 18.9635 17.0163C18.6991 17.0448 18.4317 17.0203 18.1769 16.9442L3.72331 12.9315L2.43901 6.34717L5.32874 7.14981L6.72129 9.61207L9.61102 10.4147L9.55734 3.13496L12.4484 3.93725L14.429 11.7527Z' stroke='%230F294D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M3 21H21' stroke='%230F294D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1252_2048'%3E%3Crect width='24' height='24' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n}\n\n/*Round trip css*/\n.hw-search--flightScrollerTab {\n  overflow-x: auto;\n  /* padding-bottom: 1rem; */\n}\n\n.hw-search--roundTripBreadcrumbs {\n  display: flex;\n  column-gap: 0rem;\n  row-gap: 1rem;\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n  width: 100%;\n}\n\n\n.hw-search--roundTripBreadcrumbs .item {\n  position: relative;\n  background-color: var(--hw-white);\n  /* min-height: 5.4rem; */\n  min-height: 5rem;\n  padding-right: 1.5rem;\n  padding-left: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  white-space: nowrap;\n  flex-shrink: 0;\n  color: var(--hw-black-900);\n  min-width: 10rem;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 0.5rem;\n}\n\n/* .hw-search--roundTripBreadcrumbs > .item:first-child {\n  border-top-left-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n\n.hw-search--roundTripBreadcrumbs > .item:last-child {\n  border-top-right-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n} */\n\n.hw-search--roundTripBreadcrumbs .item div+div {\n  font-size: 1.4rem;\n  line-height: 1.71429;\n\n}\n\n.hw-search--roundTripBreadcrumbs .item:not(.active) div+div {\n  color: var(--hw-gray-500);\n}\n\n.hw-search--roundTripBreadcrumbs .item.active {\n  /* background-color: var(--hw-brand-orange); */\n  color: var(--hw-white);\n  background: linear-gradient(90deg, #3264FF 21.17%, #1846D6 82.33%);\n}\n\n.hw-search--roundTripBreadcrumbs .item:not(.active):hover {\n  background-color: var(--hw-brand-orange-light);\n}\n\n.hw-search--roundTripBreadcrumbs .item.active::after {\n  background: var(--hw-brand-orange);\n}\n\n@media (min-width: 600px) {\n  .hw-search--roundTripBreadcrumbs .item {\n    min-height: 5.8rem;\n    padding-right: 4rem;\n    padding-left: 4rem;\n    min-width: 22.5rem;\n  }\n}\n\n@media (max-width: 599px) {\n  .hw-search--roundTripBreadcrumbs .item {\n    flex-grow: 1;\n  }\n\n  .hw-search--roundTripBreadcrumbs .item div+div {\n    line-height: 1.5;\n  }\n}\n\n\n\n/*End round trip css*/\n/*after fixed round trip css*/\n/* .hw-nav--tabContentRound .hw-search--innerflight__list {\n  border: .1rem solid var(--hw-gray-600);\n  border-radius: 0.5rem;\n  background-color: var(--hw-white);\n} */\n/* .hw-nav--tabContentRound .hw-search--innerflight__list .hw-search--innerflight__listItem {\n  border: none;\n  border-radius: 0;\n  background-color: rgba(0,0,0,0)\n} */\n.hw-nav--tabContentRound .hw-search--innerflight__list .hw-search--innerflight__divider {\n  /* background-color: var(--hw-gray-100); */\n  padding-top: .9rem;\n  padding-bottom: .9rem;\n}\n\n/* .hw-nav--tabContentRound .hw-search--innerflight__list .hw-search--innerflight__divider > span {\nopacity: 0;\n} */\n.hw-nav--tabContentRound .hw-search--innerflight__list .hw-search--innerflight__divider svg {\n  color: var(--hw-brand-blue);\n  margin-right: .8rem;\n}\n\n.hw-nav--tabContentRound>.hw-nav--tabPane+.hw-nav--tabPane {\n  margin-top: 1.5rem;\n}\n\n.hw-hover--link {\n  cursor: pointer;\n}\n\n.hw-hover--link:hover {\n  color: var(--hw-brand-orange);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-hover--link.active {\n  color: var(--hw-black-900);\n  border-color: var(--hw-black-900);\n  cursor: default;\n}\n\n.hw-primary--text {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  font-size: 1.4rem;\n  border-radius: 1rem;\n  padding: 1rem;\n  line-height: 1.286;\n  font-weight: bold;\n}\n\n/* .hw-blue--grid.hw-search--flightListBottom  .row {\n  flex-wrap: nowrap;\n}\n.hw-blue--grid.hw-search--flightListBottom .col.col-scroll {\n  overflow-x: auto;\n} */\n.hw-search--destinationRow {}\n\n/* .hw-blue--grid.hw-search--flightListBottom {\n  padding-left: 2rem;\n  padding-right: 2rem;\n} */\n.hw-search--destinationRowMain {\n  display: flex;\n  flex-wrap: nowrap;\n  column-gap: 2rem;\n  justify-content: space-between;\n}\n\n.hw-search--destinationRowMain .col-scroll {\n  overflow: hidden;\n}\n\n.hw-search--destinationRowMain .row.hw-search--destinationRow {\n  flex-wrap: nowrap;\n  overflow-x: auto;\n}\n\n.hw-nav--tabPane.hw-nav--tabFareDetails table.hw-table--normal {\n  min-width: 80%;\n}\n\n.hw-table--withLightOutline {\n  border: 1px solid var(--hw-gray-600);\n  border-radius: 0.5rem;\n  padding: 1rem 1.6rem;\n  display: inline-block;\n}\n\n@media (max-width: 900px) {\n  .hw-search--flightListBottom.hw-sticky--bottom {\n    bottom: 5.6rem;\n  }\n\n  .hw-search--flightListBottom.hw-sticky--bottom .hw-search--destinationRow>div:not(:last-child) {\n    border-right-width: .1rem;\n    border-bottom-width: 0;\n  }\n}\n\n@media (max-width: 767px) {\n  .hw-search--flightListBottom.hw-sticky--bottom {\n    bottom: 5.3rem;\n  }\n}\n\n/*End after fixed round trip css*/\n\n.hw-before-loader--status::before {\n  content: \"\";\n  background-color: var(--hw-brand-orange);\n  position: absolute;\n  width: 0;\n  height: 10px;\n  left: 0;\n  top: 0;\n  /*transition: width .5s ease-in-out;*/\n  -webkit-animation: progress-in-out 60s linear forwards;\n  animation: progress-in-out 60s linear forwards;\n  animation-iteration-count: 1;\n}\n\n.hw-before-loader--status-half::before {\n  content: \"\";\n  background-color: var(--hw-brand-orange);\n  position: absolute;\n  width: 0;\n  height: 10px;\n  left: 0;\n  top: 0;\n  /*transition: width .5s ease-in-out;*/\n  -webkit-animation: progress-in-out-half 60s linear forwards;\n  animation: progress-in-out-half 60s linear forwards;\n  animation-iteration-count: 1;\n}\n\n\n.hw-before-loader--status {\n  position: absolute;\n  top: 0;\n  background-color: var(--hw-brand-orange-light);\n  background: linear-gradient(0deg, #E6EFFF 0%, #E6EFFF 100%), #015FFF;\n  left: 0;\n  z-index: 9;\n  min-height: 150px;\n  display: grid;\n  right: 0;\n  grid-template-rows: auto 1fr;\n  height: 100vh;\n  transition: left .2s ease-in-out;\n}\n\n.hw-before-loader--status-half {\n  position: absolute;\n  top: 0;\n  background: rgba(0, 0, 0, 0);\n  left: 0;\n  z-index: 9;\n  min-height: 10px;\n  display: grid;\n  right: 0;\n  grid-template-rows: auto 1fr;\n  height: 10px;\n  transition: left .2s ease-in-out;\n}\n\n.hw-loader--image {\n  display: flex;\n  justify-content: center;\n  padding: 5.6rem 2rem;\n}\n\n\n.hw-loader--text {\n  background-color: var(--hw-gray-100);\n  text-align: center;\n  padding: 2rem 2rem 2rem;\n  font-weight: bold;\n  color: var(--hw-black);\n  font-size: 1.6rem;\n}\n\n\n\n@media (min-width: 901px) {\n  .hw-loader--text {\n    font-size: 1.8rem;\n  }\n\n  .hw-before-loader--status,\n  .hw-before-loader--status-half {\n    left: 32rem;\n  }\n\n  .filter-collapsed .hw-before-loader--status,\n  .filter-collapsed .hw-before-loader--status-half {\n    left: 7.4rem;\n  }\n}\n\n@-webkit-keyframes progress-in-out {\n  0% {\n    width: 0;\n  }\n\n  16% {\n    width: 60%;\n  }\n\n  25% {\n    width: 70%;\n  }\n\n  50% {\n    width: 80%;\n  }\n\n  75% {\n    width: 90%;\n  }\n\n  100% {\n    width: 99%;\n  }\n}\n\n@keyframes progress-in-out {\n  0% {\n    width: 0;\n  }\n\n  16% {\n    width: 60%;\n  }\n\n  25% {\n    width: 70%;\n  }\n\n  50% {\n    width: 80%;\n  }\n\n  75% {\n    width: 90%;\n  }\n\n  100% {\n    width: 99%;\n  }\n}\n\n@-webkit-keyframes progress-in-out-half {\n  0% {\n    width: 60%;\n  }\n\n  16% {\n    width: 70%;\n  }\n\n  25% {\n    width: 73%;\n  }\n\n  50% {\n    width: 80%;\n  }\n\n  75% {\n    width: 90%;\n  }\n\n  100% {\n    width: 99%;\n  }\n}\n\n@keyframes progress-in-out-half {\n  0% {\n    width: 60%;\n  }\n\n  16% {\n    width: 70%;\n  }\n\n  25% {\n    width: 73%;\n  }\n\n  50% {\n    width: 80%;\n  }\n\n  75% {\n    width: 90%;\n  }\n\n  100% {\n    width: 99%;\n  }\n}\n\n\n.hw-search-scroller {\n  overflow-x: auto;\n  max-width: 40%;\n  scrollbar-width: thin;\n  scrollbar-color: var(--hw-gray-100) var(--hw-brand-blue);\n}\n\n.hw-search-scroller>div:not(:last-child) {\n  border-right: .1rem solid var(--hw-gray-400);\n  padding-right: 2rem;\n\n}\n\n.row.hw-search--destinationRow {\n  scrollbar-width: thin;\n  scrollbar-color: var(--hw-gray-400) var(--hw-brand-orange-light);\n}\n\n.hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .row.hw-search--destinationRow {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  scrollbar-color: var(--hw-gray-100) var(--hw-brand-blue);\n  line-height: 125%;\n}\n\n\n/* .hw-blue--grid.hw-search--destinationMultiCity {\n  overflow-x: hidden;\n} */\n/* .hw-search--flightScrollerTab {\n  overflow-x: auto;\n  padding-bottom: 1rem;\n  padding-top: 0;\n} */\n.hw-break--word {\n  word-break: break-word;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n@media (min-width: 901px) {\n  .hw-blue--grid.hw-search--destinationMultiCity {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .hw-blue--grid.hw-search--destinationMultiCity .hw-search--destinationRow>div {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n}\n\n@media (max-width: 900px) {\n\n  .hw-widget.hw-widget--flight.hw-widget--flight__open .hw-widget--card .hw-widget--flight-close {\n    right: 1.5rem;\n    top: 2.5rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .hw-flight--listBoxInner.hw-mlCity {\n    width: 100%;\n  }\n}\n\n/* @media (min-width: 480px) and (max-width: 991px) {\n  .hw-search--flightScrollerTab {\n    margin-right: -2rem;\n    margin-left: -2rem;\n  }\n} */\n\n@media (max-width: 479px) {\n  .hw-nav--tabPane.hw-nav--tabFareDetails table.hw-table--normal {\n    min-width: 100%;\n  }\n\n  .hw-search--priceTitleBar {\n    flex-direction: column;\n    row-gap: .4rem;\n    margin-bottom: .8rem;\n  }\n\n  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .hw-search--destinationRowMain {\n    column-gap: 1rem;\n  }\n\n  .hw-search--priceTitleBar .d-flex.hw-gapy50--xxl {\n    justify-content: space-between;\n  }\n\n  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .col-fix-right {\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-end !important;\n    row-gap: .5rem;\n  }\n\n  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .col-fix-right .hw-btn {\n    font-size: 1.2rem;\n    padding: .4rem;\n    min-width: 10rem;\n  }\n\n  .hw-search--flightScrollerTab {\n    margin-right: -1.5rem;\n    margin-left: -1.5rem;\n  }\n\n  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .row.hw-search--destinationRow .hw-dtr--mtext {\n    font-size: 1.2rem;\n    line-height: 1.25;\n  }\n\n  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .row.hw-search--destinationRow .hw-gapy10,\n  .hw-blue--grid.hw-search--flightListBottom.hw-sticky--bottom .row.hw-search--destinationRow .hw-gapy16 {\n    column-gap: .5rem !important;\n  }\n\n  .hw-xs--rowLayout {\n    flex-direction: column !important;\n    row-gap: .4rem;\n  }\n\n  .hw-xs--rowLayout>.d-flex {\n    justify-content: space-between;\n  }\n\n  .hw-xs--rowLayout+.hw-fare--listPoint {\n    margin-top: .8rem;\n  }\n}\n\n@media (max-width: 370px) {\n  .hw-header .hw-logo {\n    padding-left: 3rem;\n  }\n\n  .hw-logo img {\n    max-width: clamp(11rem, 36vw, 14rem);\n  }\n\n  .hw-header .nav-link.nav-profile img {\n    max-width: 4rem;\n    max-height: 4rem;\n  }\n}\n\n.hw--vendor-img img {\n  object-fit: cover;\n}\n\n/* Seat Map Style Starts */\n\n.hw-seatmap--selection-layout {\n  border-radius: 5px;\n  width: 100%;\n  background: #f7f8fa;\n}\n\n.hw-seatmap--seat-map-wrapper {\n  min-width: 0;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.hw-seatmap--aircraft {\n  width: 100%;\n  padding: 16px;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.hw-passenger-data {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  width: 100%;\n}\n\n.hw-passenger-header {\n  color: black;\n  font-size: 2rem;\n  line-height: 1.75;\n  font-weight: bold;\n}\n\n.hw-passenger-detail {\n  margin-top: 1rem;\n  display: flex;\n  gap: 1rem;\n  /* justify-content: space-between; */\n  /* padding: 5px 15px; */\n  /* margin-inline: 1rem; */\n  border-radius: 5px;\n}\n\n.hw-passenger-data {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-left: 1rem;\n}\n\n.hw-seatmap--confirm-price {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  font-size: 1.6rem;\n  align-items: flex-end;\n  /* font-weight: bold; */\n}\n\n.hw-seatmap--plane-fuselage {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  position: relative;\n  padding: 1rem;\n  background-color: #F5F7FF;\n}\n\n.hw-seatmap--fuselage-seats {\n  background: white;\n  box-shadow: none;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  /* border-radius: 10px; */\n}\n\n.hw-seatmap--row {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n  position: relative;\n}\n\n.hw-seatmap--row:last-child {\n  margin-bottom: 0;\n}\n\n.hw-seatmap--row::before {\n  content: attr(data-row-number);\n  position: absolute;\n  left: -30px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #424242;\n  font-family: \"roboto\";\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.hw-seatmap--seat-wrapper {\n  margin: 0 8px;\n  position: relative;\n}\n\n.hw-segment--data {\n  display: flex;\n  gap: 7px;\n}\n\n.dot-separator {\n  width: 5px;\n  height: 5px;\n  background-color: #999;\n  border-radius: 50%;\n  margin-top: .7rem;\n}\n\n.pipe-separator {\n  width: 2px;\n  height: 10px;\n  background-color: #999;\n  margin-top: .7rem;\n}\n\n@media only screen and (min-width: 980px) {\n  .hw-seatmap--seat-wrapper {\n    margin: 0 6px;\n  }\n}\n\n.hw-seatmap--seat-wrapper.hw-seatmap--extra-legroom .hw-seatmap--seat {\n  border-color: #00c446;\n  background-color: #ebffed;\n}\n\n.hw-seatmap--seat-wrapper.hw-seatmap--emergency-exit-row .hw-seatmap--seat {\n  border-color: #ff5736;\n  background-color: #ffde70;\n}\n\n.hw-seatmap--seat.hw-seatmap--occupied .hw-seatmap--seat-cross {\n  color: #283D6B;\n}\n\n.hw-seatmap--seat.hw-seatmap--selected .hw-seatmap--seat-cross {\n  color: #fff;\n  opacity: 0.7;\n}\n\n.hw-seatmap--seat {\n  width: 38px;\n  height: 38px;\n  /* border: 1px solid #8e9195; */\n  border: 2px solid blue;\n  background-color: #ffffff;\n  border-radius: 14px;\n  box-sizing: border-box;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.hw-seatmap--seat.hw-seatmap--not {\n  border-color: gray;\n  border-width: 1px;\n  background-color: #f5f5f5;\n}\n\n.hw-seatmap--seat.hw-seatmap--selected,\n.hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available,\n.hw-seatmap--seat.hw-seatmap--selected:hover {\n  border-color: #007bff;\n  border-width: 1px;\n}\n\n.hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip),\n.hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip):before,\n.hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip):after,\n.hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip),\n.hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip):before,\n.hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip):after,\n.hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip),\n.hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip):before,\n.hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip):after {\n  color: #007bff !important;\n}\n\n\n.hw-seatmap--seat.hw-seatmap--available {\n  border-color: rgb(68, 68, 237);\n  border-width: 1.5px;\n}\n\n.hw-seatmap--seat.hw-seatmap--available:not(.hw-seatmap--info-box) {\n  cursor: pointer;\n}\n\n.hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) {\n  background-color: rgba(0, 123, 255, 0.1);\n}\n\n.hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) .hw-seatmap--seat-number {\n  color: #ffffff;\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable {\n  border-color: #8e9195;\n  background-color: #f5f5f5;\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable::before,\n.hw-seatmap--seat.hw-seatmap--unavailable::after {\n  background-color: #8e9195;\n}\n\n.hw-seatmap--seat.hw-seatmap--occupied {\n  border-color: #283D6B;\n  background-color: #e8f2ff;\n}\n\n.hw-seatmap--seat.hw-seatmap--occupied::before,\n.hw-seatmap--seat.hw-seatmap--occupied::after {\n  background-color: #283D6B;\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable,\n.hw-seatmap--seat.hw-seatmap--occupied {\n  position: relative;\n  overflow: hidden;\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable::before,\n.hw-seatmap--seat.hw-seatmap--unavailable::after,\n.hw-seatmap--seat.hw-seatmap--occupied::before,\n.hw-seatmap--seat.hw-seatmap--occupied::after {\n  content: \"\";\n  position: absolute;\n  top: -52.5%;\n  width: 1px;\n  height: 56px;\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable::before,\n.hw-seatmap--seat.hw-seatmap--occupied::before {\n  transform: rotate(45deg);\n  right: calc(50% + 1px);\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable::after,\n.hw-seatmap--seat.hw-seatmap--occupied::after {\n  transform: rotate(-45deg);\n  left: calc(50% + 1px);\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable:not(.hw-seatmap--info-box),\n.hw-seatmap--seat.hw-seatmap--occupied:not(.hw-seatmap--info-box) {\n  cursor: not-allowed;\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable .hw-seatmap--seat-number,\n.hw-seatmap--seat.hw-seatmap--occupied .hw-seatmap--seat-number {\n  display: none;\n}\n\n@media only screen and (min-width: 612px) {\n  .hw-seatmap--seat {\n    width: 50px;\n    height: 50px;\n    border: 1px solid #8e9195;\n    background-color: #ffffff;\n    border-radius: 18px;\n    box-sizing: border-box;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--selected,\n  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available,\n  .hw-seatmap--seat.hw-seatmap--selected:hover {\n    border-color: #007bff;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip),\n  .hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip):before,\n  .hw-seatmap--seat.hw-seatmap--selected *:not(.hw-seatmap--tooltip):after,\n  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip),\n  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip):before,\n  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available *:not(.hw-seatmap--tooltip):after,\n  .hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip),\n  .hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip):before,\n  .hw-seatmap--seat.hw-seatmap--selected:hover *:not(.hw-seatmap--tooltip):after {\n    color: #ffffff !important;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--available {\n    border-color: #007bff;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--available:not(.hw-seatmap--info-box) {\n    cursor: pointer;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) {\n    background-color: #007bff;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) .hw-seatmap--seat-number {\n    color: #ffffff;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable {\n    border-color: #8e9195;\n    background-color: #f5f5f5;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable::before,\n  .hw-seatmap--seat.hw-seatmap--unavailable::after {\n    background-color: #8e9195;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--occupied {\n    border-color: #283D6B;\n    background-color: #e8f2ff;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--occupied::before,\n  .hw-seatmap--seat.hw-seatmap--occupied::after {\n    background-color: #283D6B;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable,\n  .hw-seatmap--seat.hw-seatmap--occupied {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable::before,\n  .hw-seatmap--seat.hw-seatmap--unavailable::after,\n  .hw-seatmap--seat.hw-seatmap--occupied::before,\n  .hw-seatmap--seat.hw-seatmap--occupied::after {\n    content: \"\";\n    position: absolute;\n    top: -52.5%;\n    width: 1px;\n    height: 84px;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable::before,\n  .hw-seatmap--seat.hw-seatmap--occupied::before {\n    transform: rotate(45deg);\n    right: calc(50% + 1px);\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable::after,\n  .hw-seatmap--seat.hw-seatmap--occupied::after {\n    transform: rotate(-45deg);\n    left: calc(50% + 1px);\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable:not(.hw-seatmap--info-box),\n  .hw-seatmap--seat.hw-seatmap--occupied:not(.hw-seatmap--info-box) {\n    cursor: not-allowed;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable .hw-seatmap--seat-number,\n  .hw-seatmap--seat.hw-seatmap--occupied .hw-seatmap--seat-number {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 980px) {\n  .hw-seatmap--seat {\n    width: 50px;\n    height: 50px;\n    border: 1.5px solid #8e9195;\n    /* background-color: #ffffff; */\n    background-color: rgba(68, 68, 237, 0.574);\n    border-radius: 16px;\n    box-sizing: border-box;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--selected,\n  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available,\n  .hw-seatmap--seat.hw-seatmap--selected:hover {\n    /* border-color:var(--hw-brand-blue); */\n    /* background-color: var(--hw-brand-blue) !important; */\n    border-color: #007bff;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--selected>*:not(.hw-seatmap--tooltip),\n  .hw-seatmap--seat.hw-seatmap--selected>*:not(.hw-seatmap--tooltip):before,\n  .hw-seatmap--seat.hw-seatmap--selected>*:not(.hw-seatmap--tooltip):after,\n  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available>*:not(.hw-seatmap--tooltip),\n  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available>*:not(.hw-seatmap--tooltip):before,\n  .hw-seatmap--seat.hw-seatmap--selected.hw-seatmap--available>*:not(.hw-seatmap--tooltip):after,\n  .hw-seatmap--seat.hw-seatmap--selected:hover>*:not(.hw-seatmap--tooltip),\n  .hw-seatmap--seat.hw-seatmap--selected:hover>*:not(.hw-seatmap--tooltip):before,\n  .hw-seatmap--seat.hw-seatmap--selected:hover>*:not(.hw-seatmap--tooltip):after {\n    color: #007bff !important;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--available {\n    /* border-color: var(--hw-brand-blue); */\n    border-color: #007bff;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--available:not(.hw-seatmap--info-box) {\n    cursor: pointer;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) {\n    /* background-color: var(--hw-brand-blue); */\n    background-color: rgba(0, 123, 255, 0.1);\n  }\n\n  .hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected, .hw-seatmap--info-box) .hw-seatmap--seat-number {\n    color: #007bff;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable {\n    border-color: #8e9195;\n    background-color: #f5f5f5;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable::before,\n  .hw-seatmap--seat.hw-seatmap--unavailable::after {\n    background-color: #8e9195;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--occupied {\n    border-color: var(--hw-brand-blue);\n    background-color: #e8f2ff;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--occupied::before,\n  .hw-seatmap--seat.hw-seatmap--occupied::after {\n    background-color: var(--hw-brand-blue);\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable,\n  .hw-seatmap--seat.hw-seatmap--occupied {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable::before,\n  .hw-seatmap--seat.hw-seatmap--unavailable::after,\n  .hw-seatmap--seat.hw-seatmap--occupied::before,\n  .hw-seatmap--seat.hw-seatmap--occupied::after {\n    content: \"\";\n    position: absolute;\n    top: -52.5%;\n    width: 1px;\n    height: 84px;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable::before,\n  .hw-seatmap--seat.hw-seatmap--occupied::before {\n    transform: rotate(45deg);\n    right: calc(50% + 1px);\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable::after,\n  .hw-seatmap--seat.hw-seatmap--occupied::after {\n    transform: rotate(-45deg);\n    left: calc(50% + 1px);\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable:not(.hw-seatmap--info-box),\n  .hw-seatmap--seat.hw-seatmap--occupied:not(.hw-seatmap--info-box) {\n    cursor: not-allowed;\n  }\n\n  .hw-seatmap--seat.hw-seatmap--unavailable .hw-seatmap--seat-number,\n  .hw-seatmap--seat.hw-seatmap--occupied .hw-seatmap--seat-number {\n    display: none;\n  }\n}\n\n.hw-seatmap--seat.hw-seatmap--extra-legroom {\n  border-color: #00c446;\n  background-color: #ebffed;\n}\n\n.hw-seatmap--seat.hw-seatmap--extra-legroom:hover:not(.hw-seatmap--selected, .hw-seatmap--unavailable, .hw-seatmap--occupied) {\n  background-color: #d0ffd4;\n  border-color: #00b054;\n}\n\n.hw-seatmap--seat.hw-seatmap--exit-row {\n  border-color: #ff5736;\n  background-color: #ffde70;\n}\n\n.hw-seatmap--seat.hw-seatmap--exit-row:hover:not(.hw-seatmap--selected, .hw-seatmap--unavailable, .hw-seatmap--occupied) {\n  background-color: #ffde70;\n  border-color: #f74433;\n}\n\n.hw-seatmap--seat.hw-seatmap--selected {\n  border-color: gray;\n  /* background-color: var(--hw-brand-blue); */\n  transform: scale(1.05);\n  /* box-shadow: 0 4px 12px rgba(33, 62, 148, 0.3); */\n}\n\n.hw-seatmap--seat.hw-seatmap--selected .hw-seatmap--seat-number {\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.hw-seatmap--seat.hw-seatmap--available {\n  /* border-color:var(--hw-brand-blue); */\n  background-color: #E5F2FF;\n  border-color: #007bff;\n}\n\n.hw-seatmap--seat.hw-seatmap--available-free {\n  background-color: #F1FDF5;\n  border-color: #28a745;\n}\n\n.hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected) {\n  /* background-color: var(--hw-brand-blue); */\n  background-color: rgba(0, 123, 255, 0.1);\n  transform: scale(1.02);\n  /* box-shadow: 0 2px 8px rgba(33, 62, 148, 0.2); */\n}\n\n.hw-seatmap--seat.hw-seatmap--available:hover:not(.hw-seatmap--selected) .hw-seatmap--seat-number {\n  color: #007bff;\n}\n\n.hw-seatmap--seat.hw-seatmap--available-free:hover:not(.hw-seatmap--selected) {\n  background-color: rgba(40, 167, 69, 0.1);\n  /* Green hover effect for free seats */\n  transform: scale(1.02);\n}\n\n.hw-seatmap--seat.hw-seatmap--available-free:hover:not(.hw-seatmap--selected) .hw-seatmap--seat-number {\n  color: #28a745;\n  /* Green text color on hover for free seats */\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable {\n  border-color: #8e9195;\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable::before,\n.hw-seatmap--seat.hw-seatmap--unavailable::after {\n  background-color: #8e9195;\n}\n\n.hw-seatmap--seat.hw-seatmap--unavailable .hw-seatmap--seat-number {\n  display: none;\n}\n\n.hw-seatmap--seat.hw-seatmap--occupied {\n  border-color: var(--hw-brand-blue);\n  background-color: #e8f2ff;\n  cursor: not-allowed;\n}\n\n.hw-seatmap--seat.hw-seatmap--occupied::before,\n.hw-seatmap--seat.hw-seatmap--occupied::after {\n  background-color: var(--hw-brand-blue);\n}\n\n.hw-seatmap--seat.hw-seatmap--occupied .hw-seatmap--seat-number {\n  display: none;\n}\n\n.hw-seatmap--seat-number {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  color: #007bff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: center;\n  transition: color 0.2s ease;\n}\n\n.hw-seatmap--seat.hw-seatmap--available-free .hw-seatmap--seat-number {\n  color: #28a745;\n}\n\n@media only screen and (min-width: 612px) {\n  .hw-seatmap--seat-number {\n    font-size: 1.1rem;\n  }\n}\n\n@media only screen and (min-width: 980px) {\n  .hw-seatmap--seat-number {\n    font-size: 1.5rem;\n  }\n}\n\n.hw-seatmap--seat-number div {\n  flex-grow: 0;\n  flex-shrink: 1;\n  flex-basis: auto;\n  align-self: auto;\n  min-width: 0;\n  min-height: auto;\n}\n\n@media only screen and (min-width: 612px) {\n  .hw-seatmap--row {\n    margin-bottom: 8px;\n  }\n\n  .hw-seatmap--seat-wrapper {\n    margin: 0 4px;\n  }\n}\n\n@media only screen and (min-width: 980px) {\n  .hw-seatmap--row {\n    margin-bottom: 12px;\n  }\n}\n\n@media (max-width: 900px) {\n  .filter-collapsed .hw--listing-buttons-container {\n    z-index: 10 !important;\n  }\n\n  .hw-seatmap--selection-layout {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .hw-seatmap--aircraft {\n    flex-direction: column !important;\n  }\n\n  .hw-passenger-data {\n    order: 1;\n    width: 100%;\n    position: relative;\n    margin-bottom: 1rem;\n  }\n\n  .hw-seatmap--plane-fuselage {\n    order: 2;\n    width: 100%;\n  }\n\n  .hw-seatmap--confirm-price {\n    align-items: flex-start;\n  }\n}\n\n@media only screen and (min-width: 980px) {\n  .hw-seatmap--aircraft {\n    padding: 24px;\n    box-shadow: none;\n  }\n}\n\n@media (max-width: 530px) {\n  .hw-seatmap--row {\n    margin-bottom: 0;\n  }\n\n  .hw-passenger-data {\n    position: relative;\n    margin-bottom: 1rem;\n  }\n\n  .hw-passenger-detail {\n    max-width: 100%;\n  }\n\n  .hw-seatmap--confirm-price {\n    align-items: flex-start;\n  }\n\n  .hw-seatmap--seat-wrapper {\n    margin: 0 2px;\n  }\n}\n\n@media (max-width : 350px) {\n  .hw-seatmap--seat {\n    width: 30px;\n    height: 30px;\n    border-radius: 10px;\n  }\n}\n\n.hw-seatmap--gap {\n  width: 20px;\n  min-width: 20px;\n  display: inline-block;\n  height: 40px;\n  border-radius: 8px;\n  /* margin: 0 8px; */\n}\n\n/* Exit row marker */\n.hw-seatmap--exit {\n  width: 100%;\n  text-align: center;\n  color: var(--hw-brand-orange);\n  ;\n  font-weight: bold;\n  padding: 4px 0 4px 0;\n  border-radius: 6px;\n  margin: 4px 0 4px 0;\n  letter-spacing: 2px;\n  font-size: 1.2rem;\n}\n\n.hw-seatmap--exit-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 16px 0 16px 0;\n  width: 100%;\n}\n\n.hw-seatmap--exit-label {\n  color: var(--hw-brand-orange);\n  ;\n  /* background: var(--hw-brand-orange); */\n  font-weight: 700;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 1.2rem;\n  letter-spacing: 2px;\n}\n\n.hw-seatmap--exit-space {\n  flex: 1;\n  height: 32px;\n  background: transparent;\n}\n\n.hw-seatmap--exit-vertical-line {\n  /* height: 24px;\n  width: 4px;\n  background-color: var(--hw-brand-orange); */\n  /* margin-left: 5px; */\n}\n\n.hw-seat-not-selected {\n  width: 40px;\n  height: 40px;\n  border: 1px solid #007bff;\n  border-radius: 14px;\n  background-color: rgba(0, 123, 255, 0.1);\n}\n\n.hw-seat-available-free {\n  width: 40px;\n  height: 40px;\n  border: 1px solid #28a745;\n  border-radius: 14px;\n  background-color: rgba(40, 167, 69, 0.1);\n}\n\n.hw-seat-extra-legroom {\n  width: 40px;\n  height: 40px;\n  border: 1px solid #8e9195;\n  border-radius: 14px;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.hw-seat-selected {\n  width: 40px;\n  height: 40px;\n  border-radius: 14px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #8e9195;\n  /* background-color: #f5f5f5; */\n}\n\n.hw-selected-passenger {\n  color: #007bff;\n}\n\n.hw-seatmap-legend {\n  border-top: 1px solid #eee;\n  padding: 16px 0 0 0;\n  background: #fff;\n  /* position: sticky; */\n  bottom: 0;\n  z-index: 10;\n  text-align: left;\n  display: flex;\n  gap: 1rem\n}\n\n.hw-seatmap--tooltip {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  bottom: 120%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #fffefe;\n  color: black !important;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  white-space: nowrap;\n  z-index: 100000;\n  transition: opacity 0.2s ease;\n  border: 1px solid rgb(50, 50, 50);\n}\n\n/* Arrow border */\n.hw-seatmap--tooltip::before {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 7px;\n  border-style: solid;\n  border-color: rgb(50, 50, 50) transparent transparent transparent;\n  /* border */\n}\n\n/* Arrow fill */\n.hw-seatmap--tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 6px;\n  border-style: solid;\n  border-color: #fffefe transparent transparent transparent;\n  /* background */\n}\n\n.hw-seatmap--seat:hover .hw-seatmap--tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n\n/*new css*/\n.pt-48 {\n  padding-top: 4.8rem;\n}\n\n.hw-box--gridWhite {\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n  padding: 1.6rem;\n}\n\n.hw-recent--viewed .hw-box--gridWhite {\n  padding-bottom: 1rem;\n  padding-right: 0;\n}\n\n.hw-light--badgeBlue {\n  display: inline-flex;\n  align-items: center;\n  column-gap: 0.8rem;\n  background-color: var(--hw-brand-orange-light);\n  color: var(--hw-brand-orange);\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  font-weight: bold;\n}\n\n.hw-light--badgesmall svg {\n  display: block;\n  width: 1.8rem;\n  height: 1.8rem;\n}\n\n.hw-light--badgesmall {\n  font-size: 1.2rem;\n  line-height: 1.33333;\n}\n\n.hw-recent--middleText {\n  column-gap: 0.8rem;\n}\n\n.hw-recent--innerList {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  row-gap: 0.6rem;\n}\n\n.hw-recent--middleIcon {\n  flex-grow: 1;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 15rem;\n  max-width: 19.4rem;\n}\n\n.hw-recent--middleText>span:not(.hw-recent--middleIcon) {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 10rem;\n}\n\n.hw-recent--middleIcon hr {\n  background: var(--hw-white);\n  border-width: 1px;\n  border-style: solid;\n  /* border-image: repeating-linear-gradient(45deg,rgba(var(--hw-brand-orange-rgb),0.5),rgba(var(--hw-brand-orange-rgb),0.5) 10px,transparent 6px,transparent 15px) 10; */\n  border-image: repeating-linear-gradient(45deg, rgba(var(--hw-brand-orange-rgb), 0.5), rgba(var(--hw-brand-orange-rgb), 0.5) 8px, transparent 2px, transparent 10px) 10;\n  position: absolute;\n  width: 100%;\n}\n\n.hw-recent--middleIcon .svg-wrapper {\n  line-height: 0;\n  border: 1px solid var(--hw-brand-orange);\n  background-color: var(--hw-white);\n  border-radius: 50%;\n  width: 3rem;\n  height: 3rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  color: var(--hw-brand-orange);\n}\n\n.hw-head--textWrap {\n  margin-bottom: 0.8rem;\n}\n\n.hw-head--textWrapMedium {\n  margin-bottom: 1rem;\n}\n\n.hw-head--textWrap .h3+* {\n  margin-top: 0.4rem;\n}\n\n.hw-head--textWrap>*:first-child,\n.hw-head--textWrap>*:last-child {\n  margin-bottom: 0;\n}\n\n.hw-flight--faq .hw-faq--item {\n  border-bottom: 1px solid #d7d7d7;\n}\n\n.hw-faq--item .hw-faq--title {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 1.6rem;\n  padding-bottom: 1.6rem;\n  color: var(--hw-black-900);\n  font-size: 1.6rem;\n  line-height: 1.5;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.hw-faq--desc {\n  padding: 0 0 1.6rem 0;\n}\n\n.hw-faq--desc a {\n  font-weight: 500;\n}\n\n.hw-flight--faq>.hw-faq--item:first-child .hw-faq--title {\n  padding-top: 0;\n}\n\n.hw-flight--faq>.hw-faq--item:last-child {\n  border-bottom-width: 0;\n}\n\n.hw-multiCity--field {\n  flex-grow: 1;\n  margin: 0 !important;\n}\n\n@media (min-width: 641px) {\n  .hw-box--gridWhite {\n    padding: 2.4rem;\n  }\n\n  .hw-head--textWrap .h3+* {\n    margin-top: 0.8rem;\n  }\n\n  .hw-head--textWrap {\n    margin-bottom: 1.6rem;\n  }\n}\n\n@media (min-width: 990px) {\n  .hw-head--textWrap {\n    margin-bottom: 3.2rem;\n  }\n\n  .hw-head--textWrapMedium {\n    margin-bottom: 2rem;\n  }\n\n  .hw-faq--item .hw-faq--title {\n    font-size: 1.8rem;\n    line-height: 1.55556;\n  }\n}\n\n@media (max-width: 749px) {\n\n  .hw-head--textWrap .h3,\n  .hw-box--gridWhite .h3 {\n    font-size: 2rem;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width: 640px) {\n  .hw-horizontal--card .mt-16 {\n    margin-top: 0.8rem !important;\n  }\n}\n\n/*Grid css*/\n.hw-vertical--grid,\n.hw-horizontal--grid {\n  display: grid;\n  gap: 1.2rem;\n}\n\n.hw-vertical--grid3 {\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  align-items: start;\n}\n\n.hw-horizontal--grid4 {\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  align-items: start;\n}\n\n.hw-vertical--card {\n  display: flex;\n  align-items: center;\n  column-gap: 1.6rem;\n}\n\n.hw-img--aspect1 {\n  position: relative;\n  overflow: hidden;\n  aspect-ratio: 1/1;\n}\n\n.hw-horizontal--card .hw-hover--scaleImg {\n  border-radius: 1rem;\n}\n\n.hw-img--aspect1 img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n  object-fit: cover;\n}\n\n.hw-hover--scaleImg img {\n  transition: transform 0.3s ease-out;\n  will-change: transform;\n}\n\n.hw-vertical--card .hw-img--aspect1 {\n  min-width: 7rem;\n  max-width: 7rem;\n  border-radius: 0.5rem;\n  flex-shrink: 0;\n}\n\n.hw-hover--scale:hover .hw-hover--scaleImg img {\n  transform: scale(1.12);\n  transform-origin: center center;\n}\n\n.hw-text--hiddenL {\n  overflow: hidden;\n}\n\n.hw-text--hiddenL svg {\n  display: block;\n  flex-shrink: 0;\n  margin-left: 0.4rem;\n  margin-right: 0.4rem;\n}\n\n.hw-vertical--card .hw-text--hidden {\n  width: max-content;\n}\n\n.hw-date--selectedDate {\n  font-weight: bold;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hw-wholeBox--link {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n  cursor: pointer;\n}\n\n.hw-icon--fixRight {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 1rem;\n}\n\n.hw-input--input.active .hw-icon--fixRight svg {\n  transform: scaleY(-1);\n}\n\n.hw-date-range-picker .hw-input--input {\n  padding-right: 3.5rem;\n}\n\n@media (min-width: 768px) {\n  .hw-icon--fixRight {\n    right: 2rem;\n  }\n}\n\n@media (min-width: 990px) {\n\n  .hw-vertical--grid,\n  .hw-horizontal--grid {\n    gap: 2.4rem;\n  }\n\n  .hw-horizontal--grid4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .hw-vertical--grid3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    align-items: start;\n  }\n\n  .hw-vertical--card .hw-img--aspect1 {\n    min-width: 10rem;\n    max-width: 10rem;\n  }\n}\n\n@media (max-width: 749px) {\n  .hw-vertical--grid .hw-text18 {\n    font-size: 1.6rem;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width: 640px) {\n  .hw-mobile--scroller {\n    display: flex;\n    overflow-x: auto;\n    margin-right: -1.6rem;\n    padding-right: 1.6rem;\n    margin-left: -1.6rem;\n    padding-left: 1.6rem;\n  }\n\n  .hw-mobile--scroller .hw-horizontal--card {\n    min-width: 220px;\n  }\n\n  .hw-flight--faq {\n    margin-top: 1.6rem;\n  }\n}\n\n/*End Grid css*/\n/*Header*/\n\n.hw-profile--dropdown .hw-header--dropdownProfile {\n  margin-top: 1rem !important;\n  right: 0 !important;\n  left: auto !important;\n  padding: 2rem;\n  z-index: 1001;\n}\n\n@media (min-width: 990px) {\n  .hw-profile--dropdown .hw-header--dropdownProfile {\n    margin-top: 2.4rem !important;\n  }\n\n  .hw-header--dropdownRight {\n    right: 0 !important;\n    left: auto !important;\n  }\n}\n\n/*End header*/\n/*Footer*/\n.hw-footer {\n  position: relative;\n  background-color: var(--hw-gray-100);\n  padding-top: 5rem;\n  padding-bottom: 0;\n  z-index: 10;\n}\n\n.hw-footer--wraper {\n  background-color: var(--hw-white);\n  padding: 2.4rem 0 1.2rem 0;\n}\n\n.hw-footer--copyRight {\n  border-top: .1rem solid var(--hw-gray-200);\n  margin-top: 1.2rem;\n  padding-top: 1.2rem;\n}\n\n.hw-footer--copyRight a {\n  color: inherit;\n  /* text-decoration: underline;\n    text-underline-offset: .2rem; */\n}\n\n.hw-footer--copyRight a:hover {\n  color: var(--hw-black);\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.hw-footer--social {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n\n.hw-footer__social-link {\n  display: block;\n  color: var(--social-color);\n  border: 0.1rem solid var(--social-color);\n  padding: 0.5rem;\n  border-radius: 10rem;\n  transition: 0.2s ease-out;\n}\n\n.hw-footer__social-link:hover {\n  background-color: var(--social-color);\n  color: var(--hw-white);\n  border-color: var(--social-color);\n}\n\n.hw-footer__social-link svg {\n  display: block;\n  width: 1.6rem;\n  height: 1.6rem;\n}\n\n.hw-footer--links {\n  justify-content: end;\n  display: flex;\n  gap: 2rem;\n  flex-wrap: wrap;\n  /* max-width: 70rem; */\n  max-width: 76rem;\n}\n\n.hw-footer--brandLogo {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.6rem;\n}\n\n.hw-footer--menuTitle {\n  color: var(--hw-black-900);\n  font-weight: bold;\n  margin-bottom: 0.8rem;\n}\n\n.hw-footer--linksItem a {\n  display: inline-block;\n  text-underline-offset: 0.5rem;\n  transition: text-decoration 0.3s ease-out;\n}\n\n.hw-footer--linksItem a:hover {\n  text-decoration: underline;\n}\n\n.hw-footer--linksItem li+li {\n  margin-top: 0.4rem;\n}\n\n.hw-box--textShow {\n  background-color: rgba(215, 215, 215, 0.20);\n  padding: 1.2rem;\n}\n\n.hw-paymentMethods {\n  column-gap: 0.5rem;\n}\n\n.hw-paymentMethods>div {\n  border-radius: 2px;\n  border: 0.5px solid rgba(50, 100, 255, 0.20);\n  background-color: var(--hw-white);\n  min-width: 4rem;\n  text-align: center;\n}\n\n@media (min-width: 750px) {\n  .hw-footer--links {\n    column-gap: 5rem;\n    width: 70%;\n  }\n\n  .hw-box--textShow {\n    padding: 1.6rem 2.4rem;\n  }\n\n  .hw-footer--brandLogo {\n    row-gap: 2.4rem;\n  }\n\n  .hw-footer--copyRight {\n    margin-top: 2.4rem;\n    padding-top: 2.4rem;\n  }\n}\n\n@media (min-width: 990px) {\n  .hw-footer--links {\n    column-gap: 6.5rem;\n  }\n\n  .hw-footer--wraper {\n    padding-top: 4.8rem;\n    padding-bottom: 2.4rem;\n  }\n\n  .hw-footer__social-link {\n    padding: 0.6rem;\n  }\n\n  .hw-footer__social-link svg {\n    width: 1.8rem;\n    height: 1.8rem;\n  }\n}\n\n@media (max-width: 749px) {\n  .hw-footer--brandInfo {\n    flex-direction: column;\n    row-gap: 2rem;\n  }\n\n  .hw-footer--links {\n    justify-content: space-between;\n  }\n}\n\n/*End footer*/\n/*End new css*/\n@media (max-width: 1024px) {\n  .hw-passenger--wrapper {\n    row-gap: 2.4rem;\n  }\n}\n\n@media (max-width: 989px) {\n  .sidebar-collapsed .hw-widget.hw-widget--flight.hw-widget--flight__open {\n    z-index: 99;\n  }\n}\n\n@media (max-width: 991px) {\n  .hw-passenger--fareSummary .hw-passenger--head {\n    padding: 1.6rem;\n  }\n}\n\n.hw-footer--links .column ul li a:hover {\n  cursor: pointer;\n}\n\n.hw-seatmap--seat-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 70%;\n}\n\n.d-block {\n  display: block;\n}\n\n.hw-hightlight-fare-rule-ai-summary {\n  border: 2px dashed rgba(50, 100, 255, 0.50);\n  padding: 2.4rem;\n  background-color: rgba(29, 78, 229, 0.03);\n  border-radius: 5px;\n}\n\n\n\n.hw--fare-rule-summary-ai-point li::marker {\n  color: var(--hw-blue-new);\n}\n\n.hw--fare-rule-summary-ai-point {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 0;\n  margin-left: -1rem;\n}\n\n.hw-notfound-container {\n  display: grid;\n  place-content: center;\n  height: 100vh;\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.hw-notfound-container img {\n  margin-inline: auto;\n  max-width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n.hw-notfound-container .hw-notfound-content {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  gap: 0.5rem;\n}\n\n@media (max-width: 768px) {\n  .hw-notfound-container {\n    padding: 2rem 1rem;\n  }\n\n  .hw-notfound-container img {\n    max-width: 70%;\n  }\n\n  .hw-notfound-container .hw-notfound-content {\n    text-align: center;\n    gap: 0.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .hw-notfound-container img {\n    max-width: 60%;\n  }\n\n  .hw-notfound-container {\n    padding: 3rem 1rem;\n  }\n}\n\n.hw-search-center {\n  width: 100%;\n  padding-left: 0 !important;\n}\n\n.hw-search-notavailabel {\n  padding-block: 5rem;\n}\n\n.hw-search--flightFilterResult.hw-search-center {\n  padding-top: 0.8rem;\n}\n\n.hw-search-notavailabel.hw-flight--ntavailable {\n  margin-top: 0;\n}\n\n.hw-search-notavailabel button {\n  margin-top: 2rem;\n}\n\n.hw-input--error-search .hw-input--switchGroup .hw-input--error-search.right {\n  left: 0;\n  right: auto;\n}\n\n@media (min-width: 767px) {\n  .hw-input--switchGroup .hw-input--error-search.right {\n    left: calc(50% + 0.5rem);\n    right: auto;\n  }\n}\n\n@media (max-width: 766px) {\n  .hw-input--switchGroup .hw-input--error-search.left {\n    top: 5rem;\n    bottom: auto;\n  }\n\n  .hw-input--switchGroup .hw-input--error-search.right {\n    left: 0;\n    right: auto\n  }\n}\n\n.hw-person-error--modal {\n  color: var(--hw-red);\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 1.2rem;\n  line-height: 1.5;\n  z-index: 11;\n  background: #fbe7e9;\n  padding: 0.4rem;\n  border-radius: 0.5rem;\n}\n\n.white-space-nowrap {\n  white-space: nowrap !important;\n}\n\n.hw-airline--grid {\n  display: grid;\n  cursor: pointer;\n  grid-template-columns: auto auto 1fr auto;\n  /*flex: 1;*/\n  /*max-width: 71%;*/\n}\n\n.hw-fare--slider .swiper-slide:hover {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-dates-slider-container {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  width: 100%;\n  position: relative;\n  border-radius: 0.3125rem;\n  background: var(--White, #FFF);\n  pointer-events: all;\n}\n\n.hw-dates-skeleton-slider {\n  display: flex;\n  gap: 8px;\n  /* spacing between items */\n  overflow-x: auto;\n  /* horizontal scroll if needed */\n  white-space: nowrap;\n  scroll-snap-align: center;\n  /* keep items in single line */\n}\n\n.hw-dates-skeleton-slider::-webkit-scrollbar {\n  display: none;\n}\n\n.hw-dates-btn-prev,\n.hw-dates-btn-next {\n  width: 35px;\n  /*height: 100%;*/\n  background: transparent;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n}\n\n.hw-dates-btn-next {\n  border-left: 0.5px solid #D7D7D7;\n}\n\n.hw-dates-btn-prev {\n  border-right: .5px solid #D7D7D7;\n}\n\n.hw-date-item {\n  background: white;\n  border-left: 0.5px solid #D7D7D7;\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  /* width: 15rem;\n  flex: 0 0 13rem; */\n  /* padding: 1rem 1.4375rem; */\n  padding: 0.8rem 0.2rem 0.4rem 0.2rem;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  /* gap: .25rem; */\n  scroll-snap-align: center;\n  border-bottom: 4px solid transparent;\n  width: 33.33%;\n  flex-basis: 33.33%;\n  min-width: 33.33%;\n}\n\n@media (min-width : 575px) {\n  .hw-date-item {\n    width: 25%;\n    flex-basis: 25%;\n    min-width: 25%;\n  }\n}\n\n@media (min-width : 1024px) {\n  .hw-date-item {\n    width: 20%;\n    flex-basis: 20%;\n    min-width: 20%;\n  }\n}\n\n@media (min-width : 1200px) {\n  .hw-date-item {\n    width: calc(100% / 7);\n    flex-basis: calc(100% / 7);\n    min-width: calc(100% / 7);\n  }\n}\n\n.hw-date-item.selected {\n  border-bottom: 4px solid var(--Blue, #3264FF);\n}\n\n.hw-date-range {\n  color: var(--Violet, #121826);\n  font-family: \"DM Sans\";\n  font-size: 1.4rem;\n  font-style: normal;\n  font-weight: 700;\n  white-space: nowrap;\n  /* line-height: 2.5rem; */\n}\n\n.hw-price {\n  color: var(--Blue, #3264FF);\n  text-align: center;\n  font-family: \"DM Sans\";\n  font-size: 1.4rem;\n  font-style: normal;\n  font-weight: 500;\n  /* line-height: 0.5rem; */\n}\n\n.hw-no-price {\n  color: var(--Blue, #3264FF);\n  text-align: center;\n  font-family: \"DM Sans\";\n  font-size: 1.4rem;\n  font-style: normal;\n  font-weight: 500;\n  /* line-height: .5rem; */\n}\n\n.hw-flight--cTab .hw-no-price {\n  line-height: 1;\n}\n\n.hw-dates-slider {\n  display: flex;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  scroll-snap-type: x mandatory;\n  display: flex;\n  flex: 1 0 0;\n  overflow-y: auto;\n  pointer-events: all;\n  margin-left: -3px;\n}\n\n.hw-dates-slider::-webkit-scrollbar {\n  display: none;\n}\n\n.hw-dates--roundtrip .hw-date-range,\n.hw-dates--roundtrip .hw-price,\n.hw-dates--roundtrip .hw-no-price {\n  font-size: 1.2rem;\n}\n\n.hw-dates-slider-header {\n  display: flex;\n  justify-content: space-between;\n  background: linear-gradient(90deg, #3264FF 21.17%, #1846D6 82.33%);\n  color: var(--hw-white);\n  padding: 0.6rem 1.2rem;\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n  align-items: center;\n}\n\n.hw-dates-rotate-text {\n  position: relative;\n  height: 2.4rem;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.hw-loader {\n  width: 1.6rem;\n  height: 1.6rem;\n  border: 0.2rem solid #d3d3d3;\n  border-top: 0.2rem solid var(--hw-white);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  flex-shrink: 0;\n  will-change: transform;\n  backface-visibility: hidden;\n  transform-origin: center;\n}\n\n\n\n.hw-dates-rotate-text-inner {\n  display: flex;\n  flex-direction: column;\n  animation: scrollUp 5s linear infinite;\n}\n\n.hw-dates-rotate-text span {\n  height: 3.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (min-width : 600px) {\n  .hw-dates-slider-header {\n    padding: 0.4rem 2rem;\n  }\n}\n\n@media (max-width : 599px) {\n  .hw-dates-slider-header {\n    font-size: 1.2rem;\n  }\n\n  .hw-dates-slider-header .hw-text14 {\n    /* font-size: 1rem !important; */\n    font-size: 1.2rem !important;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width : 479px) {\n  .hw-dates-slider-header>.hw-fontBold {\n    max-width: 14rem;\n  }\n}\n\n@keyframes scrollUp {\n  0% {\n    transform: translateY(0)\n  }\n\n  50% {\n    transform: translateY(-20%)\n  }\n\n  100% {\n    transform: translateY(-50%)\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.hw-ndc-fare {\n  padding: 0.4rem 0.8rem;\n  font-size: 1.4rem;\n  line-height: 1.5;\n  font-weight: bold;\n  display: inline-flex;\n  justify-content: center;\n  column-gap: 1rem;\n  align-items: center;\n  border: none;\n  cursor: pointer;\n  border-radius: 0.5rem;\n  color: var(--hw-brand-orange);\n  background-color: rgba(50, 100, 255, 0.10);\n}\n\n.hw-airline-filter .hw-form--input {\n  padding: 0.8rem 3rem 0.8rem 1rem;\n}\n\n.hw-airline-filter>svg {\n  position: absolute;\n  right: 1.6rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--hw-brand-orange);\n  display: block;\n  width: 2rem;\n  height: 2rem;\n  pointer-events: none;\n}\n\n.hw-animated-placeholder {\n  position: absolute;\n  left: 3rem;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  white-space: nowrap;\n  overflow: hidden;\n  width: calc(100% - 100px);\n  z-index: 2;\n  height: 1.5em;\n  color: var(--Dark-Blue, #0F294D);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 28px;\n}\n\n.hw-placeholder-item {\n  position: absolute;\n  left: 8.5rem;\n  top: 0;\n  opacity: 0;\n  transform: translateY(30px);\n  transition: all .1s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  animation: scrollUpExcursion 1.2s ease-in-out infinite;\n}\n\n.hw-placeholder-item.active {\n  opacity: 1;\n  transform: translateY(0);\n  z-index: 2;\n}\n\n/* .hw-cursor {\n  display: inline-block;\n  margin-left: 4px;\n  animation: scrollUp 1s linear infinite;\n} */\n@keyframes scrollUpExcursion {\n  0% {\n    transform: translateY(0)\n  }\n\n  to {\n    transform: translateY(-80%)\n  }\n}\n\n.hw-contact--inputSingleField .css-1wy0on6 {\n  flex-direction: row-reverse !important;\n}\n\n.hw-add--bagagge .hw-select__control {\n  min-height: 5rem;\n  border-color: #CCCCCC !important;\n  outline: none !important;\n  box-shadow: none;\n}\n\n.hw-add--bagagge .hw-select__placeholder {\n  color: var(--hw-gray-800);\n}\n\n.hw-add--bagagge .hw-select__indicator.hw-select__dropdown-indicator {\n  color: var(--hw-gray-800);\n}\n\n.hw-currency {\n  font-family: 'aedregular', sans-serif !important;\n}\n\n.hw-action-tooltipWrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.hw-action-tooltipText {\n  position: absolute;\n  right: calc(100% + 10px);\n  top: 50%;\n  transform: translateY(-50%);\n  background: #fff;\n  color: #222;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 13px;\n  line-height: 1.3;\n  white-space: nowrap;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.18s ease, visibility 0.18s ease;\n  z-index: 20;\n}\n\n.hw-action-tooltipText.is-visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n@media (max-width: 767px) {\n  .hw-action-tooltipText {\n    right: auto;\n    left: 50%;\n    top: auto;\n    bottom: calc(100% + 10px);\n    transform: translateX(-50%);\n  }\n}\n\n\n\n\n\n\n\n\n\n\n/*Flight Hotel UI Redesign*/\n:root {\n  --newly-added-color: #F3960A;\n}\n\n.hw-widget.hw-widget--flight .hw-tab button {\n  font-size: 1.4rem;\n}\n\n.hw-row--gap4 {\n  row-gap: 0.4rem;\n}\n\n\n\n\n\n.hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw--vendor-img .hw-text14 {\n  font-size: 1.2rem !important;\n}\n\n.hw-search--flightFilterResult__listNew .hw-view--pricesBtn {\n  padding: 0.5rem 1.5rem;\n  font-size: 1.2rem;\n  text-transform: uppercase;\n  line-height: 1.5;\n}\n\n.hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-print-selection-box {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n}\n\n.hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-print-selection-box input {\n  width: 1.8rem;\n  height: 1.8rem;\n}\n\n.hw-flight--listBox .destination .destination-from>.hw-text14,\n.hw-flight--listBox .destination .destination-to>.hw-text14 {\n  line-height: 1.286;\n}\n\n.hw-widget--flight .hw-row--inputCheck input[type=\"checkbox\"],\n.hw-search--flightFilter input[type=\"checkbox\"] {\n  width: 1.8rem;\n  height: 1.8rem;\n  border-radius: 0.4rem;\n}\n\n.hw-text--100ellipsis {\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.hw-flight--listBox__flight {\n\n  max-width: 15rem;\n}\n\n/* .hw-search--flightFilterResult__listNew > .hw-search--flightFilterResult__listItem > .hw-search--flightFilterResult__listItemList {\n  width: 16rem;\n} */\n.hw-widget--flight .js-show--topFilter,\n.hw-hotel--filterWidgetMain .js-show--topFilter {\n  position: absolute;\n  bottom: -1rem;\n  right: 0;\n  background: var(--hw-white);\n  border: none;\n  padding: 0.5rem 1.6rem;\n  font-weight: bold;\n  color: var(--hw-brand-orange);\n  font-size: 1.4rem;\n  display: inline-flex;\n  align-items: center;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.4rem;\n  cursor: pointer;\n  min-width: 9.5rem;\n  justify-content: center;\n}\n\n.hw-hotel--filterWidgetMain .js-show--topFilter {\n  bottom: -3.5rem;\n}\n\n.hw-widget--flight .js-show--topFilter:hover,\n.hw-hotel--filterWidgetMain .js-show--topFilter:hover {\n  color: var(--hw-brand-blue);\n}\n\n.hw-widget--flight.hw-widget--flight__open .hw-widget--card {\n  transition: max-height 0.3s ease-out, overflow 0.3s ease-out;\n  max-height: max-content;\n\n}\n\n.hw-widget--flight.hw-widget--flight__open.filter-visible {\n  min-height: auto;\n}\n\n.hw-widget--flight.hw-widget--flight__open.filter-visible .hw-widget--card {\n  max-height: 5.8rem;\n  overflow: hidden;\n  /* padding: 0;  */\n\n}\n\n/* .hw-widget--flight.hw-widget--flight__open.filter-visible .hw-widget--card .hw-tab {\n  opacity: 0;\n} */\n\n.hw-search--flightFilterResult__listNew .hw-search--flightFilterResult__listItemList span img {\n  object-fit: contain;\n}\n\n@media (min-width: 1101px) {\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem {\n    display: flex;\n    flex-wrap: wrap;\n    position: relative;\n    padding-top: 2.5rem;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.mb-2 .hw-ndc-fare {\n    position: absolute;\n    font-size: 1.2rem;\n    line-height: normal;\n    top: 5px;\n    left: 5px;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.hw-flight--listBox {\n    flex: 1 1 0;\n    column-gap: 2rem;\n    padding-left: 2rem;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw--vendor-img {\n    position: absolute;\n    right: 3rem;\n    top: 4px;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-search--flightFilterResult__listItemList {\n    width: 12rem;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start !important;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-flight--listBoxAction {\n    align-items: flex-end;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.hw-flight--listBox~* {\n    width: 100%;\n  }\n\n  /*Multi city*/\n  .hw-search--flightFilterResult__listNew .hw-flight--listBoxInnerList {\n    display: flex;\n    column-gap: 2rem;\n  }\n\n  /*End*/\n\n}\n\n@media (min-width: 1101px) and (max-width: 1199px) {\n  .hw-text--100ellipsis {\n    max-width: 7rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-search--flightFilterResult__listItemList {\n    width: 16rem;\n  }\n}\n\n@media (min-width: 750px) and (max-width: 900px) {\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem {\n    display: flex;\n    flex-wrap: wrap;\n    position: relative;\n    padding-top: 2.5rem;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.mb-2 .hw-ndc-fare {\n    position: absolute;\n    font-size: 1.2rem;\n    line-height: normal;\n    top: 5px;\n    left: 5px;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.hw-flight--listBox {\n    flex: 1 1 0;\n    column-gap: 1rem;\n    padding-left: 1rem;\n    flex-wrap: nowrap;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw--vendor-img {\n    position: absolute;\n    right: 3rem;\n    top: 4px;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-search--flightFilterResult__listItemList {\n    width: 12rem;\n    justify-content: center;\n    align-items: flex-start !important;\n    flex-direction: column;\n  }\n\n  .hw-text--100ellipsis {\n    max-width: 7rem;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-flight--listBoxAction {\n    align-items: flex-end;\n    flex-direction: column;\n    width: fit-content;\n    flex-shrink: 0;\n  }\n\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem>.hw-flight--listBox~* {\n    width: 100%;\n  }\n\n  /*Multi city*/\n  .hw-search--flightFilterResult__listNew .hw-flight--listBoxInnerList {\n    column-gap: 1rem;\n    display: flex;\n  }\n\n  /*End*/\n\n}\n\n@media (max-width: 749px) {\n  .hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem .hw-search--flightFilterResult__listItemList {\n    flex-wrap: wrap;\n    margin-bottom: 0.5rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .hw-widget--flight .js-show--topFilter {\n    bottom: -1.6rem;\n    right: -1rem;\n    padding: 0.4rem 1.2rem;\n    min-width: 8rem;\n  }\n\n  .hw-widget--flight .js-show--topFilter svg {\n    width: 2rem;\n    height: 2rem;\n  }\n\n  .hw-search--flightFilterResult__listNew .hw-search--flightFilterResult__listItemList span img {\n    width: 3rem;\n    height: 3rem;\n  }\n\n  .hw-xstext20 {\n    font-size: 2rem !important;\n  }\n}\n\n.hw-search--flightFilterResult__listNew .hw-flight--line .circle,\n.hw-search--flightFilterResult__listNew .hw-flight--line .line,\n.hw-search--flightFilterResult__listNew .hw-flight--line--stop {\n  background-color: var(--newly-added-color);\n}\n\n.hw-search--flightFilterResult__listNew>.hw-search--flightFilterResult__listItem {\n  box-shadow: 0px 4px 20px rgba(15, 23, 42, 0.06);\n}\n\n.pl-null {\n  padding-left: 0 !important;\n}\n\n\n\n/*Hotel Redesign UI*/\n.hw-hotes-module.hw-hotel--widget.hw-hotel--filterWidgetMain .hw-filter--searchBtn,\n.hw-hotes-module .hw-widget--card .hw-input--groupCol .hw-filter--searchBtn {\n  min-width: 6.4rem;\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n\n.hw-hotel-search.nationality-select {\n  width: 25rem;\n  margin-left: 0.4rem;\n  position: relative;\n}\n\n.hw-hotel-search.nationality-select>div>div {\n  width: 100%;\n  padding: 0 !important;\n  min-height: 5.4rem;\n  border-radius: 0 !important;\n}\n\n.hw-hotel-search.nationality-select>div>div>div {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.hw-hotel-search.nationality-select .css-1jqq78o-placeholder {\n  margin-left: 0;\n  color: var(--hw-brand-blue);\n  font-weight: 500;\n  padding-left: 0;\n}\n\n.hw-hotes-module .hw-input--multicityGroup .hw-hotel-search.nationality-select>div>div>div .css-1xc3v61-indicatorContainer svg {\n  color: var(--hw-brand-blue) !important;\n}\n\n.hw-row--input .hw-hotel-search.nationality-select:hover .css-1u80x8j-control {\n  border-color: var(--hw-brand-orange) !important;\n}\n\n.hw-date--calender>div.hw-calender--removeBtn {\n  min-height: auto;\n  padding: 0.4rem;\n  right: 0.8rem !important;\n}\n\n.hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.hw-hotes-module.hw-hotel--widget.hw-hotel--filterWidgetMain {\n  position: sticky;\n  top: 0;\n  z-index: 11;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);\n}\n\n@media (min-width: 440px) and (max-width: 1099px) {\n  .hw-hotes-module .hw-input--groupCol .hw-input--switchGroup {\n    width: 60%;\n    flex: 1 0 0;\n  }\n\n  .hw-hotel-search.nationality-select {\n    width: 38%;\n    margin-left: 0;\n  }\n\n  .hw-hotel-search.nationality-select>div>div {\n    border-radius: 0.5rem !important;\n  }\n}\n\n@media (min-width: 900px) {\n  .hw-hotel--filterWidgetMain .js-show--topFilter {\n    display: none !important;\n  }\n}\n\n@media (max-width: 899px) {\n  .hw-hotel--filterWidgetMain .hw-hotes-moduleFilterTop {\n    transition: max-height 0.3s ease-out, opacity 0.3s ease-out;\n    max-height: 40rem;\n    overflow: hidden;\n  }\n\n  .hw-hotel--filterWidgetMain.filter-visible .hw-hotes-moduleFilterTop {\n    max-height: 0;\n\n  }\n}\n\n@media (max-width: 1239px) and (min-width: 768px) {\n  .hw--listing-buttons-container {\n    right: 0.5rem !important;\n    top: 55% !important;\n  }\n\n  /* .hw--listing-buttons-container .hw-btn {\n    width: 3.5rem !important;\n    height: 3.5rem !important;\n  } */\n}\n\n@media (max-width: 767px) {\n  .hw--listing-buttons-container {\n    right: 0.5rem !important;\n    transform: translateX(0) !important;\n    padding: 0.5rem 1rem !important;\n    bottom: 5px !important;\n  }\n\n  .hw-gapy10.hw--listing-buttons-container {\n    column-gap: 0.5rem !important;\n  }\n\n  .hw--listing-buttons-container .hw-btn {\n    width: 3.2rem !important;\n    height: 3.2rem !important;\n  }\n\n  .hw-action-tooltipText {\n    transform: translateX(-85%);\n  }\n}\n\n@media (max-width: 439px) {\n  .hw-hotel-search.nationality-select {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .hw-hotel-search.nationality-select>div>div {\n    border-radius: 0.5rem !important;\n  }\n\n  .hw-hotes-module.hw-hotel--widget .hw-date--calender>div.hw-calender--removeBtn {\n    right: 0 !important;\n    margin-top: 1rem;\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {\n\n  .hw-widget--flight.hw-widget--flight__open.filter-visible .hw-widget--card {\n    max-height: 5.4rem;\n    overflow: hidden;\n  }\n\n}\n\n/*End Hotel UI Redesign*/\n/*End Flight Hotel UI Redesign*/\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   PASSPORT PHOTO EDITOR  (hw-pe-- prefix)\n   All rules below are scoped to the photo-editor page only.\n   Colours re-use the existing CSS custom properties wherever possible.\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n/* ── Page wrapper ─────────────────────────────────────────────────────────── */\n.hw-pe--page {\n  padding-top: 2rem;\n  padding-bottom: 4rem;\n}\n\n/* ── Page heading ─────────────────────────────────────────────────────────── */\n.hw-pe--page-header {\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n  margin-bottom: 2.5rem;\n  flex-wrap: wrap;\n}\n\n.hw-pe--page-header-icon {\n  width: 4.8rem;\n  height: 4.8rem;\n  background: var(--hw-brand-orange);\n  border-radius: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.hw-pe--page-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--hw-black-900);\n  margin: 0;\n  line-height: 1.2;\n}\n\n.hw-pe--page-sub {\n  font-size: 1.3rem;\n  color: var(--hw-gray-500);\n  margin: 0.3rem 0 0;\n}\n\n/* ── Mode badge ───────────────────────────────────────────────────────────── */\n.hw-pe--mode-badge {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  padding: 0.4rem 1rem;\n  border-radius: 2rem;\n}\n\n.hw-pe--mode-dot {\n  width: 0.8rem;\n  height: 0.8rem;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.hw-pe--mode-ai {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.hw-pe--mode-local {\n  background: var(--hw-gray-100);\n  color: var(--hw-gray-500);\n}\n\n/* ── Stepper ──────────────────────────────────────────────────────────────── */\n.hw-pe--stepper-wrap {\n  position: relative;\n  width: 100%;\n  height: 5.6rem;\n  margin-bottom: 2.5rem;\n}\n\n.hw-pe--stepper-track {\n  position: absolute;\n  top: 1.6rem;\n  left: 1.6rem;\n  right: 1.6rem;\n  height: 4px;\n  background: var(--hw-gray-200);\n  border-radius: 99px;\n  z-index: 1;\n}\n\n.hw-pe--stepper-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--hw-brand-orange), var(--hw-brand-blue));\n  border-radius: 99px;\n  width: 0%;\n  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hw-pe--stepper-steps {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  z-index: 2;\n}\n\n.hw-pe--step-item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 3.2rem;\n}\n\n.hw-pe--step-circle {\n  width: 3.2rem;\n  height: 3.2rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  font-weight: 700;\n  flex-shrink: 0;\n  border: 2px solid var(--hw-gray-400);\n  color: var(--hw-gray-400);\n  background: var(--hw-white);\n  transition: all 0.4s ease;\n  box-shadow: 0 0 0 6px var(--hw-white);\n}\n\n.hw-pe--step-item.active .hw-pe--step-circle {\n  border-color: var(--hw-brand-orange);\n  background: var(--hw-brand-orange);\n  color: var(--hw-white);\n  box-shadow: 0 0 0 6px var(--hw-white), 0 4px 10px rgba(255, 122, 0, 0.25);\n}\n\n.hw-pe--step-item.done .hw-pe--step-circle {\n  border-color: var(--hw-brand-blue);\n  background: var(--hw-brand-blue);\n  color: var(--hw-white);\n}\n\n.hw-pe--step-label {\n  position: absolute;\n  top: 4rem;\n  white-space: nowrap;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--hw-gray-400);\n  transition: color 0.4s ease;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.hw-pe--stepper-steps .hw-pe--step-item:first-child .hw-pe--step-label {\n  left: 0;\n  transform: none;\n}\n\n.hw-pe--stepper-steps .hw-pe--step-item:last-child .hw-pe--step-label {\n  left: auto;\n  right: 0;\n  transform: none;\n}\n\n.hw-pe--step-item.active .hw-pe--step-label {\n  color: var(--hw-brand-orange);\n}\n\n.hw-pe--step-item.done .hw-pe--step-label {\n  color: var(--hw-brand-blue);\n}\n\n/* ── Card ─────────────────────────────────────────────────────────────────── */\n.hw-pe--card {\n  background: var(--hw-white);\n  border-radius: 0.5rem;\n  padding: 2rem;\n  box-shadow: 0px 0px 10px 0px rgba(var(--hw-black-rgb), 0.10);\n  margin-bottom: 1.5rem;\n}\n\n/* ── Section headings ─────────────────────────────────────────────────────── */\n.hw-pe--section-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin-bottom: 0.4rem;\n  color: var(--hw-black-900);\n}\n\n.hw-pe--section-sub {\n  font-size: 1.3rem;\n  color: var(--hw-gray-500);\n  margin-bottom: 2rem;\n}\n\n/* ── Back button ──────────────────────────────────────────────────────────── */\n.hw-pe--back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: var(--hw-gray-650);\n  cursor: pointer;\n  border: 1.5px solid var(--hw-gray-200);\n  background: #fff;\n  padding: 0.55rem 1.2rem 0.55rem 0.9rem;\n  border-radius: 0.6rem;\n  margin-bottom: 1.8rem;\n  transition: border-color .2s, color .2s, background .2s;\n}\n\n.hw-pe--back-btn:hover {\n  border-color: var(--hw-brand-orange);\n  color: var(--hw-brand-orange);\n  background: var(--hw-brand-orange-light);\n}\n\n/* ── Continue button ──────────────────────────────────────────────────────── */\n.hw-pe--continue-btn {\n  margin-top: 1.5rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.8rem 2rem;\n}\n\n.hw-pe--continue-btn:disabled {\n  background-color: var(--hw-gray-200) !important;\n  color: var(--hw-gray-500) !important;\n  cursor: not-allowed;\n}\n\n/* ── Country dropdown ─────────────────────────────────────────────────────── */\n.hw-pe--dropdown-trigger {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  background: var(--hw-white);\n  border: 2px solid var(--hw-gray-200);\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: border-color .2s;\n}\n\n.hw-pe--dropdown-trigger:hover {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-pe--dropdown-trigger.open {\n  border-color: var(--hw-brand-orange);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.hw-pe--dt-flag {\n  font-size: 2rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.hw-pe--dt-text {\n  flex: 1;\n}\n\n.hw-pe--dt-name {\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n\n.hw-pe--dt-size {\n  font-size: 1.15rem;\n  color: var(--hw-gray-400);\n}\n\n.hw-pe--dropdown-panel {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  background: var(--hw-white);\n  border: 2px solid var(--hw-brand-orange);\n  border-top: none;\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, .12);\n  overflow: hidden;\n}\n\n.hw-pe--dp-search {\n  padding: 0.6rem 0.75rem;\n  border-bottom: 1px solid var(--hw-gray-100);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.hw-pe--dp-search input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 1.3rem;\n  background: none;\n  color: var(--hw-black-900);\n}\n\n.hw-pe--dp-list {\n  max-height: 28rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.hw-pe--dp-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.hw-pe--dp-list::-webkit-scrollbar-thumb {\n  background: var(--hw-gray-200);\n  border-radius: 99px;\n}\n\n.hw-pe--dp-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.65rem 1rem;\n  cursor: pointer;\n  transition: background .15s;\n}\n\n.hw-pe--dp-item:hover {\n  background: var(--hw-gray-100);\n}\n\n.hw-pe--dp-item.selected {\n  background: var(--hw-brand-orange-light);\n}\n\n.hw-pe--dp-flag {\n  font-size: 1.8rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.hw-pe--dp-info {\n  flex: 1;\n}\n\n.hw-pe--dp-name {\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n.hw-pe--dp-dims {\n  font-size: 1.1rem;\n  color: var(--hw-gray-400);\n}\n\n.hw-pe--dp-tick {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  background: var(--hw-brand-orange);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--hw-white);\n}\n\n.hw-pe--dp-empty {\n  padding: 1.5rem;\n  text-align: center;\n  font-size: 1.3rem;\n  color: var(--hw-gray-400);\n}\n\n/* ── Step 1 layout (2-col: dropdown | spec preview) ──────────────────────── */\n.hw-pe--step1-layout {\n  display: grid;\n  grid-template-columns: 1fr 30rem;\n  gap: 1.5rem;\n}\n\n@media (max-width: 680px) {\n  .hw-pe--step1-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Spec preview ─────────────────────────────────────────────────────────── */\n.hw-pe--spec-preview {\n  background: var(--hw-brand-orange-light);\n  border: 1px solid rgba(var(--hw-brand-orange-rgb), 0.35);\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  height: fit-content;\n}\n\n.hw-pe--sp-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--hw-brand-orange);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.75rem;\n}\n\n.hw-pe--sp-flag-name {\n  font-size: 1.6rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-bottom: 0.6rem;\n}\n\n.hw-pe--sp-dims {\n  display: inline-block;\n  background: var(--hw-white);\n  border-radius: 6px;\n  padding: 0.4rem 1rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--hw-brand-orange);\n  margin-bottom: 1rem;\n}\n\n.hw-pe--sp-reqs {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.hw-pe--sp-reqs li {\n  font-size: 1.2rem;\n  color: var(--hw-black-500);\n  display: flex;\n  gap: 0.8rem;\n  align-items: flex-start;\n  line-height: 1.4;\n}\n\n/* ── Upload layout (sidebar | upload area) ────────────────────────────────── */\n.hw-pe--upload-layout {\n  display: grid;\n  grid-template-columns: 26rem 1fr;\n  gap: 1.5rem;\n  align-items: start;\n}\n\n@media (max-width: 640px) {\n  .hw-pe--upload-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Requirements panel (sidebar) ────────────────────────────────────────── */\n.hw-pe--req-panel {\n  background: var(--hw-white);\n  border: 1px solid var(--hw-gray-200);\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n}\n\n.hw-pe--req-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.hw-pe--req-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.hw-pe--req-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: 1.2rem;\n  color: var(--hw-black-500);\n  line-height: 1.4;\n}\n\n.hw-pe--req-icon {\n  width: 1.6rem;\n  height: 1.6rem;\n  border-radius: 50%;\n  background: var(--hw-brand-orange);\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--hw-white);\n}\n\n.hw-pe--req-dims {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--hw-gray-100);\n  color: var(--hw-gray-400);\n  text-align: center;\n}\n\n/* ── Drop zone ────────────────────────────────────────────────────────────── */\n.hw-pe--drop-zone {\n  border: 2px dashed var(--hw-gray-400);\n  border-radius: 0.5rem;\n  padding: 3rem 1.5rem;\n  text-align: center;\n  cursor: pointer;\n  background: var(--hw-white);\n  transition: border-color .2s, background .2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.hw-pe--drop-zone:hover,\n.hw-pe--drop-zone.dragover {\n  border-color: var(--hw-brand-orange);\n  background: var(--hw-brand-orange-light);\n}\n\n.hw-pe--dz-title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: var(--hw-black-500);\n  margin: 0.5rem 0 0;\n}\n\n.hw-pe--dz-sub {\n  font-size: 1.2rem;\n  color: var(--hw-gray-400);\n}\n\n/* ── Photo preview (after selection) ─────────────────────────────────────── */\n.hw-pe--preview-wrap {\n  position: relative;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  margin-bottom: 0;\n}\n\n.hw-pe--preview-img {\n  width: 100%;\n  max-height: 28rem;\n  object-fit: contain;\n  display: block;\n  background: var(--hw-gray-100);\n}\n\n.hw-pe--remove-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, .55);\n  color: var(--hw-white);\n  border: none;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n  font-size: 1.4rem;\n  line-height: 28px;\n  text-align: center;\n  transition: background .2s;\n}\n\n.hw-pe--remove-btn:hover {\n  background: rgba(0, 0, 0, .8);\n}\n\n/* ── Process button ───────────────────────────────────────────────────────── */\n.hw-pe--process-btn {\n  display: block;\n  width: 100%;\n  margin-top: 1rem;\n  padding: 0.85rem 1.5rem;\n  font-size: 1.4rem;\n  font-weight: 700;\n}\n\n.hw-pe--process-btn:disabled {\n  background-color: var(--hw-gray-200) !important;\n  color: var(--hw-gray-500) !important;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* ── Progress panel ───────────────────────────────────────────────────────── */\n.hw-pe--progress-wrap {\n  margin-top: 1rem;\n  background: var(--hw-white);\n  border: 1px solid var(--hw-gray-200);\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n}\n\n.hw-pe--progress-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.hw-pe--ps-item {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 1.3rem;\n  color: var(--hw-gray-400);\n  transition: color .3s;\n}\n\n.hw-pe--ps-item.active {\n  color: var(--hw-brand-orange);\n  font-weight: 600;\n}\n\n.hw-pe--ps-item.done {\n  color: var(--hw-green);\n}\n\n.hw-pe--ps-dot {\n  width: 0.8rem;\n  height: 0.8rem;\n  border-radius: 50%;\n  background: var(--hw-gray-200);\n  flex-shrink: 0;\n  transition: background .3s;\n}\n\n.hw-pe--ps-item.active .hw-pe--ps-dot {\n  background: var(--hw-brand-orange);\n  animation: hw-pe-pulse 1s infinite;\n}\n\n.hw-pe--ps-item.done .hw-pe--ps-dot {\n  background: var(--hw-green);\n  animation: none;\n}\n\n@keyframes hw-pe-pulse {\n\n  0%,\n  100% {\n    opacity: 1\n  }\n\n  50% {\n    opacity: .4\n  }\n}\n\n.hw-pe--progress-bar-track {\n  background: var(--hw-gray-100);\n  border-radius: 9999px;\n  height: 6px;\n  overflow: hidden;\n}\n\n.hw-pe--progress-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--hw-brand-orange), #60a5fa);\n  border-radius: 9999px;\n  transition: width .5s ease;\n}\n\n/* ── Tips row ─────────────────────────────────────────────────────────────── */\n.hw-pe--tips-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));\n  gap: 0.6rem;\n  margin-top: 1.5rem;\n}\n\n.hw-pe--tip-card {\n  background: var(--hw-brand-orange-light);\n  border-radius: 0.5rem;\n  padding: 0.75rem 1rem;\n  font-size: 1.2rem;\n  color: var(--hw-brand-orange);\n  display: flex;\n  align-items: flex-start;\n  gap: 0.4rem;\n  line-height: 1.4;\n}\n\n/* ── Alerts ───────────────────────────────────────────────────────────────── */\n.hw-pe--alert {\n  border-radius: 0.5rem;\n  padding: 0.65rem 0.9rem;\n  font-size: 1.25rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.4rem;\n  margin-bottom: 0.5rem;\n}\n\n.hw-pe--alert-warn {\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fde68a;\n}\n\n.hw-pe--alert-error {\n  background: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fca5a5;\n}\n\n.hw-pe--warnings-box {\n  margin-bottom: 1rem;\n}\n\n/* ── Result layout (before / after, 2 cols) ──────────────────────────────── */\n.hw-pe--result-container {\n  width: 100%;\n}\n\n.hw-pe--result-header-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.hw-pe--back-btn-new {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.75rem 1.4rem;\n  border-radius: 99px;\n  background: var(--hw-white);\n  border: 1.5px solid var(--hw-gray-200);\n  color: var(--hw-gray-650);\n  font-size: 1.3rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.hw-pe--back-btn-new:hover {\n  border-color: var(--hw-brand-blue);\n  color: var(--hw-brand-blue);\n  background: var(--hw-brand-blue-light);\n}\n\n.hw-pe--result-header-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.6rem 1.2rem;\n  border-radius: 99px;\n  background: var(--hw-brand-blue-light);\n  color: var(--hw-brand-blue);\n}\n\n.hw-pe--result-layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n@media (max-width: 580px) {\n  .hw-pe--result-layout {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .hw-pe--result-header-bar {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n}\n\n.hw-pe--result-card {\n  display: flex;\n  flex-direction: column;\n  border-radius: 1.2rem;\n  overflow: hidden;\n  height: 34rem;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.04);\n  border: 1px solid var(--hw-gray-200);\n  background: var(--hw-white);\n  width: 100%;\n}\n\n.hw-pe--result-card-header {\n  background: var(--hw-white);\n  border-bottom: 1px solid var(--hw-gray-200);\n  padding: 1.2rem 1.6rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.hw-pe--result-card-title {\n  color: var(--hw-gray-650);\n  letter-spacing: 0.02em;\n  text-transform: none;\n}\n\n.hw-pe--tag-new {\n  font-size: 1.1rem;\n  padding: 3px 8px;\n  border-radius: 6px;\n}\n\n.tag-raw {\n  background: var(--hw-gray-200);\n  color: var(--hw-gray-650);\n}\n\n.tag-compliant {\n  background: #dcfce7;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n}\n\n.hw-pe--result-image-container {\n  width: 100%;\n  flex: 1;\n  background-color: #f8fafc;\n  background-image: linear-gradient(45deg, #f1f5f9 25%, transparent 25%),\n    linear-gradient(-45deg, #f1f5f9 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, #f1f5f9 75%),\n    linear-gradient(-45deg, transparent 75%, #f1f5f9 75%);\n  background-size: 16px 16px;\n  background-position: 0 0, 0 8px, 8px -8px, -8px 0;\n  overflow: hidden;\n}\n\n.hw-pe--result-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.hw-pe--control-panel {\n  background: var(--hw-white);\n  border: 1px solid var(--hw-gray-200);\n  border-radius: 1.2rem;\n  padding: 2.4rem;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.04);\n  width: 100%;\n}\n\n.hw-pe--metadata-ribbon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1.2rem;\n  flex-wrap: wrap;\n}\n\n.hw-pe--meta-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0.6rem 1.2rem;\n  border-radius: 99px;\n  background: var(--hw-brand-blue-light);\n  color: var(--hw-brand-blue);\n  font-weight: 700;\n}\n\n.hw-pe--meta-flag {\n  font-size: 1.4rem;\n  line-height: 1;\n}\n\n.hw-pe--action-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1.6rem;\n}\n\n.hw-pe--download-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 1.2rem 2.8rem;\n  border-radius: 0.6rem;\n  background: var(--hw-brand-blue);\n  color: var(--hw-white);\n  font-size: 1.4rem;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(15, 41, 77, 0.08);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hw-pe--download-primary:hover {\n  background-color: #1a4d8c;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(15, 41, 77, 0.15);\n}\n\n.hw-pe--restart-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 1.2rem 2.4rem;\n  border-radius: 0.6rem;\n  background: var(--hw-white);\n  border: 1.5px solid var(--hw-brand-blue);\n  color: var(--hw-brand-blue);\n  font-size: 1.3rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hw-pe--restart-secondary:hover {\n  background: var(--hw-brand-blue-light);\n  border-color: var(--hw-brand-blue);\n  transform: translateY(-1px);\n}\n\n@media (max-width: 580px) {\n  .hw-pe--action-row {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .hw-pe--download-primary,\n  .hw-pe--restart-secondary {\n    width: 100%;\n  }\n}\n\n/* ── Tags ─────────────────────────────────────────────────────────────────── */\n.hw-pe--tag {\n  font-size: 1rem;\n  padding: 2px 7px;\n  border-radius: 2rem;\n  font-weight: 700;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.hw-pe--tag-orig {\n  background: var(--hw-gray-100);\n  color: var(--hw-gray-500);\n}\n\n.hw-pe--tag-proc {\n  background: #dcfce7;\n  color: var(--hw-green);\n}\n\n.hw-pe--tag-ai {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n/* ── AI Analysis panel ────────────────────────────────────────────────────── */\n.hw-pe--analysis-panel {\n  background: var(--hw-white);\n  border: 1px solid var(--hw-gray-200);\n  border-radius: 0.5rem;\n  padding: 2rem;\n  margin-bottom: 1.5rem;\n}\n\n.hw-pe--ap-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--hw-gray-100);\n}\n\n.hw-pe--ap-title {\n  font-size: 1.5rem;\n}\n\n.hw-pe--ap-badge {\n  margin-left: auto;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #7c3aed;\n  background: #ede9fe;\n  padding: 3px 10px;\n  border-radius: 2rem;\n}\n\n.hw-pe--analysis-grid {\n  display: grid;\n  grid-template-columns: 12rem 1fr 1fr;\n  gap: 1.5rem;\n  align-items: start;\n}\n\n@media (max-width: 540px) {\n  .hw-pe--analysis-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.hw-pe--al-head {\n  font-size: 1.1rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: 0.6rem;\n}\n\n.hw-pe--al-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.hw-pe--al-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.4rem;\n  font-size: 1.2rem;\n  color: var(--hw-black-500);\n  line-height: 1.4;\n}\n\n.hw-pe--dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  margin-top: 0.4em;\n  flex-shrink: 0;\n}\n\n.hw-pe--al-none {\n  font-style: italic;\n  color: var(--hw-gray-400);\n  font-size: 1.2rem;\n}\n\n.hw-pe--attr-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--hw-gray-100);\n}\n\n.hw-pe--chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 2rem;\n}\n\n.hw-pe--chip-ok {\n  background: #dcfce7;\n  color: var(--hw-green);\n}\n\n.hw-pe--chip-bad {\n  background: #fee2e2;\n  color: var(--hw-red);\n}\n\n.hw-pe--chip-warn {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n/* ── Mobile adjustments ───────────────────────────────────────────────────── */\n@media (max-width: 480px) {\n  .hw-pe--page {\n    padding-top: 1rem;\n    padding-bottom: 3rem;\n  }\n\n  .hw-pe--stepper-wrap {\n    display: none;\n  }\n\n  .hw-pe--card {\n    padding: 1.5rem;\n  }\n\n  .hw-pe--page-header {\n    gap: 0.8rem;\n  }\n\n  .hw-pe--page-title {\n    font-size: 1.6rem;\n  }\n\n  .hw-pe--mode-badge {\n    display: none;\n  }\n}\n\n/* ── Photo History section ────────────────────────────────────────────────── */\n.hw-pe--history-section {\n  margin-top: 3rem;\n  padding-top: 2.5rem;\n  border-top: 1.5px solid var(--hw-gray-200);\n}\n\n.hw-pe--history-hd {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  margin-bottom: 2rem;\n}\n\n.hw-pe--history-hd-icon {\n  width: 3.6rem;\n  height: 3.6rem;\n  border-radius: 0.8rem;\n  background: var(--hw-brand-blue-light);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--hw-brand-blue);\n  flex-shrink: 0;\n}\n\n.hw-pe--history-hd-text {\n  flex: 1;\n}\n\n.hw-pe--history-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 1.5rem;\n}\n\n@media (max-width: 991px) {\n  .hw-pe--history-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .hw-pe--history-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 400px) {\n  .hw-pe--history-grid {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n}\n\n.hw-pe--history-card {\n  border: 1px solid var(--hw-gray-200);\n  border-radius: 1rem;\n  overflow: hidden;\n  background: #fff;\n  transition: border-color .25s ease, box-shadow .25s ease, transform .25s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.hw-pe--history-card:hover {\n  border-color: var(--hw-brand-blue);\n  box-shadow: 0 10px 25px rgba(15, 41, 77, 0.08);\n  transform: translateY(-4px);\n}\n\n.hw-pe--history-thumb-wrap {\n  position: relative;\n  aspect-ratio: 1 / 1;\n  background: var(--hw-gray-100);\n  overflow: hidden;\n}\n\n.hw-pe--history-thumb {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.hw-pe--history-badge {\n  position: absolute;\n  top: 0.8rem;\n  left: 0.8rem;\n  background: rgba(220, 252, 231, 0.95);\n  border: 1px solid #bbf7d0;\n  color: #15803d;\n  font-size: 1rem;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 99px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.hw-pe--history-meta {\n  padding: 1.2rem;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.hw-pe--history-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin: 0.8rem 0 1.2rem 0;\n  padding-top: 0.8rem;\n  border-top: 1px solid var(--hw-gray-100);\n}\n\n.hw-pe--hd-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 1.15rem;\n  color: var(--hw-gray-500);\n}\n\n.hw-pe--hd-item svg {\n  color: var(--hw-gray-400);\n  flex-shrink: 0;\n}\n\n.hw-pe--history-actions {\n  display: flex;\n  gap: 0.6rem;\n  margin-top: auto;\n}\n\n.hw-pe--action-dl {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  background: var(--hw-brand-blue-light);\n  border: 1.5px solid transparent;\n  border-radius: 0.6rem;\n  color: var(--hw-brand-blue);\n  font-size: 1.2rem;\n  font-weight: 700;\n  padding: 0.75rem 1rem;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.hw-pe--action-dl:hover {\n  background: var(--hw-brand-blue);\n  color: var(--hw-white);\n  box-shadow: 0 4px 10px rgba(15, 41, 77, 0.15);\n}\n\n.hw-pe--action-del {\n  width: 3.2rem;\n  height: 3.2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid var(--hw-gray-200);\n  border-radius: 0.6rem;\n  background: #fff;\n  color: var(--hw-gray-500);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.hw-pe--action-del:hover {\n  background: #fee2e2;\n  border-color: #fca5a5;\n  color: var(--hw-red);\n}\n\n.hw-pe--history-flag {\n  font-size: 1.6rem;\n  line-height: 1;\n}\n\n.hw-pe--skel-line-btn {\n  height: 3.2rem;\n  border-radius: 0.6rem;\n  background: linear-gradient(90deg, var(--hw-gray-100) 25%, #e8e8e8 50%, var(--hw-gray-100) 75%);\n  background-size: 200% 100%;\n  animation: hw-pe-skeleton 1.4s infinite;\n}\n\n.hw-pe--skel-thumb {\n  aspect-ratio: 1 / 1;\n  background: linear-gradient(90deg, var(--hw-gray-100) 25%, #e8e8e8 50%, var(--hw-gray-100) 75%);\n  background-size: 200% 100%;\n  animation: hw-pe-skeleton 1.4s infinite;\n}\n\n.hw-pe--skel-line {\n  height: 1.1rem;\n  border-radius: 0.4rem;\n  background: linear-gradient(90deg, var(--hw-gray-100) 25%, #e8e8e8 50%, var(--hw-gray-100) 75%);\n  background-size: 200% 100%;\n  animation: hw-pe-skeleton 1.4s infinite;\n}\n\n.hw-pe--skel-line-sm {\n  height: 0.9rem;\n  border-radius: 0.4rem;\n  background: linear-gradient(90deg, var(--hw-gray-100) 25%, #e8e8e8 50%, var(--hw-gray-100) 75%);\n  background-size: 200% 100%;\n  animation: hw-pe-skeleton 1.4s infinite;\n}\n\n@keyframes hw-pe-skeleton {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.hw-pe--history-empty {\n  padding: 4rem 2rem;\n  text-align: center;\n  color: var(--hw-gray-500);\n  background: var(--hw-gray-100);\n  border-radius: 1rem;\n  border: 1.5px dashed var(--hw-gray-200);\n}\n\n.hw-pe--history-empty-ico {\n  opacity: 0.35;\n  margin-bottom: 1rem;\n}\n\n.hw-pe--pagination-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.2rem;\n  margin-top: 3rem;\n  border-top: 1px solid var(--hw-gray-100);\n  padding-top: 2rem;\n}\n\n.hw-pe--pagination-info {\n  font-size: 1.2rem;\n  color: var(--hw-gray-500);\n}\n\n.hw-pe--pagination {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.hw-pe--pg-btn {\n  height: 3.6rem;\n  min-width: 3.6rem;\n  padding: 0 1.2rem;\n  border: 1.5px solid var(--hw-gray-200);\n  border-radius: 0.6rem;\n  background: #fff;\n  color: var(--hw-gray-650);\n  font-size: 1.3rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: all 0.2s ease;\n}\n\n.hw-pe--pg-btn:hover:not(:disabled) {\n  border-color: var(--hw-brand-blue);\n  color: var(--hw-brand-blue);\n  background: var(--hw-brand-blue-light);\n}\n\n.hw-pe--pg-btn.active {\n  background: var(--hw-brand-orange);\n  border-color: var(--hw-brand-orange);\n  color: #fff;\n  box-shadow: 0 4px 10px rgba(255, 122, 0, 0.25);\n}\n\n.hw-pe--pg-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  border-color: var(--hw-gray-200);\n  color: var(--hw-gray-400);\n  background: #fff;\n}\n\n@media (max-width: 480px) {\n  .hw-pe--pg-txt {\n    display: none;\n  }\n\n  .hw-pe--pg-btn {\n    min-width: 3.6rem;\n    padding: 0;\n  }\n\n  .hw-pe--pagination-wrap {\n    gap: 1rem;\n  }\n}\n\n.hw-pe--demo-wrap {\n  padding-top: 2rem;\n  border-top: 1px solid var(--hw-gray-200);\n  max-width: 44rem;\n}\n\n.hw-pe--demo-title {\n  color: var(--hw-brand-blue);\n  font-size: 1.3rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.hw-pe--demo-grid {\n  position: relative;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.2rem;\n}\n\n.hw-pe--demo-arrow-indicator {\n  position: absolute;\n  top: 10.7rem;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 3.2rem;\n  height: 3.2rem;\n  border-radius: 50%;\n  background: var(--hw-white);\n  border: 1px solid var(--hw-gray-200);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--hw-brand-orange);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n  z-index: 3;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hw-pe--demo-wrap:hover .hw-pe--demo-arrow-indicator {\n  transform: translate(-50%, -50%) scale(1.15);\n  box-shadow: 0 6px 14px rgba(15, 41, 77, 0.12);\n  border-color: var(--hw-brand-orange);\n  color: var(--hw-brand-blue);\n}\n\n.hw-pe--demo-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.hw-pe--demo-img-wrap {\n  position: relative;\n  aspect-ratio: 1 / 1;\n  border-radius: 0.8rem;\n  overflow: hidden;\n  border: 1px solid var(--hw-gray-200);\n  background: var(--hw-gray-100);\n}\n\n.hw-pe--demo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.hw-pe--demo-badge {\n  position: absolute;\n  top: 0.6rem;\n  left: 0.6rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.badge-before {\n  background: #fee2e2;\n  color: var(--hw-red);\n  border: 1px solid #fca5a5;\n}\n\n.badge-after {\n  background: #dcfce7;\n  color: var(--hw-green);\n  border: 1px solid #bbf7d0;\n}\n\n.hw-pe--demo-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.hw-pe--demo-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  font-size: 1.1rem;\n  line-height: 1.3;\n}\n\n.item-bad {\n  color: var(--hw-gray-500);\n}\n\n.item-bad svg {\n  color: var(--hw-red);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.item-good {\n  color: var(--hw-black-900);\n  font-weight: 600;\n}\n\n.item-good svg {\n  color: var(--hw-green);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.hw-pe--demo-divider {\n  height: 1px;\n  background: var(--hw-gray-200);\n  margin: 1.5rem 0;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────── */\n.hw-arrow-btn {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  border: none !important;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 0.5rem;\n  padding: 0.6rem 1.2rem;\n  transition: background-color .2s ease, color .2s ease, border-color .2s ease;\n}\n\n.filter-active {\n  background-color: var(--hw-blue-new) !important;\n  color: white !important;\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
